import * as React from 'react';
import React__default, { forwardRef, useState, useEffect, useRef, useContext, createContext, useReducer, useCallback, useMemo, useLayoutEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import platform from 'platform';
import styled, { keyframes, useTheme, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { useTranslation, initReactI18next } from 'react-i18next';
import { Upload } from 'tus-js-client';
import SparkMD5 from 'spark-md5';
import useResizeObserver from 'use-resize-observer';
import { ImageSegmenter, FilesetResolver, ImageClassifier, FaceDetector, ObjectDetector } from '@mediapipe/tasks-vision';
import { createStore, useStore } from 'zustand';
import { useDebouncedCallback, useThrottledCallback } from 'use-debounce';
import { createPortal } from 'react-dom';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { useShallow } from 'zustand/react/shallow';
import SignatureCanvas from 'react-signature-canvas';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var webSdkVersion = '2.2.83';

function getPlatform() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof window !== 'undefined' && typeof window.platform !== 'undefined')
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window.platform;
  return platform;
}

function dataUrlToBase64(url) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (url.indexOf('blob:') >= 0) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
          // Fetch the Blob content
          fetch(url).then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to fetch Blob content');
            }
            return response.blob();
          }).then(function (blob) {
            var reader = new FileReader();
            reader.onload = function () {
              var base64String = reader.result ? reader.result.split(',')[1] : '';
              resolve(base64String);
            };
            reader.onerror = function () {
              reader.abort();
              reject(new Error('Error converting blob to base64'));
            };
            reader.readAsDataURL(blob);
          })["catch"](function (error) {
            reject(error);
          });
        })];
      }
      return [2 /*return*/, url.replace(/^data:image\/(png|jpeg);base64,/, '')];
    });
  });
}
function dataUrlToBase64Sync(url) {
  return url.replace(/^data:.*;base64,/, '');
}
function contentDispositionFromDataUrl(url) {
  var _a, _b;
  return (_b = (_a = url.match(/^(data:.*;base64),/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '';
}
function blobToB64(blob) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.onloadend = function () {
      return resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });
}

var SubmissionAction;
(function (SubmissionAction) {
  SubmissionAction["NONE"] = "NONE";
  SubmissionAction["ENROLL"] = "ENROLL";
  SubmissionAction["IDENTIFY"] = "IDENTIFY";
  SubmissionAction["VALIDATE"] = "VALIDATE";
  SubmissionAction["VERIFY"] = "VERIFY";
  SubmissionAction["MATCH_ID_AND_FACE"] = "MATCH_ID_AND_FACE";
})(SubmissionAction || (SubmissionAction = {}));
var SubmissionStatus;
(function (SubmissionStatus) {
  SubmissionStatus["READY"] = "READY";
  SubmissionStatus["SUBMITTING"] = "SUBMITTING";
  SubmissionStatus["SUBMITTED"] = "SUBMITTED";
  SubmissionStatus["FAILED"] = "FAILED";
})(SubmissionStatus || (SubmissionStatus = {}));
var submissionHosts = {
  prod: 'https://api.idmission.com',
  demo: 'https://apidemo.idmission.com'
};

function determineSubmissionHost(environment, token) {
  var host = submissionHosts[environment];
  if (!host) throw new Error("unrecognized SubmissionEnvironment ".concat(environment));
  return host;
}
function determineSubmissionEndpoint(action, hasId, hasSelfie) {
  switch (action) {
    case SubmissionAction.ENROLL:
      return hasId ? "/v4/customer/enroll" : "/v4/customer/enroll-biometrics";
    case SubmissionAction.IDENTIFY:
      return "/v4/customer/identify";
    case SubmissionAction.VALIDATE:
      return hasSelfie ? "/v4/customer/validate-id-match-face" : "/v4/customer/validate-id";
    case SubmissionAction.VERIFY:
      return "/v4/customer/verify";
    case SubmissionAction.MATCH_ID_AND_FACE:
      return "/v4/customer/match-id-face";
    default:
      throw new Error("unrecognized SubmissionAction ".concat(action));
  }
}
function liveCheckEndpoint(hasDocumentToMatchFace) {
  if (hasDocumentToMatchFace === void 0) {
    hasDocumentToMatchFace = false;
  }
  return hasDocumentToMatchFace ? "/v4/customer/match-id-face" : "/v4/customer/live-check";
}
function apiHeaders(sessionId, sendBase64DocumentsInSwaggerProxy) {
  if (sendBase64DocumentsInSwaggerProxy === void 0) {
    sendBase64DocumentsInSwaggerProxy = false;
  }
  var headers = {
    'Content-Type': 'application/json',
    'X-Send-Base64-Documents': sendBase64DocumentsInSwaggerProxy ? '1' : '0',
    Origin: '*'
  };
  if (sessionId) {
    headers['X-Session-Id'] = sessionId;
  }
  return headers;
}
function attachMetadataToRequest(request, _a) {
  var _b, _c;
  var selfieCaptureAttempts = _a.selfieCaptureAttempts,
    idFrontCaptureAttempts = _a.idFrontCaptureAttempts,
    idBackCaptureAttempts = _a.idBackCaptureAttempts,
    geolocationResult = _a.geolocationResult;
  var metadata = {
    selfie: selfieCaptureAttempts,
    front: idFrontCaptureAttempts,
    back: idBackCaptureAttempts,
    isRealIDCheckRequired: 'false',
    sdkVersion: "WebSDK_".concat(webSdkVersion),
    Resolution: typeof window !== 'undefined' ? "".concat(window.innerWidth, " x ").concat(window.innerHeight) : 'unknown'
  };
  var platform = getPlatform();
  if (platform) {
    metadata.os = (_b = platform.os) === null || _b === void 0 ? void 0 : _b.family;
    metadata.osVersion = (_c = platform.os) === null || _c === void 0 ? void 0 : _c.version;
    metadata.browserVersion = "".concat(platform.name, " ").concat(platform.version);
  }
  if (geolocationResult) {
    metadata.GeoLocation = JSON.stringify(geolocationResult);
  }
  request.additionalData.metadata = JSON.stringify(metadata);
}
function videoDataUrlToB64(url) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.onloadend = function () {
      resolve(dataUrlToBase64Sync(reader.result));
    };
    fetch(url).then(function (resp) {
      return resp.blob();
    }).then(function (blob) {
      return reader.readAsDataURL(blob);
    });
  });
}

var PageContainerDiv = styled.div(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  &.flex {\n    display: flex;\n  }\n\n  &.padded {\n    box-sizing: border-box;\n    padding: 16px 24px;\n  }\n"], ["\n  ", "\n\n  ", "\n\n  &.flex {\n    display: flex;\n  }\n\n  &.padded {\n    box-sizing: border-box;\n    padding: 16px 24px;\n  }\n"])), function (props) {
  var _a;
  return props.theme.isFullscreen === false ? "" : "\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: var(--app-width);\n    height: calc(\n      var(--app-height) - ".concat((_a = props.$heightOffset) !== null && _a !== void 0 ? _a : 0, "px\n    );\n    overflow-x: hidden;\n    overflow-y: auto;\n  ");
}, function (props) {
  return props.theme.fontFamily ? "font-family: ".concat(props.theme.fontFamily, ";") : "";
});
var PageContainer = /*#__PURE__*/forwardRef(function (_a, ref) {
  var children = _a.children,
    className = _a.className,
    _b = _a.heightOffset,
    heightOffset = _b === void 0 ? 0 : _b,
    style = _a.style,
    onClick = _a.onClick;
  var _c = useState(false),
    dimensionsCalculated = _c[0],
    setDimensionsCalculated = _c[1];
  useEffect(function () {
    if (typeof window === 'undefined') return;
    setDimensionsCalculated(false);
    var calcAppDimensions = function calcAppDimensions() {
      var doc = document.documentElement;
      doc.style.setProperty('--app-width', "".concat(window.innerWidth, "px"));
      doc.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
    };
    window.addEventListener('resize', calcAppDimensions);
    calcAppDimensions();
    setDimensionsCalculated(true);
    return function () {
      window.removeEventListener('resize', calcAppDimensions);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(PageContainerDiv, {
    ref: ref,
    style: style,
    onClick: onClick,
    className: className,
    "$heightOffset": heightOffset
  }, dimensionsCalculated && children);
});
PageContainer.displayName = 'PageContainer';
var templateObject_1$L;

var LoaderButton = function LoaderButton(_a) {
  var children = _a.children,
    className = _a.className,
    _b = _a.colors,
    colors = _b === void 0 ? {} : _b,
    disabled = _a.disabled,
    finished = _a.finished,
    onClick = _a.onClick,
    style = _a.style,
    _c = _a.variant,
    variant = _c === void 0 ? 'primary' : _c;
  var buttonRef = useRef(null);
  var laddaRef = useRef(null);
  var _d = useState(false),
    laddaLoaded = _d[0],
    setLaddaLoaded = _d[1];
  useEffect(function () {
    if (laddaLoaded || finished) return;
    var interval;
    import('ladda').then(function (Ladda) {
      if (!buttonRef.current) return;
      laddaRef.current = Ladda.create(buttonRef.current);
      laddaRef.current.start();
      setLaddaLoaded(true);
      var currentProgress = 0;
      interval = setInterval(function () {
        var _a;
        if (currentProgress < 0.9) currentProgress += 0.1;
        (_a = laddaRef.current) === null || _a === void 0 ? void 0 : _a.setProgress(currentProgress);
      }, 250);
    });
    return function () {
      var _a;
      (_a = laddaRef.current) === null || _a === void 0 ? void 0 : _a.remove();
      clearInterval(interval);
    };
  }, [finished, laddaLoaded]);
  useEffect(function () {
    var _a;
    if (laddaLoaded && finished) (_a = laddaRef.current) === null || _a === void 0 ? void 0 : _a.stop();
  }, [finished, laddaLoaded]);
  return /*#__PURE__*/React__default.createElement(StyledButton, {
    className: "ladda-button ".concat(className, " ").concat(disabled ? 'disabled' : ''),
    "data-style": "expand-right",
    disabled: disabled,
    ref: buttonRef,
    onClick: onClick,
    "$backgroundColor": colors.backgroundColor,
    "$textColor": colors.textColor,
    "$disabledBackgroundColor": colors.loadingBackgroundColor,
    "$disabledTextColor": colors.loadingTextColor,
    "$variant": variant,
    style: style
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "ladda-label"
  }, children));
};
var StyledButton = styled.button(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n  ", "\n\n  /*!\n * Ladda\n * http://lab.hakim.se/ladda\n * MIT licensed\n *\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\n */\n\n  position: relative;\n\n  .ladda-spinner {\n    position: absolute;\n    z-index: 2;\n    display: inline-block;\n    width: 32px;\n    top: 50%;\n    margin-top: 0;\n    opacity: 0;\n    pointer-events: none;\n  }\n  .ladda-label {\n    position: relative;\n    z-index: 3;\n  }\n  .ladda-progress {\n    position: absolute;\n    width: 0;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background: rgba(0, 0, 0, 0.2);\n    display: none;\n    transition: 0.1s linear all !important;\n  }\n  &[data-loading] .ladda-progress {\n    display: block;\n  }\n\n  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n\n  .ladda-spinner,\n  .ladda-label {\n    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n  }\n  &[data-style='zoom-in'],\n  &[data-style='zoom-in'] .ladda-spinner,\n  &[data-style='zoom-in'] .ladda-label,\n  &[data-style='zoom-out'],\n  &[data-style='zoom-out'] .ladda-spinner,\n  &[data-style='zoom-out'] .ladda-label {\n    transition: 0.3s ease all !important;\n  }\n  &[data-style='expand-right'] .ladda-spinner {\n    right: -6px;\n  }\n  &[data-style='expand-right'][data-size='s'] .ladda-spinner,\n  &[data-style='expand-right'][data-size='xs'] .ladda-spinner {\n    right: -12px;\n  }\n  &[data-style='expand-right'][data-loading] {\n    padding-right: 56px;\n  }\n  &[data-style='expand-right'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='expand-right'][data-loading][data-size='s'],\n  &[data-style='expand-right'][data-loading][data-size='xs'] {\n    padding-right: 40px;\n  }\n  &[data-style='expand-left'] .ladda-spinner {\n    left: 26px;\n  }\n  &[data-style='expand-left'][data-size='s'] .ladda-spinner,\n  &[data-style='expand-left'][data-size='xs'] .ladda-spinner {\n    left: 4px;\n  }\n  &[data-style='expand-left'][data-loading] {\n    padding-left: 56px;\n  }\n  &[data-style='expand-left'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='expand-left'][data-loading][data-size='s'],\n  &[data-style='expand-left'][data-loading][data-size='xs'] {\n    padding-left: 40px;\n  }\n  &[data-style='expand-up'] {\n    overflow: hidden;\n  }\n  &[data-style='expand-up'] .ladda-spinner {\n    top: -32px;\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='expand-up'][data-loading] {\n    padding-top: 54px;\n  }\n  &[data-style='expand-up'][data-loading] .ladda-spinner {\n    opacity: 1;\n    top: 26px;\n    margin-top: 0;\n  }\n  &[data-style='expand-up'][data-loading][data-size='s'],\n  &[data-style='expand-up'][data-loading][data-size='xs'] {\n    padding-top: 32px;\n  }\n  &[data-style='expand-up'][data-loading][data-size='s'] .ladda-spinner,\n  &[data-style='expand-up'][data-loading][data-size='xs'] .ladda-spinner {\n    top: 4px;\n  }\n  &[data-style='expand-down'] {\n    overflow: hidden;\n  }\n  &[data-style='expand-down'] .ladda-spinner {\n    top: 62px;\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='expand-down'][data-size='s'] .ladda-spinner,\n  &[data-style='expand-down'][data-size='xs'] .ladda-spinner {\n    top: 40px;\n  }\n  &[data-style='expand-down'][data-loading] {\n    padding-bottom: 54px;\n  }\n  &[data-style='expand-down'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='expand-down'][data-loading][data-size='s'],\n  &[data-style='expand-down'][data-loading][data-size='xs'] {\n    padding-bottom: 32px;\n  }\n  &[data-style='slide-left'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-left'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-left'] .ladda-spinner {\n    left: 100%;\n    margin-left: 0;\n  }\n  &[data-style='slide-left'][data-loading] .ladda-label {\n    opacity: 0;\n    left: -100%;\n  }\n  &[data-style='slide-left'][data-loading] .ladda-spinner {\n    opacity: 1;\n    left: 50%;\n  }\n  &[data-style='slide-right'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-right'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-right'] .ladda-spinner {\n    right: 100%;\n    margin-left: 0;\n    left: 16px;\n  }\n  [dir='rtl'] &[data-style='slide-right'] .ladda-spinner {\n    right: auto;\n  }\n  &[data-style='slide-right'][data-loading] .ladda-label {\n    opacity: 0;\n    left: 100%;\n  }\n  &[data-style='slide-right'][data-loading] .ladda-spinner {\n    opacity: 1;\n    left: 50%;\n  }\n  &[data-style='slide-up'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-up'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-up'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: 1em;\n  }\n  &[data-style='slide-up'][data-loading] .ladda-label {\n    opacity: 0;\n    top: -1em;\n  }\n  &[data-style='slide-up'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-top: 0;\n  }\n  &[data-style='slide-down'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-down'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-down'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: -2em;\n  }\n  &[data-style='slide-down'][data-loading] .ladda-label {\n    opacity: 0;\n    top: 1em;\n  }\n  &[data-style='slide-down'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-top: 0;\n  }\n  &[data-style='zoom-out'] {\n    overflow: hidden;\n  }\n  &[data-style='zoom-out'] .ladda-spinner {\n    left: 50%;\n    margin-left: 32px;\n    transform: scale(2.5);\n  }\n  &[data-style='zoom-out'] .ladda-label {\n    position: relative;\n    display: inline-block;\n  }\n  &[data-style='zoom-out'][data-loading] .ladda-label {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  &[data-style='zoom-out'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-left: 0;\n    transform: none;\n  }\n  &[data-style='zoom-in'] {\n    overflow: hidden;\n  }\n  &[data-style='zoom-in'] .ladda-spinner {\n    left: 50%;\n    margin-left: -16px;\n    transform: scale(0.2);\n  }\n  &[data-style='zoom-in'] .ladda-label {\n    position: relative;\n    display: inline-block;\n  }\n  &[data-style='zoom-in'][data-loading] .ladda-label {\n    opacity: 0;\n    transform: scale(2.2);\n  }\n  &[data-style='zoom-in'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-left: 0;\n    transform: none;\n  }\n  &[data-style='contract'] {\n    overflow: hidden;\n    width: 100px;\n  }\n  &[data-style='contract'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='contract'][data-loading] {\n    border-radius: 50%;\n    width: 52px;\n  }\n  &[data-style='contract'][data-loading] .ladda-label {\n    opacity: 0;\n  }\n  &[data-style='contract'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='contract-overlay'] {\n    overflow: hidden;\n    width: 100px;\n    box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);\n  }\n  &[data-style='contract-overlay'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='contract-overlay'][data-loading] {\n    border-radius: 50%;\n    width: 52px;\n    box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);\n  }\n  &[data-style='contract-overlay'][data-loading] .ladda-label {\n    opacity: 0;\n  }\n  &[data-style='contract-overlay'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  [dir='rtl'] .ladda-spinner > div {\n    left: 25% !important;\n  }\n"], ["\n  ", "\n\n  /*!\n * Ladda\n * http://lab.hakim.se/ladda\n * MIT licensed\n *\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\n */\n\n  position: relative;\n\n  .ladda-spinner {\n    position: absolute;\n    z-index: 2;\n    display: inline-block;\n    width: 32px;\n    top: 50%;\n    margin-top: 0;\n    opacity: 0;\n    pointer-events: none;\n  }\n  .ladda-label {\n    position: relative;\n    z-index: 3;\n  }\n  .ladda-progress {\n    position: absolute;\n    width: 0;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background: rgba(0, 0, 0, 0.2);\n    display: none;\n    transition: 0.1s linear all !important;\n  }\n  &[data-loading] .ladda-progress {\n    display: block;\n  }\n\n  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n\n  .ladda-spinner,\n  .ladda-label {\n    transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n  }\n  &[data-style='zoom-in'],\n  &[data-style='zoom-in'] .ladda-spinner,\n  &[data-style='zoom-in'] .ladda-label,\n  &[data-style='zoom-out'],\n  &[data-style='zoom-out'] .ladda-spinner,\n  &[data-style='zoom-out'] .ladda-label {\n    transition: 0.3s ease all !important;\n  }\n  &[data-style='expand-right'] .ladda-spinner {\n    right: -6px;\n  }\n  &[data-style='expand-right'][data-size='s'] .ladda-spinner,\n  &[data-style='expand-right'][data-size='xs'] .ladda-spinner {\n    right: -12px;\n  }\n  &[data-style='expand-right'][data-loading] {\n    padding-right: 56px;\n  }\n  &[data-style='expand-right'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='expand-right'][data-loading][data-size='s'],\n  &[data-style='expand-right'][data-loading][data-size='xs'] {\n    padding-right: 40px;\n  }\n  &[data-style='expand-left'] .ladda-spinner {\n    left: 26px;\n  }\n  &[data-style='expand-left'][data-size='s'] .ladda-spinner,\n  &[data-style='expand-left'][data-size='xs'] .ladda-spinner {\n    left: 4px;\n  }\n  &[data-style='expand-left'][data-loading] {\n    padding-left: 56px;\n  }\n  &[data-style='expand-left'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='expand-left'][data-loading][data-size='s'],\n  &[data-style='expand-left'][data-loading][data-size='xs'] {\n    padding-left: 40px;\n  }\n  &[data-style='expand-up'] {\n    overflow: hidden;\n  }\n  &[data-style='expand-up'] .ladda-spinner {\n    top: -32px;\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='expand-up'][data-loading] {\n    padding-top: 54px;\n  }\n  &[data-style='expand-up'][data-loading] .ladda-spinner {\n    opacity: 1;\n    top: 26px;\n    margin-top: 0;\n  }\n  &[data-style='expand-up'][data-loading][data-size='s'],\n  &[data-style='expand-up'][data-loading][data-size='xs'] {\n    padding-top: 32px;\n  }\n  &[data-style='expand-up'][data-loading][data-size='s'] .ladda-spinner,\n  &[data-style='expand-up'][data-loading][data-size='xs'] .ladda-spinner {\n    top: 4px;\n  }\n  &[data-style='expand-down'] {\n    overflow: hidden;\n  }\n  &[data-style='expand-down'] .ladda-spinner {\n    top: 62px;\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='expand-down'][data-size='s'] .ladda-spinner,\n  &[data-style='expand-down'][data-size='xs'] .ladda-spinner {\n    top: 40px;\n  }\n  &[data-style='expand-down'][data-loading] {\n    padding-bottom: 54px;\n  }\n  &[data-style='expand-down'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='expand-down'][data-loading][data-size='s'],\n  &[data-style='expand-down'][data-loading][data-size='xs'] {\n    padding-bottom: 32px;\n  }\n  &[data-style='slide-left'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-left'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-left'] .ladda-spinner {\n    left: 100%;\n    margin-left: 0;\n  }\n  &[data-style='slide-left'][data-loading] .ladda-label {\n    opacity: 0;\n    left: -100%;\n  }\n  &[data-style='slide-left'][data-loading] .ladda-spinner {\n    opacity: 1;\n    left: 50%;\n  }\n  &[data-style='slide-right'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-right'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-right'] .ladda-spinner {\n    right: 100%;\n    margin-left: 0;\n    left: 16px;\n  }\n  [dir='rtl'] &[data-style='slide-right'] .ladda-spinner {\n    right: auto;\n  }\n  &[data-style='slide-right'][data-loading] .ladda-label {\n    opacity: 0;\n    left: 100%;\n  }\n  &[data-style='slide-right'][data-loading] .ladda-spinner {\n    opacity: 1;\n    left: 50%;\n  }\n  &[data-style='slide-up'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-up'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-up'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: 1em;\n  }\n  &[data-style='slide-up'][data-loading] .ladda-label {\n    opacity: 0;\n    top: -1em;\n  }\n  &[data-style='slide-up'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-top: 0;\n  }\n  &[data-style='slide-down'] {\n    overflow: hidden;\n  }\n  &[data-style='slide-down'] .ladda-label {\n    position: relative;\n  }\n  &[data-style='slide-down'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: -2em;\n  }\n  &[data-style='slide-down'][data-loading] .ladda-label {\n    opacity: 0;\n    top: 1em;\n  }\n  &[data-style='slide-down'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-top: 0;\n  }\n  &[data-style='zoom-out'] {\n    overflow: hidden;\n  }\n  &[data-style='zoom-out'] .ladda-spinner {\n    left: 50%;\n    margin-left: 32px;\n    transform: scale(2.5);\n  }\n  &[data-style='zoom-out'] .ladda-label {\n    position: relative;\n    display: inline-block;\n  }\n  &[data-style='zoom-out'][data-loading] .ladda-label {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  &[data-style='zoom-out'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-left: 0;\n    transform: none;\n  }\n  &[data-style='zoom-in'] {\n    overflow: hidden;\n  }\n  &[data-style='zoom-in'] .ladda-spinner {\n    left: 50%;\n    margin-left: -16px;\n    transform: scale(0.2);\n  }\n  &[data-style='zoom-in'] .ladda-label {\n    position: relative;\n    display: inline-block;\n  }\n  &[data-style='zoom-in'][data-loading] .ladda-label {\n    opacity: 0;\n    transform: scale(2.2);\n  }\n  &[data-style='zoom-in'][data-loading] .ladda-spinner {\n    opacity: 1;\n    margin-left: 0;\n    transform: none;\n  }\n  &[data-style='contract'] {\n    overflow: hidden;\n    width: 100px;\n  }\n  &[data-style='contract'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='contract'][data-loading] {\n    border-radius: 50%;\n    width: 52px;\n  }\n  &[data-style='contract'][data-loading] .ladda-label {\n    opacity: 0;\n  }\n  &[data-style='contract'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  &[data-style='contract-overlay'] {\n    overflow: hidden;\n    width: 100px;\n    box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);\n  }\n  &[data-style='contract-overlay'] .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n  }\n  &[data-style='contract-overlay'][data-loading] {\n    border-radius: 50%;\n    width: 52px;\n    box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);\n  }\n  &[data-style='contract-overlay'][data-loading] .ladda-label {\n    opacity: 0;\n  }\n  &[data-style='contract-overlay'][data-loading] .ladda-spinner {\n    opacity: 1;\n  }\n  [dir='rtl'] .ladda-spinner > div {\n    left: 25% !important;\n  }\n"])), function (props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
  return ((_a = props.theme.buttons) === null || _a === void 0 ? void 0 : _a.style) === 'bootstrap' && "\n    border-radius: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n    text-transform: none;\n    -webkit-appearance: button;\n  \n    &:not(:disabled),\n    &[type='button']:not(:disabled),\n    &[type='reset']:not(:disabled),\n    &[type='submit']:not(:disabled) {\n      cursor: pointer;\n    }\n  \n    &:focus:not(:focus-visible) {\n      outline: 0;\n    }\n  \n    --bs-btn-padding-x: 0.75rem;\n    --bs-btn-padding-y: 0.375rem;\n    --bs-btn-font-family: ;\n    --bs-btn-font-size: 1rem;\n    --bs-btn-font-weight: 400;\n    --bs-btn-line-height: 1.5;\n    --bs-btn-color: var(--bs-body-color);\n    --bs-btn-bg: transparent;\n    --bs-btn-border-width: var(--bs-border-width);\n    --bs-btn-border-color: transparent;\n    --bs-btn-border-radius: var(--bs-border-radius);\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),\n      0 1px 1px rgba(0, 0, 0, 0.075);\n    --bs-btn-disabled-opacity: 0.65;\n    --bs-btn-focus-box-shadow: 0 0 0 0.25rem\n      rgba(var(--bs-btn-focus-shadow-rgb), 0.5);\n    display: inline-block;\n    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n    font-family: var(--bs-btn-font-family);\n    font-size: var(--bs-btn-font-size);\n    font-weight: var(--bs-btn-font-weight);\n    line-height: var(--bs-btn-line-height);\n    color: var(--bs-btn-color);\n    text-align: center;\n    text-decoration: none;\n    vertical-align: middle;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n    border-radius: var(--bs-btn-border-radius);\n    background-color: var(--bs-btn-bg);\n    //transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    //  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  \n    @media (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  \n    &:hover {\n      filter: brightness(1.15);\n    }\n  \n    &:focus-visible {\n      color: var(--bs-btn-hover-color);\n      background-color: var(--bs-btn-hover-bg);\n      border-color: var(--bs-btn-hover-border-color);\n      outline: 0;\n      box-shadow: var(--bs-btn-focus-box-shadow);\n    }\n  \n    &:disabled,\n    &.disabled,\n    fieldset:disabled & {\n      color: var(--bs-btn-disabled-color);\n      pointer-events: none;\n      background-color: var(--bs-btn-disabled-bg);\n      border-color: var(--bs-btn-disabled-border-color);\n      opacity: var(--bs-btn-disabled-opacity);\n    }\n  \n    --bs-btn-color: ".concat((_f = (_b = props.$textColor) !== null && _b !== void 0 ? _b : (_e = (_c = props.theme.buttons) === null || _c === void 0 ? void 0 : _c[(_d = props.$variant) !== null && _d !== void 0 ? _d : 'primary']) === null || _e === void 0 ? void 0 : _e.textColor) !== null && _f !== void 0 ? _f : '#fff', ";\n    --bs-btn-bg: ").concat((_l = (_g = props.$backgroundColor) !== null && _g !== void 0 ? _g : (_k = (_h = props.theme.buttons) === null || _h === void 0 ? void 0 : _h[(_j = props.$variant) !== null && _j !== void 0 ? _j : 'primary']) === null || _k === void 0 ? void 0 : _k.backgroundColor) !== null && _l !== void 0 ? _l : '#0d6efd', ";\n    --bs-btn-border-color: var(--bs-btn-bg);\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #0a58ca;\n    --bs-btn-active-border-color: #0a53be;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: ").concat((_q = (_m = props.$disabledTextColor) !== null && _m !== void 0 ? _m : (_p = (_o = props.theme.buttons) === null || _o === void 0 ? void 0 : _o.loading) === null || _p === void 0 ? void 0 : _p.textColor) !== null && _q !== void 0 ? _q : '#fff', ";\n    --bs-btn-disabled-bg: ").concat((_u = (_r = props.$disabledBackgroundColor) !== null && _r !== void 0 ? _r : (_t = (_s = props.theme.buttons) === null || _s === void 0 ? void 0 : _s.loading) === null || _t === void 0 ? void 0 : _t.backgroundColor) !== null && _u !== void 0 ? _u : 'gray', ";\n    --bs-btn-disabled-border-color: ").concat((_v = props.$disabledBackgroundColor) !== null && _v !== void 0 ? _v : '#0d6efd', ";\n  \n    --bs-btn-padding-y: 14px;\n    --bs-btn-padding-x: 1rem;\n    --bs-btn-font-size: 18px;\n    --bs-btn-border-radius: 4px;\n  ");
});
var templateObject_1$K;

var OverlayContainer = styled(PageContainer)(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  background: ", ";\n  ", "\n  z-index: 10000;\n"], ["\n  background: ", ";\n  ", "\n  z-index: 10000;\n"])), function (props) {
  return props.theme.background ? "".concat(props.theme.background) : "white";
}, function (props) {
  return props.theme.textColor ? "color: ".concat(props.theme.textColor, ";") : "";
});
var OverlayInner$2 = styled.div(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  text-align: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  max-width: 100dvw;\n  max-height: 100dvh;\n  width: 100%;\n  height: 100%;\n  ", "\n"], ["\n  text-align: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  max-width: 100dvw;\n  max-height: 100dvh;\n  width: 100%;\n  height: 100%;\n  ", "\n"])), function (props) {
  var _a;
  return (_a = props.theme.textAlign) !== null && _a !== void 0 ? _a : 'center';
}, function (props) {
  return props.theme.padding ? "box-sizing: border-box; padding: ".concat(props.theme.padding, ";") : "";
});
var OverlayImageContainer = styled.div(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-grow: 1;\n  padding-bottom: 25px;\n  max-width: 100dvw;\n  max-height: 100dvh;\n  overflow: hidden;\n\n  & > img,\n  & > svg {\n    margin: 0 auto;\n    width: max-content;\n    max-width: 100%;\n    max-height: 100%;\n    aspect-ratio: initial;\n    object-fit: contain;\n    display: block;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-grow: 1;\n  padding-bottom: 25px;\n  max-width: 100dvw;\n  max-height: 100dvh;\n  overflow: hidden;\n\n  & > img,\n  & > svg {\n    margin: 0 auto;\n    width: max-content;\n    max-width: 100%;\n    max-height: 100%;\n    aspect-ratio: initial;\n    object-fit: contain;\n    display: block;\n  }\n"])));
var OverlayImageRow = styled.div(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n  display: flex;\n  margin: auto;\n\n  & > div {\n    max-height: calc(100vh - 320px);\n\n    & > img {\n      width: 100%;\n      max-height: 100%;\n      height: auto;\n      object-fit: contain;\n    }\n  }\n"], ["\n  display: flex;\n  margin: auto;\n\n  & > div {\n    max-height: calc(100vh - 320px);\n\n    & > img {\n      width: 100%;\n      max-height: 100%;\n      height: auto;\n      object-fit: contain;\n    }\n  }\n"])));
var GrayOverlayContainer = styled(OverlayContainer)(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  background: #f7f6fb;\n"], ["\n  background: #f7f6fb;\n"])));
var ButtonsColumn = styled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 15px 0;\n  justify-content: center;\n  margin-top: 24px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 15px 0;\n  justify-content: center;\n  margin-top: 24px;\n"])));
var WideButton = styled(LoaderButton)(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  width: 100%;\n  border-radius: 30px;\n"], ["\n  width: 100%;\n  border-radius: 30px;\n"])));
var WideBorderButton = styled(WideButton)(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n  box-sizing: border-box;\n"], ["\n  color: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n  box-sizing: border-box;\n"])), function (props) {
  var _a, _b;
  return (_b = (_a = props.colors) === null || _a === void 0 ? void 0 : _a.textColor) !== null && _b !== void 0 ? _b : 'black';
}, function (props) {
  var _a, _b;
  return (_b = (_a = props.colors) === null || _a === void 0 ? void 0 : _a.backgroundColor) !== null && _b !== void 0 ? _b : 'white';
}, function (props) {
  var _a, _b;
  return (_b = (_a = props.colors) === null || _a === void 0 ? void 0 : _a.borderColor) !== null && _b !== void 0 ? _b : 'var(--idm-color-secondary-500)';
});
var templateObject_1$J, templateObject_2$A, templateObject_3$r, templateObject_4$l, templateObject_5$c, templateObject_6$9, templateObject_7$6, templateObject_8$3;

var GeolocationAccessDeniedOverlay = function GeolocationAccessDeniedOverlay(_a) {
  var accessBlockedImageUrl = _a.accessBlockedImageUrl;
  var t = useTranslation().t;
  var retryLocationAccess = useContext(SubmissionContext).retryLocationAccess;
  return /*#__PURE__*/React__default.createElement(OverlayContainer, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      height: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    style: {
      maxWidth: 500,
      height: 'auto',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(OverlayImageContainer, {
    style: {
      flexGrow: 0
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: accessBlockedImageUrl,
    alt: ''
  })), /*#__PURE__*/React__default.createElement("h3", null, t('Your location access is disabled')), /*#__PURE__*/React__default.createElement("p", {
    style: {
      lineHeight: 1.5,
      marginBottom: 50
    }
  }, t('This application requires access to your location to continue. ' + 'Please accept the permission once prompted by the browser. ' + 'If the browser does not prompt for location permissions, you must go to settings ' + 'and provide location access to the current browser.')), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "primary",
    onClick: retryLocationAccess,
    style: {
      width: 200,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    finished: true
  }, t('Retry')))));
};

var SubmissionError = /** @class */function (_super) {
  __extends(SubmissionError, _super);
  function SubmissionError(status) {
    var _this = _super.call(this, status.statusMessage) || this;
    _this.status = status;
    return _this;
  }
  return SubmissionError;
}(Error);
var NetworkError = /** @class */function (_super) {
  __extends(NetworkError, _super);
  function NetworkError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return NetworkError;
}(Error);
var SessionValidationFailedError = /** @class */function (_super) {
  __extends(SessionValidationFailedError, _super);
  function SessionValidationFailedError(err, host) {
    var _this = _super.call(this, err.message) || this;
    _this.err = err;
    _this.host = host;
    return _this;
  }
  return SessionValidationFailedError;
}(Error);

var SubmissionErrorOverlay = function SubmissionErrorOverlay(_a) {
  var error = _a.error,
    onRetry = _a.onRetry;
  return /*#__PURE__*/React__default.createElement(OverlayContainer, null, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    style: {
      justifyContent: 'center'
    }
  }, error instanceof NetworkError ? ( /*#__PURE__*/React__default.createElement(NetworkErrorContent, {
    error: error,
    onRetry: onRetry
  })) : ( /*#__PURE__*/React__default.createElement(SubmissionErrorContent, {
    error: error
  }))));
};
var SubmissionErrorContent = function SubmissionErrorContent(_a) {
  var error = _a.error;
  var t = useTranslation().t;
  var headingText = t("We're sorry, an unexpected error has occurred.");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      marginBottom: 8
    }
  }, headingText), error.status.statusCode && ( /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React__default.createElement("code", null, "Status: ", error.status.statusCode))), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Message: ", /*#__PURE__*/React__default.createElement("code", null, error.message)), error.status.errorData && ( /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Data: ", /*#__PURE__*/React__default.createElement("code", null, error.status.errorData))));
};
var NetworkErrorContent = function NetworkErrorContent(_a) {
  var onRetry = _a.onRetry;
  var t = useTranslation().t;
  var headingText = t('Network unreachable');
  var messageText = t("We're having trouble reaching our services, please check your connection and try again.");
  var retryText = t('Retry');
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      marginBottom: 8
    }
  }, headingText), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, messageText), onRetry && ( /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    finished: true,
    onClick: onRetry
  }, retryText))));
};

var SessionIdMissingOverlay = function SessionIdMissingOverlay() {
  return /*#__PURE__*/React__default.createElement(OverlayContainer, null, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      marginBottom: 8
    }
  }, "IDmission WebSDK failed to load"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Required property ", /*#__PURE__*/React__default.createElement("code", null, "sessionId"), " is missing."), /*#__PURE__*/React__default.createElement("p", {
    style: {
      lineHeight: '1.5rem'
    }
  }, "Please refer to the", ' ', /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.npmjs.com/package/idmission-web-sdk#getting-started",
    target: "_blank",
    rel: "noreferrer"
  }, "Getting Started"), ' ', "section of the documentation for information on how to use your credentials to generate a valid session for your IDmission account. Every usage of the IDmission WebSDK must be authorized with a valid session from IDmission's servers.")));
};

var SessionValidationFailedOverlay = function SessionValidationFailedOverlay(_a) {
  var message = _a.message;
  return /*#__PURE__*/React__default.createElement(OverlayContainer, null, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      marginBottom: 8
    }
  }, "IDmission WebSDK failed to load"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Required property ", /*#__PURE__*/React__default.createElement("code", null, "sessionId"), " is not valid", message && " (".concat(message, ")"), "."), /*#__PURE__*/React__default.createElement("p", {
    style: {
      lineHeight: '1.5rem'
    }
  }, "Please refer to the", ' ', /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.npmjs.com/package/idmission-web-sdk#getting-started",
    target: "_blank",
    rel: "noreferrer"
  }, "Getting Started"), ' ', "section of the documentation for information on how to use your credentials to generate a valid session for your IDmission account. Every usage of the IDmission WebSDK must be authorized with a valid session from IDmission's servers.")));
};

var AuthUrlNotAllowedOverlay = function AuthUrlNotAllowedOverlay() {
  return /*#__PURE__*/React__default.createElement(OverlayContainer, null, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      marginBottom: 8
    }
  }, "IDmission WebSDK failed to load"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "Required property ", /*#__PURE__*/React__default.createElement("code", null, "authUrl"), " comes from an unrecognized issuer."), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0,
      lineHeight: '1.5rem'
    }
  }, "Ensure you are generating a fresh session for each request to the IDmission WebSDK."), /*#__PURE__*/React__default.createElement("p", {
    style: {
      lineHeight: '1.5rem'
    }
  }, "Please refer to the", ' ', /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.npmjs.com/package/idmission-web-sdk#getting-started",
    target: "_blank",
    rel: "noreferrer"
  }, "Getting Started"), ' ', "section of the documentation for information on how to use your credentials to generate a valid session for your IDmission account. Every usage of the IDmission WebSDK must be authorized with a valid session from IDmission's servers.")));
};

var SessionValidationErrorOverlay = function SessionValidationErrorOverlay(_a) {
  var error = _a.error,
    onRetry = _a.onRetry;
  var t = useTranslation().t;
  var retryText = t('Retry');
  return /*#__PURE__*/React__default.createElement(OverlayContainer, null, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      marginBottom: 8
    }
  }, "IDmission WebSDK failed to load"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, (error === null || error === void 0 ? void 0 : error.host) ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Failed to reach ", /*#__PURE__*/React__default.createElement("code", null, error.host), ".")) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Failed to validate ", /*#__PURE__*/React__default.createElement("code", null, "sessionId"), "."))), (error === null || error === void 0 ? void 0 : error.message) && ( /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0,
      lineHeight: '1.5rem'
    }
  }, /*#__PURE__*/React__default.createElement("code", null, error.message))), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginBottom: 0,
      lineHeight: '1.5rem'
    }
  }, "Please ensure that IDmission's servers can be reached. If you believe you have reached this page in error, please contact us at", ' ', /*#__PURE__*/React__default.createElement("a", {
    href: "mailto:support@idmission.com"
  }, "support@idmission.com"), "."), onRetry && ( /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    finished: true,
    onClick: onRetry
  }, retryText)))));
};

var wavesAnimation = keyframes(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n    0% {\n        opacity: 0;\n        transform: scale3d(1, 1, 1);\n    }\n    80% {\n        opacity: 1;\n    }\n    100% {\n        transform: scale3d(2, 2, 1);\n        opacity: 0;\n    }\n"], ["\n    0% {\n        opacity: 0;\n        transform: scale3d(1, 1, 1);\n    }\n    80% {\n        opacity: 1;\n    }\n    100% {\n        transform: scale3d(2, 2, 1);\n        opacity: 0;\n    }\n"])));
var progressBarAnimation = keyframes(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n    0% {\n        width: 0;\n    }\n    100% {\n        width: 100%;\n    }\n"], ["\n    0% {\n        width: 0;\n    }\n    100% {\n        width: 100%;\n    }\n"])));
var dualRingSpinnerAnimation = keyframes(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
var progressBorderAnimation = keyframes(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n    to {\n        stroke-dashoffset: 0;\n    }\n"], ["\n    to {\n        stroke-dashoffset: 0;\n    }\n"])));
var templateObject_1$I, templateObject_2$z, templateObject_3$q, templateObject_4$k;

var Spinner = styled.div(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  margin: auto;\n\n  &:after {\n    content: ' ';\n    display: block;\n    width: ", "px;\n    height: ", "px;\n    margin: 8px;\n    border-radius: 50%;\n    border: ", "px solid\n      ", ";\n    border-color: ", " transparent\n      ", " transparent;\n    animation: ", " 1.2s linear infinite;\n    box-sizing: content-box;\n  }\n"], ["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  margin: auto;\n\n  &:after {\n    content: ' ';\n    display: block;\n    width: ", "px;\n    height: ", "px;\n    margin: 8px;\n    border-radius: 50%;\n    border: ", "px solid\n      ", ";\n    border-color: ", " transparent\n      ", " transparent;\n    animation: ", " 1.2s linear infinite;\n    box-sizing: content-box;\n  }\n"])), function (_a) {
  var $size = _a.$size;
  return $size !== null && $size !== void 0 ? $size : 80;
}, function (_a) {
  var $size = _a.$size;
  return $size !== null && $size !== void 0 ? $size : 80;
}, function (_a) {
  var $size = _a.$size;
  return ($size !== null && $size !== void 0 ? $size : 80) - 16;
}, function (_a) {
  var $size = _a.$size;
  return ($size !== null && $size !== void 0 ? $size : 80) - 16;
}, function (_a) {
  var $thickness = _a.$thickness;
  return $thickness !== null && $thickness !== void 0 ? $thickness : 6;
}, function (_a) {
  var $color = _a.$color;
  return $color !== null && $color !== void 0 ? $color : '#888';
}, function (_a) {
  var $color = _a.$color;
  return $color !== null && $color !== void 0 ? $color : '#888';
}, function (_a) {
  var $color = _a.$color;
  return $color !== null && $color !== void 0 ? $color : '#888';
}, dualRingSpinnerAnimation);
var templateObject_1$H;

var defaultAuthUrl = 'https://portal-api.idmission.com';
var allowedAuthUrls = ['https://portal-api.idmission.com', 'https://portal-api-uat.idmission.com', 'https://portal-api-demo.idmission.com', 'https://portal-api-dev.idmission.com', 'http://localhost:10000'];
function setDefaultAuthUrl(url) {
  if (!allowedAuthUrls.includes(url)) throw new Error('invalid auth url');
  defaultAuthUrl = url;
}
var initialState$6 = {
  authUrl: defaultAuthUrl,
  sessionCheckState: 'READY'
};
var AuthStateContext = /*#__PURE__*/createContext(initialState$6);
var AuthDispatchContext = /*#__PURE__*/createContext(function () {});
var reducer$4 = function reducer(state, action) {
  switch (action.type) {
    case 'setSessionId':
      return _assign(_assign({}, state), {
        sessionId: action.payload
      });
    case 'setCheckState':
      return _assign(_assign({}, state), {
        sessionCheckState: action.payload
      });
    case 'setError':
      return _assign(_assign({}, state), {
        sessionCheckState: 'ERROR',
        authError: action.payload
      });
    case 'retry':
      return _assign(_assign({}, state), {
        sessionCheckState: 'READY',
        authError: undefined,
        sessionId: undefined
      });
    default:
      return state;
  }
};
function useAuthReducer(authUrl, sessionId) {
  var _this = this;
  if (authUrl === void 0) {
    authUrl = defaultAuthUrl;
  }
  var _a = useReducer(reducer$4, _assign(_assign({}, initialState$6), {
      authUrl: authUrl
    })),
    state = _a[0],
    dispatch = _a[1];
  var resolvedSessionId = state.sessionId,
    sessionCheckState = state.sessionCheckState;
  useEffect(function () {
    if (!allowedAuthUrls.includes(authUrl)) return dispatch({
      type: 'setCheckState',
      payload: 'AUTH_URL_NOT_ALLOWED'
    });
  }, [authUrl]);
  useEffect(function () {
    if (sessionCheckState !== 'READY') return;
    if (!resolvedSessionId) {
      if (!sessionId) return dispatch({
        type: 'setCheckState',
        payload: 'MISSING'
      });
      if (typeof sessionId === 'string') return dispatch({
        type: 'setSessionId',
        payload: sessionId
      });
      if (sessionId instanceof Function) {
        sessionId().then(function (sessionId) {
          dispatch({
            type: 'setSessionId',
            payload: sessionId
          });
        })["catch"](function (e) {
          dispatch({
            type: 'setError',
            payload: new SessionValidationFailedError(e, authUrl)
          });
        });
      }
    } else {
      dispatch({
        type: 'setCheckState',
        payload: 'RUNNING'
      });
      (function () {
        return __awaiter(_this, void 0, void 0, function () {
          var resp, _a, valid, message, e_1;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 3,, 4]);
                return [4 /*yield*/, fetch("".concat(authUrl, "/portal.sessions.v1.SessionsService/ValidateSession"), {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    id: resolvedSessionId
                  })
                })];
              case 1:
                resp = _b.sent();
                return [4 /*yield*/, resp.json()];
              case 2:
                _a = _b.sent(), valid = _a.valid, message = _a.message;
                if (!resp.ok) {
                  dispatch({
                    type: 'setError',
                    payload: new SessionValidationFailedError(new Error(message), authUrl)
                  });
                }
                dispatch({
                  type: 'setCheckState',
                  payload: valid ? 'PASSED' : 'FAILED'
                });
                return [3 /*break*/, 4];
              case 3:
                e_1 = _b.sent();
                dispatch({
                  type: 'setError',
                  payload: new SessionValidationFailedError(e_1, authUrl)
                });
                return [3 /*break*/, 4];
              case 4:
                return [2 /*return*/];
            }
          });
        });
      })();
    }
  }, [authUrl, sessionCheckState, resolvedSessionId, sessionId]);
  return [state, dispatch];
}
function useAuthContext() {
  var state = useContext(AuthStateContext);
  var dispatch = useContext(AuthDispatchContext);
  if (!state || !dispatch) throw new Error('useAuthContext cannot be used without AuthStateProvider');
  return [state, dispatch];
}
function AuthProvider(_a) {
  var _b;
  var _c = _a.authUrl,
    authUrl = _c === void 0 ? defaultAuthUrl : _c,
    sessionId = _a.sessionId,
    children = _a.children;
  var _d = useAuthReducer(authUrl, sessionId),
    state = _d[0],
    dispatch = _d[1];
  if (state.sessionCheckState === 'MISSING') {
    return /*#__PURE__*/React__default.createElement(SessionIdMissingOverlay, null);
  }
  if (state.sessionCheckState === 'FAILED') {
    return /*#__PURE__*/React__default.createElement(SessionValidationFailedOverlay, {
      message: (_b = state.authError) === null || _b === void 0 ? void 0 : _b.message
    });
  }
  if (state.sessionCheckState === 'AUTH_URL_NOT_ALLOWED') {
    return /*#__PURE__*/React__default.createElement(AuthUrlNotAllowedOverlay, null);
  }
  if (state.sessionCheckState === 'ERROR') {
    return /*#__PURE__*/React__default.createElement(SessionValidationErrorOverlay, {
      error: state.authError,
      onRetry: function onRetry() {
        return dispatch({
          type: 'retry'
        });
      }
    });
  }
  if (state.sessionCheckState === 'READY' || state.sessionCheckState === 'RUNNING') return /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex"
  }, /*#__PURE__*/React__default.createElement(Spinner, null));
  return /*#__PURE__*/React__default.createElement(AuthStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React__default.createElement(AuthDispatchContext.Provider, {
    value: dispatch
  }, children));
}

var LogLevel;
(function (LogLevel) {
  LogLevel[LogLevel["Off"] = 0] = "Off";
  LogLevel[LogLevel["Error"] = 1] = "Error";
  LogLevel[LogLevel["Warn"] = 2] = "Warn";
  LogLevel[LogLevel["Info"] = 3] = "Info";
  LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));
var logLevel = LogLevel.Warn;
function useLogLevel(newLogLevel) {
  useEffect(function () {
    var oldLogLevel = logLevel;
    if (newLogLevel === oldLogLevel) return;
    logLevel = newLogLevel;
    return function () {
      logLevel = oldLogLevel;
    };
  }, [newLogLevel]);
}
function useDebugLogging(enabled) {
  useLogLevel(enabled ? LogLevel.Debug : logLevel);
}
function debug() {
  var parts = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    parts[_i] = arguments[_i];
  }
  if (logLevel < LogLevel.Debug) return;
  console.debug.apply(console, parts); // eslint-disable-line no-console
}
function log() {
  var parts = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    parts[_i] = arguments[_i];
  }
  if (logLevel < LogLevel.Info) return;
  console.log.apply(console, parts); // eslint-disable-line no-console
}
function warn() {
  var parts = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    parts[_i] = arguments[_i];
  }
  if (logLevel < LogLevel.Warn) return;
  console.warn.apply(console, parts); // eslint-disable-line no-console
}
function error() {
  var parts = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    parts[_i] = arguments[_i];
  }
  if (logLevel < LogLevel.Error) return;
  console.error.apply(console, parts); // eslint-disable-line no-console
}

var defaultSubmissionUrl = 'https://portal-api.idmission.com/swagger';
function setDefaultSubmissionUrl(url) {
  defaultSubmissionUrl = url;
}
var defaultDocumentServiceUrl = 'https://portal-api.idmission.com/files/';
function setDefaultDocumentServiceUrl(url) {
  defaultDocumentServiceUrl = url;
}
function setServerUrl(url) {
  setDefaultAuthUrl(url);
  setDefaultSubmissionUrl(url + '/swagger');
  setDefaultDocumentServiceUrl(url + '/files/');
}
var SubmissionContext = /*#__PURE__*/createContext({
  submit: function submit() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, null];
      });
    });
  },
  submissionStatus: SubmissionStatus.READY,
  submissionRequest: null,
  submissionResponse: null,
  submissionError: null,
  submissionEnvironment: 'prod',
  idFrontImage: null,
  idBackImage: null,
  passportImage: null,
  selfieImage: null,
  signatureData: null,
  signatureVideoUrl: null,
  idCaptureVideoUrl: null,
  idCaptureVideoIdFrontImage: null,
  idCaptureVideoIdBackImage: null,
  idCaptureVideoAudioUrl: null,
  idCaptureVideoAudioStartsAt: null,
  additionalDocuments: null,
  setIdFrontImage: function setIdFrontImage() {
    return null;
  },
  setIdBackImage: function setIdBackImage() {
    return null;
  },
  setPassportImage: function setPassportImage() {
    return null;
  },
  setSelfieImage: function setSelfieImage() {
    return null;
  },
  setSignatureData: function setSignatureData() {
    return null;
  },
  setSignatureVideoUrl: function setSignatureVideoUrl() {
    return null;
  },
  setIdCaptureVideoUrl: function setIdCaptureVideoUrl() {
    return null;
  },
  setIdCaptureVideoIdFrontImage: function setIdCaptureVideoIdFrontImage() {
    return null;
  },
  setIdCaptureVideoIdBackImage: function setIdCaptureVideoIdBackImage() {
    return null;
  },
  setIdCaptureVideoAudioUrl: function setIdCaptureVideoAudioUrl() {
    return null;
  },
  setIdCaptureVideoAudioStartsAt: function setIdCaptureVideoAudioStartsAt() {
    return null;
  },
  setExpectedAudioText: function setExpectedAudioText() {
    return null;
  },
  setAdditionalDocuments: function setAdditionalDocuments() {
    return null;
  },
  uploadDocument: Promise.resolve,
  logIdFrontCaptureAttempt: function logIdFrontCaptureAttempt() {
    return null;
  },
  logIdBackCaptureAttempt: function logIdBackCaptureAttempt() {
    return null;
  },
  logSelfieCaptureAttempt: function logSelfieCaptureAttempt() {
    return null;
  },
  livenessCheckRequest: null,
  checkLiveness: function checkLiveness() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        throw new Error('checkLiveness is not implemented');
      });
    });
  },
  retryLocationAccess: function retryLocationAccess() {
    return null;
  }
});
var SubmissionProvider = function SubmissionProvider(_a) {
  var action = _a.action,
    children = _a.children,
    _b = _a.submissionUrl,
    submissionUrl = _b === void 0 ? defaultSubmissionUrl : _b,
    _c = _a.environment,
    environment = _c === void 0 ? 'prod' : _c,
    companyId = _a.companyId,
    enrollmentId = _a.enrollmentId,
    personalData = _a.personalData,
    cardData = _a.cardData,
    idData = _a.idData,
    _d = _a.bypassAgeValidation,
    bypassAgeValidation = _d === void 0 ? false : _d,
    _e = _a.bypassNameMatching,
    bypassNameMatching = _e === void 0 ? true : _e,
    _f = _a.needImmediateResponse,
    needImmediateResponse = _f === void 0 ? false : _f,
    _g = _a.manualReviewRequired,
    manualReviewRequired = _g === void 0 ? false : _g,
    _h = _a.idBackImageRequired,
    idBackImageRequired = _h === void 0 ? true : _h,
    _j = _a.idImageResolutionCheck,
    idImageResolutionCheck = _j === void 0 ? true : _j,
    _k = _a.verifyIdWithExternalDatabases,
    verifyIdWithExternalDatabases = _k === void 0 ? false : _k,
    _l = _a.deduplicationEnabled,
    deduplicationEnabled = _l === void 0 ? false : _l,
    _m = _a.deduplicationSynchronous,
    deduplicationSynchronous = _m === void 0 ? false : _m,
    idCardForFaceMatch = _a.idCardForFaceMatch,
    _o = _a.geolocationEnabled,
    geolocationEnabled = _o === void 0 ? true : _o,
    _p = _a.geolocationRequired,
    geolocationRequired = _p === void 0 ? false : _p,
    _q = _a.webhooksEnabled,
    webhooksEnabled = _q === void 0 ? false : _q,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    _r = _a.webhooksStripSpecialCharacters,
    webhooksStripSpecialCharacters = _r === void 0 ? true : _r,
    _s = _a.webhooksSendInputImages,
    webhooksSendInputImages = _s === void 0 ? false : _s,
    _t = _a.webhooksSendProcessedImages,
    webhooksSendProcessedImages = _t === void 0 ? false : _t,
    _u = _a.webhooksFireOnReview,
    webhooksFireOnReview = _u === void 0 ? false : _u,
    webhooksFireOnReviewURL = _a.webhooksFireOnReviewURL,
    customerDataMatchConfig = _a.customerDataMatchConfig,
    precapturedDocuments = _a.precapturedDocuments,
    _v = _a.documentServiceUrl,
    documentServiceUrl = _v === void 0 ? defaultDocumentServiceUrl : _v,
    _w = _a.sendBase64DocumentsInSwaggerProxy,
    sendBase64DocumentsInSwaggerProxy = _w === void 0 ? false : _w,
    userSuppliedOnSubmit = _a.onSubmit,
    userSuppliedOnBeforeSubmit = _a.onBeforeSubmit,
    userSuppliedOnBeforeLivenessCheck = _a.onBeforeLivenessCheck,
    userSuppliedOnBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    userSuppliedOnDocumentUploadProgress = _a.onDocumentUploadProgress,
    userSuppliedOnDocumentUploaded = _a.onDocumentUploaded,
    userSuppliedOnDocumentUploadFailed = _a.onDocumentUploadFailed,
    userSuppliedOnResponseReceived = _a.onResponseReceived,
    userSuppliedOnRequestFailure = _a.onRequestFailure,
    clientRequestID = _a.clientRequestID,
    _x = _a.useDocumentServiceForLivenessChecks,
    useDocumentServiceForLivenessChecks = _x === void 0 ? false : _x;
  var sessionId = useAuthContext()[0].sessionId;
  var _y = useState(SubmissionStatus.READY),
    submissionStatus = _y[0],
    setSubmissionStatus = _y[1];
  var _z = useState(null),
    submissionRequest = _z[0],
    setSubmissionRequest = _z[1];
  var _0 = useState(null),
    submissionResponse = _0[0],
    setSubmissionResponse = _0[1];
  var _1 = useState(null),
    submissionError = _1[0],
    setSubmissionError = _1[1];
  var _2 = useState(null),
    retrySubmission = _2[0],
    setRetrySubmission = _2[1];
  var _3 = useState(null),
    livenessCheckRequest = _3[0],
    setLivenessCheckRequest = _3[1];
  var _4 = useState(null),
    idFrontImage = _4[0],
    setIdFrontImage = _4[1];
  var _5 = useState(null),
    idBackImage = _5[0],
    setIdBackImage = _5[1];
  var _6 = useState(null),
    passportImage = _6[0],
    setPassportImage = _6[1];
  var _7 = useState(null),
    selfieImage = _7[0],
    setSelfieImage = _7[1];
  var _8 = useState(null),
    signatureData = _8[0],
    setSignatureData = _8[1];
  var _9 = useState(null),
    signatureVideoUrl = _9[0],
    setSignatureVideoUrl = _9[1];
  var _10 = useState(null),
    idCaptureVideoUrl = _10[0],
    setIdCaptureVideoUrl = _10[1];
  var _11 = useState(null),
    idCaptureVideoIdFrontImage = _11[0],
    setIdCaptureVideoIdFrontImage = _11[1];
  var _12 = useState(null),
    idCaptureVideoIdBackImage = _12[0],
    setIdCaptureVideoIdBackImage = _12[1];
  var _13 = useState(null),
    idCaptureVideoAudioUrl = _13[0],
    setIdCaptureVideoAudioUrl = _13[1];
  var _14 = useState(null),
    idCaptureVideoAudioStartsAt = _14[0],
    setIdCaptureVideoAudioStartsAt = _14[1];
  var _15 = useState(null),
    expectedAudioText = _15[0],
    setExpectedAudioText = _15[1];
  var _16 = useState(null),
    additionalDocuments = _16[0],
    setAdditionalDocuments = _16[1];
  var _17 = useState(null),
    geolocationResult = _17[0],
    setGeolocationResult = _17[1];
  var _18 = useState(0),
    geolocationAttempts = _18[0],
    setGeolocationAttempts = _18[1];
  var _19 = useState(false),
    geolocationBlocked = _19[0],
    setGeolocationBlocked = _19[1];
  var _20 = useState([]),
    idFrontCaptureAttempts = _20[0],
    setIdFrontCaptureAttempts = _20[1];
  var _21 = useState([]),
    idBackCaptureAttempts = _21[0],
    setIdBackCaptureAttempts = _21[1];
  var _22 = useState([]),
    selfieCaptureAttempts = _22[0],
    setSelfieCaptureAttempts = _22[1];
  var logIdFrontCaptureAttempt = useCallback(function (attempt) {
    setIdFrontCaptureAttempts(function (attempts) {
      return __spreadArray(__spreadArray([], attempts, true), [attempt], false);
    });
  }, []);
  var logIdBackCaptureAttempt = useCallback(function (attempt) {
    setIdBackCaptureAttempts(function (attempts) {
      return __spreadArray(__spreadArray([], attempts, true), [attempt], false);
    });
  }, []);
  var logSelfieCaptureAttempt = useCallback(function (attempt) {
    setSelfieCaptureAttempts(function (attempts) {
      return __spreadArray(__spreadArray([], attempts, true), [attempt], false);
    });
  }, []);
  useEffect(function () {
    if (precapturedDocuments === null || precapturedDocuments === void 0 ? void 0 : precapturedDocuments.selfie) {
      setSelfieImage(dataUrlToBase64Sync(precapturedDocuments.selfie.imageData));
    }
  }, [precapturedDocuments === null || precapturedDocuments === void 0 ? void 0 : precapturedDocuments.selfie]);
  var onSubmit = useRef();
  useEffect(function () {
    onSubmit.current = userSuppliedOnSubmit;
  }, [userSuppliedOnSubmit]);
  var onBeforeSubmit = useRef();
  useEffect(function () {
    onBeforeSubmit.current = userSuppliedOnBeforeSubmit;
  }, [userSuppliedOnBeforeSubmit]);
  var onBeforeLivenessCheck = useRef();
  useEffect(function () {
    onBeforeLivenessCheck.current = userSuppliedOnBeforeLivenessCheck;
  }, [userSuppliedOnBeforeLivenessCheck]);
  var onResponseReceived = useRef();
  useEffect(function () {
    onResponseReceived.current = userSuppliedOnResponseReceived;
  }, [userSuppliedOnResponseReceived]);
  var onRequestFailure = useRef();
  useEffect(function () {
    onRequestFailure.current = userSuppliedOnRequestFailure;
  }, [userSuppliedOnRequestFailure]);
  var onBeforeDocumentUpload = useRef();
  useEffect(function () {
    onBeforeDocumentUpload.current = userSuppliedOnBeforeDocumentUpload;
  }, [userSuppliedOnBeforeDocumentUpload]);
  var onDocumentUploadProgress = useRef();
  useEffect(function () {
    onDocumentUploadProgress.current = userSuppliedOnDocumentUploadProgress;
  }, [userSuppliedOnDocumentUploadProgress]);
  var onDocumentUploaded = useRef();
  useEffect(function () {
    onDocumentUploaded.current = userSuppliedOnDocumentUploaded;
  }, [userSuppliedOnDocumentUploaded]);
  var onDocumentUploadFailed = useRef();
  useEffect(function () {
    onDocumentUploadFailed.current = userSuppliedOnDocumentUploadFailed;
  }, [userSuppliedOnDocumentUploadFailed]);
  var uploadDocument = useCallback(function (src, metadata) {
    return __awaiter(void 0, void 0, void 0, function () {
      var blob, _a;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            blob = typeof src === 'string' ? convertBase64ToBlob(src) : src;
            _a = onBeforeDocumentUpload.current;
            if (!_a) return [3 /*break*/, 2];
            return [4 /*yield*/, (_b = onBeforeDocumentUpload.current) === null || _b === void 0 ? void 0 : _b.call(onBeforeDocumentUpload, blob, metadata)];
          case 1:
            _a = _c.sent() === false;
            _c.label = 2;
          case 2:
            if (_a) {
              return [2 /*return*/, blobToB64(blob)];
            }
            return [2 /*return*/, performUpload({
              blob: blob,
              endpoint: documentServiceUrl,
              sessionId: sessionId,
              metadata: metadata,
              onDocumentUploadProgress: onDocumentUploadProgress.current,
              onDocumentUploaded: onDocumentUploaded.current,
              onDocumentUploadFailed: onDocumentUploadFailed.current
            })];
        }
      });
    });
  }, [documentServiceUrl, sessionId]);
  var buildSubmissionPayload = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      function uploadIfPossible(src_1, filename_1) {
        return __awaiter(this, arguments, void 0, function (src, filename, filetype) {
          if (filetype === void 0) {
            filetype = 'image/jpeg';
          }
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!documentServiceUrl) return [2 /*return*/, src];
                if (!src.startsWith('data:')) src = "data:".concat(filetype, ";base64,").concat(src);
                return [4 /*yield*/, uploadDocument(src, {
                  filename: filename,
                  filetype: filetype
                })];
              case 1:
                return [2 /*return*/, _a.sent()];
            }
          });
        });
      }
      var documents, _a, _b, _c, submissionRequest, onBeforeSubmitResult;
      var _d;
      var _e, _f, _g, _h;
      return __generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            _d = {
              idFrontImage: idFrontImage,
              idBackImage: idBackImage,
              passportImage: passportImage,
              selfieImage: selfieImage
            };
            _a = signatureVideoUrl;
            if (!_a) return [3 /*break*/, 2];
            return [4 /*yield*/, videoDataUrlToB64(signatureVideoUrl)];
          case 1:
            _a = _j.sent();
            _j.label = 2;
          case 2:
            _d.signatureVideo = _a;
            _b = idCaptureVideoUrl;
            if (!_b) return [3 /*break*/, 4];
            return [4 /*yield*/, videoDataUrlToB64(idCaptureVideoUrl)];
          case 3:
            _b = _j.sent();
            _j.label = 4;
          case 4:
            _d.idCaptureVideo = _b;
            _c = idCaptureVideoAudioUrl;
            if (!_c) return [3 /*break*/, 6];
            return [4 /*yield*/, videoDataUrlToB64(idCaptureVideoAudioUrl)];
          case 5:
            _c = _j.sent();
            _j.label = 6;
          case 6:
            documents = (_d.idCaptureVideoAudio = _c, _d.idCaptureVideoIdFrontImage = idCaptureVideoIdFrontImage, _d.idCaptureVideoIdBackImage = idCaptureVideoIdBackImage, _d);
            if (signatureData) {
              documents.signatureImage = signatureData === null || signatureData === void 0 ? void 0 : signatureData.fileContent;
            }
            if (!documentServiceUrl) return [3 /*break*/, 8];
            return [4 /*yield*/, Promise.all(Object.keys(documents).map(function (k) {
              return __awaiter(void 0, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                  switch (_c.label) {
                    case 0:
                      if (!documents[k]) return [3 /*break*/, 2];
                      _a = documents;
                      _b = k;
                      return [4 /*yield*/, uploadIfPossible(documents[k], k)];
                    case 1:
                      _a[_b] = _c.sent();
                      _c.label = 2;
                    case 2:
                      return [2 /*return*/];
                  }
                });
              });
            }))];
          case 7:
            _j.sent();
            _j.label = 8;
          case 8:
            submissionRequest = {
              securityData: {
                userName: '',
                password: '',
                merchantId: 0
              },
              customerData: {
                idData: _assign({
                  idType: 'NSP',
                  idCountry: 'NSP',
                  idState: ''
                }, idData)
              },
              additionalData: {
                uniqueRequestId: new Date().getTime().toString(),
                manualReviewRequired: manualReviewRequired === 'forced' ? 'F' : manualReviewRequired ? 'Y' : 'N',
                bypassAgeValidation: bypassAgeValidation ? 'Y' : 'N',
                bypassNameMatching: bypassNameMatching ? 'Y' : 'N',
                postDataAPIRequired: webhooksEnabled ? 'Y' : 'N',
                postDataAPIURL: webhooksURL,
                postDataOnReviewRequired: webhooksFireOnReview ? 'Y' : 'N',
                postDataOnReviewAPIURL: webhooksFireOnReviewURL,
                sendInputImagesInPost: webhooksSendInputImages ? 'Y' : 'N',
                sendProcessedImagesInPost: webhooksSendProcessedImages ? 'Y' : 'N',
                needImmediateResponse: needImmediateResponse ? 'Y' : 'N',
                deDuplicationRequired: deduplicationEnabled ? 'Y' : 'N',
                deduplicationSynchronous: deduplicationSynchronous ? 'Y' : 'N',
                verifyDataWithHost: verifyIdWithExternalDatabases ? 'Y' : 'N',
                idBackImageRequired: idBackImageRequired ? 'Y' : 'N',
                stripSpecialCharacters: webhooksStripSpecialCharacters ? 'Y' : 'N',
                idImageResolutionCheck: idImageResolutionCheck ? 'Y' : 'N',
                customerDataMatchConfig: customerDataMatchConfig
              }
            };
            if (clientRequestID) {
              submissionRequest.additionalData.clientRequestID = clientRequestID;
            }
            if (documents.idFrontImage) {
              submissionRequest.customerData.idData.idImageFront = documents.idFrontImage;
            }
            if (documents.idBackImage) {
              submissionRequest.customerData.idData.idImageBack = documents.idBackImage;
            }
            if (documents.passportImage) {
              submissionRequest.customerData.idData.idImageFront = documents.passportImage;
            }
            if (documents.selfieImage) {
              // if (action === SubmissionAction.IDENTIFY) {
              //   // TODO: remove once API is fixed
              //   submissionRequest.biometricData = { selfie: documents.selfieImage }
              // }
              submissionRequest.customerData.biometricData = {
                selfie: documents.selfieImage
              };
            }
            if (idCardForFaceMatch) {
              (_e = submissionRequest.customerData.idData).idImageFront || (_e.idImageFront = idCardForFaceMatch);
            }
            if (companyId) {
              submissionRequest.employee = {
                companyId: companyId
              };
            }
            if (personalData) {
              submissionRequest.customerData.personalData = personalData;
            }
            if (cardData) {
              submissionRequest.customerData.cardData = cardData;
            }
            if (enrollmentId) {
              (_f = submissionRequest.customerData).personalData || (_f.personalData = {});
              submissionRequest.customerData.personalData.uniqueNumber = enrollmentId;
            }
            if (webhooksClientTraceId) {
              submissionRequest.additionalData.clientTraceId = webhooksClientTraceId;
            }
            if (signatureData) {
              submissionRequest.customerData.signatureData = {
                signatureImage: JSON.stringify(signatureData)
              };
              if (documents.signatureVideo) {
                submissionRequest.customerData.signatureData.signatureVideo = documents.signatureVideo;
              }
            }
            if (additionalDocuments) {
              submissionRequest.customerData.additionalDocuments = additionalDocuments.map(function (d) {
                return _assign(_assign({}, d), {
                  additionalDocument: JSON.stringify(_assign(_assign({}, d.additionalDocument), {
                    uniqueId: submissionRequest.additionalData.uniqueRequestId
                  }))
                });
              });
            }
            if (documents.idCaptureVideo) {
              (_g = submissionRequest.customerData).biometricData || (_g.biometricData = {});
              submissionRequest.customerData.biometricData.videoData = documents.idCaptureVideo;
            }
            if (documents.idCaptureVideoAudio) {
              (_h = submissionRequest.customerData).biometricData || (_h.biometricData = {});
              submissionRequest.customerData.biometricData.voiceData = documents.idCaptureVideoAudio;
              submissionRequest.customerData.biometricData.voiceStartTime = idCaptureVideoAudioStartsAt !== null && idCaptureVideoAudioStartsAt !== void 0 ? idCaptureVideoAudioStartsAt : undefined;
              submissionRequest.customerData.biometricData.expectedAudioText = expectedAudioText !== null && expectedAudioText !== void 0 ? expectedAudioText : undefined;
            }
            if (documents.idCaptureVideoIdFrontImage) {
              submissionRequest.customerData.idData.videoIdImageFront = documents.idCaptureVideoIdFrontImage;
            }
            if (documents.idCaptureVideoIdBackImage) {
              submissionRequest.customerData.idData.videoIdImageBack = documents.idCaptureVideoIdBackImage;
            }
            attachMetadataToRequest(submissionRequest, {
              selfieCaptureAttempts: selfieCaptureAttempts,
              idFrontCaptureAttempts: idFrontCaptureAttempts,
              idBackCaptureAttempts: idBackCaptureAttempts,
              geolocationResult: geolocationResult
            });
            if (!onBeforeSubmit.current) return [3 /*break*/, 10];
            return [4 /*yield*/, onBeforeSubmit.current(submissionRequest)];
          case 9:
            onBeforeSubmitResult = _j.sent();
            if (onBeforeSubmitResult) submissionRequest = onBeforeSubmitResult;
            _j.label = 10;
          case 10:
            return [2 /*return*/, submissionRequest];
        }
      });
    });
  }, [additionalDocuments, bypassAgeValidation, bypassNameMatching, cardData, clientRequestID, companyId, customerDataMatchConfig, deduplicationEnabled, deduplicationSynchronous, documentServiceUrl, enrollmentId, expectedAudioText, geolocationResult, idBackCaptureAttempts, idBackImage, idBackImageRequired, idCaptureVideoAudioStartsAt, idCaptureVideoAudioUrl, idCaptureVideoIdBackImage, idCaptureVideoIdFrontImage, idCaptureVideoUrl, idCardForFaceMatch, idData, idFrontCaptureAttempts, idFrontImage, idImageResolutionCheck, manualReviewRequired, needImmediateResponse, passportImage, personalData, selfieCaptureAttempts, selfieImage, signatureData, signatureVideoUrl, uploadDocument, verifyIdWithExternalDatabases, webhooksClientTraceId, webhooksEnabled, webhooksFireOnReview, webhooksFireOnReviewURL, webhooksSendInputImages, webhooksSendProcessedImages, webhooksStripSpecialCharacters, webhooksURL]);
  var defaultOnSubmit = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var submissionResponse_1, payload, host, endpoint, response, statusMessage, submissionResponse_2, e_1, err;
      var _a, _b, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (action === SubmissionAction.NONE) {
              submissionResponse_1 = {
                status: {
                  statusCode: '000'
                },
                resultData: {}
              };
              setSubmissionStatus(SubmissionStatus.SUBMITTED);
              setSubmissionResponse(submissionResponse_1);
              return [2 /*return*/, submissionResponse_1];
            }
            setSubmissionStatus(SubmissionStatus.SUBMITTING);
            _d.label = 1;
          case 1:
            _d.trys.push([1, 7,, 8]);
            return [4 /*yield*/, buildSubmissionPayload()];
          case 2:
            payload = _d.sent();
            host = submissionUrl || determineSubmissionHost(environment);
            endpoint = determineSubmissionEndpoint(action, !!(idFrontImage || idBackImage || passportImage), !!selfieImage);
            return [4 /*yield*/, fetch(host + endpoint, {
              method: 'POST',
              headers: apiHeaders(sessionId, sendBase64DocumentsInSwaggerProxy),
              body: JSON.stringify(payload)
            })["catch"](function (e) {
              throw new NetworkError(e.message);
            })];
          case 3:
            response = _d.sent();
            if (!(!response || !response.ok)) return [3 /*break*/, 5];
            return [4 /*yield*/, response === null || response === void 0 ? void 0 : response.text()];
          case 4:
            statusMessage = _d.sent();
            if (!statusMessage || statusMessage === 'Load failed') throw new NetworkError(statusMessage);
            throw new SubmissionError({
              statusCode: (_a = response === null || response === void 0 ? void 0 : response.statusText) !== null && _a !== void 0 ? _a : '???',
              statusMessage: statusMessage
            });
          case 5:
            return [4 /*yield*/, response.json()];
          case 6:
            submissionResponse_2 = _d.sent();
            if (submissionResponse_2.status.statusCode !== '000') {
              throw new SubmissionError(submissionResponse_2.status);
            }
            setSubmissionRequest(payload);
            setSubmissionResponse(submissionResponse_2);
            setSubmissionStatus(SubmissionStatus.SUBMITTED);
            (_b = onResponseReceived.current) === null || _b === void 0 ? void 0 : _b.call(onResponseReceived, submissionResponse_2, payload);
            return [2 /*return*/, submissionResponse_2];
          case 7:
            e_1 = _d.sent();
            err = e_1;
            setSubmissionStatus(SubmissionStatus.FAILED);
            setSubmissionError(e_1 instanceof SubmissionError || e_1 instanceof NetworkError ? e_1 : err.message === 'Load failed' ? new NetworkError() : new SubmissionError({
              statusCode: '',
              statusMessage: err.message
            }));
            setRetrySubmission(function () {
              return ['VERIFY', 'IDENTIFY'].includes(action) ? function () {
                return null;
              } : defaultOnSubmit;
            });
            (_c = onRequestFailure.current) === null || _c === void 0 ? void 0 : _c.call(onRequestFailure, err);
            throw err;
          case 8:
            return [2 /*return*/];
        }
      });
    });
  }, [action, buildSubmissionPayload, submissionUrl, environment, idFrontImage, idBackImage, passportImage, selfieImage, sessionId, sendBase64DocumentsInSwaggerProxy]);
  var submit = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!onSubmit.current) return [3 /*break*/, 2];
            _b = (_a = onSubmit).current;
            return [4 /*yield*/, buildSubmissionPayload()];
          case 1:
            return [2 /*return*/, _b.apply(_a, [_c.sent()])];
          case 2:
            return [4 /*yield*/, defaultOnSubmit()];
          case 3:
            return [2 /*return*/, _c.sent()];
        }
      });
    });
  }, [buildSubmissionPayload, defaultOnSubmit]);
  var buildLivenessCheckPayload = useCallback(function (imageDataUrl) {
    return __awaiter(void 0, void 0, void 0, function () {
      var selfie, request, onBeforeLivenessCheckResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            selfie = imageDataUrl;
            if (!(useDocumentServiceForLivenessChecks && documentServiceUrl)) return [3 /*break*/, 2];
            if (!selfie.startsWith('data:')) {
              selfie = "data:image/jpeg;base64,".concat(selfie);
            }
            return [4 /*yield*/, uploadDocument(selfie, {
              filename: 'liveness',
              filetype: 'image/jpeg'
            })];
          case 1:
            selfie = _a.sent();
            return [3 /*break*/, 3];
          case 2:
            selfie = dataUrlToBase64Sync(selfie);
            _a.label = 3;
          case 3:
            request = {
              securityData: {
                userName: '',
                password: '',
                merchantId: 0
              },
              customerData: {
                biometricData: {
                  selfie: selfie
                }
              },
              additionalData: {
                uniqueRequestId: new Date().getTime().toString(),
                stripSpecialCharacters: webhooksStripSpecialCharacters ? 'Y' : 'N',
                estimateAge: 'N',
                predictGender: 'N'
              }
            };
            if (clientRequestID) {
              request.additionalData.clientRequestID = clientRequestID;
            }
            if (idCardForFaceMatch) {
              request.customerData.idData = {
                idImageFront: idCardForFaceMatch
              };
              // TODO: remove when fixed
              request.customerData.additionalData = {
                uniqueRequestId: request.additionalData.uniqueRequestId
              };
            }
            attachMetadataToRequest(request, {
              selfieCaptureAttempts: selfieCaptureAttempts,
              idFrontCaptureAttempts: idFrontCaptureAttempts,
              idBackCaptureAttempts: idBackCaptureAttempts,
              geolocationResult: geolocationResult
            });
            if (!onBeforeLivenessCheck.current) return [3 /*break*/, 5];
            return [4 /*yield*/, onBeforeLivenessCheck.current(request)];
          case 4:
            onBeforeLivenessCheckResult = _a.sent();
            if (onBeforeLivenessCheckResult) request = onBeforeLivenessCheckResult;
            _a.label = 5;
          case 5:
            setLivenessCheckRequest(request);
            return [2 /*return*/, request];
        }
      });
    });
  }, [clientRequestID, documentServiceUrl, geolocationResult, idBackCaptureAttempts, idCardForFaceMatch, idFrontCaptureAttempts, selfieCaptureAttempts, uploadDocument, webhooksStripSpecialCharacters]);
  var checkLiveness = useCallback(function (imageDataUrl) {
    return __awaiter(void 0, void 0, void 0, function () {
      var request, host, endpoint, response, statusMessage, submissionResponse_3, e_2, err;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 6,, 7]);
            return [4 /*yield*/, buildLivenessCheckPayload(imageDataUrl)];
          case 1:
            request = _b.sent();
            host = submissionUrl || determineSubmissionHost(environment);
            endpoint = liveCheckEndpoint(!!idCardForFaceMatch);
            return [4 /*yield*/, fetch(host + endpoint, {
              method: 'POST',
              headers: apiHeaders(sessionId, sendBase64DocumentsInSwaggerProxy),
              body: JSON.stringify(request)
            })["catch"](function (e) {
              throw new NetworkError(e.message);
            })];
          case 2:
            response = _b.sent();
            if (!!response.ok) return [3 /*break*/, 4];
            return [4 /*yield*/, response.text()];
          case 3:
            statusMessage = _b.sent();
            if (!statusMessage || statusMessage === 'Load failed') throw new NetworkError(statusMessage);
            throw new SubmissionError({
              statusCode: response.statusText,
              statusMessage: statusMessage
            });
          case 4:
            return [4 /*yield*/, response.json()];
          case 5:
            submissionResponse_3 = _b.sent();
            if (submissionResponse_3.status.statusCode !== '000') {
              throw new SubmissionError(submissionResponse_3.status);
            }
            setSubmissionResponse(submissionResponse_3);
            return [2 /*return*/, submissionResponse_3];
          case 6:
            e_2 = _b.sent();
            err = e_2;
            setSubmissionStatus(SubmissionStatus.FAILED);
            setSubmissionError(e_2 instanceof SubmissionError || e_2 instanceof NetworkError ? e_2 : err.message === 'Load failed' ? new NetworkError() : new SubmissionError({
              statusCode: '',
              statusMessage: err.message
            }));
            // the face liveness routine will call again, so don't repeat the call here.
            setRetrySubmission(function () {
              return function () {
                return null;
              };
            });
            (_a = onRequestFailure.current) === null || _a === void 0 ? void 0 : _a.call(onRequestFailure, err);
            throw err;
          case 7:
            return [2 /*return*/];
        }
      });
    });
  }, [buildLivenessCheckPayload, submissionUrl, environment, idCardForFaceMatch, sessionId, sendBase64DocumentsInSwaggerProxy]);
  var retryLocationAccess = useCallback(function () {
    setGeolocationAttempts(function (n) {
      return n + 1;
    });
  }, []);
  useEffect(function () {
    if (!geolocationEnabled) return;
    log('making geolocation attempt', geolocationAttempts);
    navigator.geolocation.getCurrentPosition(function (position) {
      setGeolocationResult(position);
      setGeolocationBlocked(false);
    }, function (positionError) {
      if (positionError.code === 1) {
        setGeolocationBlocked(true);
      } else {
        throw new Error(positionError.message);
      }
    });
  }, [geolocationAttempts, geolocationEnabled, geolocationRequired]);
  var onRetry = useCallback(function () {
    if (!retrySubmission) return;
    setSubmissionError(null);
    setSubmissionStatus(SubmissionStatus.READY);
    retrySubmission();
  }, [retrySubmission]);
  var value = {
    submit: submit,
    submissionStatus: submissionStatus,
    submissionRequest: submissionRequest,
    submissionResponse: submissionResponse,
    submissionError: submissionError,
    submissionEnvironment: environment,
    idFrontImage: idFrontImage,
    idBackImage: idBackImage,
    passportImage: passportImage,
    selfieImage: selfieImage,
    signatureData: signatureData,
    signatureVideoUrl: signatureVideoUrl,
    idCaptureVideoUrl: idCaptureVideoUrl,
    idCaptureVideoIdFrontImage: idCaptureVideoIdFrontImage,
    idCaptureVideoIdBackImage: idCaptureVideoIdBackImage,
    idCaptureVideoAudioUrl: idCaptureVideoAudioUrl,
    idCaptureVideoAudioStartsAt: idCaptureVideoAudioStartsAt,
    additionalDocuments: additionalDocuments,
    setIdFrontImage: setIdFrontImage,
    setIdBackImage: setIdBackImage,
    setPassportImage: setPassportImage,
    setSelfieImage: setSelfieImage,
    setSignatureData: setSignatureData,
    setSignatureVideoUrl: setSignatureVideoUrl,
    setIdCaptureVideoUrl: setIdCaptureVideoUrl,
    setIdCaptureVideoIdFrontImage: setIdCaptureVideoIdFrontImage,
    setIdCaptureVideoIdBackImage: setIdCaptureVideoIdBackImage,
    setIdCaptureVideoAudioUrl: setIdCaptureVideoAudioUrl,
    setIdCaptureVideoAudioStartsAt: setIdCaptureVideoAudioStartsAt,
    setExpectedAudioText: setExpectedAudioText,
    setAdditionalDocuments: setAdditionalDocuments,
    uploadDocument: uploadDocument,
    logIdFrontCaptureAttempt: logIdFrontCaptureAttempt,
    logIdBackCaptureAttempt: logIdBackCaptureAttempt,
    logSelfieCaptureAttempt: logSelfieCaptureAttempt,
    livenessCheckRequest: livenessCheckRequest,
    checkLiveness: checkLiveness,
    retryLocationAccess: retryLocationAccess
  };
  return /*#__PURE__*/React__default.createElement(SubmissionContext.Provider, {
    value: value
  }, geolocationRequired && geolocationBlocked ? ( /*#__PURE__*/React__default.createElement(GeolocationAccessDeniedOverlay, null)) : children, submissionError && ( /*#__PURE__*/React__default.createElement(SubmissionErrorOverlay, {
    error: submissionError,
    onRetry: onRetry
  })));
};
function createUpload(blob, options) {
  var UploadType =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  typeof window.tus !== 'undefined' ? window.tus.Upload : Upload;
  return new UploadType(blob, options);
}
function convertBase64ToBlob(base64Image) {
  // Split into two parts
  var parts = base64Image.split(';base64,');
  // Hold the content type
  var imageType = parts[0].split(':')[1];
  // Decode Base64 string
  var decodedData = window.atob(parts[1]);
  // Create UNIT8ARRAY of size same as row data length
  var uInt8Array = new Uint8Array(decodedData.length);
  // Insert all character code into uInt8Array
  for (var i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }
  // Return BLOB image after conversion
  return new Blob([uInt8Array], {
    type: imageType
  });
}
function calculateMd5(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onloadend = function () {
      if (!reader.result) return reject(new Error('Failed to read file'));
      resolve(SparkMD5.ArrayBuffer.hash(reader.result));
    };
  });
}
function getEnvFromUrl(url) {
  if (url.startsWith('https://portal-api.idmission.com')) {
    return 'prod';
  } else if (url.startsWith('https://portal-api-uat.idmission.com')) {
    return 'uat';
  } else if (url.startsWith('https://portal-api-demo.idmission.com')) {
    return 'demo';
  } else if (url.startsWith('https://portal-api-dev.idmission.com')) {
    return 'dev';
  } else if (url.startsWith('http://localhost:10000')) {
    return 'local';
  }
  return 'unknown';
}
function performUpload(_a) {
  return __awaiter(this, arguments, void 0, function (_b) {
    var fingerprint;
    var blob = _b.blob,
      endpoint = _b.endpoint,
      sessionId = _b.sessionId,
      metadata = _b.metadata,
      onDocumentUploadProgress = _b.onDocumentUploadProgress,
      onDocumentUploaded = _b.onDocumentUploaded,
      onDocumentUploadFailed = _b.onDocumentUploadFailed;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4 /*yield*/, calculateMd5(blob)];
        case 1:
          fingerprint = _c.sent();
          return [2 /*return*/, new Promise(function (resolve, reject) {
            var documentId;
            var upload = createUpload(blob, {
              endpoint: endpoint,
              retryDelays: [0, 1000, 1000, 1000, 3000, 5000, 10000, 20000],
              headers: {
                'X-Session-Id': sessionId
              },
              metadata: _assign({
                filetype: blob.type,
                contentType: blob.type,
                fingerprint: fingerprint
              }, metadata || {}),
              onProgress: function onProgress(bytesUploaded, bytesTotal) {
                onDocumentUploadProgress === null || onDocumentUploadProgress === void 0 ? void 0 : onDocumentUploadProgress({
                  bytesUploaded: bytesUploaded,
                  bytesTotal: bytesTotal,
                  percentage: (bytesUploaded / bytesTotal * 100).toFixed(2) + '%',
                  metadata: metadata
                });
              },
              onAfterResponse: function onAfterResponse(_req, res) {
                var contentType = res.getHeader('Content-Type');
                if (!(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith('application/json'))) return;
                var body = res.getBody();
                if (!body) return;
                try {
                  var parsedId = JSON.parse(body).id;
                  if (parsedId.startsWith('urn:documentsv1:')) {
                    documentId = parsedId;
                  }
                } catch (e) {
                  warn('Failed to parse documents service response body', e);
                }
              },
              onSuccess: function onSuccess() {
                var _a;
                documentId || (documentId = "urn:documentsv1:".concat(getEnvFromUrl(upload.url), ":").concat((_a = upload.url.split('/files/').pop()) === null || _a === void 0 ? void 0 : _a.split('+').shift()));
                onDocumentUploaded === null || onDocumentUploaded === void 0 ? void 0 : onDocumentUploaded(documentId, metadata);
                resolve(documentId);
              },
              onError: function onError(error) {
                log('Failed because: ' + error);
                onDocumentUploadFailed === null || onDocumentUploadFailed === void 0 ? void 0 : onDocumentUploadFailed(error, metadata);
                reject(error);
              }
            });
            // Check if there are any previous uploads to continue.
            upload.findPreviousUploads().then(function (previousUploads) {
              // Found previous uploads so we select the first one.
              if (previousUploads.length) {
                upload.resumeFromPreviousUpload(previousUploads[0]);
              }
              // Start the upload
              upload.start();
            });
          })];
      }
    });
  });
}

var visionTasksBasePath = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.7/wasm";
var visionRuntimePreloading = false;
function preloadVisionRuntime() {
  return __awaiter(this, void 0, void 0, function () {
    function handleDownloadProgress(event) {
      var detail = event.detail;
      if (detail.url !== url) return;
      progressByUseCase.visionRuntime = sumUpProgressForDependencies([url]);
      document.dispatchEvent(new CustomEvent('idmission.preloadProgress.visionRuntime', {
        detail: progressByUseCase.visionRuntime
      }));
    }
    var url;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (visionRuntimePreloading) return [2 /*return*/, new Promise(function (resolve) {
            setInterval(function () {
              if (!visionRuntimePreloading) resolve();
            }, 100);
          })];
          visionRuntimePreloading = true;
          url = "".concat(visionTasksBasePath, "/vision_wasm_internal.wasm");
          document.addEventListener('idmission.preloadProgress', handleDownloadProgress);
          _a.label = 1;
        case 1:
          _a.trys.push([1,, 3, 4]);
          return [4 /*yield*/, preloadDependency(url)];
        case 2:
          _a.sent();
          return [3 /*break*/, 4];
        case 3:
          document.removeEventListener('idmission.preloadProgress', handleDownloadProgress);
          visionRuntimePreloading = false;
          return [7 /*endfinally*/];
        case 4:
          return [2 /*return*/];
      }
    });
  });
}

function getFrameDimensions(frame) {
  var frameWidth = frame.width,
    frameHeight = frame.height;
  if (frame instanceof HTMLImageElement) {
    frameWidth = frame.naturalWidth;
    frameHeight = frame.naturalHeight;
  }
  if (frame instanceof HTMLVideoElement) {
    frameWidth = frame.videoWidth;
    frameHeight = frame.videoHeight;
  }
  return [frameWidth, frameHeight];
}

var InvisibleCanvas = styled.canvas(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
function drawToCanvas(canvas, frame, width, height) {
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;
  if (!width || !height) {
    var _a = getFrameDimensions(frame),
      frameWidth = _a[0],
      frameHeight = _a[1];
    width || (width = frameWidth);
    height || (height = frameHeight);
  }
  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(frame, 0, 0, width, height);
}
function clearCanvas(canvas) {
  var _a;
  (_a = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d')) === null || _a === void 0 ? void 0 : _a.clearRect(0, 0, canvas === null || canvas === void 0 ? void 0 : canvas.width, canvas === null || canvas === void 0 ? void 0 : canvas.height);
}
var templateObject_1$G;

function cropToShoulders(rawCanvas, cropCanvas, resizeCanvas, frame, face, quality, maxHeight) {
  if (quality === void 0) {
    quality = 0.92;
  }
  if (!rawCanvas || !cropCanvas || !resizeCanvas) return '';
  var rawCtx = rawCanvas.getContext('2d');
  var cropCtx = cropCanvas.getContext('2d');
  var resizeCtx = resizeCanvas.getContext('2d');
  if (!rawCtx || !cropCtx || !resizeCtx) throw new Error('could not get 2d context');
  rawCanvas.width = frame.width;
  rawCanvas.height = frame.height;
  rawCtx.putImageData(frame, 0, 0);
  if (frame.height > frame.width) {
    cropCanvas.width = frame.width;
    cropCanvas.height = frame.height;
    cropCtx.drawImage(rawCanvas, 0, 0, cropCanvas.width, cropCanvas.height);
  } else {
    var _a = face.box,
      xMin = _a.xMin,
      width = _a.width;
    var desiredWidth = frame.height * 0.6;
    var faceCenterX = xMin + width / 2;
    var xPos = Math.max(0, faceCenterX - desiredWidth / 2);
    cropCanvas.width = desiredWidth;
    cropCanvas.height = frame.height;
    cropCtx.drawImage(rawCanvas, xPos, 0, cropCanvas.width, cropCanvas.height, 0, 0, cropCanvas.width, cropCanvas.height);
  }
  resizeCanvas.height = maxHeight !== null && maxHeight !== void 0 ? maxHeight : cropCanvas.height;
  resizeCanvas.width = cropCanvas.width * (resizeCanvas.height / cropCanvas.height);
  resizeCtx === null || resizeCtx === void 0 ? void 0 : resizeCtx.drawImage(cropCanvas, 0, 0, resizeCanvas.width, resizeCanvas.height);
  var dataURL = resizeCanvas.toDataURL('image/jpeg', quality);
  log('cropToShoulders size', new TextEncoder().encode(dataURL).length);
  clearCanvas(rawCanvas);
  clearCanvas(cropCanvas);
  clearCanvas(resizeCanvas);
  return dataURL;
}
function cropToDetectedObjectBox(frame, box, canvas) {
  canvas || (canvas = document.createElement('canvas'));
  var ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('could not get 2d context');
  var xMin = box.xMin,
    yMin = box.yMin,
    width = box.width,
    height = box.height;
  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(frame, xMin, yMin, width, height, 0, 0, width, height);
  return canvas;
}

var defaultImageSegmenterModelPath = 'https://websdk-cdn-dev.idmission.com/assets/models/selfiesegmenter20240524/selfie_segmenter.tflite';
var imageSegmenterModelSizeInBytes = 256440.32;
// The idea here is that we globally set a cache key based on the time at page load. That way our built-in speed test
// isn't fooled by cache times, but subsequent downloads of the vision runtime still do load from the cache.
var tinyModelCacheKey = new Date().getTime();
var initialModelCapabilities = {
  probeState: 'notProbed',
  delegate: 'GPU',
  networkTier: 'untested',
  networkSpeed: 0,
  networkTestTime: 0
};
var modelCapabilities = _assign({}, initialModelCapabilities);
function probeModelCapabilities() {
  return __awaiter(this, void 0, void 0, function () {
    var error_1, error_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (modelCapabilities.probeState === 'probed') return [2 /*return*/];
          if (modelCapabilities.probeState === 'probing') return [2 /*return*/, new Promise(function (resolve) {
            setInterval(function () {
              if (modelCapabilities.probeState === 'probed') resolve();
            }, 100);
          })];
          modelCapabilities.probeState = 'probing';
          return [4 /*yield*/, preloadVisionRuntime()];
        case 1:
          _a.sent();
          _a.label = 2;
        case 2:
          _a.trys.push([2, 4, 9, 10]);
          log('Model Probing: testing GPU capabilities...');
          return [4 /*yield*/, loadTinyModel('GPU')];
        case 3:
          _a.sent();
          log('Model Probing: GPU is capable.');
          return [3 /*break*/, 10];
        case 4:
          error_1 = _a.sent();
          warn('Model Probing: GPU delegate could not be loaded', error_1);
          modelCapabilities.delegate = 'CPU';
          _a.label = 5;
        case 5:
          _a.trys.push([5, 7,, 8]);
          log('Model Probing: testing CPU capabilities...');
          return [4 /*yield*/, loadTinyModel('CPU')];
        case 6:
          _a.sent();
          log('Model Probing: CPU is capable.');
          return [3 /*break*/, 8];
        case 7:
          error_2 = _a.sent();
          warn('Model Probing: CPU delegate could not be loaded', error_2);
          modelCapabilities.delegate = 'NONE';
          return [3 /*break*/, 8];
        case 8:
          return [3 /*break*/, 10];
        case 9:
          modelCapabilities.probeState = 'probed';
          return [7 /*endfinally*/];
        case 10:
          return [2 /*return*/];
      }
    });
  });
}
function loadTinyModel() {
  return __awaiter(this, arguments, void 0, function (delegate, maxTime) {
    var modelAssetPath, startedAt, e_1, time, speedMbps, model, _a, _b, emptyFrame;
    if (delegate === void 0) {
      delegate = 'GPU';
    }
    if (maxTime === void 0) {
      maxTime = 10000;
    }
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          modelAssetPath = "".concat(defaultImageSegmenterModelPath, "?_=").concat(tinyModelCacheKey);
          startedAt = new Date();
          _c.label = 1;
        case 1:
          _c.trys.push([1, 3,, 4]);
          return [4 /*yield*/, Promise.race([preloadDependency(modelAssetPath), giveUpAfter(maxTime)])];
        case 2:
          _c.sent();
          return [3 /*break*/, 4];
        case 3:
          e_1 = _c.sent();
          error('speed test failed', e_1);
          modelCapabilities.networkTier = 'unusable';
          return [2 /*return*/];
        case 4:
          time = (new Date().getTime() - startedAt.getTime()) / 1000.0;
          modelCapabilities.networkTestTime || (modelCapabilities.networkTestTime = time);
          modelCapabilities.networkSpeed || (modelCapabilities.networkSpeed = imageSegmenterModelSizeInBytes / time);
          modelCapabilities.networkTier = time < 0.5 ? 'fast' : time < 2 ? 'medium' : 'slow';
          speedMbps = modelCapabilities.networkSpeed / 1024 / 1024;
          log('Model Probing: network speed', speedMbps.toFixed(3), 'Mbps');
          log('Model Probing: network test took', time);
          log('Model Probing: network tier', modelCapabilities.networkTier);
          _b = (_a = ImageSegmenter).createFromOptions;
          return [4 /*yield*/, FilesetResolver.forVisionTasks(visionTasksBasePath)];
        case 5:
          return [4 /*yield*/, _b.apply(_a, [_c.sent(), {
            baseOptions: {
              modelAssetPath: modelAssetPath,
              delegate: delegate
            }
          }])];
        case 6:
          model = _c.sent();
          emptyFrame = document.createElement('canvas');
          model.segment(emptyFrame);
          emptyFrame.remove();
          return [2 /*return*/];
      }
    });
  });
}
function giveUpAfter(maxTime) {
  return new Promise(function (_resolve, reject) {
    setTimeout(function () {
      reject(new Error('gave up after reaching maximum time allowed'));
    }, maxTime);
  });
}

function convertBoundingBox(box) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    xMin: (_a = box === null || box === void 0 ? void 0 : box.originX) !== null && _a !== void 0 ? _a : 0,
    xMax: ((_b = box === null || box === void 0 ? void 0 : box.originX) !== null && _b !== void 0 ? _b : 0) + ((_c = box === null || box === void 0 ? void 0 : box.width) !== null && _c !== void 0 ? _c : 0),
    yMin: (_d = box === null || box === void 0 ? void 0 : box.originY) !== null && _d !== void 0 ? _d : 0,
    yMax: ((_e = box === null || box === void 0 ? void 0 : box.originY) !== null && _e !== void 0 ? _e : 0) + ((_f = box === null || box === void 0 ? void 0 : box.height) !== null && _f !== void 0 ? _f : 0),
    width: (_g = box === null || box === void 0 ? void 0 : box.width) !== null && _g !== void 0 ? _g : 0,
    height: (_h = box === null || box === void 0 ? void 0 : box.height) !== null && _h !== void 0 ? _h : 0
  };
}
function waitForVideoReady(videoRef, checkEveryMs) {
  if (checkEveryMs === void 0) {
    checkEveryMs = 100;
  }
  return new Promise(function (resolve) {
    var _a, _b, _c;
    if (((_b = (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.readyState) !== null && _b !== void 0 ? _b : 0) >= 2) return resolve();
    (_c = videoRef.current) === null || _c === void 0 ? void 0 : _c.load();
    var interval = setInterval(function () {
      var _a, _b;
      if (((_b = (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.readyState) !== null && _b !== void 0 ? _b : 0) >= 2) {
        clearInterval(interval);
        resolve();
      }
    }, checkEveryMs);
  });
}
function calculateIoU(boxA, boxB) {
  var xA = Math.max(boxA.xMin, boxB.xMin);
  var yA = Math.max(boxA.yMin, boxB.yMin);
  var xB = Math.min(boxA.xMax, boxB.xMax);
  var yB = Math.min(boxA.yMax, boxB.yMax);
  var intersectWidth = Math.max(0, xB - xA);
  var intersectHeight = Math.max(0, yB - yA);
  var intersectionArea = intersectWidth * intersectHeight;
  var boxAArea = (boxA.xMax - boxA.xMin) * (boxA.yMax - boxA.yMin);
  var boxBArea = (boxB.xMax - boxB.xMin) * (boxB.yMax - boxB.yMin);
  var unionArea = boxAArea + boxBArea - intersectionArea;
  if (unionArea === 0) return 0;
  return intersectionArea / unionArea;
}
function average(arr) {
  var len = arr.length;
  if (len === 0) return 0;
  var sum = 0;
  for (var i = 0; i < len; i++) sum += arr[i];
  return sum / len;
}

var DEFAULT_CDN_URL = 'https://websdk-cdn-dev.idmission.com/assets';

var defaultDocumentDetectorModelPath = "".concat(DEFAULT_CDN_URL, "/models/DocumentDetector/DocumentDetector-20250111_090328.tflite");

var defaultFocusModelPath = "".concat(DEFAULT_CDN_URL, "/models/Focus/Focus-20241008_102708.tflite");

var defaultFaceDetectorModelPath = "".concat(DEFAULT_CDN_URL, "/models/blazeface20240207/blaze_face_short_range.tflite");

var defaultFocusModelLoadTimeoutMs = 45000;
var defaultFocusThresholds = {
  idCardFront: {
    desktop: 0,
    mobile: 0.3
  },
  idCardBack: {
    desktop: 0,
    mobile: 0.3
  },
  passport: {
    desktop: 0,
    mobile: 0.3
  },
  singlePage: {
    desktop: 0,
    mobile: 0.3
  }
};
var classifier = null;
var classifierSettings = null;
function loadFocusModel() {
  return __awaiter(this, arguments, void 0, function (modelAssetPath) {
    var _a, _b;
    if (modelAssetPath === void 0) {
      modelAssetPath = defaultFocusModelPath;
    }
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          if (classifier && (classifierSettings === null || classifierSettings === void 0 ? void 0 : classifierSettings.modelAssetPath) === modelAssetPath) return [2 /*return*/, classifier];
          closeFocusModel();
          return [4 /*yield*/, preloadFocusModelDependencies()];
        case 1:
          _c.sent();
          if (modelCapabilities.delegate === 'NONE') {
            throw new Error('No available delegate for focus detector.');
          }
          _b = (_a = ImageClassifier).createFromOptions;
          return [4 /*yield*/, FilesetResolver.forVisionTasks(visionTasksBasePath)];
        case 2:
          return [4 /*yield*/, _b.apply(_a, [_c.sent(), {
            baseOptions: {
              modelAssetPath: modelAssetPath,
              delegate: modelCapabilities.delegate
            },
            // canvas: document.createElement('canvas'),
            runningMode: 'VIDEO'
          }])];
        case 3:
          classifier = _c.sent();
          classifierSettings = {
            modelAssetPath: modelAssetPath
          };
          return [2 /*return*/, classifier];
      }
    });
  });
}
function closeFocusModel() {
  classifier === null || classifier === void 0 ? void 0 : classifier.close();
  classifier = null;
  classifierSettings = null;
}
function useLoadFocusModel(_a) {
  var _b = _a.modelPath,
    modelPath = _b === void 0 ? defaultFocusModelPath : _b,
    _c = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _c === void 0 ? defaultFocusModelLoadTimeoutMs : _c,
    onModelError = _a.onModelError,
    videoRef = _a.videoRef,
    _d = _a.shouldLoadModels,
    shouldLoadModels = _d === void 0 ? true : _d;
  var _e = useState(false),
    ready = _e[0],
    setReady = _e[1];
  var _f = useState(0),
    modelDownloadProgress = _f[0],
    setModelDownloadProgress = _f[1];
  var _g = useState(null),
    modelError = _g[0],
    setModelError = _g[1];
  useEffect(function loadModel() {
    var _this = this;
    if (!shouldLoadModels) return;
    setReady(false);
    function handleDownloadProgress(event) {
      setModelDownloadProgress(progressToPercentage(event.detail));
    }
    document.addEventListener('idmission.preloadProgress.focus', handleDownloadProgress);
    var modelLoadTimeout = setTimeout(function () {
      setModelError(new Error('Model loading time limit exceeded.'));
    }, modelLoadTimeoutMs);
    loadFocusModel(modelPath).then(function (loadedModel) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setModelDownloadProgress(100);
              clearTimeout(modelLoadTimeout);
              return [4 /*yield*/, waitForVideoReady(videoRef)];
            case 1:
              _a.sent();
              setTimeout(function () {
                loadedModel.classifyForVideo(videoRef.current, performance.now());
                setReady(true);
              }, 500);
              return [2 /*return*/];
          }
        });
      });
    })["catch"](function (e) {
      setModelError(e);
    })["finally"](function () {
      clearTimeout(modelLoadTimeout);
    });
    return function () {
      log('unloading focus model');
      closeFocusModel();
      clearTimeout(modelLoadTimeout);
      document.removeEventListener('idmission.preloadProgress.focus', handleDownloadProgress);
    };
  }, [modelPath, modelLoadTimeoutMs, videoRef, shouldLoadModels]);
  useEffect(function handleModelError() {
    if (modelError) onModelError === null || onModelError === void 0 ? void 0 : onModelError(modelError);
  }, [modelError, onModelError]);
  return {
    ready: ready,
    modelDownloadProgress: modelDownloadProgress,
    modelError: modelError
  };
}
var lastFocusPredictionAt = 0;
var lastFocusPredictionTime = 0;
function setLastFocusPredictionAt(time) {
  lastFocusPredictionTime = time - lastFocusPredictionAt;
  lastFocusPredictionAt = time;
}
function makeFocusModelPrediction(imageData, cropCanvas, rotateCanvas, box) {
  var _a, _b, _c, _d, _e;
  if (!classifier) return null;
  var startedAt = new Date();
  var image = cropIfNecessary(imageData, cropCanvas, rotateCanvas, box);
  var result = classifier.classifyForVideo(image, performance.now());
  var score = (_e = (_d = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.classifications) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.categories) === null || _c === void 0 ? void 0 : _c.find(function (c) {
    return c.categoryName === 'focused';
  })) === null || _d === void 0 ? void 0 : _d.score) !== null && _e !== void 0 ? _e : 0;
  var predictionTime = new Date().getTime() - startedAt.getTime();
  return {
    score: score,
    predictionTime: predictionTime
  };
}
function cropIfNecessary(imageData, cropCanvas, rotateCanvas, box) {
  if (!box) return imageData;
  var cropped = cropToDetectedObjectBox(imageData, box, cropCanvas);
  var _a = [box.width, box.height],
    bw = _a[0],
    bh = _a[1];
  if (bh <= bw) return cropped;
  var ctx = rotateCanvas.getContext('2d');
  if (!ctx) return cropped;
  rotateCanvas.width = bh;
  rotateCanvas.height = bw;
  ctx.clearRect(0, 0, rotateCanvas.width, rotateCanvas.height);
  ctx.translate(rotateCanvas.width / 2, rotateCanvas.height / 2);
  ctx.rotate(1.5708); // 90 deg in radians
  ctx.drawImage(cropped, -bw / 2, -bh / 2);
  return rotateCanvas;
}

var defaultSelfieCaptureModelLoadTimeoutMs = 45000;
var detector$1 = null;
var detectorSettings$1 = null;
function loadFaceDetector() {
  return __awaiter(this, arguments, void 0, function (modelAssetPath) {
    var _a, _b;
    if (modelAssetPath === void 0) {
      modelAssetPath = defaultFaceDetectorModelPath;
    }
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          if (detector$1 && (detectorSettings$1 === null || detectorSettings$1 === void 0 ? void 0 : detectorSettings$1.modelAssetPath) === modelAssetPath) return [2 /*return*/, detector$1];
          closeFaceDetector();
          return [4 /*yield*/, preloadFaceDetectorDependencies()];
        case 1:
          _c.sent();
          if (modelCapabilities.delegate === 'NONE') {
            throw new Error('No available delegate for face detector.');
          }
          _b = (_a = FaceDetector).createFromOptions;
          return [4 /*yield*/, FilesetResolver.forVisionTasks(visionTasksBasePath)];
        case 2:
          return [4 /*yield*/, _b.apply(_a, [_c.sent(), {
            // canvas: document.createElement('canvas'),
            baseOptions: {
              modelAssetPath: modelAssetPath,
              delegate: modelCapabilities.delegate
            },
            runningMode: 'VIDEO'
          }])];
        case 3:
          detector$1 = _c.sent();
          detectorSettings$1 = {
            modelAssetPath: modelAssetPath
          };
          return [2 /*return*/, detector$1];
      }
    });
  });
}
function closeFaceDetector() {
  detector$1 === null || detector$1 === void 0 ? void 0 : detector$1.close();
  detector$1 = null;
  detectorSettings$1 = null;
}
function useLoadFaceDetector(_a) {
  var onModelError = _a.onModelError,
    _b = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _b === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _b,
    videoRef = _a.videoRef;
  var _c = useState(false),
    ready = _c[0],
    setReady = _c[1];
  var _d = useState(0),
    modelDownloadProgress = _d[0],
    setModelDownloadProgress = _d[1];
  var _e = useState(null),
    modelError = _e[0],
    setModelError = _e[1];
  useEffect(function loadModel() {
    var _this = this;
    setReady(false);
    var modelLoadTimeout = setTimeout(function () {
      setModelError(new Error('Model loading time limit exceeded.'));
    }, modelLoadTimeoutMs);
    function handleDownloadProgress(event) {
      setModelDownloadProgress(progressToPercentage(event.detail));
    }
    document.addEventListener('idmission.preloadProgress.faceDetection', handleDownloadProgress);
    loadFaceDetector().then(function (model) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setModelDownloadProgress(100);
              clearTimeout(modelLoadTimeout);
              return [4 /*yield*/, waitForVideoReady(videoRef)];
            case 1:
              _a.sent();
              model.detectForVideo(videoRef.current, performance.now());
              setReady(true);
              return [2 /*return*/];
          }
        });
      });
    })["catch"](function (e) {
      setModelError(e);
    })["finally"](function () {
      clearTimeout(modelLoadTimeout);
    });
    return function () {
      log('unloading face detection model');
      closeFaceDetector();
      clearTimeout(modelLoadTimeout);
      document.removeEventListener('idmission.preloadProgress.faceDetection', handleDownloadProgress);
    };
  }, [modelLoadTimeoutMs, videoRef]);
  useEffect(function handleModelError() {
    if (modelError) onModelError === null || onModelError === void 0 ? void 0 : onModelError(modelError);
  }, [modelError, onModelError]);
  return {
    ready: ready,
    modelDownloadProgress: modelDownloadProgress,
    modelError: modelError
  };
}
var lastFaceDetectionAt = 0;
var lastFaceDetectionTime = 0;
function setLastFaceDetectionAt(time) {
  lastFaceDetectionTime = time - lastFaceDetectionAt;
  lastFaceDetectionAt = time;
}
var framesNeededSamples$1 = [];
function trackFramesNeeded$1(value, bufferLength) {
  if (bufferLength === void 0) {
    bufferLength = 25;
  }
  framesNeededSamples$1.unshift(value);
  if (framesNeededSamples$1.length > bufferLength) framesNeededSamples$1.length = bufferLength;
}
var lastNFaces = [];
var lastNPairs$1 = [];
function trackFace(face, framesNeeded) {
  if (framesNeeded === void 0) {
    framesNeeded = 12;
  }
  lastNFaces.unshift(face);
  if (lastNFaces.length > framesNeeded) lastNFaces.length = framesNeeded;
  if (lastNFaces.length > 1) {
    var lastFace = lastNFaces[1];
    var iou = calculateIoU(face.box, lastFace.box);
    lastNPairs$1.unshift({
      a: face,
      b: lastFace,
      iou: iou
    });
    if (lastNPairs$1.length > framesNeeded - 1) lastNPairs$1.length = framesNeeded - 1;
  }
}
function makeFaceDetectorPrediction(imageData) {
  if (!detector$1) return null;
  var prediction = detector$1.detectForVideo(imageData, performance.now());
  var faces = prediction.detections.map(function (d) {
    return {
      box: convertBoundingBox(d.boundingBox),
      keypoints: d.keypoints.map(function (k) {
        var _a;
        return _assign(_assign({}, k), {
          x: k.x * imageData.width,
          y: k.y * imageData.height,
          name: (_a = k.label) !== null && _a !== void 0 ? _a : ''
        });
      })
    };
  });
  return _assign(_assign({}, prediction), {
    faces: faces
  });
}
function processFaceDetectorPrediction(_a) {
  var faces = _a.faces,
    videoWidth = _a.videoWidth,
    videoHeight = _a.videoHeight,
    _b = _a.requireVerticalFaceCentering,
    requireVerticalFaceCentering = _b === void 0 ? true : _b,
    _c = _a.stabilityThreshold,
    stabilityThreshold = _c === void 0 ? 0.7 : _c;
  var face = faces[0];
  var faceNotDetected = faces.length === 0;
  var faceNotCentered = requireVerticalFaceCentering,
    faceLookingAway = false,
    faceTooClose = false,
    faceTooFar = false;
  if (face) {
    // calculate centroids
    var vCX = videoWidth / 2;
    var vCY = videoHeight / 2;
    var fCX = (face.box.xMin + face.box.xMax) / 2;
    var fCY = (face.box.yMin + face.box.yMax) / 2;
    // calculate thresholds
    var vTX = videoWidth * 0.125;
    var vTY = videoHeight * 0.125;
    var fTW = face.box.width * 0.2;
    var fTH = face.box.height * 0.2;
    var nose = face.keypoints[2]; //.find((k) => k.name === 'noseTip')
    if (nose) {
      faceLookingAway = Math.abs(fCX - nose.x) > fTW || Math.abs(fCY - nose.y) > fTH;
      var faceNotCenteredHorizontally = Math.abs(vCX - fCX) > vTX;
      var faceNotCenteredVertically = Math.abs(vCY + 50 - fCY) > vTY;
      faceNotCentered = faceNotCenteredHorizontally || requireVerticalFaceCentering && faceNotCenteredVertically;
    }
    var isMobile = videoWidth < videoHeight;
    var tooCloseMultiple = 1.5;
    var tooFarMultiple = isMobile ? 6 : 7;
    faceTooClose = face.box.width > videoWidth / tooCloseMultiple;
    faceTooFar = face.box.width < videoWidth / tooFarMultiple;
  }
  var faceInGuides = !faceNotDetected && !faceNotCentered && !faceLookingAway && !faceTooClose && !faceTooFar;
  if (lastFaceDetectionTime > 0) {
    trackFramesNeeded$1(500 / lastFaceDetectionTime);
  }
  var faceIsStable = false;
  if (faceInGuides) {
    var framesNeeded = Math.ceil(average(framesNeededSamples$1));
    trackFace(face, framesNeeded);
    faceIsStable = lastNFaces.length >= framesNeeded && !lastNPairs$1.some(function (pair) {
      return pair.iou < stabilityThreshold;
    });
  }
  var faceReady = faceInGuides && faceIsStable;
  return {
    face: face,
    faceNotDetected: faceNotDetected,
    faceNotCentered: faceNotCentered,
    faceLookingAway: faceLookingAway,
    faceTooClose: faceTooClose,
    faceTooFar: faceTooFar,
    faceReady: faceReady,
    faceReadyAt: faceReady ? new Date() : null,
    faceIsStable: faceIsStable
  };
}

var preloadModels = function preloadModels(_a) {
  return __awaiter(void 0, [_a], void 0, function (_b) {
    var preloadTasks;
    var _c = _b.documentDetectionModel,
      documentDetectionModel = _c === void 0 ? true : _c,
      _d = _b.focusModel,
      focusModel = _d === void 0 ? true : _d,
      _e = _b.faceDetectionModel,
      faceDetectionModel = _e === void 0 ? true : _e;
    return __generator(this, function (_f) {
      switch (_f.label) {
        case 0:
          return [4 /*yield*/, probeModelCapabilities()];
        case 1:
          _f.sent();
          preloadTasks = [];
          if (documentDetectionModel) {
            preloadTasks.push(preloadDocumentDetectorDependencies);
          }
          if (focusModel) {
            preloadTasks.push(preloadFocusModelDependencies);
          }
          if (faceDetectionModel) {
            preloadTasks.push(preloadFaceDetectorDependencies);
          }
          return [4 /*yield*/, Promise.all(preloadTasks)];
        case 2:
          _f.sent();
          return [2 /*return*/];
      }
    });
  });
};
var progressByUrl = {};
var progressByUseCase = {
  visionRuntime: {
    loaded: 0,
    total: 0
  },
  documentDetection: {
    loaded: 0,
    total: 0
  },
  focus: {
    loaded: 0,
    total: 0
  },
  faceDetection: {
    loaded: 0,
    total: 0
  }
};
function preloadDependency(url) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, new Promise(function (resolve, reject) {
        var req = new XMLHttpRequest();
        req.addEventListener('progress', function (event) {
          if (!event.lengthComputable) return;
          progressByUrl[url] = event;
          document.dispatchEvent(new CustomEvent('idmission.preloadProgress', {
            detail: {
              url: url,
              loaded: event.loaded,
              total: event.total
            }
          }));
        });
        req.addEventListener('loadend', function () {
          resolve(req.readyState === 4 && req.status === 200);
        });
        req.addEventListener('error', reject);
        req.open('GET', url, true);
        req.send();
      })];
    });
  });
}
var documentDetectorPreloading = false,
  focusModelPreloading = false,
  faceDetectorPreloading = false;
function preloadDocumentDetectorDependencies() {
  return __awaiter(this, void 0, void 0, function () {
    function handleDownloadProgress(event) {
      var detail = event.detail;
      if (!dependencies.includes(detail.url)) return;
      progressByUseCase.documentDetection = sumUpProgressForDependencies(dependencies);
      document.dispatchEvent(new CustomEvent('idmission.preloadProgress.documentDetection', {
        detail: progressByUseCase.documentDetection
      }));
    }
    var dependencies;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (documentDetectorPreloading) return [2 /*return*/, new Promise(function (resolve) {
            var i = setInterval(function () {
              if (!documentDetectorPreloading) {
                clearInterval(i);
                resolve();
              }
            }, 100);
          })];
          documentDetectorPreloading = true;
          return [4 /*yield*/, probeModelCapabilities()];
        case 1:
          _a.sent();
          if (modelCapabilities.delegate === 'NONE') {
            throw new Error('No available delegate for document detector.');
          }
          dependencies = [defaultDocumentDetectorModelPath];
          document.addEventListener('idmission.preloadProgress', handleDownloadProgress);
          _a.label = 2;
        case 2:
          _a.trys.push([2,, 4, 5]);
          return [4 /*yield*/, Promise.all(dependencies.map(preloadDependency))];
        case 3:
          _a.sent();
          return [3 /*break*/, 5];
        case 4:
          document.removeEventListener('idmission.preloadProgress', handleDownloadProgress);
          documentDetectorPreloading = false;
          return [7 /*endfinally*/];
        case 5:
          return [2 /*return*/];
      }
    });
  });
}
function preloadFocusModelDependencies() {
  return __awaiter(this, void 0, void 0, function () {
    function handleModelDownloadProgress(event) {
      var detail = event.detail;
      if (!dependencies.includes(detail.url)) return;
      progressByUseCase.focus = sumUpProgressForDependencies(dependencies);
      document.dispatchEvent(new CustomEvent('idmission.preloadProgress.focus', {
        detail: progressByUseCase.focus
      }));
    }
    var dependencies;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (focusModelPreloading) return [2 /*return*/, new Promise(function (resolve) {
            var i = setInterval(function () {
              if (!focusModelPreloading) {
                clearInterval(i);
                resolve();
              }
            }, 100);
          })];
          focusModelPreloading = true;
          return [4 /*yield*/, probeModelCapabilities()];
        case 1:
          _a.sent();
          if (modelCapabilities.delegate === 'NONE') {
            throw new Error('No available delegate for document detector.');
          }
          dependencies = [defaultFocusModelPath];
          document.addEventListener('idmission.preloadProgress', handleModelDownloadProgress);
          _a.label = 2;
        case 2:
          _a.trys.push([2,, 4, 5]);
          return [4 /*yield*/, Promise.all(dependencies.map(preloadDependency))];
        case 3:
          _a.sent();
          return [3 /*break*/, 5];
        case 4:
          document.removeEventListener('idmission.preloadProgress', handleModelDownloadProgress);
          focusModelPreloading = false;
          return [7 /*endfinally*/];
        case 5:
          return [2 /*return*/];
      }
    });
  });
}
function preloadFaceDetectorDependencies() {
  return __awaiter(this, void 0, void 0, function () {
    function handleModelDownloadProgress(event) {
      var detail = event.detail;
      if (!dependencies.includes(detail.url)) return;
      progressByUseCase.faceDetection = sumUpProgressForDependencies(dependencies);
      document.dispatchEvent(new CustomEvent('idmission.preloadProgress.faceDetection', {
        detail: progressByUseCase.faceDetection
      }));
    }
    var dependencies;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (faceDetectorPreloading) return [2 /*return*/, new Promise(function (resolve) {
            var i = setInterval(function () {
              if (!faceDetectorPreloading) {
                clearInterval(i);
                resolve();
              }
            }, 100);
          })];
          faceDetectorPreloading = true;
          return [4 /*yield*/, probeModelCapabilities()];
        case 1:
          _a.sent();
          if (modelCapabilities.delegate === 'NONE') {
            throw new Error('No available delegate for document detector.');
          }
          dependencies = [defaultFaceDetectorModelPath];
          document.addEventListener('idmission.preloadProgress', handleModelDownloadProgress);
          _a.label = 2;
        case 2:
          _a.trys.push([2,, 4, 5]);
          return [4 /*yield*/, Promise.all(dependencies.map(preloadDependency))];
        case 3:
          _a.sent();
          return [3 /*break*/, 5];
        case 4:
          document.removeEventListener('idmission.preloadProgress', handleModelDownloadProgress);
          faceDetectorPreloading = false;
          return [7 /*endfinally*/];
        case 5:
          return [2 /*return*/];
      }
    });
  });
}
function progressToPercentage(progress) {
  return progress.total > 0 ? Math.round(100.0 * progress.loaded / progress.total) : 0;
}
function sumUpProgressForDependencies(dependencies) {
  return dependencies.reduce(function (result, dependency) {
    var dependencyProgress = progressByUrl[dependency];
    if (!dependencyProgress) return result;
    result.loaded += dependencyProgress.loaded;
    result.total += dependencyProgress.total;
    return result;
  }, {
    loaded: 0,
    total: 0
  });
}

var defaultDocumentDetectionScoreThreshold = 0.1;
var defaultDocumentDetectionModelLoadTimeoutMs = 45000;
var defaultDocumentDetectionThresholds = {
  idCardFront: 0.6,
  idCardBack: 0.6,
  passport: 0.4,
  singlePage: 0.4,
  stability: {
    idCardFront: 0.85,
    idCardBack: 0.85,
    passport: 0.5,
    singlePage: 0.5
  }
};
var documentTypeDisplayNames = {
  idCardFront: 'ID card front',
  idCardBack: 'ID card back',
  passport: 'Passport',
  singlePage: 'Single page',
  none: 'None'
};
var detector = null;
var detectorSettings = null;
function loadDocumentDetector() {
  return __awaiter(this, arguments, void 0, function (modelAssetPath, scoreThreshold) {
    var _a, _b;
    if (modelAssetPath === void 0) {
      modelAssetPath = defaultDocumentDetectorModelPath;
    }
    if (scoreThreshold === void 0) {
      scoreThreshold = defaultDocumentDetectionScoreThreshold;
    }
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          if (detector && (detectorSettings === null || detectorSettings === void 0 ? void 0 : detectorSettings.modelAssetPath) === modelAssetPath && (detectorSettings === null || detectorSettings === void 0 ? void 0 : detectorSettings.scoreThreshold) === scoreThreshold) return [2 /*return*/, detector];
          closeDocumentDetector();
          return [4 /*yield*/, preloadDocumentDetectorDependencies()];
        case 1:
          _c.sent();
          if (modelCapabilities.delegate === 'NONE') {
            throw new Error('No available delegate for document detector.');
          }
          _b = (_a = ObjectDetector).createFromOptions;
          return [4 /*yield*/, FilesetResolver.forVisionTasks(visionTasksBasePath)];
        case 2:
          return [4 /*yield*/, _b.apply(_a, [_c.sent(), {
            baseOptions: {
              modelAssetPath: modelAssetPath,
              delegate: modelCapabilities.delegate
            },
            // canvas: document.createElement('canvas'),
            scoreThreshold: scoreThreshold,
            runningMode: 'VIDEO'
          }])];
        case 3:
          detector = _c.sent();
          detectorSettings = {
            modelAssetPath: modelAssetPath,
            scoreThreshold: scoreThreshold
          };
          return [2 /*return*/, detector];
      }
    });
  });
}
function closeDocumentDetector() {
  detector === null || detector === void 0 ? void 0 : detector.close();
  detector = null;
  detectorSettings = null;
}
function useLoadDocumentDetector(_a) {
  var _b = _a.shouldLoadModels,
    shouldLoadModels = _b === void 0 ? true : _b,
    _c = _a.modelPath,
    modelPath = _c === void 0 ? defaultDocumentDetectorModelPath : _c,
    _d = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _d === void 0 ? defaultDocumentDetectionModelLoadTimeoutMs : _d,
    _e = _a.scoreThreshold,
    scoreThreshold = _e === void 0 ? defaultDocumentDetectionScoreThreshold : _e,
    onModelError = _a.onModelError,
    videoRef = _a.videoRef;
  var _f = useState(false),
    ready = _f[0],
    setReady = _f[1];
  var _g = useState(0),
    modelDownloadProgress = _g[0],
    setModelDownloadProgress = _g[1];
  var _h = useState(null),
    modelError = _h[0],
    setModelError = _h[1];
  useEffect(function loadModel() {
    var _this = this;
    if (!shouldLoadModels) return;
    setReady(false);
    function handleDownloadProgress(event) {
      setModelDownloadProgress(progressToPercentage(event.detail));
    }
    document.addEventListener('idmission.preloadProgress.documentDetection', handleDownloadProgress);
    var modelLoadTimeout = setTimeout(function () {
      setModelError(new Error('Model loading time limit exceeded.'));
    }, modelLoadTimeoutMs);
    loadDocumentDetector(modelPath, scoreThreshold).then(function (model) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setModelDownloadProgress(100);
              clearTimeout(modelLoadTimeout);
              return [4 /*yield*/, waitForVideoReady(videoRef)];
            case 1:
              _a.sent();
              setTimeout(function () {
                model.detectForVideo(videoRef.current, performance.now());
                setReady(true);
              }, 500);
              return [2 /*return*/];
          }
        });
      });
    })["catch"](function (e) {
      setModelError(e);
    })["finally"](function () {
      clearTimeout(modelLoadTimeout);
    });
    return function () {
      log('unloading document detection model');
      closeDocumentDetector();
      clearTimeout(modelLoadTimeout);
      document.removeEventListener('idmission.preloadProgress.documentDetection', handleDownloadProgress);
    };
  }, [shouldLoadModels, modelLoadTimeoutMs, modelPath, scoreThreshold, videoRef]);
  useEffect(function handleModelError() {
    if (modelError) onModelError === null || onModelError === void 0 ? void 0 : onModelError(modelError);
  }, [modelError, onModelError]);
  return {
    ready: ready,
    modelDownloadProgress: modelDownloadProgress,
    modelError: modelError,
    setModelError: setModelError
  };
}
function makeDocumentDetectorPrediction(frame) {
  return __awaiter(this, void 0, void 0, function () {
    var startedAt, prediction, time, frameWidth, frameHeight;
    return __generator(this, function (_a) {
      if (!detector) return [2 /*return*/, null];
      startedAt = new Date();
      // Detectors can throw errors, for example when using custom URLs that
      // contain a model that doesn't provide the expected output.
      try {
        prediction = detector.detectForVideo(frame, performance.now());
        time = new Date().getTime() - startedAt.getTime();
        frameWidth = frame.width;
        frameHeight = frame.height;
        return [2 /*return*/, _assign(_assign({}, prediction), {
          time: time,
          frameWidth: frameWidth,
          frameHeight: frameHeight
        })];
      } catch (e) {
        error('caught object detection error', e);
      }
      return [2 /*return*/, null];
    });
  });
}
var lastDetectionAt = 0;
var lastDetectionTime = 0;
function setLastDetectionAt(time) {
  lastDetectionTime = time - lastDetectionAt;
  lastDetectionAt = time;
}
var framesNeededSamples = [];
function trackFramesNeeded(value, bufferLength) {
  if (bufferLength === void 0) {
    bufferLength = 25;
  }
  framesNeededSamples.unshift(value);
  if (framesNeededSamples.length > bufferLength) framesNeededSamples.length = bufferLength;
}
var lastNBoxes = [];
var lastNPairs = [];
function trackBox(box, framesNeeded) {
  if (framesNeeded === void 0) {
    framesNeeded = 12;
  }
  lastNBoxes.unshift(box);
  if (lastNBoxes.length > framesNeeded) lastNBoxes.length = framesNeeded;
  if (lastNBoxes.length > 1) {
    var lastBox = lastNBoxes[1];
    var iou = calculateIoU(box, lastBox);
    lastNPairs.unshift({
      a: box,
      b: lastBox,
      iou: iou
    });
    if (lastNPairs.length > framesNeeded - 1) lastNPairs.length = framesNeeded - 1;
  }
}
var defaultDocumentDetectionBoundaries = {
  top: 20,
  bottom: 20,
  left: 20,
  right: 20
};
function processDocumentDetectorPrediction(prediction, thresholds, boundaries) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  if (boundaries === void 0) {
    boundaries = defaultDocumentDetectionBoundaries;
  }
  var detections = prediction.detections,
    frameWidth = prediction.frameWidth,
    frameHeight = prediction.frameHeight,
    time = prediction.time;
  var boundaryTop = (_a = boundaries.top) !== null && _a !== void 0 ? _a : 20;
  var boundaryLeft = (_b = boundaries.left) !== null && _b !== void 0 ? _b : 20;
  var boundaryRight = (_c = boundaries.right) !== null && _c !== void 0 ? _c : 20;
  var boundaryBottom = (_d = boundaries.bottom) !== null && _d !== void 0 ? _d : 20;
  var frameWidth80Pct = frameWidth * 0.8;
  var detectedObjects = applyNonMaxSuppression(detections.flatMap(function (d) {
    return d.categories.map(function (category) {
      return {
        label: category === null || category === void 0 ? void 0 : category.categoryName,
        score: category === null || category === void 0 ? void 0 : category.score,
        box: convertBoundingBox(d.boundingBox)
      };
    });
  }), function (obj) {
    var _a = obj.box,
      xMin = _a.xMin,
      yMin = _a.yMin,
      width = _a.width,
      height = _a.height;
    return yMin > boundaryTop &&
    // Is it valid top edge of ID detected?
    yMin + height + boundaryBottom < frameHeight && (
    // Is it valid bottom edge less than max video height
    xMin > boundaryLeft || xMin + width > frameWidth80Pct) &&
    // If either the left side visible or if not, right edge of ID should be more than 80% of width.
    xMin + width + boundaryRight < frameWidth // Valid right edge if it's less than video width.
    ;
  });
  var allZero = detections.length > 0 && !detections.some(function (_a) {
    var boundingBox = _a.boundingBox;
    return Object.values(boundingBox !== null && boundingBox !== void 0 ? boundingBox : {}).some(function (n) {
      return n > 0;
    });
  });
  var bestIdCardFront = detectedObjects.find(function (obj) {
    return obj.label === 'Document';
  });
  var bestIdCardBack = detectedObjects.find(function (obj) {
    return obj.label === 'Document back';
  });
  var bestPassportPage = detectedObjects.find(function (obj) {
    return obj.label === 'Passport page';
  });
  var bestSinglePage = detectedObjects.find(function (obj) {
    return obj.label === 'Single page';
  });
  var idCardFrontDetectionScore = (_e = bestIdCardFront === null || bestIdCardFront === void 0 ? void 0 : bestIdCardFront.score) !== null && _e !== void 0 ? _e : 0;
  var idCardBackDetectionScore = (_f = bestIdCardBack === null || bestIdCardBack === void 0 ? void 0 : bestIdCardBack.score) !== null && _f !== void 0 ? _f : 0;
  var passportDetectionScore = (_g = bestPassportPage === null || bestPassportPage === void 0 ? void 0 : bestPassportPage.score) !== null && _g !== void 0 ? _g : 0;
  var singlePageDetectionScore = (_h = bestSinglePage === null || bestSinglePage === void 0 ? void 0 : bestSinglePage.score) !== null && _h !== void 0 ? _h : 0;
  var idCardFrontDetectionThresholdMet = idCardFrontDetectionScore >= ((_j = thresholds.idCardFront) !== null && _j !== void 0 ? _j : 0);
  var idCardBackDetectionThresholdMet = idCardBackDetectionScore >= ((_k = thresholds.idCardBack) !== null && _k !== void 0 ? _k : 0);
  var passportDetectionThresholdMet = passportDetectionScore >= ((_l = thresholds.passport) !== null && _l !== void 0 ? _l : 0);
  var singlePageDetectionThresholdMet = singlePageDetectionScore >= ((_m = thresholds.singlePage) !== null && _m !== void 0 ? _m : 0);
  var bestDocument = singlePageDetectionThresholdMet ? bestSinglePage : passportDetectionThresholdMet ? bestPassportPage : idCardBackDetectionThresholdMet ? bestIdCardBack : bestIdCardFront;
  var detectionThreshold = singlePageDetectionThresholdMet ? thresholds.singlePage : passportDetectionThresholdMet ? thresholds.passport : idCardBackDetectionThresholdMet ? thresholds.idCardBack : thresholds.idCardFront;
  var detectionScore = (_o = bestDocument === null || bestDocument === void 0 ? void 0 : bestDocument.score) !== null && _o !== void 0 ? _o : 0;
  var detectionThresholdMet = detectionScore >= (detectionThreshold !== null && detectionThreshold !== void 0 ? detectionThreshold : 0);
  var detectedDocumentType = 'none';
  if (singlePageDetectionThresholdMet) {
    detectedDocumentType = 'singlePage';
  } else if (passportDetectionThresholdMet) {
    detectedDocumentType = 'passport';
  } else if (idCardBackDetectionThresholdMet) {
    detectedDocumentType = 'idCardBack';
  } else if (detectionThresholdMet) {
    detectedDocumentType = 'idCardFront';
  }
  var documentInBounds = !!bestDocument;
  if (lastDetectionTime > 0) {
    trackFramesNeeded(1000 / lastDetectionTime);
  }
  var documentIsStable = false;
  var documentTooClose = false;
  if (bestDocument) {
    var _q = [bestDocument.box.width / frameWidth, bestDocument.box.height / frameHeight],
      docWidth = _q[0],
      docHeight = _q[1];
    documentTooClose = docWidth > 0.85 || docHeight > 0.85;
    if (detectionThresholdMet && documentInBounds && !documentTooClose) {
      var thresholdSet = (_p = thresholds.stability) !== null && _p !== void 0 ? _p : defaultDocumentDetectionThresholds.stability;
      var threshold_1 = thresholdSet[detectedDocumentType];
      var framesNeeded = Math.ceil(average(framesNeededSamples));
      trackBox(bestDocument.box, framesNeeded);
      documentIsStable = lastNBoxes.length >= framesNeeded && !lastNPairs.some(function (pair) {
        return pair.iou < threshold_1;
      });
    }
  }
  return {
    prediction: prediction,
    detectedObjects: detectedObjects,
    detectionScore: detectionScore,
    detectionTime: time,
    detectionThresholdMet: detectionThresholdMet,
    detectedDocumentType: detectedDocumentType,
    idCardFrontDetectionScore: idCardFrontDetectionScore,
    idCardFrontDetectionThresholdMet: idCardFrontDetectionThresholdMet,
    idCardBackDetectionScore: idCardBackDetectionScore,
    idCardBackDetectionThresholdMet: idCardBackDetectionThresholdMet,
    passportDetectionScore: passportDetectionScore,
    passportDetectionThresholdMet: passportDetectionThresholdMet,
    singlePageDetectionScore: singlePageDetectionScore,
    singlePageDetectionThresholdMet: singlePageDetectionThresholdMet,
    bestDocument: bestDocument,
    documentInBounds: documentInBounds,
    documentTooClose: documentTooClose,
    documentIsStable: documentIsStable,
    frameWidth: frameWidth,
    frameHeight: frameHeight,
    allZero: allZero
  };
}
function applyNonMaxSuppression(detectedObjects, isGoodBox) {
  var maxes = {};
  detectedObjects.forEach(function (obj, i) {
    if (obj) {
      if (!maxes[obj.label]) maxes[obj.label] = [0, -1];
      if (obj.score > maxes[obj.label][0] && (isGoodBox === null || isGoodBox === void 0 ? void 0 : isGoodBox(obj))) maxes[obj.label] = [obj.score, i];
    }
  });
  return Object.keys(maxes).map(function (label) {
    return detectedObjects[maxes[label][1]];
  }).filter(function (obj) {
    return !!obj;
  });
}

function useFrameLoop(fn, _a) {
  var _b = _a.throttleMs,
    throttleMs = _b === void 0 ? 0 : _b,
    _c = _a.autoStart,
    autoStart = _c === void 0 ? false : _c;
  var _d = useState(false),
    running = _d[0],
    setRunning = _d[1];
  var startedAtRef = useRef(null);
  var loopId = useRef(0);
  var frameId = useRef(0);
  useEffect(function runFrameLoop() {
    if (!running) return;
    var timer;
    var currentLoopId = loopId.current;
    function renderPrediction() {
      return __awaiter(this, void 0, void 0, function () {
        var start, timeRunning, took, amountToThrottle;
        var _a, _b;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (currentLoopId !== loopId.current) return [2 /*return*/];
              start = new Date().getTime();
              timeRunning = start - ((_b = (_a = startedAtRef.current) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0);
              return [4 /*yield*/, fn(frameId.current, timeRunning)];
            case 1:
              _c.sent();
              took = new Date().getTime() - start;
              amountToThrottle = Math.max((throttleMs !== null && throttleMs !== void 0 ? throttleMs : 0) - took, 0);
              timer = setTimeout(function () {
                frameId.current = requestAnimationFrame(renderPrediction);
              }, amountToThrottle);
              return [2 /*return*/];
          }
        });
      });
    }
    renderPrediction().then();
    return function () {
      loopId.current += 1;
      if (frameId.current) cancelAnimationFrame(frameId.current);
      if (timer) clearTimeout(timer);
    };
  }, [fn, running, throttleMs]);
  var start = useCallback(function () {
    startedAtRef.current = new Date();
    setRunning(true);
  }, []);
  var stop = useCallback(function () {
    loopId.current += 1; // force the loop to stop immediately.
    setRunning(false);
    startedAtRef.current = null;
  }, []);
  useEffect(function startAutomatically() {
    if (autoStart) start();
    return function () {
      stop();
    };
  }, [autoStart, start, stop]);
  return {
    start: start,
    stop: stop
  };
}

function listAvailableCameras(facingMode_1) {
  return __awaiter(this, arguments, void 0, function (facingMode, requestMicAccess) {
    var cameraEnumerationStream, videoDevices;
    if (requestMicAccess === void 0) {
      requestMicAccess = false;
    }
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
            video: {
              facingMode: {
                exact: facingMode
              }
            },
            audio: requestMicAccess
          })
          // This lists all available cameras attached to the user's device.
          ];
        case 1:
          cameraEnumerationStream = _a.sent();
          return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
        case 2:
          videoDevices = _a.sent().filter(function (_a) {
            var kind = _a.kind;
            return kind === 'videoinput';
          });
          // Release the access to the user's camera that we obtained for enumeration purposes.
          cameraEnumerationStream.getVideoTracks().forEach(function (track) {
            track.enabled = false;
            track.stop();
          });
          cameraEnumerationStream = null;
          return [2 /*return*/, videoDevices];
      }
    });
  });
}
var frontCameraLabels = ['front', 'avant', 'anteriore', 'cameraaanvoorzijde', 'kamerapåframsidan', 'forsidekamera', 'kamerapåforsiden', 'aparatprzedni', 'etukamera', 'kameradepan', 'ÖnKamera', 'cameramặttrước', 'camerăfață', 'prednákamera', 'prednjakamera', 'előlapikamera', 'přednífotoaparát', 'μπροστινήκάμερα', 'переднякамера', 'передняякамера', 'преднакамера', 'алдыңғыкамера', 'מצלמה קדמית', 'الكاميرا الأمامية', 'फ़्रंटकैमरा', '前置相机', '前置鏡頭', '前面カメラ', '전면카메라', 'กล้องด้านหน้า'].map(function (s) {
  return s.toLocaleLowerCase().split(' ').join('');
});
var rearCameraLabels = ['back', 'rear', 'posterior', 'trasera', 'traseira', 'arrière', 'rückkamera', 'fotocamera(posteriore)', 'cameraaanachterzijde', 'kamerapåbaksidan', 'kamerapåbaksiden', 'bagsidekamera', 'aparattylny', 'takakamera', 'arkakamera', 'kamerabelakang', 'cameramặtsau', 'camerăspate', 'stražnjakamera', 'zadnákamera', 'hátoldalikamera', 'zadnífotoaparát', 'πίσωκάμερα', 'заднякамера', 'Задняякамера', 'заднакамера', 'артқыкамера', 'מצלמה אחורית', 'الكاميرا الخلفية', 'बैककैमरा', '后置相机', '後置鏡頭', '背面カメラ', '후면카메라', 'กล้องด้านหลัง'].map(function (s) {
  return s.toLocaleLowerCase().split(' ').join('');
});
var backUltraWideCameraLabels = ['backdualwidecamera', 'backultrawidecamera', 'ultraampliaposterior', 'ultra-angulartraseira', 'ultragrandeangulartraseira', 'ultragrandangle', 'ultragranangular', 'ultra-weitwinkelkamera', 'ultra-grandangolo', 'ultrabredecameraaanachterzijde', 'ultravidvinkelkamerapåbaksidan', 'ultravidvinkelkameraetpåbagsiden', 'ultravidvinkelkamerabak', 'ultragenişkameraarkayüzü', 'ultralaajakulmainentakakamera', 'tylnyaparatultraszerokokątny', 'cameracựcrộngmặtsau', 'camerăcuobiectivultra‑superangularspate', 'ultraszéleslátószögűkamera', 'kameraultralebarbelakang', 'stražnjaultraširokakamera', 'zadníultraširokoúhlýfotoaparát', 'ultraširokouhlá', 'πίσωυπερευρείακάμερα', 'заднянадширококутнакамера', 'Задняясверхширокоугольнаякамера', 'Задна свръх широкоъгълна камера', 'артқыультракеңбұрыштыкамера', 'מצלמה אולטרה רחבה אחורית', 'كاميرا خلفية عريضة جدًا', 'बैकअल्ट्रावाइडकैमरा', '后置超广角相机', '後置超廣角鏡頭相機', '背面超広角カメラ', '후면울트라와이드카메라', 'กล้องด้านหลังอัลตร้าไวด์'].map(function (s) {
  return s.toLocaleLowerCase().split(' ').join('');
});
var cameraLabelMatches = function cameraLabelMatches(labelOrDevice, labelSetOrLabel) {
  var label = labelOrDevice instanceof MediaDeviceInfo ? getDeviceLabel(labelOrDevice) : labelOrDevice;
  var labelSet = typeof labelSetOrLabel === 'string' ? [labelSetOrLabel] : labelSetOrLabel;
  return labelSet.some(function (l) {
    return label.includes(l);
  });
};
var getDeviceLabel = function getDeviceLabel(deviceInfo) {
  return deviceInfo.label.toLocaleLowerCase().split(' ').join('');
};
var currentCamera;
function obtainCameraAccess(stream, deviceLabel, video) {
  releaseCameraAccess();
  log('obtaining camera access...');
  var _a = stream.getVideoTracks()[0].getSettings(),
    width = _a.width,
    height = _a.height;
  log('camera dimensions', width, height);
  var label = deviceLabel.toLocaleLowerCase().split(' ').join('');
  log('camera label', label);
  var isRearFacing = cameraLabelMatches(label, __spreadArray(__spreadArray(__spreadArray([], rearCameraLabels, true), backUltraWideCameraLabels, true), ['iphone'], false));
  log('is rear facing?', isRearFacing);
  var release = function release() {
    stream.getTracks().forEach(function (track) {
      track.enabled = false;
      track.stop();
    });
    if (video) {
      video.pause();
      video.srcObject = null;
      video.src = '';
    }
  };
  width || (width = 0);
  height || (height = 0);
  currentCamera = {
    label: deviceLabel,
    stream: stream,
    width: width,
    height: height,
    isRearFacing: isRearFacing,
    release: release
  };
  log('camera access granted');
  if (video) video.srcObject = stream;
  log('video source initialized');
  return currentCamera;
}
function releaseCameraAccess() {
  if (!currentCamera) return;
  log('releasing camera access...');
  currentCamera.release();
  currentCamera = undefined;
}

var initialState$5 = {
  videoRef: {
    current: null
  },
  videoLoaded: false,
  videoStream: null,
  videoDevice: null,
  isRearFacing: false,
  camera: null,
  cameraReady: false,
  cameraAccessDenied: false,
  iphoneContinuityCameraAvailable: false,
  iphoneContinuityCameraDenied: false,
  preferIphoneContinuityCamera: true,
  audioStream: null,
  microphoneReady: false,
  microphoneAccessDenied: false
};
var createCameraStore = function createCameraStore(config) {
  var store = createStore(function (set, get) {
    return _assign(_assign(_assign({}, initialState$5), config), {
      reset: function reset() {
        return set(_assign(_assign({}, initialState$5), config));
      },
      setConfig: function setConfig(config) {
        return set(config);
      },
      onVideoMounted: function onVideoMounted() {
        return set({
          videoLoaded: true
        });
      },
      setIphoneContinuityCameraAllowed: function setIphoneContinuityCameraAllowed(value) {
        return set({
          preferIphoneContinuityCamera: value
        });
      },
      requestCameraAccess: function requestCameraAccess() {
        return __awaiter(this, void 0, void 0, function () {
          var _a, videoRef, releaseCameraAccess, preferFrontFacingCamera, preferIphoneContinuityCamera, iphoneContinuityCameraDenied, availableCameras, selectedCamera, platform_1, iphoneContinuityCamera, constraints, stream_1, e_1, e_2, handleStreamEnded_1, videoTrack_1, camera_1, e_3;
          var _b, _c, _d;
          return __generator(this, function (_e) {
            switch (_e.label) {
              case 0:
                _a = get(), videoRef = _a.videoRef, releaseCameraAccess = _a.releaseCameraAccess, preferFrontFacingCamera = _a.preferFrontFacingCamera, preferIphoneContinuityCamera = _a.preferIphoneContinuityCamera, iphoneContinuityCameraDenied = _a.iphoneContinuityCameraDenied;
                releaseCameraAccess();
                _e.label = 1;
              case 1:
                _e.trys.push([1, 11,, 12]);
                return [4 /*yield*/, listAvailableCameras()];
              case 2:
                availableCameras = _e.sent();
                selectedCamera = void 0;
                debug('availableCameras', availableCameras);
                platform_1 = getPlatform();
                debug('platformDetails', platform_1);
                if (!iphoneContinuityCameraDenied && (!(platform_1 === null || platform_1 === void 0 ? void 0 : platform_1.os) || platform_1.os.family === 'OS X')) {
                  iphoneContinuityCamera = availableCameras.find(function (deviceInfo) {
                    return cameraLabelMatches(deviceInfo, 'iphone');
                  });
                  set({
                    iphoneContinuityCameraAvailable: !!iphoneContinuityCamera
                  });
                  if (iphoneContinuityCamera && preferIphoneContinuityCamera) {
                    selectedCamera = iphoneContinuityCamera;
                  }
                } else if (((_b = platform_1 === null || platform_1 === void 0 ? void 0 : platform_1.os) === null || _b === void 0 ? void 0 : _b.family) === 'Android' || availableCameras.every(function (c) {
                  return c.label.startsWith('camera2 ');
                })) {
                  availableCameras = availableCameras.sort(function (a, b) {
                    return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
                  });
                  debug('cameras have been sorted', availableCameras);
                }
                if (preferFrontFacingCamera) {
                  selectedCamera = availableCameras.find(function (deviceInfo) {
                    return cameraLabelMatches(deviceInfo, frontCameraLabels);
                  });
                }
                selectedCamera || (selectedCamera = availableCameras.find(function (deviceInfo) {
                  return cameraLabelMatches(deviceInfo, 'backtriplecamera');
                }));
                selectedCamera || (selectedCamera = availableCameras.find(function (deviceInfo) {
                  return cameraLabelMatches(deviceInfo, 'backdualcamera');
                }));
                selectedCamera || (selectedCamera = availableCameras.find(function (deviceInfo) {
                  return cameraLabelMatches(deviceInfo, rearCameraLabels) && !cameraLabelMatches(deviceInfo, backUltraWideCameraLabels);
                }));
                selectedCamera || (selectedCamera = availableCameras.find(function (deviceInfo) {
                  return cameraLabelMatches(deviceInfo, rearCameraLabels);
                }));
                // on iOS, the front facing camera always is at the first position in the list, so we skip it if all else fails.
                if (!preferFrontFacingCamera && ((_c = platform_1 === null || platform_1 === void 0 ? void 0 : platform_1.os) === null || _c === void 0 ? void 0 : _c.family) === 'iOS' && availableCameras.length > 0) {
                  selectedCamera || (selectedCamera = availableCameras[1]);
                }
                selectedCamera || (selectedCamera = availableCameras[0]);
                debug('selectedCamera', selectedCamera);
                set({
                  videoDevice: selectedCamera
                });
                constraints = {
                  audio: false,
                  video: {
                    deviceId: {
                      exact: selectedCamera.deviceId
                    },
                    width: {
                      ideal: config.maxVideoWidth
                    },
                    aspectRatio: 1.777777778,
                    frameRate: {}
                  }
                };
                if (config.maxFps) {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  constraints.video.frameRate = {
                    max: config.maxFps
                  };
                }
                stream_1 = null;
                _e.label = 3;
              case 3:
                _e.trys.push([3, 5,, 6]);
                debug('obtaining camera access with constraints', constraints);
                return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constraints)];
              case 4:
                stream_1 = _e.sent();
                return [3 /*break*/, 6];
              case 5:
                e_1 = _e.sent();
                if (e_1.name === 'NotAllowedError') {
                  if (preferIphoneContinuityCamera) {
                    set({
                      iphoneContinuityCameraAvailable: false,
                      iphoneContinuityCameraDenied: true
                    });
                  } else {
                    set({
                      cameraAccessDenied: true
                    });
                  }
                  return [2 /*return*/];
                }
                return [3 /*break*/, 6];
              case 6:
                if (!!stream_1) return [3 /*break*/, 10];
                _e.label = 7;
              case 7:
                _e.trys.push([7, 9,, 10]);
                return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                  audio: false,
                  video: true
                })];
              case 8:
                stream_1 = _e.sent();
                debug('opened stream with no width and height constraints');
                return [3 /*break*/, 10];
              case 9:
                e_2 = _e.sent();
                debug('cannot open stream at all', e_2);
                return [3 /*break*/, 10];
              case 10:
                if (!stream_1) {
                  error('failed to open camera');
                  throw new Error('failed to open camera: ');
                }
                debug('camera access granted with constraints', constraints);
                handleStreamEnded_1 = function handleStreamEnded_1() {
                  if (preferIphoneContinuityCamera && get().iphoneContinuityCameraAvailable) {
                    debug('someone unplugged the continuity camera');
                    set({
                      videoStream: null,
                      videoDevice: null,
                      cameraReady: false,
                      iphoneContinuityCameraAvailable: false,
                      iphoneContinuityCameraDenied: true
                    });
                    get().requestCameraAccess();
                  } else {
                    debug('someone unplugged the webcam');
                    releaseCameraAccess();
                    set({
                      videoStream: null,
                      videoDevice: null,
                      videoLoaded: false,
                      cameraReady: false,
                      cameraAccessDenied: true
                    });
                  }
                };
                (_d = videoRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener('ended', handleStreamEnded_1);
                videoTrack_1 = stream_1.getVideoTracks()[0];
                videoTrack_1.onended = handleStreamEnded_1;
                camera_1 = obtainCameraAccess(stream_1, selectedCamera.label, videoRef.current);
                setTimeout(function () {
                  // iOS 17 has a strange behavior where the video track flickers between muted and unmuted
                  // when the camera access is being requested. This delay is a workaround for that.
                  videoTrack_1.onmute = function () {
                    if (videoTrack_1.readyState !== 'live') handleStreamEnded_1();
                  };
                  set({
                    camera: camera_1,
                    cameraReady: true,
                    cameraAccessDenied: false,
                    isRearFacing: camera_1.isRearFacing,
                    videoStream: stream_1
                  });
                }, 500);
                return [3 /*break*/, 12];
              case 11:
                e_3 = _e.sent();
                if (e_3.name === 'NotAllowedError') {
                  error('camera access has been blocked by the user', e_3);
                  set({
                    cameraAccessDenied: true
                  });
                } else {
                  error('camera access encountered some other error', e_3);
                  throw e_3;
                }
                return [3 /*break*/, 12];
              case 12:
                return [2 /*return*/];
            }
          });
        });
      },
      releaseCameraAccess: function releaseCameraAccess() {
        return __awaiter(this, void 0, void 0, function () {
          var camera;
          return __generator(this, function (_a) {
            camera = get().camera;
            if (!camera) return [2 /*return*/];
            camera.release();
            set({
              camera: null,
              cameraReady: false,
              cameraAccessDenied: false
            });
            return [2 /*return*/];
          });
        });
      },
      requestMicrophoneAccess: function requestMicrophoneAccess() {
        return __awaiter(this, void 0, void 0, function () {
          var stream_2, e_4;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                get().releaseMicrophoneAccess();
                _a.label = 1;
              case 1:
                _a.trys.push([1, 3,, 4]);
                return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                  audio: true,
                  video: false
                })
                // iOS 17 has a strange behavior where the video track flickers between muted and unmuted
                // when the camera access is being requested. This delay is a workaround for that.
                ];
              case 2:
                stream_2 = _a.sent();
                // iOS 17 has a strange behavior where the video track flickers between muted and unmuted
                // when the camera access is being requested. This delay is a workaround for that.
                setTimeout(function () {
                  set({
                    audioStream: stream_2,
                    microphoneReady: true,
                    microphoneAccessDenied: false
                  });
                  var handleStreamEnded = function handleStreamEnded() {
                    set({
                      microphoneReady: false,
                      microphoneAccessDenied: true
                    });
                  };
                  var track = stream_2.getAudioTracks()[0];
                  track.onended = handleStreamEnded;
                  track.onmute = function () {
                    if (track.readyState !== 'live') handleStreamEnded();
                  };
                }, 500);
                return [3 /*break*/, 4];
              case 3:
                e_4 = _a.sent();
                debug('failed to open microphone', e_4);
                set({
                  microphoneAccessDenied: true
                });
                return [3 /*break*/, 4];
              case 4:
                return [2 /*return*/];
            }
          });
        });
      },
      releaseMicrophoneAccess: function releaseMicrophoneAccess() {
        var _a;
        var audioStream = get().audioStream;
        (_a = audioStream === null || audioStream === void 0 ? void 0 : audioStream.stop) === null || _a === void 0 ? void 0 : _a.call(audioStream);
        audioStream === null || audioStream === void 0 ? void 0 : audioStream.getAudioTracks().forEach(function (track) {
          var _a;
          (_a = track.stop) === null || _a === void 0 ? void 0 : _a.call(track);
        });
        set({
          audioStream: null,
          microphoneReady: false,
          microphoneAccessDenied: false
        });
      }
    });
  });
  if (config.requestAccessAutomatically) {
    void store.getState().requestCameraAccess();
  }
  return _assign(_assign({}, store), {
    destroy: function destroy() {
      store.getState().releaseCameraAccess();
      store.getState().releaseMicrophoneAccess();
    }
  });
};
var CameraStoreContext = /*#__PURE__*/createContext(undefined);
function CameraStoreProvider(_a) {
  var children = _a.children,
    _b = _a.requestAccessAutomatically,
    requestAccessAutomatically = _b === void 0 ? true : _b,
    _c = _a.preferIphoneContinuityCamera,
    preferIphoneContinuityCamera = _c === void 0 ? true : _c,
    _d = _a.preferFrontFacingCamera,
    preferFrontFacingCamera = _d === void 0 ? false : _d,
    _e = _a.maxVideoWidth,
    maxVideoWidth = _e === void 0 ? 1920 : _e,
    maxFps = _a.maxFps,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    onMicrophoneAccessDenied = _a.onMicrophoneAccessDenied,
    _f = _a.requireMicrophoneAccess,
    requireMicrophoneAccess = _f === void 0 ? false : _f;
  var videoRef = useRef(null);
  var store = useRef();
  store.current || (store.current = createCameraStore({
    videoRef: videoRef,
    requestAccessAutomatically: requestAccessAutomatically,
    preferIphoneContinuityCamera: preferIphoneContinuityCamera,
    preferFrontFacingCamera: preferFrontFacingCamera,
    maxVideoWidth: maxVideoWidth,
    maxFps: maxFps,
    onCameraAccessDenied: onCameraAccessDenied,
    onMicrophoneAccessDenied: onMicrophoneAccessDenied,
    requireMicrophoneAccess: requireMicrophoneAccess
  }));
  useEffect(function () {
    var _a, _b, _c;
    var state = (_a = store.current) === null || _a === void 0 ? void 0 : _a.getState();
    if (!state) return;
    if (preferIphoneContinuityCamera !== (state === null || state === void 0 ? void 0 : state.preferIphoneContinuityCamera) || preferFrontFacingCamera !== (state === null || state === void 0 ? void 0 : state.preferFrontFacingCamera)) {
      (_b = store.current) === null || _b === void 0 ? void 0 : _b.setState({
        preferIphoneContinuityCamera: preferIphoneContinuityCamera,
        preferFrontFacingCamera: preferFrontFacingCamera
      });
      (_c = store.current) === null || _c === void 0 ? void 0 : _c.getState().requestCameraAccess();
    }
  }, [preferFrontFacingCamera, preferIphoneContinuityCamera]);
  useEffect(function () {
    var _a;
    if (!requireMicrophoneAccess) return;
    (_a = store.current) === null || _a === void 0 ? void 0 : _a.getState().requestMicrophoneAccess();
    return function () {
      var _a;
      return (_a = store.current) === null || _a === void 0 ? void 0 : _a.getState().releaseMicrophoneAccess();
    };
  }, [requireMicrophoneAccess]);
  useEffect(function () {
    return function () {
      var _a;
      return (_a = store.current) === null || _a === void 0 ? void 0 : _a.destroy();
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(CameraStoreContext.Provider, {
    value: store.current
  }, children);
}
function useCameraStore(selector) {
  var store = useContext(CameraStoreContext);
  if (!store) throw new Error('useCameraStore cannot be used without Provider');
  return useStore(store, selector);
}

var DocumentDetectionModelContext = /*#__PURE__*/createContext({
  startDocumentDetection: function startDocumentDetection() {
    return null;
  },
  stopDocumentDetection: function stopDocumentDetection() {
    return null;
  },
  documentDetectionModelReady: false,
  documentDetectionModelDownloadProgress: 0,
  documentDetectionModelError: null,
  onDocumentDetected: function onDocumentDetected() {
    return null;
  },
  detectionTime: 0,
  documentDetectionThresholds: {},
  setDocumentDetectionThresholds: function setDocumentDetectionThresholds() {
    return null;
  },
  documentDetectionBoundaries: defaultDocumentDetectionBoundaries,
  setDocumentDetectionBoundaries: function setDocumentDetectionBoundaries() {
    return null;
  },
  documentDetectionLastPredictionCanvas: {
    current: null
  },
  clearDocumentDetectionLastPredictionCanvas: function clearDocumentDetectionLastPredictionCanvas() {
    return null;
  }
});
function DocumentDetectionModelProvider(_a) {
  var _this = this;
  var _b = _a.autoStart,
    autoStart = _b === void 0 ? true : _b,
    children = _a.children,
    _c = _a.throttleMs,
    throttleMs = _c === void 0 ? 16 : _c,
    _d = _a.delayAfterStartMs,
    delayAfterStartMs = _d === void 0 ? 0 : _d,
    _e = _a.documentDetectionModelPath,
    documentDetectionModelPath = _e === void 0 ? defaultDocumentDetectorModelPath : _e,
    _f = _a.documentDetectionModelScoreThreshold,
    documentDetectionModelScoreThreshold = _f === void 0 ? defaultDocumentDetectionScoreThreshold : _f,
    _g = _a.documentDetectionModelLoadTimeoutMs,
    documentDetectionModelLoadTimeoutMs = _g === void 0 ? defaultDocumentDetectionModelLoadTimeoutMs : _g,
    onDocumentDetectionModelError = _a.onDocumentDetectionModelError,
    _h = _a.shouldLoadModels,
    shouldLoadModels = _h === void 0 ? true : _h;
  var _j = useCameraStore(),
    videoRef = _j.videoRef,
    videoLoaded = _j.videoLoaded,
    cameraReady = _j.cameraReady;
  var lastPredictionCanvas = useRef(null);
  var onPredictionHandler = useRef();
  var _k = useState({}),
    documentDetectionThresholds = _k[0],
    setDocumentDetectionThresholds = _k[1];
  var _l = useState(defaultDocumentDetectionBoundaries),
    documentDetectionBoundaries = _l[0],
    setDocumentDetectionBoundaries = _l[1];
  var _m = useState(0),
    timesAllZero = _m[0],
    setTimesAllZero = _m[1];
  var _o = useState(0),
    canvasKey = _o[0],
    setCanvasKey = _o[1];
  var stopDetection = useRef(0);
  var _p = useLoadDocumentDetector({
      modelPath: documentDetectionModelPath,
      modelLoadTimeoutMs: documentDetectionModelLoadTimeoutMs,
      scoreThreshold: documentDetectionModelScoreThreshold,
      onModelError: onDocumentDetectionModelError,
      videoRef: videoRef,
      shouldLoadModels: shouldLoadModels
    }),
    ready = _p.ready,
    modelDownloadProgress = _p.modelDownloadProgress,
    modelError = _p.modelError,
    setModelError = _p.setModelError;
  var _q = useFrameLoop(useCallback(function (frameId, timeRunning) {
      return __awaiter(_this, void 0, void 0, function () {
        var stopDetectionAtStart, vw, vh, ctx, prediction, processedPrediction;
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!videoLoaded || !cameraReady || !ready || !videoRef.current || !lastPredictionCanvas.current) return [2 /*return*/];
              stopDetectionAtStart = stopDetection.current;
              vw = videoRef.current.videoWidth;
              vh = videoRef.current.videoHeight;
              lastPredictionCanvas.current.width = vw;
              lastPredictionCanvas.current.height = vh;
              ctx = lastPredictionCanvas.current.getContext('2d');
              if (!(ctx && videoRef.current.readyState === 4)) return [3 /*break*/, 3];
              if (stopDetectionAtStart !== stopDetection.current) return [2 /*return*/];
              ctx.drawImage(videoRef.current, 0, 0, vw, vh);
              return [4 /*yield*/, makeDocumentDetectorPrediction(lastPredictionCanvas.current)];
            case 1:
              prediction = _b.sent();
              if (!prediction) return [3 /*break*/, 3];
              processedPrediction = processDocumentDetectorPrediction(prediction, documentDetectionThresholds, documentDetectionBoundaries);
              processedPrediction.frameId = frameId;
              setLastDetectionAt(new Date().getTime());
              debug(processedPrediction);
              if (processedPrediction.allZero) setTimesAllZero(function (n) {
                return n + 1;
              });
              if (stopDetectionAtStart !== stopDetection.current) return [2 /*return*/];
              if (timeRunning < delayAfterStartMs) return [2 /*return*/];
              return [4 /*yield*/, (_a = onPredictionHandler.current) === null || _a === void 0 ? void 0 : _a.call(onPredictionHandler, processedPrediction)];
            case 2:
              _b.sent();
              _b.label = 3;
            case 3:
              return [2 /*return*/];
          }
        });
      });
    }, [cameraReady, delayAfterStartMs, documentDetectionBoundaries, documentDetectionThresholds, ready, videoLoaded, videoRef]), {
      throttleMs: throttleMs,
      autoStart: autoStart
    }),
    start = _q.start,
    stop = _q.stop;
  useEffect(function setErrorIfAllZero() {
    if (timesAllZero >= 2) {
      setModelError(new Error('model is returning all zeroes'));
    }
  }, [setModelError, timesAllZero]);
  var onDocumentDetected = useCallback(function (handler) {
    onPredictionHandler.current = handler;
  }, []);
  var clearDocumentDetectionLastPredictionCanvas = useCallback(function () {
    stopDetection.current += 1;
    setCanvasKey(function (n) {
      return n + 1;
    });
  }, []);
  var value = useMemo(function () {
    return {
      startDocumentDetection: start,
      stopDocumentDetection: stop,
      documentDetectionModelReady: ready,
      documentDetectionModelError: modelError,
      documentDetectionModelDownloadProgress: modelDownloadProgress,
      onDocumentDetected: onDocumentDetected,
      detectionTime: lastDetectionTime,
      documentDetectionThresholds: documentDetectionThresholds,
      setDocumentDetectionThresholds: setDocumentDetectionThresholds,
      documentDetectionBoundaries: documentDetectionBoundaries,
      setDocumentDetectionBoundaries: setDocumentDetectionBoundaries,
      documentDetectionLastPredictionCanvas: lastPredictionCanvas,
      clearDocumentDetectionLastPredictionCanvas: clearDocumentDetectionLastPredictionCanvas
    };
  }, [start, stop, ready, modelError, modelDownloadProgress, onDocumentDetected, documentDetectionThresholds, documentDetectionBoundaries, clearDocumentDetectionLastPredictionCanvas]);
  return /*#__PURE__*/React.createElement(DocumentDetectionModelContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(InvisibleCanvas, {
    key: canvasKey,
    ref: lastPredictionCanvas
  }), children);
}

var FocusModelContext = /*#__PURE__*/createContext({
  focusModelReady: false,
  focusModelDownloadProgress: 0,
  focusModelError: null,
  focusThresholds: {},
  setFocusThresholds: function setFocusThresholds() {
    return null;
  },
  makeFocusPrediction: function makeFocusPrediction() {
    return null;
  },
  focusPredictionTime: 0
});
function FocusModelProvider(_a) {
  var children = _a.children,
    _b = _a.focusModelPath,
    focusModelPath = _b === void 0 ? defaultFocusModelPath : _b,
    _c = _a.focusModelLoadTimeoutMs,
    focusModelLoadTimeoutMs = _c === void 0 ? defaultFocusModelLoadTimeoutMs : _c,
    onFocusModelError = _a.onFocusModelError,
    _d = _a.showCanvases,
    showCanvases = _d === void 0 ? false : _d,
    _e = _a.shouldLoadModels,
    shouldLoadModels = _e === void 0 ? true : _e;
  var cropCanvas = useRef(null);
  var rotateCanvas = useRef(null);
  var _f = useState({}),
    focusThresholds = _f[0],
    setFocusThresholds = _f[1];
  var videoRef = useCameraStore().videoRef;
  var _g = useLoadFocusModel({
      modelPath: focusModelPath,
      modelLoadTimeoutMs: focusModelLoadTimeoutMs,
      onModelError: onFocusModelError,
      videoRef: videoRef,
      shouldLoadModels: shouldLoadModels
    }),
    ready = _g.ready,
    modelDownloadProgress = _g.modelDownloadProgress,
    modelError = _g.modelError;
  var makeFocusPrediction = useCallback(function (imageData, box) {
    if (!ready) return null;
    var prediction = makeFocusModelPrediction(imageData, cropCanvas.current, rotateCanvas.current, box);
    if (!prediction) return null;
    setLastFocusPredictionAt(prediction.predictionTime);
    return prediction;
  }, [ready]);
  var value = useMemo(function () {
    return {
      focusModelReady: ready,
      focusModelDownloadProgress: modelDownloadProgress,
      focusModelError: modelError,
      makeFocusPrediction: makeFocusPrediction,
      focusPredictionTime: lastFocusPredictionTime,
      focusThresholds: focusThresholds,
      setFocusThresholds: setFocusThresholds
    };
  }, [focusThresholds, makeFocusPrediction, modelDownloadProgress, modelError, ready]);
  return /*#__PURE__*/React__default.createElement(FocusModelContext.Provider, {
    value: value
  }, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: rotateCanvas,
    style: showCanvases ? {
      display: 'block'
    } : undefined
  }), /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: cropCanvas,
    style: showCanvases ? {
      display: 'block'
    } : undefined
  }), children);
}

function _isNavigatorDefined() {
  return typeof navigator !== 'undefined' && navigator != null;
}
var isMobileCache;
function isMobile() {
  if (isMobileCache !== undefined) return isMobileCache;
  isMobileCache = evaluateIsMobile();
  return isMobileCache;
}
function evaluateIsMobile(nav) {
  if (nav || _isNavigatorDefined()) {
    if (!nav) {
      nav = navigator;
    }
    if (nav.product === 'ReactNative') {
      return true;
    }
    var a = nav.userAgent || nav.vendor || (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    typeof window !== 'undefined' ? window.opera : '');
    if (!a) {
      var navAny = nav;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return navAny.userAgentData && navAny.userAgentData.mobile;
    }
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
  }
  return false;
}

var onMobile = isMobile();
var defaultIdCaptureThresholds = {
  detection: defaultDocumentDetectionThresholds,
  focus: defaultFocusThresholds
};
var IdCaptureModelsContext = /*#__PURE__*/createContext({
  ready: false,
  start: function start() {
    return null;
  },
  stop: function stop() {
    return null;
  },
  modelDownloadProgress: 0,
  modelError: null,
  thresholds: defaultIdCaptureThresholds,
  setThresholds: function setThresholds() {
    return null;
  },
  documentDetectionBoundaries: defaultDocumentDetectionBoundaries,
  setDocumentDetectionBoundaries: function setDocumentDetectionBoundaries() {
    return null;
  },
  onPredictionMade: function onPredictionMade() {
    return null;
  },
  detectionTime: 0,
  focusPredictionTime: 0,
  bestFrameDetails: {
    current: null
  },
  getBestFrame: function getBestFrame() {
    return null;
  },
  resetBestFrame: function resetBestFrame() {
    return null;
  },
  requiredDocumentType: 'none',
  setRequiredDocumentType: function setRequiredDocumentType() {
    return null;
  }
});
function IdCaptureModelsProviderInner(_a) {
  var children = _a.children,
    onModelError = _a.onModelError,
    _b = _a.allowSinglePageIdCapture,
    allowSinglePageIdCapture = _b === void 0 ? false : _b;
  var _c = useContext(DocumentDetectionModelContext),
    documentDetectionModelReady = _c.documentDetectionModelReady,
    documentDetectionModelDownloadProgress = _c.documentDetectionModelDownloadProgress,
    startDocumentDetection = _c.startDocumentDetection,
    stopDocumentDetection = _c.stopDocumentDetection,
    lastPredictionCanvas = _c.documentDetectionLastPredictionCanvas,
    clearDocumentDetectionLastPredictionCanvas = _c.clearDocumentDetectionLastPredictionCanvas,
    onDocumentDetected = _c.onDocumentDetected,
    detectionTime = _c.detectionTime,
    documentDetectionThresholds = _c.documentDetectionThresholds,
    setDocumentDetectionThresholds = _c.setDocumentDetectionThresholds,
    documentDetectionBoundaries = _c.documentDetectionBoundaries,
    setDocumentDetectionBoundaries = _c.setDocumentDetectionBoundaries,
    documentDetectionModelError = _c.documentDetectionModelError;
  var _d = useContext(FocusModelContext),
    focusModelReady = _d.focusModelReady,
    focusModelDownloadProgress = _d.focusModelDownloadProgress,
    makeFocusPrediction = _d.makeFocusPrediction,
    focusThresholds = _d.focusThresholds,
    setFocusThresholds = _d.setFocusThresholds,
    focusPredictionTime = _d.focusPredictionTime,
    focusModelError = _d.focusModelError;
  var onPredictionHandler = useRef();
  var bestFrameDetails = useRef(null);
  var bestPredictionCanvas = useRef(null);
  var bestFocusScore = useRef(0);
  var stopDetection = useRef(0);
  var _e = useState('none'),
    requiredDocumentType = _e[0],
    setRequiredDocumentType = _e[1];
  var thresholds = useMemo(function () {
    return _assign(_assign({}, documentDetectionThresholds), {
      focus: focusThresholds
    });
  }, [documentDetectionThresholds, focusThresholds]);
  var setThresholds = useCallback(function (thresholds) {
    if (thresholds.detection) {
      setDocumentDetectionThresholds(thresholds.detection);
    }
    if (thresholds.focus) {
      setFocusThresholds(thresholds.focus);
    }
  }, [setDocumentDetectionThresholds, setFocusThresholds]);
  useEffect(function handleDetections() {
    var _this = this;
    onDocumentDetected(function (prediction) {
      return __awaiter(_this, void 0, void 0, function () {
        var stopDetectionAtStart, focusPredictionTime, focusScore, focusThresholdMet, isSinglePage, isRequiredDocumentType, focusPrediction, focusThresholdSet, focusThreshold;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
          if (!lastPredictionCanvas.current) return [2 /*return*/];
          stopDetectionAtStart = stopDetection.current;
          focusPredictionTime = 0, focusScore = 0, focusThresholdMet = false;
          isSinglePage = prediction.detectedDocumentType === 'singlePage';
          if (!allowSinglePageIdCapture && isSinglePage) {
            prediction.detectedDocumentType = 'passport';
            prediction.passportDetectionScore = prediction.singlePageDetectionScore;
            prediction.passportDetectionThresholdMet = prediction.singlePageDetectionThresholdMet;
            prediction.singlePageDetectionScore = 0;
            prediction.singlePageDetectionThresholdMet = false;
          }
          isRequiredDocumentType = requiredDocumentType === 'none' || prediction.detectedDocumentType === requiredDocumentType || ((_a = requiredDocumentType.includes) === null || _a === void 0 ? void 0 : _a.call(requiredDocumentType, prediction.detectedDocumentType)) || allowSinglePageIdCapture && isSinglePage && ((_b = requiredDocumentType.includes) === null || _b === void 0 ? void 0 : _b.call(requiredDocumentType, 'idCardFront'));
          if (isRequiredDocumentType && prediction.detectedDocumentType !== 'none' && prediction.detectionThresholdMet && prediction.documentInBounds && !prediction.documentTooClose && prediction.documentIsStable) {
            focusPrediction = makeFocusPrediction(lastPredictionCanvas.current, (_c = prediction.bestDocument) === null || _c === void 0 ? void 0 : _c.box);
            if (focusPrediction) {
              focusScore = focusPrediction.score;
              focusPredictionTime = focusPrediction.predictionTime;
            }
            focusThresholdSet = (_d = thresholds.focus) === null || _d === void 0 ? void 0 : _d[prediction.detectedDocumentType];
            focusThreshold = (_e = onMobile ? focusThresholdSet === null || focusThresholdSet === void 0 ? void 0 : focusThresholdSet.mobile : focusThresholdSet === null || focusThresholdSet === void 0 ? void 0 : focusThresholdSet.desktop) !== null && _e !== void 0 ? _e : 0;
            focusThresholdMet = focusScore >= focusThreshold;
            if (bestFocusScore.current <= focusScore && stopDetectionAtStart === stopDetection.current) {
              bestFocusScore.current = focusScore;
              drawToCanvas(bestPredictionCanvas.current, lastPredictionCanvas.current);
              bestFrameDetails.current = {
                boundingBox: (_f = prediction.bestDocument) === null || _f === void 0 ? void 0 : _f.box,
                documentType: prediction.detectedDocumentType,
                detectionScore: prediction.detectionScore,
                focusScore: focusScore
              };
            }
          }
          (_g = onPredictionHandler.current) === null || _g === void 0 ? void 0 : _g.call(onPredictionHandler, _assign(_assign({}, prediction), {
            focusScore: focusScore,
            focusPredictionTime: focusPredictionTime,
            focusThresholdMet: focusThresholdMet
          }));
          return [2 /*return*/];
        });
      });
    });
  }, [allowSinglePageIdCapture, lastPredictionCanvas, makeFocusPrediction, onDocumentDetected, requiredDocumentType, thresholds.focus]);
  var modelError = documentDetectionModelError !== null && documentDetectionModelError !== void 0 ? documentDetectionModelError : focusModelError;
  useEffect(function handleModelErrors() {
    if (modelError) onModelError === null || onModelError === void 0 ? void 0 : onModelError(modelError);
  }, [modelError, onModelError]);
  var onPredictionMade = useCallback(function (handler) {
    onPredictionHandler.current = handler;
  }, []);
  var getBestFrame = useCallback(function () {
    if (!bestFrameDetails.current || !bestPredictionCanvas.current) return null;
    return _assign(_assign({}, bestFrameDetails.current), {
      canvas: bestPredictionCanvas.current
    });
  }, []);
  var _f = useState(0),
    canvasKey = _f[0],
    setCanvasKey = _f[1];
  var resetBestFrame = useCallback(function () {
    stopDetection.current += 1;
    setCanvasKey(function (n) {
      return n + 1;
    });
    clearDocumentDetectionLastPredictionCanvas();
    bestFrameDetails.current = null;
    bestFocusScore.current = 0;
  }, [clearDocumentDetectionLastPredictionCanvas]);
  useEffect(function () {
    if (requiredDocumentType) resetBestFrame();
  }, [requiredDocumentType, resetBestFrame]);
  var value = useMemo(function () {
    return {
      ready: documentDetectionModelReady && focusModelReady,
      modelDownloadProgress: (documentDetectionModelDownloadProgress + focusModelDownloadProgress) / 2,
      modelError: modelError,
      start: startDocumentDetection,
      stop: stopDocumentDetection,
      thresholds: thresholds,
      setThresholds: setThresholds,
      documentDetectionBoundaries: documentDetectionBoundaries,
      setDocumentDetectionBoundaries: setDocumentDetectionBoundaries,
      onPredictionMade: onPredictionMade,
      detectionTime: detectionTime,
      focusPredictionTime: focusPredictionTime,
      getBestFrame: getBestFrame,
      resetBestFrame: resetBestFrame,
      bestFrameDetails: bestFrameDetails,
      requiredDocumentType: requiredDocumentType,
      setRequiredDocumentType: setRequiredDocumentType
    };
  }, [detectionTime, documentDetectionBoundaries, documentDetectionModelDownloadProgress, documentDetectionModelReady, focusModelDownloadProgress, focusModelReady, focusPredictionTime, getBestFrame, modelError, onPredictionMade, requiredDocumentType, resetBestFrame, setDocumentDetectionBoundaries, setThresholds, startDocumentDetection, stopDocumentDetection, thresholds]);
  return /*#__PURE__*/React__default.createElement(IdCaptureModelsContext.Provider, {
    value: value
  }, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    key: canvasKey,
    ref: bestPredictionCanvas
  }), children);
}
function IdCaptureModelsProvider(_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return /*#__PURE__*/React__default.createElement(DocumentDetectionModelProvider, _assign({}, props), /*#__PURE__*/React__default.createElement(FocusModelProvider, _assign({}, props), /*#__PURE__*/React__default.createElement(IdCaptureModelsProviderInner, _assign({}, props), children)));
}

var CapturedDocumentTypeValues = ['idCardFront', 'idCardBack', 'passport', 'singlePage', 'selfie'];

var acceptedDocumentTypesForIdCaptureRequirementOption = {
  idCardFront: ['idCardFront'],
  idCardBack: ['idCardBack'],
  passport: ['passport'],
  idCard: ['idCardFront', 'idCardBack'],
  idCardAndPassport: ['idCardFront', 'idCardBack', 'passport'],
  idCardOrPassport: ['idCardFront', 'idCardBack', 'passport'] // this one is so weird
};
function minImageCountForIdCaptureRequirementOption(idCaptureRequirement) {
  if (idCaptureRequirement === 'idCardOrPassport') return 1;
  return acceptedDocumentTypesForIdCaptureRequirementOption[idCaptureRequirement].length;
}
function maxImageCountForIdCaptureRequirementOption(idCaptureRequirement) {
  if (idCaptureRequirement === 'idCardOrPassport') return 2;
  return minImageCountForIdCaptureRequirementOption(idCaptureRequirement);
}
function remainingIdCaptureRequirements(captureRequirement, capturedDocuments, requestedDocumentType) {
  var isIdCardOrPassport = captureRequirement === 'idCardOrPassport';
  if (isIdCardOrPassport && requestedDocumentType === 'passport') return [];
  var acceptedTypes = acceptedDocumentTypesForIdCaptureRequirementOption[captureRequirement];
  if (captureRequirement.includes('idCard') && 'singlePage' in capturedDocuments) {
    acceptedTypes = acceptedTypes.filter(function (v) {
      return !v.includes('idCard');
    });
  }
  if (isIdCardOrPassport) {
    acceptedTypes = acceptedTypes.filter(function (v) {
      return v !== 'passport';
    });
  }
  return acceptedTypes.filter(function (v) {
    return !(v in capturedDocuments);
  });
}

var initialState$4 = {
  initialDrawComplete: false,
  redrawing: false,
  guideRectX: 0,
  guideRectY: 0,
  guideRectWidth: 0,
  guideRectHeight: 0,
  guideRectOffsetTop: 0,
  guideImageWidth: 0,
  guideImageHeight: 0,
  pageWidth: 0,
  pageHeight: 0,
  videoWidth: 0,
  videoHeight: 0,
  detectedObjects: [],
  bestDocument: undefined,
  detectedDocumentType: 'none',
  detectionThresholdMet: false,
  documentInBounds: false,
  documentTooClose: false,
  documentIsStable: false,
  flipRequired: false,
  backDetectedFirst: false,
  idCardDetectedButNotAllowed: false,
  passportDetectedButNotAllowed: false,
  enableOverrideWrongDocumentTypeDialog: false,
  allowOverrideWrongDocumentTypeAfterMs: 8000,
  allowOverrideWrongDocumentTypeGuidance: false,
  overrideWrongDocumentTypeGuidance: false,
  wrongDocumentTypePredictions: 0,
  idCardFrontDetectionScore: 0,
  idCardFrontDetectionThresholdMet: false,
  idCardBackDetectionScore: 0,
  idCardBackDetectionThresholdMet: false,
  passportDetectionScore: 0,
  passportDetectionThresholdMet: false,
  singlePageDetectionScore: 0,
  singlePageDetectionThresholdMet: false,
  focusScore: 0,
  focusThresholdMet: false,
  isGoodFrame: false,
  goodFramesCount: 0,
  goodFramesThreshold: 3,
  goodFramesThresholdMet: false,
  lastFrameCapturedAt: null,
  frameCaptureRate: 0,
  capturing: false,
  captureFailed: false,
  imageUrl: null,
  captureState: 'capturing',
  capturedDocuments: {},
  captureRequirement: 'idCardOrPassport',
  requestedDocumentType: 'idCardFront',
  allowSinglePageIdCapture: false,
  allowIdCardBackToFrontCapture: false,
  operationStartedAt: null,
  captureStartedAt: null
};
var IdCaptureStateContext = /*#__PURE__*/createContext(initialState$4);
var IdCaptureDispatchContext = /*#__PURE__*/createContext(function () {});
var _reducer = function reducer(state, action) {
  var _a, _b;
  switch (action.type) {
    case 'configureWizard':
      {
        var _c = action.payload,
          captureRequirement = _c.captureRequirement,
          precapturedDocuments = _c.precapturedDocuments,
          allowSinglePageIdCapture = _c.allowSinglePageIdCapture,
          allowIdCardBackToFrontCapture = _c.allowIdCardBackToFrontCapture,
          enableOverrideWrongDocumentTypeDialog = _c.enableOverrideWrongDocumentTypeDialog,
          allowOverrideWrongDocumentTypeAfterMs = _c.allowOverrideWrongDocumentTypeAfterMs;
        var newState = _assign(_assign({}, state), {
          captureRequirement: captureRequirement,
          allowSinglePageIdCapture: allowSinglePageIdCapture !== null && allowSinglePageIdCapture !== void 0 ? allowSinglePageIdCapture : false,
          allowIdCardBackToFrontCapture: allowIdCardBackToFrontCapture !== null && allowIdCardBackToFrontCapture !== void 0 ? allowIdCardBackToFrontCapture : false,
          enableOverrideWrongDocumentTypeDialog: enableOverrideWrongDocumentTypeDialog,
          allowOverrideWrongDocumentTypeAfterMs: allowOverrideWrongDocumentTypeAfterMs
        });
        if (captureRequirement === 'idCardBack') newState.requestedDocumentType = 'idCardBack';
        if (captureRequirement === 'passport') newState.requestedDocumentType = 'passport';
        if (precapturedDocuments) {
          for (var _i = 0, CapturedDocumentTypeValues_1 = CapturedDocumentTypeValues; _i < CapturedDocumentTypeValues_1.length; _i++) {
            var k = CapturedDocumentTypeValues_1[_i];
            var payload = precapturedDocuments[k];
            if (payload) {
              newState.requestedDocumentType = k;
              newState = _reducer(newState, {
                type: 'documentCaptured',
                payload: payload
              });
            }
          }
        }
        newState.operationStartedAt = new Date();
        return newState;
      }
    case 'setRequiredDocumentType':
      return _assign(_assign({}, state), {
        requiredDocumentType: action.payload
      });
    case 'redrawRequested':
      return _assign(_assign({}, state), {
        redrawing: true,
        guideRectX: 0,
        guideRectY: 0,
        guideRectWidth: 0,
        guideRectHeight: 0,
        guideRectOffsetTop: 0
      });
    case 'redrawInProgress':
      return _assign(_assign({}, state), {
        redrawing: false,
        guideRectX: 0,
        guideRectY: 0,
        guideRectWidth: 0,
        guideRectHeight: 0,
        guideRectOffsetTop: 0
      });
    case 'redrawCompleted':
      return _assign(_assign(_assign({}, state), action.payload), {
        initialDrawComplete: true
      });
    case 'pageRendered':
      return _assign(_assign({}, state), action.payload);
    case 'guideImageLoaded':
      return _assign(_assign({}, state), {
        guideImageWidth: action.payload.width,
        guideImageHeight: action.payload.height
      });
    case 'objectsDetected':
      {
        var _d = action.payload.prediction,
          detectedObjects = _d.detectedObjects,
          detectionThresholdMet = _d.detectionThresholdMet,
          detectedDocumentType = _d.detectedDocumentType,
          idCardFrontDetectionScore = _d.idCardFrontDetectionScore,
          idCardFrontDetectionThresholdMet = _d.idCardFrontDetectionThresholdMet,
          idCardBackDetectionScore = _d.idCardBackDetectionScore,
          idCardBackDetectionThresholdMet = _d.idCardBackDetectionThresholdMet,
          passportDetectionScore = _d.passportDetectionScore,
          passportDetectionThresholdMet = _d.passportDetectionThresholdMet,
          singlePageDetectionScore = _d.singlePageDetectionScore,
          singlePageDetectionThresholdMet = _d.singlePageDetectionThresholdMet,
          bestDocument = _d.bestDocument,
          documentInBounds = _d.documentInBounds,
          documentTooClose = _d.documentTooClose,
          documentIsStable = _d.documentIsStable,
          focusScore = _d.focusScore,
          focusThresholdMet = _d.focusThresholdMet,
          frameWidth = _d.frameWidth,
          frameHeight = _d.frameHeight;
        var frameCapturedAt = new Date();
        var frameCaptureRate = 0;
        var goodFramesThreshold = state.goodFramesThreshold;
        if (state.lastFrameCapturedAt) {
          var frameTime = frameCapturedAt.getTime() - state.lastFrameCapturedAt.getTime();
          if (frameTime > 0) {
            frameCaptureRate = 1000.0 / frameTime;
            if (frameCaptureRate > 0) {
              goodFramesThreshold = Math.ceil(3 * frameCaptureRate);
            }
          }
        }
        var idCardDetected = detectedDocumentType.includes('idCard') || detectedDocumentType === 'singlePage';
        var idCardDetectedButNotAllowed = idCardDetected && !state.captureRequirement.includes('idCard');
        var passportNotAllowed = !state.captureRequirement.toLowerCase().includes('passport');
        var idCardFrontWasCaptured = 'idCardFront' in state.capturedDocuments;
        var idCardBackWasCaptured = 'idCardBack' in state.capturedDocuments;
        var idCardBeingCaptured = idCardFrontWasCaptured && !idCardBackWasCaptured || !idCardFrontWasCaptured && idCardBackWasCaptured;
        var passportDetectedButNotAllowed = detectedDocumentType === 'passport' && (passportNotAllowed || idCardBeingCaptured);
        var flipRequired = !state.overrideWrongDocumentTypeGuidance && (state.allowIdCardBackToFrontCapture ? idCardFrontWasCaptured && detectedDocumentType === 'idCardFront' : state.requestedDocumentType === 'idCardBack' && detectedDocumentType === 'idCardFront');
        var backDetectedFirst = !state.overrideWrongDocumentTypeGuidance && (state.allowIdCardBackToFrontCapture ? idCardBackWasCaptured && detectedDocumentType === 'idCardBack' : state.requestedDocumentType === 'idCardFront' && detectedDocumentType === 'idCardBack');
        var wrongDocumentTypePredictions = state.wrongDocumentTypePredictions;
        if (state.captureState === 'capturing' && (flipRequired || backDetectedFirst)) {
          wrongDocumentTypePredictions += 1;
        }
        var isGoodFrame = detectionThresholdMet && documentInBounds && !documentTooClose && !flipRequired && !backDetectedFirst && focusThresholdMet && !idCardDetectedButNotAllowed && !passportDetectedButNotAllowed && documentIsStable;
        var goodFramesCount = state.goodFramesCount;
        if (isGoodFrame) {
          goodFramesCount += 1;
        }
        var goodFramesThresholdMet = goodFramesCount >= goodFramesThreshold;
        var requestedDocumentType = state.requestedDocumentType;
        if (state.captureRequirement.includes('idCard') && state.allowIdCardBackToFrontCapture) {
          if (detectedDocumentType === 'idCardFront' && state.requestedDocumentType !== 'idCardFront' && !idCardFrontWasCaptured) {
            requestedDocumentType = 'idCardFront';
          } else if (detectedDocumentType === 'idCardBack' && state.requestedDocumentType !== 'idCardBack' && !idCardBackWasCaptured) {
            requestedDocumentType = 'idCardBack';
          }
        }
        if (state.captureRequirement === 'idCardOrPassport') {
          if (detectedDocumentType === 'passport' && state.requestedDocumentType !== 'passport') {
            requestedDocumentType = 'passport';
          }
          if (requestedDocumentType === 'passport' && passportDetectionScore < 0.3) {
            requestedDocumentType = idCardFrontWasCaptured ? 'idCardBack' : 'idCardFront';
          }
        }
        var hasBeenRunningForLongEnough = !!state.captureStartedAt && new Date().getTime() - state.captureStartedAt.getTime() > 1000;
        var overrideFlipRequirementThreshold = Math.ceil(state.allowOverrideWrongDocumentTypeAfterMs / 1000 * frameCaptureRate);
        var allowOverrideFlipRequirement = state.enableOverrideWrongDocumentTypeDialog && hasBeenRunningForLongEnough && !state.overrideWrongDocumentTypeGuidance && overrideFlipRequirementThreshold > 0 && (state.allowOverrideWrongDocumentTypeGuidance || wrongDocumentTypePredictions >= overrideFlipRequirementThreshold);
        return _assign(_assign({}, state), {
          videoWidth: frameWidth,
          videoHeight: frameHeight,
          detectedObjects: detectedObjects,
          bestDocument: bestDocument,
          requestedDocumentType: requestedDocumentType,
          detectedDocumentType: detectedDocumentType,
          detectionThresholdMet: detectionThresholdMet,
          documentInBounds: documentInBounds,
          documentTooClose: documentTooClose,
          documentIsStable: documentIsStable,
          flipRequired: flipRequired,
          backDetectedFirst: backDetectedFirst,
          idCardDetectedButNotAllowed: idCardDetectedButNotAllowed,
          passportDetectedButNotAllowed: passportDetectedButNotAllowed,
          allowOverrideWrongDocumentTypeGuidance: allowOverrideFlipRequirement,
          wrongDocumentTypePredictions: wrongDocumentTypePredictions,
          idCardFrontDetectionScore: idCardFrontDetectionScore,
          idCardFrontDetectionThresholdMet: idCardFrontDetectionThresholdMet,
          idCardBackDetectionScore: idCardBackDetectionScore,
          idCardBackDetectionThresholdMet: idCardBackDetectionThresholdMet,
          passportDetectionScore: passportDetectionScore,
          passportDetectionThresholdMet: passportDetectionThresholdMet,
          singlePageDetectionScore: singlePageDetectionScore,
          singlePageDetectionThresholdMet: singlePageDetectionThresholdMet,
          focusScore: focusScore,
          focusThresholdMet: focusThresholdMet,
          isGoodFrame: isGoodFrame,
          goodFramesCount: goodFramesCount,
          goodFramesThreshold: goodFramesThreshold,
          goodFramesThresholdMet: goodFramesThresholdMet,
          lastFrameCapturedAt: frameCapturedAt,
          frameCaptureRate: frameCaptureRate
        });
      }
    case 'captureStarted':
      return _assign(_assign({}, state), {
        captureStartedAt: new Date(),
        capturing: false,
        captureFailed: false
      });
    case 'capturing':
      return _assign(_assign({}, state), {
        capturing: true,
        captureFailed: false
      });
    case 'captured':
      return _assign(_assign({}, state), {
        capturing: false,
        captureFailed: false
      });
    case 'frameCaptured':
      return _assign(_assign({}, state), {
        imageUrl: action.payload.imageUrl
      });
    case 'captureFailed':
      return _assign(_assign({}, state), {
        capturing: false,
        captureFailed: true
      });
    case 'documentCaptured':
      {
        var newState = _assign(_assign({}, state), {
          capturing: false,
          captureFailed: false,
          allowOverrideFlipRequirement: false,
          overrideFlipRequirement: false,
          goodFramesCount: 0,
          wrongDocumentTypePredictions: 0,
          capturedDocuments: _assign(_assign({}, state.capturedDocuments), (_a = {}, _a[action.payload.documentType] = action.payload, _a))
        });
        var remainingRequirements = remainingIdCaptureRequirements(state.captureRequirement, newState.capturedDocuments, state.requestedDocumentType);
        if (remainingRequirements.length === 0) {
          newState.captureState = 'complete';
        } else {
          newState.requestedDocumentType = remainingRequirements[0];
          if (state.requestedDocumentType === 'idCardFront' && newState.requestedDocumentType === 'idCardBack' || state.requestedDocumentType === 'idCardBack' && newState.requestedDocumentType === 'idCardFront') {
            newState.captureState = 'requestingFlip';
            newState.idCardFrontDetectionThresholdMet = false;
            newState.idCardBackDetectionThresholdMet = false;
            newState.passportDetectionThresholdMet = false;
            newState.wrongDocumentTypePredictions = 0;
          }
        }
        return newState;
      }
    case 'documentCapturedManually':
      {
        var newState = _assign(_assign({}, state), {
          capturedDocuments: _assign(_assign({}, state.capturedDocuments), (_b = {}, _b[state.requestedDocumentType] = _assign(_assign({}, action.payload), {
            width: 0,
            height: 0
          }), _b))
        });
        var remainingRequirements = remainingIdCaptureRequirements(state.captureRequirement, newState.capturedDocuments, state.requestedDocumentType);
        if (remainingRequirements.length === 0) {
          newState.captureState = 'complete';
        } else {
          newState.requestedDocumentType = remainingRequirements[0];
          if (state.requestedDocumentType === 'idCardFront' && newState.requestedDocumentType === 'idCardBack' || state.requestedDocumentType === 'idCardBack' && newState.requestedDocumentType === 'idCardFront') {
            newState.captureState = 'requestingFlip';
            newState.idCardFrontDetectionThresholdMet = false;
            newState.idCardBackDetectionThresholdMet = false;
            newState.passportDetectionThresholdMet = false;
          }
        }
        return newState;
      }
    case 'flipRequestCompleted':
      return _assign(_assign({}, state), {
        captureState: 'capturing',
        allowOverrideWrongDocumentTypeGuidance: false,
        overrideWrongDocumentTypeGuidance: false,
        wrongDocumentTypePredictions: 0
      });
    case 'allowOverrideFlipRequirement':
      return _assign(_assign({}, state), {
        allowOverrideWrongDocumentTypeGuidance: true
      });
    case 'overrideFlipRequirement':
      return _assign(_assign({}, state), {
        allowOverrideWrongDocumentTypeGuidance: false,
        overrideWrongDocumentTypeGuidance: true
      });
    case 'resetWizard':
      return _assign(_assign({}, initialState$4), {
        captureRequirement: state.captureRequirement,
        allowIdCardBackToFrontCapture: state.allowIdCardBackToFrontCapture
      });
    default:
      return state;
  }
};
var IdCaptureStateProvider = function IdCaptureStateProvider(_a) {
  var children = _a.children;
  var _b = useReducer(_reducer, initialState$4),
    state = _b[0],
    dispatch = _b[1];
  var onResize = useDebouncedCallback(function () {
    dispatch({
      type: 'redrawRequested'
    });
  }, 500);
  useLayoutEffect(function () {
    if (typeof window === 'undefined') return;
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  var setRequiredDocumentType = useContext(IdCaptureModelsContext).setRequiredDocumentType;
  useEffect(function () {
    if (state.overrideWrongDocumentTypeGuidance) {
      setRequiredDocumentType('none');
    }
  }, [state.overrideWrongDocumentTypeGuidance, setRequiredDocumentType]);
  return /*#__PURE__*/React__default.createElement(IdCaptureStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React__default.createElement(IdCaptureDispatchContext.Provider, {
    value: dispatch
  }, children));
};
var useIdCaptureState = function useIdCaptureState() {
  var state = useContext(IdCaptureStateContext);
  var dispatch = useContext(IdCaptureDispatchContext);
  if (!state || !dispatch) throw new Error('useIdCaptureState cannot be used without IdCaptureStateProvider');
  return [state, dispatch];
};

function DebugStatsPane(_a) {
  var children = _a.children;
  var element = /*#__PURE__*/React__default.createElement(DebugStatsPaneDiv, null, children);
  var portalLocation = document.getElementById('idmission-above-guides-content');
  if (!portalLocation) return element;
  return /*#__PURE__*/createPortal(element, portalLocation);
}
var DebugStatsPaneDiv = styled.span(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  font-size: 16px;\n  font-family: monospace;\n  position: absolute;\n  left: 20px;\n  bottom: 20px;\n  margin-right: 20px;\n  padding: 8px;\n  color: limegreen;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10002;\n"], ["\n  font-size: 16px;\n  font-family: monospace;\n  position: absolute;\n  left: 20px;\n  bottom: 20px;\n  margin-right: 20px;\n  padding: 8px;\n  color: limegreen;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10002;\n"])));
var ObjectDetectionDebugOverlayDiv = styled.div(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  position: absolute;\n  z-index: 1001;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  ", "\n  transform-style: preserve-3d;\n"], ["\n  position: absolute;\n  z-index: 1001;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  ", "\n  transform-style: preserve-3d;\n"])), function (_a) {
  var $flipX = _a.$flipX;
  return $flipX ? 'transform: scaleX(-1);' : '';
});
var ObjectDetectionDebugBox = styled.div(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  font: 10px monospace;\n  position: absolute;\n  border: 3px solid ", ";\n  color: ", ";\n  ", "\n  transform-style: preserve-3d;\n"], ["\n  font: 10px monospace;\n  position: absolute;\n  border: 3px solid ", ";\n  color: ", ";\n  ", "\n  transform-style: preserve-3d;\n"])), function (_a) {
  var $color = _a.$color;
  return $color !== null && $color !== void 0 ? $color : 'green';
}, function (_a) {
  var $color = _a.$color;
  return $color !== null && $color !== void 0 ? $color : 'green';
}, function (_a) {
  var $flipX = _a.$flipX;
  return $flipX ? 'transform: scaleX(-1);' : '';
});
var FaceDetectionKeypointMarker = styled.div(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  border: 2px solid ", ";\n  font: 10px monospace;\n  color: ", ";\n  border-radius: 50%;\n  ", "\n  transform-style: preserve-3d;\n"], ["\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  border: 2px solid ", ";\n  font: 10px monospace;\n  color: ", ";\n  border-radius: 50%;\n  ", "\n  transform-style: preserve-3d;\n"])), function (_a) {
  var $color = _a.$color;
  return $color !== null && $color !== void 0 ? $color : 'red';
}, function (_a) {
  var $color = _a.$color;
  return $color !== null && $color !== void 0 ? $color : 'red';
}, function (_a) {
  var $flipX = _a.$flipX;
  return $flipX ? 'transform: scaleX(-1);' : '';
});
function useDebugScalingDetails(_a) {
  var _b = _a.enabled,
    enabled = _b === void 0 ? true : _b,
    pageWidth = _a.pageWidth,
    pageHeight = _a.pageHeight,
    videoWidth = _a.videoWidth,
    videoHeight = _a.videoHeight;
  return useMemo(function () {
    var horizontal = false,
      scaledWidth = 0,
      scaledHeight = 0,
      xOffset = 0,
      yOffset = 0;
    if (enabled) {
      horizontal = pageWidth / pageHeight < videoWidth / videoHeight;
      if (horizontal) {
        scaledWidth = videoWidth * (pageHeight / videoHeight);
        xOffset = (scaledWidth - pageWidth) / 2;
      } else {
        scaledHeight = videoHeight * (pageWidth / videoWidth);
        yOffset = (scaledHeight - pageHeight) / 2;
      }
    }
    return {
      horizontal: horizontal,
      pageWidth: pageWidth,
      pageHeight: pageHeight,
      videoWidth: videoWidth,
      videoHeight: videoHeight,
      scaledWidth: scaledWidth,
      scaledHeight: scaledHeight,
      xOffset: xOffset,
      yOffset: yOffset
    };
  }, [enabled, pageHeight, pageWidth, videoHeight, videoWidth]);
}
var DebugBoundingBoxOverlay = function DebugBoundingBoxOverlay(_a) {
  var scaling = _a.scaling,
    $flipX = _a.$flipX,
    children = _a.children;
  var _b = useIdCaptureState()[0],
    guideRectWidth = _b.guideRectWidth,
    guideRectHeight = _b.guideRectHeight,
    guideRectX = _b.guideRectX,
    guideRectY = _b.guideRectY;
  return /*#__PURE__*/React__default.createElement(ObjectDetectionDebugOverlayDiv, {
    id: "debug-overlay-div",
    "$flipX": $flipX,
    style: {
      top: guideRectY,
      left: guideRectX,
      width: guideRectWidth || (scaling === null || scaling === void 0 ? void 0 : scaling.pageWidth),
      height: guideRectHeight || (scaling === null || scaling === void 0 ? void 0 : scaling.pageHeight)
    }
  }, children);
};
function IdCaptureDetectedObjectDebugBox(_a) {
  var obj = _a.obj,
    flipX = _a.flipX,
    _b = _a.color,
    color = _b === void 0 ? 'green' : _b,
    scaling = _a.scaling;
  var horizontal = scaling.horizontal,
    pageWidth = scaling.pageWidth,
    pageHeight = scaling.pageHeight,
    videoWidth = scaling.videoWidth,
    videoHeight = scaling.videoHeight,
    scaledWidth = scaling.scaledWidth,
    scaledHeight = scaling.scaledHeight,
    xOffset = scaling.xOffset,
    yOffset = scaling.yOffset;
  if (!videoWidth || !videoHeight || !pageWidth || !pageHeight) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  var top;
  var left;
  var width;
  var height;
  if (horizontal) {
    top = obj.box.yMin / videoHeight * pageHeight;
    left = obj.box.xMin / videoWidth * scaledWidth - xOffset;
    width = obj.box.width / videoWidth * scaledWidth;
    height = obj.box.height / videoHeight * pageHeight;
  } else {
    top = obj.box.yMin / videoHeight * scaledHeight - yOffset;
    left = obj.box.xMin / videoWidth * pageWidth;
    width = obj.box.width / videoWidth * pageWidth;
    height = obj.box.height / videoHeight * scaledHeight;
  }
  return /*#__PURE__*/React__default.createElement(ObjectDetectionDebugBox, {
    "$flipX": flipX,
    "$color": color,
    style: {
      top: top,
      left: left,
      width: width,
      height: height
    }
  });
}
function SelfieCaptureFaceDebugBox(_a) {
  var face = _a.face,
    flipX = _a.flipX,
    _b = _a.color,
    color = _b === void 0 ? 'green' : _b,
    scaling = _a.scaling;
  var horizontal = scaling.horizontal,
    pageWidth = scaling.pageWidth,
    pageHeight = scaling.pageHeight,
    videoWidth = scaling.videoWidth,
    videoHeight = scaling.videoHeight,
    scaledWidth = scaling.scaledWidth,
    scaledHeight = scaling.scaledHeight,
    xOffset = scaling.xOffset,
    yOffset = scaling.yOffset;
  if (!videoWidth || !videoHeight || !pageWidth || !pageHeight) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  var top;
  var left;
  var width;
  var height;
  if (horizontal) {
    top = face.box.yMin / videoHeight * pageHeight;
    left = face.box.xMin / videoWidth * scaledWidth - xOffset;
    width = face.box.width / videoWidth * scaledWidth;
    height = face.box.height / videoHeight * pageHeight;
  } else {
    top = face.box.yMin / videoHeight * scaledHeight - yOffset;
    left = face.box.xMin / videoWidth * pageWidth;
    width = face.box.width / videoWidth * pageWidth;
    height = face.box.height / videoHeight * scaledHeight;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ObjectDetectionDebugBox, {
    "$flipX": flipX,
    "$color": color,
    style: {
      top: top,
      left: left,
      width: width,
      height: height
    }
  }), face.keypoints.map(function (point, ii) {
    return /*#__PURE__*/React__default.createElement(SelfieCaptureFaceKeypoint, {
      key: ii,
      point: point,
      scaling: scaling,
      flipX: flipX
    });
  }));
}
function SelfieCaptureFaceKeypoint(_a) {
  var point = _a.point,
    flipX = _a.flipX,
    _b = _a.color,
    color = _b === void 0 ? 'red' : _b,
    _c = _a.scaling,
    horizontal = _c.horizontal,
    pageWidth = _c.pageWidth,
    pageHeight = _c.pageHeight,
    videoWidth = _c.videoWidth,
    videoHeight = _c.videoHeight,
    scaledWidth = _c.scaledWidth,
    scaledHeight = _c.scaledHeight,
    xOffset = _c.xOffset,
    yOffset = _c.yOffset;
  var left, top;
  if (horizontal) {
    left = point.x / videoWidth * scaledWidth - xOffset;
    top = point.y / videoHeight * pageHeight;
  } else {
    left = point.x / videoWidth * pageWidth;
    top = point.y / videoHeight * scaledHeight - yOffset;
  }
  top -= 2;
  left -= 2;
  return /*#__PURE__*/React__default.createElement(FaceDetectionKeypointMarker, {
    "$flipX": flipX,
    "$color": color,
    style: {
      top: top,
      left: left
    }
  });
}
var templateObject_1$F, templateObject_2$y, templateObject_3$p, templateObject_4$j;

var en = {};

var es = {
  'Use your device camera to capture your ID': 'Para capturar la identificación hay que utilizar la cámara del dispositivo.',
  'Use your iPhone as a webcam': 'Usar el iPhone como cámara web',
  'Models warming up...': 'Cargando modelos...',
  'Camera initializing...': 'Inicializando la cámara...',
  'Camera access blocked': 'Acceso bloqueado a la cámara',
  'Location access blocked': 'Acceso bloqueado a la localización',
  Continue: 'Continuar',
  'Processing...': 'Procesando...',
  'Your camera permission is disabled': 'El permiso de la cámara está desactivado',
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions, you must go to settings and provide camera access to the current browser.': 'Esta aplicación requiere el acceso a la cámara para continuar. Hay que aceptar el permiso una vez que se muestre la ventana en el explorador. Si no aparece la ventana para otorgar permisos, entonces hay que dirigirse a Configuración y otorgar el permiso a la cámara en el explorador actual.',
  'Your microphone permission is disabled': 'El permiso de la micrófono está desactivado',
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions, you must go to settings and provide microphone access to the current browser.': 'Esta aplicación requiere tener acceso al micrófono para continuar. Hay que aceptar el permiso una vez que se muestre la ventana en el explorador. Si no aparece la ventana para otorgar permisos, entonces hay que dirigirse a Configuración y otorgar el permiso al micrófono en el explorador actual.',
  'Your location permission is disabled': 'El permiso de la localización está desactivado',
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions, you must go to settings and provide location access to the current browser.': 'Esta aplicación requiere el acceso a la localización para continuar. Hay que aceptar el permiso una vez que se muestre la ventana en el explorador. Si no aparece la ventana para otorgar permisos, entonces hay que dirigirse a Configuración y otorgar el permiso a la localización en el explorador actual.',
  Retry: 'Reintentar',
  'Scan the front of ID': 'Escanear el frente de la ID',
  'Scan the back of ID': 'Escanear el reverso de la ID',
  'Scan the ID page of passport': 'Escanear la página de datos del pasaporte',
  'ID Card Front': 'Frente de la ID',
  'ID Card Back': 'Reverso de la ID',
  Passport: 'Pasaporte',
  'Document not detected': 'No se ha detectado el documento',
  'Document is not centered': 'Documento no centrado',
  'Document too close, please back up': 'Documento muy cerca, favor de alejarse',
  'Please hold your ID document steady': 'Por favor, hay que mantener firme su identificación',
  'Document out of focus – try improving the lighting': 'Documento no enfocado - hay que tratar de mejorar la iluminación',
  'ID card front detected - please flip your ID card': 'Anverso de ID detectado, por favor voltea tu identificación',
  'ID card back detected - please flip your ID card': 'Reverso de ID detectado, por favor voltea tu identificación',
  'ID card detected, please scan a passport instead': 'Se ha detectado una credencial, por favor hay que escanear un pasaporte',
  'Passport detected, please scan an ID card instead': 'Se ha detectado un pasaporte, por favor hay que escanear una credencial',
  'Document detected, hold still...': 'Se ha detectado el documento, no moverse por favor...',
  'ID card front detected, hold still...': 'Anverso de ID detectado, no mover...',
  'ID card back detected, hold still...': 'Reverso de ID detectado, no mover...',
  'Passport detected, hold still...': 'Pasaporte detectado, no mover...',
  'Capturing...': 'Capturando...',
  'Capture failed!': 'Falló la captura',
  'Please flip your ID card...': 'Por favor voltea la identificación...',
  'ID card front captured.': 'Se ha capturado el frente de la identificación.',
  'ID card back captured.': 'Se ha capturado el reverso de la identificación.',
  'ID Capture Successful': 'Captura Exitosa de ID',
  'Verify the entire ID was captured clearly with no glare.': 'Hay que verificar que toda la ID se vea completa y sin reflejos.',
  Submit: 'Enviar',
  'Submitting...': 'Enviando...',
  'Use your device camera to capture your face': 'Hay que utilizar la cámara del dispositivo para capturar el rostro',
  'Remove Sunglasses & Hat': 'Hay que quitarse lentes y/o la gorra',
  'Avoid Excessive Backlighting': 'Hay que evitar demasiada luz en el fondo',
  'Hold still for a few seconds...': 'Hay que permanecer quieto por unos segundos...',
  'Please hold still...': 'Favor de no moverse...',
  'Look straight into the camera...': 'Hay que mirar directamente a la cámara...',
  'Move back...': 'Hay que hacerse hacia atrás..',
  'Move forward...': 'Hay que hacerse hacia adelante...',
  'Move to the center...': 'Hay que moverse hacia el centro...',
  'Please remove your eye coverings (sunglasses, eye patch, etc.)...': 'Hay que quitarse lo que cubre los ojos (lentes, parche, etc.)...',
  'Please remove your head coverings (hat, scarf, etc.)...': 'Hay que quitarse lo que cubre la cabeza (gorra, mascada, etc.)...',
  'Please remove your mask...': 'Hay que quitarse el cubrebocas...',
  'Live face not detected, please try again': 'Rostro vivo no detectado. Por favor hay que intentar de nuevo.',
  Exit: 'Salir',
  'Face liveness has been verified!': 'Se ha verificado la Prueba de Vida en rostro!',
  Done: 'Terminar',
  'Could not verify your face.': 'No se pudo verificar tu rostro.',
  'An error occurred while verifying your face.': 'Se ha producido un error al verificar tu rostro.',
  'Customer has been identified!': '¡Se ha identificado al cliente!',
  'Customer not found': 'Cliente no encontrado',
  'Additional document capture': 'Captura de otro documento',
  Next: 'Siguiente',
  'Please sign the box below': 'Por favor, hay que firmar en el recuadro de abajo',
  Accept: 'Aceptar',
  Clear: 'Borrar',
  'Video signature has been successfully captured!': 'La video firma ha sido exitosa.',
  'Network unreachable': 'No hay conexión a internet.',
  "We're having trouble reaching our services, please check your connection and try again.": "Estamos teniendo problemas para alcanzar nuestros servicios, por favor verificar la conexi\xF3n a internet e intentar de nuevo.",
  "We're sorry, an unexpected error has occurred.": "Lo sentimos, se ha producido un error inesperado.",
  'Document Capture': 'Captura de documento',
  Capture: 'Capturar',
  'Retry capture': 'Reintentar la captura',
  Upload: 'Enviar',
  'Uploading...': 'Procesando...',
  'Upload succeeded!': 'Proceso completo!',
  'Performing facial recognition, please hold still...': 'Realizando el reconocimiento facial, por favor no te muevas',
  'Display the front of your ID card...': 'Hay que mostrar el frente de la identificación...',
  'Display the back of your ID card...': 'Hay que mostrar el reverso de la identificación...',
  'Display the ID page of your passport...': 'Hay que mostrar el página de datos del pasaporte...',
  'Please move your face to the center...': 'Por favor, hay que mover la cabeza hacia el centro...',
  'Searching for ID card...': 'Localizando la identificación...',
  'Please read the following text aloud': 'Hay que leer el siguiente texto en voz alta',
  'Video ID has been successfully captured!': 'Video ID capturado exitosamente!',
  'ID Front Image': 'Frente de ID',
  'ID Back Image': 'Reverso de ID',
  "We're having some trouble.": 'Se ha presentado un problema.',
  'On-device capture guidance failed, please capture a selfie manually.': 'La captura automática para toma de selfie falló. Por favor, hay que tomarse la selfie manualmente.',
  'Verifying...': 'Verificando....',
  'Please capture the front of your ID card.': 'Hay que capturar el frente de la identificación.',
  'Please capture the back of your ID card.': 'Hay que capturar el reverso de la identificación.',
  'Please capture the front of your ID card, or the ID page of your passport.': 'Hay que capturar el frente de la identificación o la página de datos del pasaporte.',
  'Please capture the back of your ID card, or click Done if submitting a passport.': 'Hay que capturar el reverso de la identificación o hay que presionar el botón de Terminar si se trata de un pasaporte.',
  'Please capture the ID page of your passport.': 'Hay que capturar la página de datos del pasaporte.',
  'On-device capture guidance failed, please capture a photo of your ID card manually.': 'La captura automática falló. Por favor hay que tomar una foto de la identificación manualmente.',
  'On-device capture guidance failed, please capture a photo of your passport manually.': 'La captura automática falló. Por favor hay que tomar una foto de la pasaporte manualmente.',
  'On-device capture guidance failed, please capture photos of your ID card and passport manually.': 'La captura automática falló. Por favor hay que tomar una foto de la identificación y del pasaporte manualmente.',
  'On-device capture guidance failed, please capture photos of your ID card or passport manually.': 'La captura automática falló. Por favor hay que tomar una foto de la identificación o del pasaporte manualmente.',
  'Capture ID page of passport': 'Captura pasaporte (página de la foto)',
  'Capture back of ID card': 'Captura del reverso',
  'Downloading...': 'Descargando...',
  'Accessing camera...': 'Accediendo a la cámara',
  'Camera ready': 'Cámara está lista',
  'Loading guided capture experience...': 'Cargando la experiencia guiada para la captura....',
  'Guided capture experience ready': 'La experiencia guiada está lista',
  "Let's Go!": 'Vamos!',
  'We are having trouble identifying the correct side of your id, do you want to continue with capture anyway?': 'Estamos teniendo problemas para identificar el lado correcto de tu identificación, quieres continuar con la captura?',
  OK: 'Sí'
};

var de = {
  'English - en': 'German - de',
  'Use your device camera to capture your ID': 'Ihre Gerätekamera zur Aufnahme Ihres Ausweises verwenden',
  'Use your iPhone as a webcam': 'Ihr iPhone als Webcam verwenden',
  'Models warming up...': 'Modelle wärmen sich auf...',
  'Camera initializing...': 'Kamera wird initialisiert ...',
  'Camera access blocked': 'Kamerazugriff blockiert',
  'Location access blocked': 'Standortzugriff blockiert',
  Continue: 'Fortfahren',
  'Processing...': 'Verarbeitung läuft...',
  'Your camera permission is disabled': 'Ihre Kameraberechtigung ist deaktiviert',
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions you must go to settings and provide camera access to the current browser.': 'Diese Anwendung benötigt zum Fortfahren Zugriff auf Ihre Kamera. Bitte stimmen Sie der Berechtigung bei Aufforderung durch den Browser zu. Wenn der Browser nicht nach Kameraberechtigungen fragt, müssen Sie die Einstellungen aufrufen und der Kamera Zugriff auf den aktuellen Browser gewähren.',
  'Your microphone permission is disabled': 'Ihre Mikrofonberechtigung ist deaktiviert',
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions you must go to settings and provide microphone access to the current browser.': 'Diese Anwendung benötigt zum Fortfahren Zugriff auf Ihr Mikrofon. Bitte stimmen Sie der Berechtigung bei Aufforderung durch den Browser zu. Wenn der Browser nicht nach Mikrofonberechtigungen fragt, müssen Sie die Einstellungen aufrufen und dem Mikrofon Zugriff auf den aktuellen Browser gewähren.',
  'Your location permission is disabled': 'Ihre Standortberechtigung ist deaktiviert',
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions you must go to settings and provide location access to the current browser.': 'Diese Anwendung benötigt zum Fortfahren Zugriff auf Ihren Standort. Bitte stimmen Sie der Berechtigung bei Aufforderung durch den Browser zu. Wenn der Browser nicht nach Standortberechtigungen fragt, müssen Sie die Einstellungen aufrufen und dem Standort Zugriff auf den aktuellen Browser gewähren.',
  Retry: 'Erneut versuchen',
  'Scan the front of ID': 'Vorderseite des Ausweises scannen',
  'Scan the back of ID': 'Rückseite des Ausweises scannen',
  'Scan the ID page of passport': 'Ausweis-Seite des Passes scannen',
  'ID Card Front': 'Vorderseite des Ausweises',
  'ID Card Back': 'Rückseite des Ausweises',
  Passport: 'Reisepass',
  'Document not detected': 'Dokument nicht erkannt',
  'Document is not centered': 'Dokument ist nicht zentriert',
  'Document too close please back up': 'Dokument ist zu nah, bitte Abstand vergrößern',
  'Please hold your ID document steady': 'Ihr Ausweisdokument ruhig halten',
  'Document out of focus – try improving the lighting': 'Dokument unscharf – versuchen Sie, die Beleuchtung zu verbessern',
  'ID card front detected - please flip your ID card': 'Vorderseite des Ausweises erkannt - bitte Ihren Ausweis umdrehen',
  'ID card back detected - please flip your ID card': 'Rückseite des Ausweises erkannt - bitte Ihren Ausweis umdrehen',
  'ID card detected please scan a passport instead': 'Ausweis erkannt, bitte stattdessen einen Pass scannen',
  'Passport detected please scan an ID card instead': 'Pass erkannt, bitte stattdessen einen Ausweis scannen',
  'Document detected hold still...': 'Dokument erkannt, stillhalten...',
  'ID card front detected hold still...': 'Vorderseite des Ausweises erkannt, stillhalten...',
  'ID card back detected hold still...': 'Rückseite des Ausweises erkannt, stillhalten...',
  'Passport detected hold still...': 'Pass erkannt, stillhalten...',
  'Capturing...': 'Wird erfasst...',
  'Capture failed!': 'Erfassung fehlgeschlagen!',
  'Please flip your ID card...': 'Bitte drehen Sie Ihren Ausweis um...',
  'ID card front captured.': 'Vorderseite des Ausweises erfasst.',
  'ID card back captured.': 'Rückseite des Ausweises erfasst.',
  'ID Capture Successful': 'Ausweiserfassung erfolgreich',
  'Verify the entire ID was captured clearly with no glare.': 'Sicherstellen, dass der gesamte Ausweis ohne Blendlicht klar erfasst wurde.',
  Submit: 'Einreichen',
  'Submitting...': 'Wird eingereicht ...',
  'Use your device camera to capture your face': 'Ihre Gerätekamera zur Aufnahme Ihres Gesichts verwenden',
  'Remove Sunglasses & Hat': 'Sonnenbrille und Kopfbedeckung absetzen',
  'Avoid Excessive Backlighting': 'Übermäßiges Gegenlicht vermeiden',
  'Hold still for a few seconds...': 'Einige Sekunden lang stillhalten...',
  'Please hold still...': 'Bitte stillhalten...',
  'Look straight into the camera...': 'Direkt in die Kamera blicken...',
  'Move back...': 'Nach hinten bewegen...',
  'Move forward...': 'Nach vorne bewegen...',
  'Move to the center...': 'In die Mitte bewegen...',
  'Please remove your eye coverings (sunglasses eye patch etc.)...': 'Bitte Augenbedeckung entfernen (Sonnenbrille, Augenklappe usw.)...',
  'Please remove your head coverings (hat scarf etc.)...': 'Bitte Kopfbedeckung abnehmen (Mütze, Schal usw.)...',
  'Please remove your mask...': 'Bitte Maske ablegen...',
  'Live face not detected, please try again': 'Live-Gesicht nicht erkannt, bitte erneut versuchen',
  Exit: 'Verlassen',
  'Face liveness has been verified!': 'Echtzeit des Gesichts wurde verifiziert!',
  Done: 'Fertig',
  'Could not verify your face.': 'Ihr Gesicht konnte nicht verifiziert werden.',
  'An error occurred while verifying your face.': 'Beim Verifizieren Ihres Gesichts ist ein Fehler aufgetreten.',
  'Customer has been identified!': 'Kunde wurde identifiziert!',
  'Customer not found': 'Kunde nicht gefunden',
  'Additional document capture': 'Zusätzliches Dokument erfassen',
  Next: 'Weiter',
  'Please sign the box below': 'Bitte im Feld unten unterschreiben',
  Accept: 'Annehmen',
  Clear: 'Löschen',
  'Video signature has been successfully captured!': 'Videosignatur wurde erfolgreich erfasst!',
  'Network unreachable': 'Netzwerk nicht erreichbar',
  "We're having trouble reaching our services please check your connection and try again.": 'Wir haben Probleme, unsere Dienste zu erreichen. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  "We're sorry an unexpected error has occurred.": 'Leider ist ein unerwarteter Fehler aufgetreten.',
  'Document Capture': 'Dokument erfassen',
  Capture: 'Erfassen',
  'Retry capture': 'Erfassung erneut versuchen',
  Upload: 'Hochladen',
  'Uploading...': 'Wird hochgeladen...',
  'Upload succeeded!': 'Upload erfolgreich!',
  'Performing facial recognition please hold still...': 'Gesichtserkennung wird durchgeführt, bitte stillhalten...',
  'Display the front of your ID card...': 'Anzeige der Vorderseite Ihres Ausweises...',
  'Display the back of your ID card...': 'Anzeige der Rückseite Ihres Ausweises...',
  'Display the ID page of your passport...': 'Anzeige der Ausweis-Seite Ihres Passes...',
  'Please move your face to the center...': 'Bitte bewegen Sie Ihr Gesicht in die Mitte...',
  'Searching for ID card...': 'Nach Ausweis suchen...',
  'Please read the following text aloud': 'Bitte lesen Sie den folgenden Text laut',
  'Video ID has been successfully captured!': 'Video-ID wurde erfolgreich erfasst!',
  'ID Front Image': 'Bild Ausweisvorderseite',
  'ID Back Image': 'Bild Ausweisrückseite',
  "We're having some trouble.": 'Wir haben Probleme.',
  'On-device capture guidance failed please capture a selfie manually.': 'Leitfaden zur Erfassung am Gerät fehlgeschlagen, bitte manuell ein Selfie erfassen.',
  'Verifying...': 'Verifizierung ...',
  'Please capture the front of your ID card.': 'Bitte die Vorderseite Ihres Ausweises erfassen.',
  'Please capture the back of your ID card.': 'Bitte die Rückseite Ihres Ausweises erfassen.',
  'Please capture the front of your ID card or the ID page of your passport.': 'Bitte Vorderseite Ihres Ausweises oder Ausweis-Seite Ihres Passes erfassen.',
  'Please capture the back of your ID card or click Done if submitting a passport.': 'Bitte Rückseite Ihres Ausweises oder auf Fertig klicken, wenn ein Pass versendet wird.',
  'Please capture the ID page of your passport.': 'Bitte die Ausweis-Seite Ihres Passes erfassen.',
  'On-device capture guidance failed please capture a photo of your ID card manually.': 'Leitfaden zur Erfassung am Gerät fehlgeschlagen, bitte manuell ein Foto Ihres Ausweises erfassen.',
  'On-device capture guidance failed please capture a photo of your passport manually.': 'Leitfaden zur Erfassung am Gerät fehlgeschlagen, bitte manuell ein Foto Ihres Passes erfassen.',
  'On-device capture guidance failed please capture photos of your ID card and passport manually.': 'Leitfaden zur Erfassung am Gerät fehlgeschlagen, bitte manuell Fotos Ihres Ausweises und Passes erfassen.',
  'On-device capture guidance failed please capture photos of your ID card or passport manually.': 'Leitfaden zur Erfassung am Gerät fehlgeschlagen, bitte manuell Fotos Ihres Ausweises oder Passes erfassen.',
  'Capture ID page of passport': 'Ausweis-Seite des Passes erfassen',
  'Capture back of ID card': 'Rückseite des Ausweises erfassen',
  'Downloading...': 'Wird heruntergeladen...',
  'Accessing camera...': 'Es wird auf die Kamera zugegriffen...',
  'Camera ready': 'Kamera bereit',
  'Loading guided capture experience...': 'Geführte Erfassung wird geladen...',
  'Guided capture experience ready': 'Geführte Erfassung bereit',
  "Let's Go!": 'Los geht‘s!',
  'We are having trouble identifying the correct side of your id do you want to continue with capture anyway?': 'Wir haben Probleme, die richtige Seite Ihres Ausweises zu erkennen. Möchten Sie dennoch mit der Erfassung fortfahren?',
  OK: 'OK'
};

var fr = {
  'English - en': 'French - fr',
  'Use your device camera to capture your ID': 'Utilisez la caméra de votre appareil pour capturer votre ID',
  'Use your iPhone as a webcam': 'Utiliser votre iPhone comme Webcam',
  'Models warming up...': "Les modèles s'échauffent...",
  'Camera initializing...': 'Initialisation de la caméra...',
  'Camera access blocked': 'Accès à la caméra bloqué',
  'Location access blocked': 'Accès à la localisation bloqué',
  Continue: 'Continuer',
  'Processing...': 'Traitement en cours...',
  'Your camera permission is disabled': "L'autorisation de votre caméra est désactivée",
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions you must go to settings and provide camera access to the current browser.': "Cette application nécessite l'accès à votre caméra pour continuer. Veuillez accepter l'autorisation une fois que le navigateur vous le demande. Si le navigateur ne vous demande pas d'autorisation pour la caméra vous devez accéder aux paramètres et accorder l'accès à la caméra pour le navigateur actuel.",
  'Your microphone permission is disabled': "L'autorisation de votre microphone est désactivée",
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions you must go to settings and provide microphone access to the current browser.': "Cette application nécessite l'accès à votre microphone pour continuer. Veuillez accepter l'autorisation une fois que le navigateur vous le demande. Si le navigateur ne vous demande pas d'autorisation pour le microphone vous devez accéder aux paramètres et accorder l'accès au microphone pour le navigateur actuel.",
  'Your location permission is disabled': "L'autorisation de votre localisation est désactivée",
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions you must go to settings and provide location access to the current browser.': "Cette application nécessite l'accès à votre localisation pour continuer. Veuillez accepter l'autorisation une fois que le navigateur vous le demande. Si le navigateur ne vous demande pas d'autorisation pour la localisation vous devez accéder aux paramètres et accorder l'accès à la localisation pour le navigateur actuel.",
  Retry: 'Réessayer',
  'Scan the front of ID': "Scannez le recto de la pièce d'identité",
  'Scan the back of ID': "Scannez le verso de la pièce d'identité",
  'Scan the ID page of passport': "Scannez la page d'identité du passeport",
  'ID Card Front': "Recto de la carte d'identité",
  'ID Card Back': "Verso de la carte d'identité",
  Passport: 'Passeport',
  'Document not detected': 'Document non détecté',
  'Document is not centered': "Le document n'est pas centré",
  'Document too close please back up': 'Document trop proche, veuillez sauvegarder',
  'Please hold your ID document steady': "Veuillez maintenir fermement votre pièce d'identité",
  'Document out of focus – try improving the lighting': 'Document flou – essayez d’améliorer l’éclairage',
  'ID card front detected - please flip your ID card': "Recto de la carte d'identité détecté - veuillez retourner votre carte d'identité",
  'ID card back detected - please flip your ID card': "Verso de la carte d'identité détectée - veuillez retourner votre carte d'identité",
  'ID card detected please scan a passport instead': "Carte d'identité détectée, veuillez scanner plutôt un passeport",
  'Passport detected please scan an ID card instead': "Passeport détecté, veuillez scanner plutôt une carte d'identité",
  'Document detected hold still...': 'Document détecté, restez immobile...',
  'ID card front detected hold still...': "Recto de la carte d'identité détecté, restez immobile...",
  'ID card back detected hold still...': "Verso de la carte d'identité détecté, restez immobile...",
  'Passport detected hold still...': 'Passeport détecté, restez immobile...',
  'Capturing...': 'Capture en cours...',
  'Capture failed!': 'La capture a échoué !',
  'Please flip your ID card...': "Veuillez retourner votre carte d'identité...",
  'ID card front captured.': "Recto de la carte d'identité capturé.",
  'ID card back captured.': "Verso de la carte d'identité capturé.",
  'ID Capture Successful': "Capture d'identité réussie",
  'Verify the entire ID was captured clearly with no glare.': "Vérifiez que l'intégralité de la pièce d’identité a été capturée clairement, sans reflet.",
  Submit: 'Soumettre',
  'Submitting...': 'Soumission en cours...',
  'Use your device camera to capture your face': 'Utilisez la caméra de votre appareil pour capturer votre visage',
  'Remove Sunglasses & Hat': 'Retirez les lunettes de soleil et le couvre-chef',
  'Avoid Excessive Backlighting': 'Évitez tout contre-jour excessif',
  'Hold still for a few seconds...': 'Restez immobile pendant quelques secondes...',
  'Please hold still...': 'Veuillez rester immobile.',
  'Look straight into the camera...': 'Regardez droit vers la caméra...',
  'Move back...': 'Reculez...',
  'Move forward...': 'Avancez...',
  'Move to the center...': 'Déplacez-vous vers le centre...',
  'Please remove your eye coverings (sunglasses eye patch etc.)...': 'Veuillez retirer ce qui recouvre vos yeux (lunettes de soleil, cache-œil, etc.)...',
  'Please remove your head coverings (hat scarf etc.)...': 'Veuillez retirer vos couvre-chefs (chapeau, foulard, etc.)...',
  'Please remove your mask...': 'Veuillez retirer votre masque...',
  'Live face not detected, please try again': 'Visage vivant non détecté veuillez réessayer',
  Exit: 'Quitter',
  'Face liveness has been verified!': 'Le caractère vivant du visage a été vérifié!',
  Done: 'Fini',
  'Could not verify your face.': 'Impossible de vérifier votre visage.',
  'An error occurred while verifying your face.': "Une erreur s'est produite lors de la vérification de votre visage.",
  'Customer has been identified!': 'Le client a été identifié !',
  'Customer not found': 'Client non trouvé',
  'Additional document capture': 'Capture de documents supplémentaires',
  Next: 'Suivant',
  'Please sign the box below': 'Veuillez signer la case ci-dessous',
  Accept: 'Accepter',
  Clear: 'Effacer',
  'Video signature has been successfully captured!': 'La signature vidéo a été capturée avec succès!',
  'Network unreachable': 'Réseau inaccessible',
  "We're having trouble reaching our services please check your connection and try again.": 'Nous rencontrons des difficultés pour accéder à nos services, veuillez vérifier votre connexion et réessayer.',
  "We're sorry an unexpected error has occurred.": 'Nous sommes désolés, une erreur inattendue est survenue.',
  'Document Capture': 'Capture de document',
  Capture: 'Capturer',
  'Retry capture': 'Réessayer la capture',
  Upload: 'Télécharger',
  'Uploading...': 'Chargement en cours....',
  'Upload succeeded!': 'Téléchargement réussi!',
  'Performing facial recognition please hold still...': 'Exécution de la reconnaissance faciale, veuillez rester immobile...',
  'Display the front of your ID card...': "Affichez le recto de votre carte d'identité...",
  'Display the back of your ID card...': "Affichez le verso de votre carte d'identité...",
  'Display the ID page of your passport...': "Montrez la page d'identité de votre passeport...",
  'Please move your face to the center...': 'Veuillez déplacer votre visage vers le centre...',
  'Searching for ID card...': "Recherche d’une carte d'identité...",
  'Please read the following text aloud': 'Veuillez lire le texte suivant à voix haute',
  'Video ID has been successfully captured!': 'L’ID vidéo a été capturé avec succès!',
  'ID Front Image': 'Image recto de la pièce d’identité',
  'ID Back Image': 'Image verso de la pièce d’identité',
  "We're having some trouble.": 'Nous rencontrons quelques problèmes.',
  'On-device capture guidance failed please capture a selfie manually.': "Le guidage de capture sur l'appareil a échoué, veuillez capturer un selfie manuellement.",
  'Verifying...': 'Vérification en cours...',
  'Please capture the front of your ID card.': "Veuillez capturer le recto de votre carte d'identité.",
  'Please capture the back of your ID card.': "Veuillez capturer le verso de votre carte d'identité.",
  'Please capture the front of your ID card or the ID page of your passport.': 'Veuillez capturer le recto de votre carte d’identité ou la page d’identité de votre passeport.',
  'Please capture the back of your ID card or click Done if submitting a passport.': 'Veuillez capturer le verso de votre carte d’identité ou cliquer sur Terminé si vous soumettez un passeport.',
  'Please capture the ID page of your passport.': "Veuillez capturer la page d'identité de votre passeport.",
  'On-device capture guidance failed please capture a photo of your ID card manually.': "Le guidage de capture sur l'appareil a échoué, veuillez capturer une photo de votre pièce d’identité manuellement.",
  'On-device capture guidance failed please capture a photo of your passport manually.': "Le guidage de capture sur l'appareil a échoué, veuillez capturer une photo de votre passeport manuellement.",
  'On-device capture guidance failed please capture photos of your ID card and passport manually.': "Le guidage de capture sur l'appareil a échoué, veuillez capturer manuellement des photos de votre carte d'identité et de votre passeport.",
  'On-device capture guidance failed please capture photos of your ID card or passport manually.': "Le guidage de capture sur l'appareil a échoué, veuillez capturer manuellement des photos de votre carte d'identité ou de votre passeport.",
  'Capture ID page of passport': "Capturez la page d'identité du passeport",
  'Capture back of ID card': "Capturez le verso de la carte d'identité",
  'Downloading...': 'Téléchargement en cours...',
  'Accessing camera...': 'Accès à la caméra...',
  'Camera ready': 'Caméra prête',
  'Loading guided capture experience...': "Chargement de l'expérience de capture guidée...",
  'Guided capture experience ready': 'Expérience de capture guidée prête',
  "Let's Go!": 'Allons-y !',
  'We are having trouble identifying the correct side of your id do you want to continue with capture anyway?': "Nous rencontrons des difficultés pour identifier la bonne face de votre pièce d'identité. Voulez-vous quand même continuer la capture ?",
  OK: 'OK'
};

var it = {
  'English - en': 'Italian - it',
  'Use your device camera to capture your ID': 'Utilizzare la fotocamera del dispositivo per acquisire il documento',
  'Use your iPhone as a webcam': 'Utilizza iPhone come webcam',
  'Models warming up...': 'Riscaldamento modelli...',
  'Camera initializing...': 'Inizializzazione fotocamera...',
  'Camera access blocked': 'Accesso alla fotocamera bloccato',
  'Location access blocked': 'Accesso alla posizione bloccato',
  Continue: 'Continua',
  'Processing...': 'Elaborazione...',
  'Your camera permission is disabled': 'Autorizzazione fotocamera disabilitata',
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions you must go to settings and provide camera access to the current browser.': "Questa applicazione richiede l'accesso alla fotocamera per continuare. Accettare l'autorizzazione una volta richiesta dal browser. Se il browser non richiede l'autorizzazione della fotocamera, accedere alle impostazioni e fornire l'accesso alla fotocamera al browser corrente.",
  'Your microphone permission is disabled': 'Autorizzazione microfono disabilitata',
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions you must go to settings and provide microphone access to the current browser.': "Questa applicazione richiede l'accesso al microfono per continuare. Accettare l'autorizzazione una volta richiesta dal browser. Se il browser non richiede l'autorizzazione del microfono, accedere alle impostazioni e fornire l'accesso al microfono al browser corrente.",
  'Your location permission is disabled': 'Autorizzazione posizione disabilitata',
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions you must go to settings and provide location access to the current browser.': "Questa applicazione richiede l'accesso alla posizione per continuare. Accettare l'autorizzazione una volta richiesta dal browser. Se il browser non richiede l'autorizzazione della posizione, accedere alle impostazioni e fornire l'accesso alla posizione al browser corrente.",
  Retry: 'Riprova',
  'Scan the front of ID': 'Scansiona il fronte del documento',
  'Scan the back of ID': 'Scansiona il retro del documento',
  'Scan the ID page of passport': 'Scansione la pagina identificativa del passaporto',
  'ID Card Front': 'Fronte documento d’identità',
  'ID Card Back': 'Retro documento d’identità',
  Passport: 'Passaporto',
  'Document not detected': 'Documento non rilevato',
  'Document is not centered': 'Documento non centrato',
  'Document too close please back up': 'Documento troppo vicino, allontanarlo',
  'Please hold your ID document steady': 'Tenere il documento d’identità fermo',
  'Document out of focus – try improving the lighting': 'Documento fuori fuoco - provare a migliorare l’illuminazione',
  'ID card front detected - please flip your ID card': 'Fronte del documento d’identità rilevato - Girare il documento d’identità',
  'ID card back detected - please flip your ID card': 'Retro del documento d’identità rilevato - Girare il documento d’identità',
  'ID card detected please scan a passport instead': 'Documento d’identità rilevato, scansionare un passaporto al suo posto',
  'Passport detected please scan an ID card instead': 'Passaporto rilevato, scansionare una documento d’identità al suo posto',
  'Document detected hold still...': 'Documento rilevato, tenere fermo...',
  'ID card front detected hold still...': 'Fronte documento d’identità rilevato, tenere fermo...',
  'ID card back detected hold still...': 'Retro documento d’identità rilevato, tenere fermo...',
  'Passport detected hold still...': 'Passaporto rilevato, tenere fermo...',
  'Capturing...': 'Acquisizione...',
  'Capture failed!': 'Acquisizione non riuscita!',
  'Please flip your ID card...': 'Capovolgere il documento d’identità',
  'ID card front captured.': 'Fronte documento d’identità acquisito.',
  'ID card back captured.': 'Retro documento d’identità acquisito.',
  'ID Capture Successful': 'Acquisizione documento riuscita',
  'Verify the entire ID was captured clearly with no glare.': 'Verificare che tutto il documento sia acquisito chiaramente e senza riflessi.',
  Submit: 'Invia',
  'Submitting...': 'Invio...',
  'Use your device camera to capture your face': 'Utilizzare la fotocamera del dispositivo per acquisire il volto',
  'Remove Sunglasses & Hat': 'Rimuovere occhiali da sole e cappello',
  'Avoid Excessive Backlighting': 'Evitare una retroilluminazione eccessiva',
  'Hold still for a few seconds...': 'Tenere fermo qualche secondo...',
  'Please hold still...': 'Tenere fermo...',
  'Look straight into the camera...': 'Guardare dritto nella fotocamera...',
  'Move back...': 'Spostarsi più lontano...',
  'Move forward...': 'Spostarsi più vicino...',
  'Move to the center...': 'Spostarsi al centro...',
  'Please remove your eye coverings (sunglasses eye patch etc.)...': 'Rimuovere tutto ciò che copre gli occhi (occhiali da sole, bende, ecc.)...',
  'Please remove your head coverings (hat scarf etc.)...': 'Rimuovere tutto ciò che ricopre il capo (cappello, sciarpa, ecc.)...',
  'Please remove your mask...': 'Rimuovere la mascherina...',
  'Live face not detected, please try again': 'Volto reale non rilevato riprovare',
  Exit: 'Esci',
  'Face liveness has been verified!': 'Verifica del volto eseguita!',
  Done: 'Fatto',
  'Could not verify your face.': 'Non è stato possibile verificare il volto.',
  'An error occurred while verifying your face.': 'Si è verificato un errore durante la verifica del volto.',
  'Customer has been identified!': 'Cliente identificato!',
  'Customer not found': 'Cliente non trovato',
  'Additional document capture': 'Acquisizione aggiuntiva del documento',
  Next: 'Seguente',
  'Please sign the box below': 'Firmare nel riquadro qui sotto',
  Accept: 'Accetta',
  Clear: 'Cancella',
  'Video signature has been successfully captured!': 'La firma video è stata acquisita correttamente!',
  'Network unreachable': 'Rete non raggiungibile',
  "We're having trouble reaching our services please check your connection and try again.": 'Si è verificato un problema nel raggiungere i nostri servizi, verificare la connessione e riprovare.',
  "We're sorry an unexpected error has occurred.": 'Spiacenti, si è verificato un errore inatteso.',
  'Document Capture': 'Acquisizione documento',
  Capture: 'Acquisisci',
  'Retry capture': 'Riprova acquisizione',
  Upload: 'Carica',
  'Uploading...': 'Caricamento...',
  'Upload succeeded!': 'Caricamento riuscito!',
  'Performing facial recognition please hold still...': 'Riconoscimento volto in corso, tenere fermo...',
  'Display the front of your ID card...': 'Mostrare il fronte del documento d’identità...',
  'Display the back of your ID card...': 'Mostrare il retro della documento d’identità...',
  'Display the ID page of your passport...': 'Mostrare la pagina identificativa del passaporto...',
  'Please move your face to the center...': 'Spostare il volto al centro...',
  'Searching for ID card...': 'Ricerca documento d’identità in corso...',
  'Please read the following text aloud': 'Leggere il testo seguente a voce alta',
  'Video ID has been successfully captured!': 'L’ID video è stato acquisito correttamente!',
  'ID Front Image': 'Immagine fronte documento d’identità',
  'ID Back Image': 'Immagine retro documento d’identità',
  "We're having some trouble.": 'Si è verificato un problema.',
  'On-device capture guidance failed please capture a selfie manually.': "La guida all'acquisizione sul dispositivo non è riuscita. Scattare un selfie manualmente.",
  'Verifying...': 'Verifica...',
  'Please capture the front of your ID card.': 'Acquisire il fronte del documento d’identità.',
  'Please capture the back of your ID card.': 'Acquisire il retro del documento d’identità.',
  'Please capture the front of your ID card or the ID page of your passport.': 'Acquisire il fronte del documento d’identità o la pagina identificativa del passaporto.',
  'Please capture the back of your ID card or click Done if submitting a passport.': 'Acquisire il retro del documento d’identità o fare clic su Fatto se si invia un passaporto.',
  'Please capture the ID page of your passport.': 'Acquisire la pagina identificativa del passaporto.',
  'On-device capture guidance failed please capture a photo of your ID card manually.': "La guida all'acquisizione sul dispositivo non è riuscita. Acquisire una foto del documento d’identità manualmente.",
  'On-device capture guidance failed please capture a photo of your passport manually.': "La guida all'acquisizione sul dispositivo non è riuscita. Acquisire una foto del passaporto manualmente.",
  'On-device capture guidance failed please capture photos of your ID card and passport manually.': "La guida all'acquisizione sul dispositivo non è riuscita. Acquisire delle foto del documento d’identità e del passaporto manualmente.",
  'On-device capture guidance failed please capture photos of your ID card or passport manually.': "La guida all'acquisizione sul dispositivo non è riuscita. Acquisire delle foto del documento d’identità o del passaporto manualmente.",
  'Capture ID page of passport': 'Acquisisci pagina identificativa del passaporto',
  'Capture back of ID card': 'Acquisisci retro del documento d’identità',
  'Downloading...': 'Download in corso...',
  'Accessing camera...': 'Accesso alla fotocamera...',
  'Camera ready': 'Fotocamera pronta',
  'Loading guided capture experience...': "Caricamento dell'esperienza di acquisizione guidata...",
  'Guided capture experience ready': 'Esperienza di acquisizione guidata pronta',
  "Let's Go!": 'Iniziamo!',
  'We are having trouble identifying the correct side of your id do you want to continue with capture anyway?': "Si stanno verificando problemi nell'identificare il lato corretto del documento d'identità. Procedere con l'acquisizione?",
  OK: 'OK'
};

var ja = {
  'English - en': 'Japanese - ja',
  'Use your device camera to capture your ID': 'デバイスのカメラを使用して身分証を撮影してください',
  'Use your iPhone as a webcam': 'iPhoneをウェブカムとして使用',
  'Models warming up...': 'モデルをウォームアップ中…',
  'Camera initializing...': 'カメラを初期化中…',
  'Camera access blocked': 'カメラへのアクセスがブロックされました',
  'Location access blocked': '位置へのアクセスがブロックされました',
  Continue: '続行',
  'Processing...': '処理中…',
  'Your camera permission is disabled': 'カメラの許可が停止されました',
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions you must go to settings and provide camera access to the current browser.': 'このアプリケーションが動作するにはカメラへのアクセスが必要です。ブラウザーで許可をプロンプトされたら、同意してください。ブラウザーがカメラの許可をプロンプト表示しない場合は、設定へ進んでお使いのブラウザーへカメラへのアクセスを許可する必要があります。',
  'Your microphone permission is disabled': 'マイクの許可が停止されました',
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions you must go to settings and provide microphone access to the current browser.': 'このアプリケーションが動作するにはマイクへのアクセスが必要です。ブラウザーで許可をプロンプトされたら、同意してください。ブラウザーがマイクの許可をプロンプト表示しない場合は、設定へ進んでお使いのブラウザーへマイクへのアクセスを許可する必要があります。',
  'Your location permission is disabled': '位置の許可が停止されました',
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions you must go to settings and provide location access to the current browser.': 'このアプリケーションが動作するには位置へのアクセスが必要です。ブラウザーで許可をプロンプトされたら、同意してください。ブラウザーが位置の許可をプロンプト表示しない場合は、設定へ進んでお使いのブラウザーへ位置へのアクセスを許可する必要があります。',
  Retry: '再試行',
  'Scan the front of ID': '身分証の正面をスキャン',
  'Scan the back of ID': '身分証の背面をスキャン',
  'Scan the ID page of passport': 'パスポートの身分ページをスキャン',
  'ID Card Front': '身分証の正面',
  'ID Card Back': '身分証の背面',
  Passport: 'パスポート',
  'Document not detected': 'ドキュメントが検出されません',
  'Document is not centered': 'ドキュメントが中央に合っていません',
  'Document too close please back up': 'ドキュメントが近すぎます。遠ざけてください',
  'Please hold your ID document steady': '身分証が動かないように押さえてください',
  'Document out of focus – try improving the lighting': 'ドキュメントの焦点がぼやけています。照明を調節してください',
  'ID card front detected - please flip your ID card': '身分証の正面が検出されました。身分証を裏返してください',
  'ID card back detected - please flip your ID card': '身分証の背面が検出されました。身分証を裏返してください',
  'ID card detected please scan a passport instead': '身分証が検出されました。パスポートをスキャンしてください',
  'Passport detected please scan an ID card instead': 'パスポートが検出されました。身分証をスキャンしてください',
  'Document detected hold still...': 'ドキュメントが検出されました。動かないようにしてください…',
  'ID card front detected hold still...': '身分証の正面が検出されました。動かないようにしてください…',
  'ID card back detected hold still...': '身分証の背面が検出されました。動かないようにしてください…',
  'Passport detected hold still...': 'パスポートが検出されました。動かないようにしてください…',
  'Capturing...': '撮影中…',
  'Capture failed!': '撮影に失敗しました',
  'Please flip your ID card...': '身分証を裏返してください…',
  'ID card front captured.': '身分証の正面が撮影されました。',
  'ID card back captured.': '身分証の背面が撮影されました。',
  'ID Capture Successful': '身分証を撮影しました',
  'Verify the entire ID was captured clearly with no glare.': 'ぎらつきなく、身分証のすべてが明瞭に撮影されたことを確かめてください。',
  Submit: '提出',
  'Submitting...': '提出中…',
  'Use your device camera to capture your face': 'デバイスのカメラを使用して自分の顔を撮影してください',
  'Remove Sunglasses & Hat': 'サングラスと帽子を取り外す',
  'Avoid Excessive Backlighting': '背景が明るすぎないようにする',
  'Hold still for a few seconds...': '数秒間そのままにしてください…',
  'Please hold still...': '動かないように押さえてください…',
  'Look straight into the camera...': 'カメラを真正面から見てください…',
  'Move back...': '遠ざかってください…',
  'Move forward...': '近づいてください…',
  'Move to the center...': '中央へ移動してください…',
  'Please remove your eye coverings (sunglasses eye patch etc.)...': '目を覆うもの（サングラスや眼帯など）を取り外してください…',
  'Please remove your head coverings (hat scarf etc.)...': '頭を覆うもの（帽子やスカーフなど）を取り外してください…',
  'Please remove your mask...': 'マスクを取り外してください…',
  'Live face not detected, please try again': '顔のライブネスが検出されません。再度お試しください',
  Exit: '終了',
  'Face liveness has been verified!': '顔のライブネスが認証されました',
  Done: '完了',
  'Could not verify your face.': '顔を検証できませんでした。',
  'An error occurred while verifying your face.': '顔の検証中にエラーが発生しました。',
  'Customer has been identified!': '顧客が特定されました',
  'Customer not found': '顧客が見つかりませんでした',
  'Additional document capture': '別のドキュメントの撮影',
  Next: '次へ',
  'Please sign the box below': '以下のボックス内に署名してください',
  Accept: '同意',
  Clear: '消去',
  'Video signature has been successfully captured!': 'ビデオ署名を撮影しました',
  'Network unreachable': 'ネットワークに接続できません',
  "We're having trouble reaching our services please check your connection and try again.": 'サービス接続時に問題が発生しています。接続を確認して再度お試しください。',
  "We're sorry an unexpected error has occurred.": '不慮のエラーが発生しました。申し訳ありません。',
  'Document Capture': 'ドキュメントの撮影',
  Capture: '撮影',
  'Retry capture': '撮影のやりなおし',
  Upload: 'アップロード',
  'Uploading...': 'アップロード中…',
  'Upload succeeded!': '正常にアップロードされました',
  'Performing facial recognition please hold still...': '顔認識を行っています。動かないようにしてください…',
  'Display the front of your ID card...': '身分証の正面を表示します…',
  'Display the back of your ID card...': '身分証の背面を表示します…',
  'Display the ID page of your passport...': 'パスポートの身分ページを表示します…',
  'Please move your face to the center...': '顔を中央に動かしてください…',
  'Searching for ID card...': '身分証を検索しています…',
  'Please read the following text aloud': '以下のテキストを読み上げてください',
  'Video ID has been successfully captured!': 'ビデオ身分を撮影しました',
  'ID Front Image': '身分証の正面画像',
  'ID Back Image': '身分証の背面画像',
  "We're having some trouble.": '問題が発生しました。',
  'On-device capture guidance failed please capture a selfie manually.': 'デバイスの撮影ガイダンスが動作しません。手動でセルフィーを撮影してください。',
  'Verifying...': '検証中…',
  'Please capture the front of your ID card.': '身分証の正面を撮影してください…',
  'Please capture the back of your ID card.': '身分証の背面を撮影してください…',
  'Please capture the front of your ID card or the ID page of your passport.': '身分証の正面またはパスポートの身分ページを撮影してください。',
  'Please capture the back of your ID card or click Done if submitting a passport.': '身分証の背面を撮影するか、パスポートを撮影する場合は完了をクリックしてください。',
  'Please capture the ID page of your passport.': 'パスポートの身分ページを撮影してください…',
  'On-device capture guidance failed please capture a photo of your ID card manually.': 'デバイスの撮影ガイダンスが動作しません。手動で身分証を撮影してください。',
  'On-device capture guidance failed please capture a photo of your passport manually.': 'デバイスの撮影ガイダンスが動作しません。手動でパスポートを撮影してください。',
  'On-device capture guidance failed please capture photos of your ID card and passport manually.': 'デバイスの撮影ガイダンスが動作しません。手動で身分証とパスポートを撮影してください。',
  'On-device capture guidance failed please capture photos of your ID card or passport manually.': 'デバイスの撮影ガイダンスが動作しません。手動で身分証またはパスポートを撮影してください。',
  'Capture ID page of passport': 'パスポートの身分ページを撮影',
  'Capture back of ID card': '身分証の背面を撮影',
  'Downloading...': 'ダウンロード中…',
  'Accessing camera...': 'カメラへアクセス中…',
  'Camera ready': 'カメラが準備完了',
  'Loading guided capture experience...': '撮影ガイダンスのエクスペリエンスを読み込み中…',
  'Guided capture experience ready': '撮影ガイダンスのエクスペリエンスが準備完了',
  "Let's Go!": '始めましょう',
  'We are having trouble identifying the correct side of your id do you want to continue with capture anyway?': '身分証の正しい寸法を特定できません。それでも撮影を続行しますか？',
  OK: 'OK'
};

var pt = {
  'English - en': 'Portuguese (Brazil) - pt',
  'Use your device camera to capture your ID': 'Usar a câmera do dispositivo para fotografar sua identidade',
  'Use your iPhone as a webcam': 'Use seu iPhone como uma câmera Web',
  'Models warming up...': 'Modelos aquecendo...',
  'Camera initializing...': 'Câmera inicializando...',
  'Camera access blocked': 'Acesso à câmera bloqueado',
  'Location access blocked': 'Acesso ao local bloqueado',
  Continue: 'Continuar',
  'Processing...': 'Processando...',
  'Your camera permission is disabled': 'A permissão da câmera está desativada',
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions you must go to settings and provide camera access to the current browser.': 'Este aplicativo requer acesso à sua câmera para continuar. Aceite a permissão quando o navegador solicitar. Se o navegador não solicitar permissões para a câmera vá para as configurações e forneça acesso à câmera para o navegador atual.',
  'Your microphone permission is disabled': 'A permissão do seu microfone está desativada',
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions you must go to settings and provide microphone access to the current browser.': 'Este aplicativo requer acesso ao seu microfone para continuar. Aceite a permissão quando o navegador solicitar. Se o navegador não solicitar permissões para o microfone vá para as configurações e forneça acesso ao microfone para o navegador atual.',
  'Your location permission is disabled': 'A permissão do seu local está desativada',
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions you must go to settings and provide location access to the current browser.': 'Este aplicativo requer acesso ao seu local para continuar. Aceite a permissão quando o navegador solicitar. Se o navegador não solicitar permissões para o local vá para as configurações e forneça acesso do local para o navegador atual.',
  Retry: 'Tentar novamente',
  'Scan the front of ID': 'Digitalizar a frente da ID',
  'Scan the back of ID': 'Digitalize o verso da ID',
  'Scan the ID page of passport': 'Digitalize a página de identificação do passaporte',
  'ID Card Front': 'Frente da carteira de identidade',
  'ID Card Back': 'Verso da carteira de identidade',
  Passport: 'Passaporte',
  'Document not detected': 'Documento não detectado',
  'Document is not centered': 'Documento não está centralizado',
  'Document too close please back up': 'Documento muito próximo, recue',
  'Please hold your ID document steady': 'Segure seu documento de identificação com firmeza',
  'Document out of focus – try improving the lighting': 'Documento fora de foco - tente melhorar a iluminação',
  'ID card front detected - please flip your ID card': 'Detectada a frente da carteira de identidade - vire a carteira de identidade',
  'ID card back detected - please flip your ID card': 'Detectado o verso da carteira de identidade - vire a carteira de identidade',
  'ID card detected please scan a passport instead': 'Detectada a carteira de identidade - escaneie um passaporte em seu lugar',
  'Passport detected please scan an ID card instead': 'Detectado passaporte, escaneie uma carteira de identidade em seu lugar',
  'Document detected hold still...': 'Documento detectado - mantenha-se imóvel...',
  'ID card front detected hold still...': 'Detectada a frente da carteira de identidade - mantenha-se imóvel...',
  'ID card back detected hold still...': 'Detectado o verso da carteira de identidade - mantenha-se imóvel...',
  'Passport detected hold still...': 'Passaporte detectado - mantenha-se imóvel...',
  'Capturing...': 'Capturando...',
  'Capture failed!': 'A captura falhou!',
  'Please flip your ID card...': 'Por favor, vire sua carteira de identidade..',
  'ID card front captured.': 'Frente da carteira de identidade capturada.',
  'ID card back captured.': 'Verso da carteira de identidade capturado.',
  'ID Capture Successful': 'Captura de ID bem-sucedida',
  'Verify the entire ID was captured clearly with no glare.': 'Verifique se a identidade inteira foi capturada com clareza e sem reflexos.',
  Submit: 'Enviar',
  'Submitting...': 'Enviando...',
  'Use your device camera to capture your face': 'Use a câmera do dispositivo para fotografar seu rosto',
  'Remove Sunglasses & Hat': 'Remova os óculos de sol e o chapéu',
  'Avoid Excessive Backlighting': 'Evite o excesso de luz de fundo',
  'Hold still for a few seconds...': 'Fique imóvel por alguns segundos...',
  'Please hold still...': 'Por favor, mantenha-se imóvel...',
  'Look straight into the camera...': 'Olhe diretamente para a câmera.',
  'Move back...': 'Mover para trás...',
  'Move forward...': 'Mover para frente...',
  'Move to the center...': 'Mover para o centro...',
  'Please remove your eye coverings (sunglasses eye patch etc.)...': 'Por favor, remova as coberturas dos olhos (óculos de sol, tapa-olho, etc.)...',
  'Please remove your head coverings (hat scarf etc.)...': 'Por favor, remova as coberturas da cabeça (chapéu, cachecol, etc.)...',
  'Please remove your mask...': 'Por favor, remova sua máscara...',
  'Live face not detected, please try again': 'Não foi possível detectar a veracidade do rosto tente novamente',
  Exit: 'Sair',
  'Face liveness has been verified!': 'A veracidade do rosto foi verificada!',
  Done: 'Concluído',
  'Could not verify your face.': 'Não foi possível verificar seu rosto.',
  'An error occurred while verifying your face.': 'Ocorreu um erro ao verificar seu rosto.',
  'Customer has been identified!': 'O cliente foi identificado!',
  'Customer not found': 'Cliente não encontrado',
  'Additional document capture': 'Captura de documento adicional',
  Next: 'Próximo',
  'Please sign the box below': 'Por favor, assine o campo abaixo',
  Accept: 'Aceitar',
  Clear: 'Apagar',
  'Video signature has been successfully captured!': 'A assinatura de vídeo foi capturada com sucesso!',
  'Network unreachable': 'Rede inacessível',
  "We're having trouble reaching our services please check your connection and try again.": 'Estamos com dificuldades para acessar nossos serviços, verifique sua conexão e tente novamente.',
  "We're sorry an unexpected error has occurred.": 'Lamentamos, mas ocorreu um erro inesperado.',
  'Document Capture': 'Captura de Documento',
  Capture: 'Capturar',
  'Retry capture': 'Repetir captura',
  Upload: 'Carregar',
  'Uploading...': 'Carregando...',
  'Upload succeeded!': 'O carregamento foi bem-sucedido!',
  'Performing facial recognition please hold still...': 'Executando o reconhecimento facial, mantenha-se imóvel...',
  'Display the front of your ID card...': 'Exiba a frente da sua carteira de identidade',
  'Display the back of your ID card...': 'Exiba o verso da sua carteira de identidade',
  'Display the ID page of your passport...': 'Exiba a página de identificação do seu passaporte...',
  'Please move your face to the center...': 'Mova seu rosto para o centro...',
  'Searching for ID card...': 'Procurando por carteira de identidade...',
  'Please read the following text aloud': 'Leia o texto a seguir em voz alta',
  'Video ID has been successfully captured!': 'O vídeo de identificação foi capturado com sucesso!',
  'ID Front Image': 'Imagem frontal da ID',
  'ID Back Image': 'Imagem traseira da ID',
  "We're having some trouble.": 'Estamos tendo alguns problemas.',
  'On-device capture guidance failed please capture a selfie manually.': 'A orientação de captura no dispositivo falhou, capture uma selfie manualmente.',
  'Verifying...': 'Verificando...',
  'Please capture the front of your ID card.': 'Capture a frente da sua carteira de identidade.',
  'Please capture the back of your ID card.': 'Capture o verso da sua carteira de identidade',
  'Please capture the front of your ID card or the ID page of your passport.': 'Capture a frente da sua carteira de identidade ou a página de identificação do seu passaporte.',
  'Please capture the back of your ID card or click Done if submitting a passport.': 'Capture o verso da sua carteira de identidade ou clique em Done (Concluído) se estiver enviando um passaporte.',
  'Please capture the ID page of your passport.': 'Capture a página de identificação de seu passaporte.',
  'On-device capture guidance failed please capture a photo of your ID card manually.': 'A orientação de captura no dispositivo falhou, capture uma foto da sua carteira de identidade manualmente.',
  'On-device capture guidance failed please capture a photo of your passport manually.': 'A orientação de captura no dispositivo falhou, capture uma foto do seu passaporte manualmente.',
  'On-device capture guidance failed please capture photos of your ID card and passport manually.': 'A orientação de captura no dispositivo falhou, capture as fotos da sua carteira de identidade e passaporte manualmente.',
  'On-device capture guidance failed please capture photos of your ID card or passport manually.': 'A orientação de captura no dispositivo falhou, capture as fotos da sua carteira de identidade ou passaporte manualmente.',
  'Capture ID page of passport': 'Capture a página de identificação do passaporte',
  'Capture back of ID card': 'Capture o verso da carteira de identidade',
  'Downloading...': 'Baixando...',
  'Accessing camera...': 'Acessando a câmera...',
  'Camera ready': 'Câmera pronta',
  'Loading guided capture experience...': 'Carregando a experiência de captura guiada...',
  'Guided capture experience ready': 'Experiência de captura guiada pronta',
  "Let's Go!": 'Vamos lá!',
  'We are having trouble identifying the correct side of your id do you want to continue with capture anyway?': 'Estamos com dificuldades para identificar o lado correto da sua identidade. Deseja continuar com a captura mesmo assim?',
  OK: 'OK'
};

var ru = {
  'English - en': 'Russian - ru',
  'Use your device camera to capture your ID': 'Используйте камеру вашего устройства для съемки удостоверения личности',
  'Use your iPhone as a webcam': 'Используйте iPhone в качестве веб-камеры',
  'Models warming up...': 'Модели разогреваются…',
  'Camera initializing...': 'Камера инициализируется…',
  'Camera access blocked': 'Доступ к камере заблокирован',
  'Location access blocked': 'Доступ к местоположению заблокирован',
  Continue: 'Продолжить',
  'Processing...': 'Обработка...',
  'Your camera permission is disabled': 'Не выдано разрешение для использования камеры',
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions you must go to settings and provide camera access to the current browser.': 'Для продолжения работы данного приложения требуется доступ к камере. Предоставьте разрешение, как только браузер его запросит. Если браузер не запрашивает разрешение на доступ к камере, необходимо перейти в настройки и предоставить текущему браузеру доступ к камере.',
  'Your microphone permission is disabled': 'Разрешение на доступ к микрофону отключено',
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions you must go to settings and provide microphone access to the current browser.': 'Для продолжения работы данного приложения требуется доступ к микрофону. Предоставьте разрешение, как только браузер его запросит. Если браузер не запрашивает разрешение на доступ к микрофону, необходимо перейти в настройки и предоставить текущему браузеру доступ к микрофону.',
  'Your location permission is disabled': 'Разрешение на доступ к местоположению отключено',
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions you must go to settings and provide location access to the current browser.': 'Для продолжения работы данного приложения требуется доступ к местоположению. Предоставьте разрешение, как только браузер его запросит. Если браузер не запрашивает разрешение на доступ к местоположению, необходимо перейти в настройки и предоставить текущему браузеру доступ к местоположению.',
  Retry: 'Повторить попытку',
  'Scan the front of ID': 'Сканируйте лицевую сторону удостоверения личности',
  'Scan the back of ID': 'Сканируйте оборотную сторону удостоверения личности',
  'Scan the ID page of passport': 'Сканируйте страницу с идентификационными данными в паспорте',
  'ID Card Front': 'Лицевая сторона удостоверения личности',
  'ID Card Back': 'Оборотная сторона удостоверения личности',
  Passport: 'Паспорт',
  'Document not detected': 'Документ не определен',
  'Document is not centered': 'Документ не отцентрирован',
  'Document too close please back up': 'Документ находится слишком близко, отодвиньтесь назад',
  'Please hold your ID document steady': 'Держите удостоверение личности ровно',
  'Document out of focus – try improving the lighting': 'Документ не в фокусе, попробуйте улучшить освещение',
  'ID card front detected - please flip your ID card': 'Обнаружена лицевая сторона удостоверения личности, переверните удостоверение личности',
  'ID card back detected - please flip your ID card': 'Обнаружена обратная сторона удостоверения личности, переверните удостоверение личности',
  'ID card detected please scan a passport instead': 'Обнаружено удостоверение личности, отсканируйте вместо него паспорт',
  'Passport detected please scan an ID card instead': 'Обнаружен паспорт, отсканируйте вместо него удостоверение личности',
  'Document detected hold still...': 'Обнаружен документ, не двигайтесь…',
  'ID card front detected hold still...': 'Обнаружена лицевая сторона удостоверения личности, не двигайтесь…',
  'ID card back detected hold still...': 'Обнаружена обратная сторона удостоверения личности, не двигайтесь…',
  'Passport detected hold still...': 'Обнаружен паспорт, не двигайтесь…',
  'Capturing...': 'Захват изображения…',
  'Capture failed!': 'Захват изображения не выполнен!',
  'Please flip your ID card...': 'Переверните удостоверение личности…',
  'ID card front captured.': 'Лицевая сторона удостоверения личности снята.',
  'ID card back captured.': 'Обратная сторона удостоверения личности снята.',
  'ID Capture Successful': 'Захват удостоверения личности выполнен успешно',
  'Verify the entire ID was captured clearly with no glare.': 'Убедитесь, что все удостоверение личности было снято четко и без бликов.',
  Submit: 'Отправить',
  'Submitting...': 'Отправка…',
  'Use your device camera to capture your face': 'Используйте камеру вашего устройства для съемки лица',
  'Remove Sunglasses & Hat': 'Снимите солнцезащитные очки и головной убор',
  'Avoid Excessive Backlighting': 'Избегайте чрезмерной подсветки сзади',
  'Hold still for a few seconds...': 'Замрите на несколько секунд…',
  'Please hold still...': 'Не двигайтесь…',
  'Look straight into the camera...': 'Смотрите прямо в камеру…',
  'Move back...': 'Отойдите назад…',
  'Move forward...': 'Подвиньтесь вперед…',
  'Move to the center...': 'Переместите к центру…',
  'Please remove your eye coverings (sunglasses eye patch etc.)...': 'Снимите предметы, закрывающие глаза (солнцезащитные очки, повязку и т.д.)…',
  'Please remove your head coverings (hat scarf etc.)...': 'Снимите предметы, покрывающие голову (шапку, шарф и т.д.)…',
  'Please remove your mask...': 'Снимите маску…',
  'Live face not detected, please try again': 'Реальное лицо не обнаружено, повторите попытку',
  Exit: 'Выход',
  'Face liveness has been verified!': 'Реальность лица проверена!',
  Done: 'Готово',
  'Could not verify your face.': 'Не удалось идентифицировать ваше лицо.',
  'An error occurred while verifying your face.': 'Произошла ошибка при идентификации вашего лица.',
  'Customer has been identified!': 'Клиент идентифицирован!',
  'Customer not found': 'Клиент не найден',
  'Additional document capture': 'Захват дополнительного документа',
  Next: 'Далее',
  'Please sign the box below': 'Поставьте подпись в поле ниже',
  Accept: 'Принять',
  Clear: 'Очистить',
  'Video signature has been successfully captured!': 'Видеоподпись успешно записана!',
  'Network unreachable': 'Сеть недоступна',
  "We're having trouble reaching our services please check your connection and try again.": 'У нас возникли проблемы с доступом к нашим службам, проверьте подключение и повторите попытку.',
  "We're sorry an unexpected error has occurred.": 'К сожалению, произошла непредвиденная ошибка.',
  'Document Capture': 'Съемка документа',
  Capture: 'Съемка',
  'Retry capture': 'Повторить съемку',
  Upload: 'Загрузить',
  'Uploading...': 'Загрузка…',
  'Upload succeeded!': 'Загрузка успешно выполнена!',
  'Performing facial recognition please hold still...': 'Выполняется распознавание лица, не двигайтесь…',
  'Display the front of your ID card...': 'Покажите лицевую сторону вашего удостоверения личности…',
  'Display the back of your ID card...': 'Покажите обратную сторону вашего удостоверения личности…',
  'Display the ID page of your passport...': 'Покажите страницу с идентификационными данными вашего паспорта…',
  'Please move your face to the center...': 'Переместите лицо в центр…',
  'Searching for ID card...': 'Выполняется поиск удостоверения личности…',
  'Please read the following text aloud': 'Прочтите следующий текст вслух',
  'Video ID has been successfully captured!': 'Видеоидентификация успешно выполнена!',
  'ID Front Image': 'Изображение лицевой стороны удостоверения личности',
  'ID Back Image': 'Изображение обратной стороны удостоверения личности',
  "We're having some trouble.": 'Возникли некоторые проблемы.',
  'On-device capture guidance failed please capture a selfie manually.': 'Произошел сбой при выполнении руководства по съемке в устройстве, сделайте селфи вручную.',
  'Verifying...': 'Идентификация…',
  'Please capture the front of your ID card.': 'Снимите лицевую сторону вашего удостоверения личности.',
  'Please capture the back of your ID card.': 'Снимите обратную сторону вашего удостоверения личности.',
  'Please capture the front of your ID card or the ID page of your passport.': 'Снимите лицевую сторону вашего удостоверения личности или страницу с идентификационными данными вашего паспорта.',
  'Please capture the back of your ID card or click Done if submitting a passport.': 'Снимите обратную сторону вашего удостоверения личности или нажмите «Готово», если отправляете паспорт.',
  'Please capture the ID page of your passport.': 'Снимите страницу с идентификационными данными вашего паспорта.',
  'On-device capture guidance failed please capture a photo of your ID card manually.': 'Произошел сбой при выполнении руководства по съемке в устройстве, сделайте фотографию вашего удостоверения личности вручную.',
  'On-device capture guidance failed please capture a photo of your passport manually.': 'Произошел сбой при выполнении руководства по съемке в устройстве, сделайте фотографию вашего паспорта вручную.',
  'On-device capture guidance failed please capture photos of your ID card and passport manually.': 'Произошел сбой при выполнении руководства по съемке в устройстве, сделайте фотографии вашего удостоверения личности и паспорта вручную.',
  'On-device capture guidance failed please capture photos of your ID card or passport manually.': 'Произошел сбой при выполнении руководства по съемке в устройстве, сделайте фотографии вашего удостоверения личности или паспорта вручную.',
  'Capture ID page of passport': 'Съемка страницы с идентификационными данными паспорта',
  'Capture back of ID card': 'Съемка обратной стороны удостоверения личности',
  'Downloading...': 'Загрузка…',
  'Accessing camera...': 'Доступ к камере…',
  'Camera ready': 'Камера готова',
  'Loading guided capture experience...': 'Загрузка данных опыта управляемой съемки…',
  'Guided capture experience ready': 'Данные опыта управляемой съемки готовы',
  "Let's Go!": 'Поехали!',
  'We are having trouble identifying the correct side of your id do you want to continue with capture anyway?': 'У нас возникли проблемы с определением правильной стороны вашего удостоверения личности. Все равно хотите продолжить съемку?',
  OK: 'OK'
};

var zh = {
  'English - en': 'Chinese (Traditional) - zh',
  'Use your device camera to capture your ID': '使用裝置相機拍攝證件',
  'Use your iPhone as a webcam': '將 iPhone 當作網路攝影機使用',
  'Models warming up...': '正在暖機...',
  'Camera initializing...': '相機正在初始化...',
  'Camera access blocked': '相機存取遭封鎖',
  'Location access blocked': '位置存取遭封鎖',
  Continue: '繼續',
  'Processing...': '正在處理...',
  'Your camera permission is disabled': '已停用相機權限',
  'This application requires access to your camera to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for camera permissions you must go to settings and provide camera access to the current browser.': '此應用程式需要存取相機才能繼續。瀏覽器提示後，請接受權限。如果瀏覽器未提示相機權限，必須前往設定並為目前瀏覽器提供相機存取權限。',
  'Your microphone permission is disabled': '已停用麥克風權限',
  'This application requires access to your microphone to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for microphone permissions you must go to settings and provide microphone access to the current browser.': '此應用程式需要存取麥克風才能繼續。瀏覽器提示後，請接受權限。如果瀏覽器未提示麥克風權限，必須前往設定並為目前瀏覽器提供麥克風存取權限。',
  'Your location permission is disabled': '已停用位置權限',
  'This application requires access to your location to continue. Please accept the permission once prompted by the browser. If the browser does not prompt for location permissions you must go to settings and provide location access to the current browser.': '此應用程式需要存取位置才能繼續。瀏覽器提示後，請接受權限。如果瀏覽器未提示位置權限，必須前往設定並為目前瀏覽器提供位置存取權限。',
  Retry: '重試',
  'Scan the front of ID': '掃描證件正面',
  'Scan the back of ID': '掃描證件背面',
  'Scan the ID page of passport': '掃描護照的 ID 頁面',
  'ID Card Front': '證件正面',
  'ID Card Back': '證件背面',
  Passport: '護照',
  'Document not detected': '未偵測到文件',
  'Document is not centered': '文件未置中',
  'Document too close please back up': '文件太近，請後退',
  'Please hold your ID document steady': '請拿穩證件',
  'Document out of focus – try improving the lighting': '文件失焦 – 請嘗試改善燈光',
  'ID card front detected - please flip your ID card': '偵測到證件正面 - 請將證件翻面',
  'ID card back detected - please flip your ID card': '偵測到證件背面 - 請將證件翻面',
  'ID card detected please scan a passport instead': '偵測到證件，請掃描護照',
  'Passport detected please scan an ID card instead': '偵測到護照，請掃描證件',
  'Document detected hold still...': '偵測到的文件保持不動...',
  'ID card front detected hold still...': '偵測到的證件正面保持不動...',
  'ID card back detected hold still...': '偵測到的證件背面保持不動...',
  'Passport detected hold still...': '偵測到的護照保持不動...',
  'Capturing...': '正在拍攝...',
  'Capture failed!': '拍攝失敗！',
  'Please flip your ID card...': '請將證件翻面...',
  'ID card front captured.': '已拍攝證件正面。',
  'ID card back captured.': '已拍攝證件背面。',
  'ID Capture Successful': '證件拍攝成功',
  'Verify the entire ID was captured clearly with no glare.': '確認是否清楚拍攝整個證件，無眩光。',
  Submit: '提交',
  'Submitting...': '正在提交...',
  'Use your device camera to capture your face': '使用裝置相機拍攝您的臉部',
  'Remove Sunglasses & Hat': '取下太陽眼鏡和帽子',
  'Avoid Excessive Backlighting': '避免過度背光',
  'Hold still for a few seconds...': '請保持不動幾秒...',
  'Please hold still...': '請保持不動...',
  'Look straight into the camera...': '請直視相機...',
  'Move back...': '請後退...',
  'Move forward...': '請前進...',
  'Move to the center...': '請移至中心...',
  'Please remove your eye coverings (sunglasses eye patch etc.)...': '請取下眼睛遮蓋物（太陽眼鏡、眼罩等）...',
  'Please remove your head coverings (hat scarf etc.)...': '請取下頭部遮蓋物（帽子、圍巾等）...',
  'Please remove your mask...': '請脫下口罩...',
  'Live face not detected, please try again': '未偵測到活體人臉，請再試一次',
  Exit: '退出',
  'Face liveness has been verified!': '已驗證人臉活體！',
  Done: '完成',
  'Could not verify your face.': '無法驗證您的臉部。',
  'An error occurred while verifying your face.': '驗證您的臉部時發生錯誤。',
  'Customer has been identified!': '已識別客戶！',
  'Customer not found': '找不到客戶',
  'Additional document capture': '其他文件拍攝',
  Next: '下一步',
  'Please sign the box below': '請在下方的方框中簽名',
  Accept: '接受',
  Clear: '清除',
  'Video signature has been successfully captured!': '已成功拍攝影片簽名！',
  'Network unreachable': '網路無法連線',
  "We're having trouble reaching our services please check your connection and try again.": '無法與服務連線，請檢查連線並再試一次。',
  "We're sorry an unexpected error has occurred.": '很抱歉，發生非預期錯誤。',
  'Document Capture': '文件拍攝',
  Capture: '拍攝',
  'Retry capture': '重試拍攝',
  Upload: '上傳',
  'Uploading...': '正在上傳...',
  'Upload succeeded!': '上傳成功！',
  'Performing facial recognition please hold still...': '正在進行臉部辨識，請保持不動...',
  'Display the front of your ID card...': '出示證件正面...',
  'Display the back of your ID card...': '出示證件背面...',
  'Display the ID page of your passport...': '出示護照的 ID 頁面...',
  'Please move your face to the center...': '請將臉部移至中心...',
  'Searching for ID card...': '正在搜尋證件...',
  'Please read the following text aloud': '請大聲讀出以下文字',
  'Video ID has been successfully captured!': '已成功拍攝影片 ID！',
  'ID Front Image': '證件正面影像',
  'ID Back Image': '證件背面影像',
  "We're having some trouble.": '發生一些問題。',
  'On-device capture guidance failed please capture a selfie manually.': '裝置上拍攝引導失敗，請手動拍攝自拍照',
  'Verifying...': '正在驗證...',
  'Please capture the front of your ID card.': '請拍攝證件正面。',
  'Please capture the back of your ID card.': '請拍攝證件背面。',
  'Please capture the front of your ID card or the ID page of your passport.': '請拍攝證件正面或護照的 ID 頁面。',
  'Please capture the back of your ID card or click Done if submitting a passport.': '請拍攝證件背面，或者如果提交護照，請按一下「完成」。',
  'Please capture the ID page of your passport.': '請拍攝護照的 ID 頁面。',
  'On-device capture guidance failed please capture a photo of your ID card manually.': '裝置上拍攝引導失敗，請手動拍攝證件的照片。',
  'On-device capture guidance failed please capture a photo of your passport manually.': '裝置上拍攝引導失敗，請手動拍攝護照的照片。',
  'On-device capture guidance failed please capture photos of your ID card and passport manually.': '裝置上拍攝引導失敗，請手動拍攝證件和護照的照片。',
  'On-device capture guidance failed please capture photos of your ID card or passport manually.': '裝置上拍攝引導失敗，請手動拍攝證件或護照的照片。',
  'Capture ID page of passport': '拍攝護照的 ID 頁面',
  'Capture back of ID card': '拍攝證件背面',
  'Downloading...': '正在下載...',
  'Accessing camera...': '正在存取相機...',
  'Camera ready': '相機就緒',
  'Loading guided capture experience...': '正在載入引導式拍攝體驗...',
  'Guided capture experience ready': '引導式拍攝體驗就緒',
  "Let's Go!": '開始！',
  'We are having trouble identifying the correct side of your id do you want to continue with capture anyway?': '無法識別證件的正確一面，是否仍要繼續拍攝？',
  OK: '確定'
};

var resources = {
  en: {
    translation: en
  },
  es: {
    translation: es
  },
  de: {
    translation: de
  },
  fr: {
    translation: fr
  },
  it: {
    translation: it
  },
  ja: {
    translation: ja
  },
  pt: {
    translation: pt
  },
  ru: {
    translation: ru
  },
  zh: {
    translation: zh
  }
};
function initializeI18n() {
  void i18n.use(LanguageDetector).use(initReactI18next).init({
    resources: resources,
    detection: {
      caches: []
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });
}
var useLanguage = function useLanguage(lang) {
  var i18n = useTranslation().i18n;
  useEffect(function () {
    if (lang !== 'auto') {
      void i18n.changeLanguage(lang);
    } else {
      void i18n.changeLanguage(); // call without argument to use detection
    }
  }, [i18n, lang]);
};
function evaluateVerbiage(t, currentLanguage, verbiage, fallback) {
  if (typeof verbiage === 'string') return verbiage;
  if (typeof verbiage === 'object') {
    var translations = verbiage;
    if (translations[currentLanguage]) return translations[currentLanguage];
    var nonLocaleLang = currentLanguage.split('-')[0];
    if (translations[nonLocaleLang]) return translations[nonLocaleLang];
  }
  return t(fallback);
}
function useVerbiage(verbiage, fallback) {
  var _a = useTranslation(),
    t = _a.t,
    i18n = _a.i18n;
  return useMemo(function () {
    return evaluateVerbiage(t, i18n.language, verbiage, fallback);
  }, [fallback, i18n.language, t, verbiage]);
}
function useTranslations(verbiage, fallbacks) {
  var _a = useTranslation(),
    t = _a.t,
    i18n = _a.i18n;
  return useMemo(function () {
    return _assign(_assign({}, verbiage), Object.keys(fallbacks).reduce(function (result, key) {
      var _a;
      return _assign(_assign({}, result), (_a = {}, _a[key] = evaluateVerbiage(t, i18n.language, verbiage === null || verbiage === void 0 ? void 0 : verbiage[key], fallbacks[key]), _a));
    }, {}));
  }, [fallbacks, i18n.language, t, verbiage]);
}

var GuidanceMessageContainerDiv = styled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  position: absolute;\n  top: calc(", ");\n  ", "\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n"], ["\n  position: absolute;\n  top: calc(", ");\n  ", "\n  font-weight: bold;\n  width: 100%;\n  display: flex;\n"])), function (_a) {
  var $top = _a.$top;
  return $top !== null && $top !== void 0 ? $top : '10vh';
}, function (_a) {
  var $bottom = _a.$bottom;
  return $bottom ? "bottom: ".concat($bottom, ";") : "";
});
var GuidanceMessageContainer = function GuidanceMessageContainer(props) {
  var element = /*#__PURE__*/React__default.createElement(GuidanceMessageContainerDiv, _assign({}, props));
  var portalLocation = document.getElementById('idmission-above-guides-content');
  if (!portalLocation) return element;
  return /*#__PURE__*/createPortal(element, portalLocation);
};
var GuidanceMessage = styled.div(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: auto;\n  background: ", ";\n  color: ", ";\n  padding: 10px 12px 8px;\n  border-radius: 8px;\n  z-index: 10001;\n"], ["\n  margin-left: auto;\n  margin-right: auto;\n  background: ", ";\n  color: ", ";\n  padding: 10px 12px 8px;\n  border-radius: 8px;\n  z-index: 10001;\n"])), function (props) {
  var _a, _b, _c, _d, _e, _f;
  return (_f = (_a = props.$background) !== null && _a !== void 0 ? _a : (_e = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.guidanceMessages) === null || _c === void 0 ? void 0 : _c[(_d = props.$variant) !== null && _d !== void 0 ? _d : 'default']) === null || _e === void 0 ? void 0 : _e.backgroundColor) !== null && _f !== void 0 ? _f : '#ccc';
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return (_f = (_a = props.$textColor) !== null && _a !== void 0 ? _a : (_e = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.guidanceMessages) === null || _c === void 0 ? void 0 : _c[(_d = props.$variant) !== null && _d !== void 0 ? _d : 'default']) === null || _e === void 0 ? void 0 : _e.textColor) !== null && _f !== void 0 ? _f : 'black';
});
var templateObject_1$E, templateObject_2$x;

function OverrideWrongDocumentTypeGuidanceDialog(_a) {
  var _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.verbiage,
    rawVerbiage = _c === void 0 ? {} : _c;
  var _d = useIdCaptureState(),
    state = _d[0],
    dispatch = _d[1];
  var verbiage = useTranslations(rawVerbiage, {
    messageText: 'We are having trouble identifying the correct side of your id, do you want to continue with capture anyway?',
    buttonText: 'OK'
  });
  if (!state.allowOverrideWrongDocumentTypeGuidance) return null;
  return /*#__PURE__*/React__default.createElement(Container$2, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(InnerContainer, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(Message, {
    className: classNames.message
  }, verbiage.messageText), /*#__PURE__*/React__default.createElement(ButtonContainer, {
    className: classNames.buttonContainer
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "positive",
    className: classNames.button,
    onClick: function onClick() {
      return dispatch({
        type: 'overrideFlipRequirement'
      });
    }
  }, verbiage.buttonText))));
}
var Container$2 = styled.div(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100dvw;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  z-index: 100001;\n"], ["\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100dvw;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  z-index: 100001;\n"])), function (props) {
  var _a, _b, _c;
  return (_c = (_b = (_a = props.theme.idCapture) === null || _a === void 0 ? void 0 : _a.overrideWrongDocumentTypeGuidance) === null || _b === void 0 ? void 0 : _b.backgroundColor) !== null && _c !== void 0 ? _c : '#eed202';
}, function (props) {
  var _a, _b, _c;
  return (_c = (_b = (_a = props.theme.idCapture) === null || _a === void 0 ? void 0 : _a.overrideWrongDocumentTypeGuidance) === null || _b === void 0 ? void 0 : _b.textColor) !== null && _c !== void 0 ? _c : 'black';
});
var InnerContainer = styled.div(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  padding: 16px 24px;\n  margin: auto 0;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: row;\n  padding: 16px 24px;\n  margin: auto 0;\n  width: 100%;\n"])));
var Message = styled.span(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  display: block;\n  margin: auto 12px auto 0;\n"], ["\n  display: block;\n  margin: auto 12px auto 0;\n"])));
var ButtonContainer = styled.div(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  display: flex;\n  margin-left: auto;\n"], ["\n  display: flex;\n  margin-left: auto;\n"])));
var Button = styled(LoaderButton)(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  white-space: nowrap;\n  margin: auto;\n"], ["\n  white-space: nowrap;\n  margin: auto;\n"])));
var templateObject_1$D, templateObject_2$w, templateObject_3$o, templateObject_4$i, templateObject_5$b;

var IdCapture = function IdCapture(_a) {
  var _b, _c, _d, _e, _f, _g, _h;
  var requiredDocumentType = _a.requiredDocumentType,
    _j = _a.thresholds,
    thresholds = _j === void 0 ? defaultIdCaptureThresholds : _j,
    guidanceMessage = _a.guidanceMessage,
    guidanceSatisfied = _a.guidanceSatisfied,
    onCapture = _a.onCapture,
    _k = _a.classNames,
    classNames = _k === void 0 ? {} : _k,
    _l = _a.colors,
    colors = _l === void 0 ? {} : _l,
    _m = _a.verbiage,
    rawVerbiage = _m === void 0 ? {} : _m,
    _o = _a.debugMode,
    debugMode = _o === void 0 ? false : _o;
  var _p = useResizeObserver(),
    ref = _p.ref,
    _q = _p.width,
    width = _q === void 0 ? 1 : _q,
    _r = _p.height,
    height = _r === void 0 ? 1 : _r;
  var _s = useIdCaptureState(),
    state = _s[0],
    dispatch = _s[1];
  var _t = useCameraStore(),
    camera = _t.camera,
    isRearFacing = _t.isRearFacing;
  var _u = useContext(IdCaptureModelsContext),
    modelsReady = _u.ready,
    setThresholds = _u.setThresholds,
    detectionTime = _u.detectionTime,
    focusPredictionTime = _u.focusPredictionTime,
    getBestFrame = _u.getBestFrame;
  useEffect(function () {
    setThresholds(thresholds);
  }, [thresholds, setThresholds]);
  useEffect(function () {
    if (!requiredDocumentType) return;
    dispatch({
      type: 'setRequiredDocumentType',
      payload: requiredDocumentType
    });
  }, [dispatch, requiredDocumentType]);
  useEffect(function () {
    dispatch({
      type: 'pageRendered',
      payload: {
        pageWidth: width,
        pageHeight: height
      }
    });
  }, [dispatch, height, width]);
  var shouldCapture = state.goodFramesThresholdMet && !state.capturing && timeSince(state.captureStartedAt) >= 3000;
  useEffect(function () {
    if (!shouldCapture) return;
    dispatch({
      type: 'capturing'
    });
    var bestFrame = getBestFrame();
    if (!bestFrame) {
      log('uh oh, i did not get a photo');
      dispatch({
        type: 'captureFailed'
      });
      return;
    }
    var canvas = bestFrame.canvas,
      documentType = bestFrame.documentType,
      boundingBox = bestFrame.boundingBox,
      detectionScore = bestFrame.detectionScore,
      focusScore = bestFrame.focusScore;
    var width = canvas.width,
      height = canvas.height;
    var imageUrl = canvas.toDataURL('image/jpeg', 0.95);
    dispatch({
      type: 'frameCaptured',
      payload: {
        imageUrl: imageUrl
      }
    });
    var capturedDocumentType = documentType;
    setTimeout(function () {
      var _a;
      var captureTime = new Date().getTime() - ((_a = state.captureStartedAt) !== null && _a !== void 0 ? _a : new Date()).getTime();
      var metadata = {
        autoCapture: 'Y',
        captureTime: captureTime,
        boundingBox: boundingBox,
        bestDetectionScore: detectionScore,
        bestFocusScore: focusScore
      };
      onCapture === null || onCapture === void 0 ? void 0 : onCapture(imageUrl, width, height, capturedDocumentType, metadata);
      dispatch({
        type: 'captured'
      });
    }, 0);
  }, [dispatch, getBestFrame, onCapture, shouldCapture, state.captureStartedAt, state.requestedDocumentType]);
  var theme = useTheme();
  colors.guideBoxUnsatisfiedColor || (colors.guideBoxUnsatisfiedColor = (_d = (_c = (_b = theme.idCapture) === null || _b === void 0 ? void 0 : _b.guideBox) === null || _c === void 0 ? void 0 : _c.unsatisfiedColor) !== null && _d !== void 0 ? _d : 'white');
  colors.guideBoxSatisfiedColor || (colors.guideBoxSatisfiedColor = (_g = (_f = (_e = theme.idCapture) === null || _e === void 0 ? void 0 : _e.guideBox) === null || _f === void 0 ? void 0 : _f.satisfiedColor) !== null && _g !== void 0 ? _g : 'green');
  var verbiage = useTranslations(rawVerbiage, {
    instructionText: 'Scan the front of ID',
    processingIdCardText: 'ID card front captured.',
    guidanceSatisfiedText: "".concat(documentTypeDisplayNames[state.detectedDocumentType], " detected, hold still..."),
    guidancePleaseFlipText: 'ID card front detected - please flip your ID card',
    guidanceBackDetectedFirstText: 'ID card back detected - please flip your ID card',
    guidanceTooBlurryText: 'Document out of focus – try improving the lighting',
    guidanceNotCenteredText: 'Document is not centered',
    guidanceTooCloseText: 'Document too close, please back up',
    guidanceNotDetectedText: 'Document not detected',
    guidanceIdCardNotAllowedText: 'ID card detected, please scan a passport instead',
    guidancePassportNotAllowedText: 'Passport detected, please scan an ID card instead',
    guidanceNotStableText: 'Please hold your ID document steady'
  });
  var debugScalingDetails = useDebugScalingDetails({
    enabled: debugMode,
    pageWidth: state.guideRectWidth,
    pageHeight: state.guideRectHeight,
    videoWidth: state.videoWidth,
    videoHeight: state.videoHeight
  });
  var satisfied = state.isGoodFrame;
  if (typeof guidanceSatisfied === 'boolean') satisfied = guidanceSatisfied;
  guidanceMessage || (guidanceMessage = satisfied ? verbiage.guidanceSatisfiedText : !state.detectionThresholdMet ? verbiage.guidanceNotDetectedText : state.backDetectedFirst ? verbiage.guidanceBackDetectedFirstText : state.flipRequired ? verbiage.guidancePleaseFlipText : state.idCardDetectedButNotAllowed ? verbiage.guidanceIdCardNotAllowedText : state.passportDetectedButNotAllowed ? verbiage.guidancePassportNotAllowedText : !state.documentInBounds ? verbiage.guidanceNotCenteredText : state.documentTooClose ? verbiage.guidanceTooCloseText : !state.documentIsStable ? verbiage.guidanceNotStableText : !state.focusThresholdMet ? verbiage.guidanceTooBlurryText : '');
  return /*#__PURE__*/React__default.createElement(PageContainer, {
    ref: ref,
    className: "flex ".concat((_h = classNames.container) !== null && _h !== void 0 ? _h : '')
  }, guidanceMessage !== '' && ( /*#__PURE__*/React__default.createElement(GuidanceMessageContainer, {
    "$top": "",
    "$bottom": "12.5dvh",
    className: classNames.guidanceMessageContainer
  }, /*#__PURE__*/React__default.createElement(GuidanceMessage, {
    "$variant": satisfied ? 'positive' : 'default',
    className: classNames.guidanceMessage
  }, guidanceMessage), /*#__PURE__*/React__default.createElement(OverrideWrongDocumentTypeGuidanceDialog, {
    classNames: classNames.overrideWrongDocumentTypeGuidanceDialog,
    verbiage: rawVerbiage.overrideWrongDocumentTypeGuidanceDialog
  }))), debugMode && ( /*#__PURE__*/React__default.createElement(DebugBoundingBoxOverlay, {
    "$flipX": !isRearFacing,
    scaling: debugScalingDetails
  }, state.detectedObjects.map(function (obj, i) {
    return /*#__PURE__*/React__default.createElement(IdCaptureDetectedObjectDebugBox, {
      key: i,
      obj: obj,
      scaling: debugScalingDetails,
      flipX: !isRearFacing
    });
  }))), debugMode && ( /*#__PURE__*/React__default.createElement(DebugStatsPane, null, camera ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\u2705 Camera: ", camera.label, " (", camera.width, "x", camera.height, ")")) : '❌ Camera not ready', /*#__PURE__*/React__default.createElement("br", null), state.frameCaptureRate > 0.75 ? '✅' : '👎', " Frame Rate:", ' ', Math.round((state.frameCaptureRate + Number.EPSILON) * 1000) / 1000, ' ', "fps (", detectionTime, "ms doc detect, ", focusPredictionTime, "ms focus)", /*#__PURE__*/React__default.createElement("br", null), modelsReady ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, state.detectionThresholdMet ? '✅' : '❌', " Detected Document Type: ", state.detectedDocumentType, /*#__PURE__*/React__default.createElement("br", null), state.idCardFrontDetectionThresholdMet ? '✅' : '❌', " ID Card Front Score: ", state.idCardFrontDetectionScore.toFixed(3), /*#__PURE__*/React__default.createElement("br", null), state.idCardBackDetectionThresholdMet ? '✅' : '❌', " ID Card Back Score: ", state.idCardBackDetectionScore.toFixed(3), /*#__PURE__*/React__default.createElement("br", null), state.passportDetectionThresholdMet ? '✅' : '❌', " Passport Score: ", state.passportDetectionScore.toFixed(3), /*#__PURE__*/React__default.createElement("br", null), state.singlePageDetectionThresholdMet ? '✅' : '❌', " Single Page Score: ", state.singlePageDetectionScore.toFixed(3), /*#__PURE__*/React__default.createElement("br", null), state.focusThresholdMet ? '✅' : '❌', " Focus Score:", ' ', state.focusScore.toFixed(3), /*#__PURE__*/React__default.createElement("br", null), state.documentInBounds ? '✅' : '❌', " Document In Bounds", /*#__PURE__*/React__default.createElement("br", null), state.documentIsStable ? '✅' : '❌', " Document Is Stable", /*#__PURE__*/React__default.createElement("br", null), state.goodFramesThresholdMet ? '✅' : '❌', " Good Frame Count:", ' ', state.goodFramesCount, "/", state.goodFramesThreshold)) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\u274C Models not ready")))));
};
var timeSince = function timeSince(t) {
  if (!t) return 0;
  return Math.abs(new Date().getTime() - t.getTime());
};

var CameraAccessDeniedOverlay = function CameraAccessDeniedOverlay(_a) {
  var _b;
  var _c = _a.assets,
    assets = _c === void 0 ? {} : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  var requestCameraAccess = useCameraStore(function (state) {
    return state.requestCameraAccess;
  });
  assets.imageUrl || (assets.imageUrl = DEFAULT_CDN_URL + '/camera-disable-icon.png');
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Your camera permission is disabled',
    descriptionText: 'This application requires access to your camera to continue. ' + 'Please accept the permission once prompted by the browser. ' + 'If the browser does not prompt for camera permissions, you must go to settings ' + 'and provide camera access to the current browser.',
    retryBtnText: 'Retry'
  });
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: "flex ".concat((_b = classNames.container) !== null && _b !== void 0 ? _b : '')
  }, /*#__PURE__*/React__default.createElement(StyledOverlayInner$3, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(StyledOverlayImageContainer$3, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    src: assets.imageUrl,
    alt: "",
    className: classNames.image
  })), /*#__PURE__*/React__default.createElement("h3", {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(Description$4, {
    className: classNames.description
  }, verbiage.descriptionText), /*#__PURE__*/React__default.createElement(RetryButton$1, {
    variant: "warning",
    onClick: requestCameraAccess,
    colors: colors.retryBtn,
    className: classNames.retryBtn,
    finished: true
  }, verbiage.retryBtnText)));
};
var StyledOverlayInner$3 = styled(OverlayInner$2)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  max-width: 500px;\n  height: auto;\n  margin: auto;\n"], ["\n  max-width: 500px;\n  height: auto;\n  margin: auto;\n"])));
var StyledOverlayImageContainer$3 = styled(OverlayImageContainer)(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  flex-grow: 0;\n"], ["\n  flex-grow: 0;\n"])));
var Description$4 = styled.p(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  line-height: 1.5;\n  margin-bottom: 50px;\n"], ["\n  line-height: 1.5;\n  margin-bottom: 50px;\n"])));
var RetryButton$1 = styled(LoaderButton)(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  width: 200px;\n  margin: 0 auto;\n"], ["\n  width: 200px;\n  margin: 0 auto;\n"])));
var templateObject_1$C, templateObject_2$v, templateObject_3$n, templateObject_4$h;

var ExitCaptureStyledButton = styled.button(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  font-size: 20px;\n  width: 32px;\n  height: 32px;\n  font-family: monospace;\n  z-index: 1002;\n  border: none;\n  border-radius: 4px;\n  background: #ccc;\n  cursor: pointer;\n  padding: 8px;\n  box-sizing: border-box;\n  display: flex;\n\n  &:hover {\n    background: #ddd;\n  }\n\n  & > svg {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n"], ["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  font-size: 20px;\n  width: 32px;\n  height: 32px;\n  font-family: monospace;\n  z-index: 1002;\n  border: none;\n  border-radius: 4px;\n  background: #ccc;\n  cursor: pointer;\n  padding: 8px;\n  box-sizing: border-box;\n  display: flex;\n\n  &:hover {\n    background: #ddd;\n  }\n\n  & > svg {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n"])));
var ExitCaptureButton = function ExitCaptureButton(_a) {
  var onClick = _a.onClick,
    className = _a.className;
  return /*#__PURE__*/React__default.createElement(ExitCaptureStyledButton, {
    onClick: onClick,
    className: className
  }, /*#__PURE__*/React__default.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "19.3 19.3 25.499999999999996 25.499999999999996",
    enableBackground: "new 0 0 64 64",
    width: 16,
    height: 16
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "close-outline-bot_x5F_s1g1_x5F_s2g2_x5F_s3g1_x5F_s4g1"
  }, /*#__PURE__*/React__default.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "19.75",
    y1: "44.25",
    x2: "44.25",
    y2: "19.75"
  })), /*#__PURE__*/React__default.createElement("g", {
    id: "close-outline-top_x5F_s1g1_x5F_s2g2_x5F_s3g1_x5F_s4g1"
  }, /*#__PURE__*/React__default.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    x1: "44.25",
    y1: "44.25",
    x2: "19.75",
    y2: "19.75"
  }))));
};
var templateObject_1$B;

var ButtonsRow = styled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  display: flex;\n  gap: 0 15px;\n  justify-content: center;\n"], ["\n  display: flex;\n  gap: 0 15px;\n  justify-content: center;\n"])));
var templateObject_1$A;

function IdCaptureLoadingGraphic(props) {
  var isMobile = window.innerHeight > window.innerWidth;
  return isMobile ? ( /*#__PURE__*/React__default.createElement(IdCaptureLoadingGraphicMobile, _assign({}, props))) : ( /*#__PURE__*/React__default.createElement(IdCaptureLoadingGraphicDesktop, _assign({}, props)));
}
function IdCaptureLoadingGraphicDesktop(_a) {
  var _b, _c, _d, _e, _f, _g;
  var _h = _a.width,
    width = _h === void 0 ? 698 : _h,
    _j = _a.height,
    height = _j === void 0 ? 452 : _j,
    className = _a.className;
  var _k = useState(0),
    frame = _k[0],
    setFrame = _k[1];
  useEffect(function () {
    var i = setInterval(function () {
      setFrame(function (n) {
        return (n + 1) % 7;
      });
    }, 1000);
    return function () {
      clearInterval(i);
    };
  }, []);
  var theme = useTheme();
  var accentColor = (_d = (_c = (_b = theme.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.loadingGraphicAccentColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
  var accentOpacity = (_g = (_f = (_e = theme.idCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.loadingGraphicAccentOpacity) !== null && _g !== void 0 ? _g : 0.2;
  return /*#__PURE__*/React__default.createElement(LoadingGraphicWrapper, null, /*#__PURE__*/React__default.createElement(LoadingGraphicSvg, {
    className: className,
    width: width,
    height: height,
    "$frame": frame,
    "$borderColor": accentColor,
    viewBox: "0 0 698 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    filter: frame === 1 ? 'url(#filter0_f_91_884)' : undefined
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M10 0.5L688 0.5C693.247 0.5 697.5 4.75329 697.5 10L697.5 442C697.5 447.246 693.247 451.5 688 451.5L9.99999 451.5C4.75328 451.5 0.5 447.246 0.5 442L0.5 9.99998C0.5 4.75328 4.75329 0.5 10 0.5Z",
    fill: "#F3F3F3",
    stroke: "#DCDCDC"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask0_91_854",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "30",
    y: "60",
    width: "207",
    height: "266"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "30.7754",
    y: "60.5945",
    width: "205.426",
    height: "265.304",
    rx: "3",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask0_91_854)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M161.429 226.164C161.472 226.322 161.474 226.488 161.438 226.647C157.252 244.639 146.071 257.508 132.955 257.508C119.837 257.508 108.632 244.59 104.447 226.595C104.411 226.439 104.413 226.276 104.453 226.121L107.568 214.051L108.337 211.118C108.453 210.678 108.85 210.371 109.305 210.371L156.578 210.371C157.034 210.371 157.432 210.68 157.546 211.122L160.976 224.435L161.305 225.701L161.429 226.164Z",
    fill: "#D2D4DA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M185.475 157.408C185.556 157.356 185.628 157.291 185.693 157.219C210.004 130.149 193.715 196.897 180.188 189.065C157.256 175.818 183.525 158.645 185.475 157.408Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M267.491 324.918C267.577 325.255 267.487 325.608 267.24 325.853C254.85 338.143 225.105 345.481 222.791 346.037C222.686 346.063 222.601 346.067 222.493 346.058C219.509 345.795 174.209 342.097 147.081 357.481C142.849 359.881 122.568 356.455 121.909 356.343C121.888 356.339 121.882 356.339 121.861 356.337L89.946 352.929C89.8715 352.921 89.8068 352.921 89.7323 352.929C87.9869 353.117 64.0883 355.438 45.1808 343.79C29.8522 334.346 9.55527 336.584 -1.36759 325.857C-1.61519 325.614 -1.71005 325.255 -1.62441 324.919L1.46107 312.802C6.33129 293.793 21.3654 279.026 40.5404 274.455L42.6579 273.963L66.162 268.361L72.5851 266.837C75.2907 266.181 77.8788 265.267 80.3256 264.095C82.3725 263.11 84.3253 261.962 86.1605 260.649C88.1368 259.243 89.9955 257.649 91.6659 255.891C96.1597 251.18 99.4771 245.367 101.171 238.827L103.665 229.17L104.324 226.568L104.371 226.357L107.571 214.051L108.319 211.123C108.433 210.681 108.831 210.371 109.288 210.371L156.558 210.371C157.013 210.371 157.411 210.679 157.526 211.12L160.978 224.435L161.308 225.701L161.475 226.325C161.489 226.377 161.496 226.431 161.496 226.486V226.486C161.496 226.54 161.503 226.595 161.517 226.647L162.202 229.193L164.696 238.827C167.025 247.781 172.413 255.446 179.73 260.649C183.729 263.532 188.317 265.665 193.282 266.837L199.211 268.244L225.326 274.455C244.501 279.026 259.535 293.793 264.406 312.802L267.491 324.918Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M161.429 226.164C161.472 226.322 161.474 226.488 161.438 226.647C157.252 244.639 146.071 257.508 132.955 257.508C119.837 257.508 108.632 244.59 104.447 226.595C104.411 226.439 104.413 226.276 104.453 226.121L107.568 214.051L108.337 211.118C108.453 210.678 108.85 210.371 109.305 210.371L156.578 210.371C157.034 210.371 157.432 210.68 157.546 211.122L160.976 224.435L161.305 225.701L161.429 226.164Z",
    fill: "#DC968D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M80.3983 157.408C80.3166 157.356 80.2445 157.291 80.1799 157.219C55.8686 130.149 72.1582 196.897 85.685 189.065C108.616 175.818 82.3476 158.645 80.3983 157.408Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M189.527 137.873C189.52 137.873 189.515 137.879 189.515 137.885C189.515 139.944 189.397 141.956 189.162 143.968C188.974 145.796 188.15 153.601 186.692 163.54C185.895 169.048 184.865 175.184 183.649 181.346C183.638 181.398 183.635 181.447 183.631 181.5V181.5C183.625 181.607 183.575 181.713 183.554 181.818C180.568 196.836 176.367 211.751 170.881 217.193C164.67 223.381 159.682 229.007 153.988 233.062C148.295 237.14 141.919 239.672 132.978 239.672C124.038 239.672 117.662 237.14 111.968 233.062C106.298 229.007 101.286 223.381 95.0752 217.193C89.5754 211.714 85.367 196.715 82.3561 181.682C82.3499 181.651 82.3467 181.628 82.3467 181.596V181.596C82.3467 181.566 82.3438 181.526 82.338 181.496C81.9648 179.566 81.6147 177.636 81.2645 175.728C81.1233 174.932 80.9821 174.135 80.841 173.338C80.2528 169.962 79.7352 166.657 79.2646 163.563C77.5768 152.19 76.7532 143.609 76.7472 143.546C76.747 143.544 76.7471 143.545 76.7469 143.543C76.5589 141.692 76.4648 139.794 76.4648 137.873C76.4648 137.381 76.4648 136.889 76.4648 136.397C76.5825 131.967 77.1942 127.654 78.3 123.528C78.3471 123.341 78.3941 123.153 78.4412 122.966C84.723 100.089 105.121 83.0011 129.731 81.6416C130.814 81.5713 131.872 81.5479 132.978 81.5479C148.601 81.5479 162.741 87.8531 172.975 98.0494C181.822 106.839 187.75 118.559 189.186 131.615C189.42 133.674 189.538 135.756 189.539 137.862C189.539 137.868 189.533 137.873 189.527 137.873V137.873Z",
    fill: "#FEAEA5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M141.871 188.529C141.871 192.42 137.895 195.561 132.977 195.561C128.06 195.561 124.107 192.42 124.107 188.529V188.529C124.107 188.132 124.593 188.105 124.773 188.459C126.079 191.03 129.266 192.842 132.977 192.842C136.689 192.842 139.893 191.03 141.204 188.458C141.381 188.112 141.871 188.14 141.871 188.529V188.529Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M267.512 325.037C267.599 325.374 267.509 325.727 267.264 325.974C232.886 360.672 133.16 359.767 132.956 359.765C132.95 359.765 132.962 359.765 132.956 359.765C132.752 359.767 33.0007 360.672 -1.3537 325.95C-1.59784 325.703 -1.68748 325.351 -1.60167 325.014L1.48353 312.922C6.35375 293.889 21.3879 279.122 40.5629 274.551L66.2315 268.456L72.6075 266.933C75.2325 266.311 77.7789 265.415 80.1745 264.28C80.5729 264.092 81.0485 264.176 81.3541 264.494C94.359 278.009 112.66 286.435 132.956 286.435C153.253 286.435 171.556 278.008 184.562 264.49C184.865 264.174 185.337 264.088 185.734 264.274C188.127 265.395 190.657 266.311 193.304 266.933L198.88 268.269L225.349 274.551C244.524 279.122 259.558 293.889 264.405 312.922L267.512 325.037Z",
    fill: "#6E7174"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M197.318 267.895C198.038 268.068 198.334 268.924 197.847 269.481C190.872 277.457 169.982 297.251 132.954 298.717C92.046 300.357 71.408 275.554 67.0543 269.627C66.6418 269.065 66.9505 268.284 67.6281 268.122L72.606 266.933C75.231 266.311 77.7773 265.415 80.173 264.28C80.5713 264.092 81.0469 264.176 81.3526 264.494C94.3575 278.009 112.659 286.435 132.954 286.435C153.252 286.435 171.555 278.008 184.56 264.49C184.864 264.174 185.336 264.088 185.732 264.274C188.126 265.395 190.655 266.311 193.303 266.933L197.318 267.895Z",
    fill: "#555A5E"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M75.4663 140.851C75.4663 152.603 78.3795 166.091 80.4253 174.114C80.713 175.242 82.458 175.01 82.5156 173.848C83.0875 162.287 85.7494 140.134 97.4904 130.033C108.545 120.523 117.526 131.201 132.13 131.201C145.353 131.201 157.695 120.704 168.836 130.033C181.053 140.264 183.463 159.992 183.739 171.736C183.767 172.936 185.717 173.218 186.003 172.053C187.986 163.959 190.429 151.77 190.429 140.851C190.429 100.426 174.665 81.3704 132.13 81.3704C93.3928 81.3704 75.4663 100.225 75.4663 140.851Z",
    fill: "#525252"
  })), /*#__PURE__*/React__default.createElement("rect", {
    x: "30.7754",
    y: "360.29",
    width: "640.93",
    height: "40.942",
    rx: "3",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "267.427",
    y: "134.29",
    width: "402.636",
    height: "40.942",
    rx: "3",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "267.427",
    y: "209.623",
    width: "180.775",
    height: "40.942",
    rx: "3",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "481.069",
    y: "209.623",
    width: "188.992",
    height: "40.942",
    rx: "3",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "267.427",
    y: "284.956",
    width: "180.775",
    height: "40.942",
    rx: "3",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "481.069",
    y: "284.956",
    width: "188.992",
    height: "40.942",
    rx: "3",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "266.829",
    y: "58.3618",
    width: "402.636",
    height: "40.942",
    rx: "3",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("g", {
    fillOpacity: frame === 3 ? accentOpacity : 0,
    style: {
      transition: 'fill-opacity 0.2s linear'
    }
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "672",
    y: "55",
    width: "47",
    height: "410",
    transform: "rotate(90 672 55)",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "670",
    y: "206",
    width: "47",
    height: "194",
    transform: "rotate(90 670 206)",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "242",
    y: "61",
    width: "271",
    height: "218",
    transform: "rotate(90 242 61)",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "677",
    y: "357",
    width: "47",
    height: "653",
    transform: "rotate(90 677 357)",
    fill: accentColor
  })), /*#__PURE__*/React__default.createElement("g", {
    fillOpacity: frame === 4 ? accentOpacity : 0,
    style: {
      transition: 'fill-opacity 0.2s linear'
    }
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "455",
    y: "281",
    width: "47",
    height: "194",
    transform: "rotate(90 455 281)",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "672",
    y: "131",
    width: "47",
    height: "411",
    transform: "rotate(90 672 131)",
    fill: accentColor
  })), /*#__PURE__*/React__default.createElement("g", {
    fillOpacity: frame >= 5 ? 1 : 0,
    style: {
      transition: 'fill-opacity 0.2s linear'
    }
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "360",
    cy: "215",
    r: "41",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M339.937 218.076L350.044 229.83L381.809 201.915",
    stroke: "white",
    strokeWidth: "10",
    strokeOpacity: frame >= 5 ? 1 : 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transition: 'stroke-opacity 0.2s linear'
    }
  }))), /*#__PURE__*/React__default.createElement("filter", {
    id: "filter0_f_91_884",
    x: "0",
    y: "0",
    width: "848",
    height: "556",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React__default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React__default.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React__default.createElement("feGaussianBlur", {
    stdDeviation: "5",
    result: "effect1_foregroundBlur_91_884"
  }))));
}
function IdCaptureLoadingGraphicMobile(_a) {
  var _b, _c, _d, _e, _f, _g;
  var _h = _a.width,
    width = _h === void 0 ? 428 : _h,
    _j = _a.height,
    height = _j === void 0 ? 747 : _j,
    className = _a.className;
  var _k = useState(0),
    frame = _k[0],
    setFrame = _k[1];
  useEffect(function () {
    var i = setInterval(function () {
      setFrame(function (n) {
        return (n + 1) % 7;
      });
    }, 1000);
    return function () {
      clearInterval(i);
    };
  }, []);
  var theme = useTheme();
  var accentColor = (_d = (_c = (_b = theme.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.loadingGraphicAccentColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
  var accentOpacity = (_g = (_f = (_e = theme.idCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.loadingGraphicAccentOpacity) !== null && _g !== void 0 ? _g : 0.2;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 428 747",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement(LoadingGraphicCardGroup, {
    id: "card",
    "$offScreen": frame < 1
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M76.5001 181.274C76.5001 176.027 80.7534 171.774 86.0001 171.774L342 171.774C347.247 171.774 351.5 176.027 351.5 181.274L351.5 586C351.5 591.247 347.247 595.5 342 595.5L86.0001 595.5C80.7534 595.5 76.5001 591.247 76.5001 586L76.5001 181.274Z",
    fill: "#F3F3F3",
    stroke: "#DCDCDC"
  }), /*#__PURE__*/React__default.createElement("mask", {
    id: "mask0_29_1815",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "113",
    y: "452",
    width: "163",
    height: "126"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "113",
    y: "577.273",
    width: "125",
    height: "162",
    rx: "3",
    transform: "rotate(-90 113 577.273)",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask0_29_1815)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M214.008 497.796C214.165 497.754 214.33 497.751 214.489 497.788C225.426 500.352 233.24 507.14 233.24 515.098C233.24 523.058 225.395 529.861 214.455 532.423C214.3 532.46 214.138 532.458 213.983 532.418L206.704 530.546L205.204 530.154C204.764 530.039 204.457 529.641 204.457 529.186L204.457 501.028C204.457 500.571 204.766 500.173 205.208 500.059L213.044 498.048L213.817 497.847L214.008 497.796Z",
    fill: "#D2D4DA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M172.144 483.183C172.092 483.102 172.027 483.031 171.955 482.966C155.547 468.233 196.225 478.134 191.447 486.357C183.444 500.161 173.096 484.665 172.144 483.183Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M274.192 433.287C274.528 433.202 274.882 433.292 275.124 433.541C282.444 441.074 286.849 458.59 287.283 460.373C287.308 460.479 287.314 460.558 287.305 460.667C287.111 462.898 284.971 490.135 294.285 506.502C295.735 509.05 293.703 521.155 293.593 521.803C293.589 521.823 293.587 521.84 293.585 521.861L291.51 541.224C291.502 541.299 291.502 541.364 291.509 541.439C291.65 542.782 292.959 557.13 285.925 568.508C280.203 577.763 281.504 589.995 275.126 596.677C274.887 596.927 274.528 597.02 274.193 596.935L267.003 595.111C255.396 592.147 246.379 582.999 243.588 571.332L243.287 570.043L239.866 555.741L238.936 551.833C238.535 550.186 237.977 548.611 237.262 547.123C236.66 545.877 235.959 544.689 235.158 543.572C234.299 542.37 233.326 541.239 232.252 540.222C229.375 537.488 225.826 535.469 221.832 534.438L215.936 532.921L214.347 532.52L214.218 532.491L206.704 530.544L205.21 530.164C204.767 530.051 204.457 529.652 204.457 529.194L204.457 501.04C204.457 500.584 204.765 500.186 205.207 500.071L213.044 498.046L213.817 497.846L214.198 497.744C214.23 497.736 214.263 497.731 214.297 497.731C214.33 497.731 214.363 497.727 214.395 497.718L215.95 497.302L221.832 495.784C227.3 494.367 231.98 491.088 235.158 486.636C236.918 484.202 238.22 481.411 238.936 478.39L239.795 474.782L243.588 458.891C246.379 447.223 255.396 438.075 267.003 435.112L274.192 433.287Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M214.008 497.796C214.165 497.754 214.33 497.751 214.489 497.788C225.426 500.352 233.24 507.14 233.24 515.098C233.24 523.058 225.395 529.861 214.455 532.423C214.3 532.46 214.138 532.458 213.983 532.418L206.704 530.546L205.204 530.154C204.764 530.039 204.457 529.641 204.457 529.186L204.457 501.028C204.457 500.571 204.766 500.173 205.208 500.059L213.044 498.048L213.817 497.847L214.008 497.796Z",
    fill: "#DC968D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M172.144 547.035C172.092 547.117 172.027 547.188 171.955 547.252C155.547 561.986 196.225 552.085 191.447 543.861C183.444 530.057 173.096 545.553 172.144 547.035Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M160.188 480.675C160.188 480.679 160.191 480.682 160.195 480.682C161.452 480.682 162.681 480.754 163.91 480.897C165.026 481.011 169.792 481.512 175.861 482.4C179.224 482.885 182.971 483.511 186.733 484.252C186.765 484.258 186.795 484.26 186.827 484.262C186.893 484.266 186.958 484.296 187.022 484.309C196.192 486.126 205.299 488.682 208.623 492.02C212.401 495.8 215.836 498.835 218.312 502.3C220.803 505.764 222.348 509.644 222.348 515.084C222.348 520.524 220.803 524.404 218.312 527.869C215.836 531.319 212.401 534.368 208.623 538.148C205.277 541.494 196.118 544.055 186.939 545.887C186.92 545.891 186.906 545.893 186.886 545.893C186.867 545.893 186.844 545.895 186.825 545.898C185.646 546.125 184.468 546.338 183.303 546.551C182.817 546.637 182.33 546.723 181.843 546.809C179.782 547.167 177.764 547.482 175.875 547.768C168.946 548.793 163.714 549.294 163.652 549.3C163.651 549.3 163.651 549.3 163.649 549.3C162.519 549.415 161.361 549.472 160.188 549.472C159.888 549.472 159.587 549.472 159.287 549.472C156.581 549.4 153.948 549.028 151.429 548.355C151.314 548.327 151.2 548.298 151.085 548.269C137.116 544.447 126.682 532.035 125.852 517.06C125.809 516.401 125.795 515.757 125.795 515.084C125.795 505.578 129.645 496.974 135.871 490.746C141.238 485.363 148.395 481.756 156.367 480.882C157.624 480.739 158.895 480.668 160.181 480.668C160.185 480.668 160.188 480.671 160.188 480.675Z",
    fill: "#FEAEA5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M191.119 509.673C193.495 509.673 195.413 512.092 195.413 515.084C195.413 518.077 193.495 520.482 191.119 520.482C190.877 520.482 190.861 520.186 191.077 520.077C192.647 519.282 193.753 517.343 193.753 515.084C193.753 512.826 192.647 510.876 191.077 510.079C190.866 509.971 190.883 509.673 191.119 509.673Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M274.264 433.275C274.6 433.189 274.954 433.278 275.199 433.524C296.217 454.568 295.682 514.893 295.68 515.097C295.68 515.103 295.68 515.092 295.68 515.098C295.682 515.302 296.217 575.643 275.184 596.673C274.939 596.917 274.586 597.007 274.251 596.921L267.076 595.097C255.454 592.134 246.437 582.986 243.646 571.318L239.925 555.699L238.994 551.819C238.638 550.318 238.133 548.86 237.499 547.48C237.314 547.078 237.398 546.602 237.715 546.294C245.845 538.394 250.903 527.342 250.903 515.098C250.903 502.851 245.844 491.798 237.711 483.897C237.396 483.591 237.311 483.119 237.493 482.719C238.122 481.341 238.638 479.89 238.994 478.376L239.81 474.983L243.646 458.877C246.437 447.21 255.454 438.061 267.076 435.112L274.264 433.275Z",
    fill: "#6E7174"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M239.436 476.54C239.609 475.821 240.466 475.529 241.015 476.024C246.147 480.64 257.535 493.254 258.403 515.098C259.367 539.068 245.359 551.601 241.088 554.862C240.535 555.285 239.753 554.982 239.59 554.305L238.994 551.82C238.638 550.319 238.133 548.86 237.499 547.48C237.314 547.079 237.398 546.603 237.715 546.295C245.845 538.394 250.903 527.343 250.903 515.098C250.903 502.852 245.844 491.799 237.711 483.898C237.396 483.592 237.311 483.119 237.493 482.72C238.122 481.342 238.638 479.891 238.994 478.377L239.436 476.54Z",
    fill: "#555A5E"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M162.007 550.079C167.945 550.079 174.609 548.865 179.507 547.741C180.642 547.481 180.435 545.695 179.275 545.595C171.872 544.959 160.808 542.941 155.401 536.678C149.594 529.951 156.114 524.486 156.114 515.6C156.114 507.554 149.704 500.044 155.401 493.265C160.661 487.005 170.034 484.976 177.145 484.392C178.342 484.293 178.605 482.241 177.431 481.993C172.848 481.025 167.193 480.126 162.007 480.126C137.322 480.126 125.686 489.718 125.686 515.6C125.686 539.171 137.2 550.079 162.007 550.079Z",
    fill: "#525252"
  })), /*#__PURE__*/React__default.createElement("rect", {
    x: "296",
    y: "577.273",
    width: "390",
    height: "25",
    rx: "3",
    transform: "rotate(-90 296 577.273)",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "158",
    y: "433.273",
    width: "245",
    height: "25",
    rx: "3",
    transform: "rotate(-90 158 433.273)",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "204",
    y: "433.273",
    width: "110",
    height: "25",
    rx: "3",
    transform: "rotate(-90 204 433.273)",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "204",
    y: "303.274",
    width: "115",
    height: "25",
    rx: "3",
    transform: "rotate(-90 204 303.274)",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "250",
    y: "433.273",
    width: "110",
    height: "25",
    rx: "3",
    transform: "rotate(-90 250 433.273)",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "250",
    y: "303.274",
    width: "115",
    height: "25",
    rx: "3",
    transform: "rotate(-90 250 303.274)",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "111.637",
    y: "433.637",
    width: "245",
    height: "25",
    rx: "3",
    transform: "rotate(-90 111.637 433.637)",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React__default.createElement("g", {
    fillOpacity: frame === 2 ? accentOpacity : 0,
    style: {
      transition: 'fill-opacity 0.2s linear'
    }
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "200",
    y: "188",
    width: "33",
    height: "118",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "108",
    y: "444",
    width: "171",
    height: "136",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "108",
    y: "187",
    width: "33",
    height: "247",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "293",
    y: "186",
    width: "31",
    height: "394",
    fill: accentColor
  })), /*#__PURE__*/React__default.createElement("g", {
    fillOpacity: frame === 3 ? accentOpacity : 0,
    style: {
      transition: 'fill-opacity 0.2s linear'
    }
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "154",
    y: "185",
    width: "33",
    height: "249",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "247",
    y: "322",
    width: "31",
    height: "113",
    rx: "5",
    fill: accentColor
  })), /*#__PURE__*/React__default.createElement("g", {
    fillOpacity: frame >= 4 ? 1 : 0,
    strokeOpacity: frame >= 4 ? 1 : 0,
    style: {
      transition: 'fill-opacity 0.2s linear, stroke-opacity 0.2s linear'
    }
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "78.5",
    y: "171.5",
    width: "271",
    height: "426",
    rx: "2.5",
    stroke: accentColor,
    strokeWidth: "5"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "214.5",
    cy: "383.5",
    r: "23.5",
    fill: accentColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M203 385.263L208.793 392L227 376",
    stroke: "white",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React__default.createElement(LoadingGraphicPhoneGroup, {
    id: "phone",
    clipPath: "url(#clip0_29_1778)",
    "$offScreen": frame < 1
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "154",
    y: "693",
    width: "120",
    height: "5",
    rx: "2.5",
    fill: "#333343"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.869 156.244H373.495V156.241C376.342 156.241 378.647 158.551 378.647 161.396V234.788C378.647 237.637 376.339 239.944 373.495 239.944H372.869V677.09C372.869 698.895 355.203 716.571 333.411 716.571H94.2366C72.444 716.571 54.7781 698.895 54.7781 677.09V278.699H54.1523C51.3051 278.699 49 276.39 49 273.544V228.052C49 225.203 51.3082 222.897 54.1523 222.897H54.7781V212.047H54.1523C51.3051 212.047 49 209.737 49 206.892V161.399C49 158.551 51.3082 156.244 54.1523 156.244H54.7781V90.4813C54.7781 68.6761 72.444 51 94.2366 51H333.411C355.203 51 372.869 68.6761 372.869 90.4813V156.244ZM98.3077 60.7649H329.34C347.039 60.7649 361.387 75.1214 361.387 92.8311V674.734C361.387 692.444 347.039 706.8 329.34 706.8H98.3077C80.6082 706.8 66.26 692.444 66.26 674.734V92.8311C66.26 75.1214 80.6082 60.7649 98.3077 60.7649Z",
    fill: "#333343"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "154",
    y: "71",
    width: "120",
    height: "20",
    rx: "10",
    fill: "#333343"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_29_1778"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "428",
    height: "747",
    fill: "white"
  }))));
}
var LoadingGraphicWrapper = styled.div(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n"], ["\n  display: flex;\n  width: 100%;\n  height: 100%;\n"])));
var LoadingGraphicSvg = styled.svg(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  margin: auto;\n  transform: scale(\n    ", "\n  );\n  transform-style: preserve-3d;\n  transition:\n    transform 0.2s linear,\n    border-width 0.2s linear;\n  border: ", "px solid\n    ", ";\n"], ["\n  margin: auto;\n  transform: scale(\n    ", "\n  );\n  transform-style: preserve-3d;\n  transition:\n    transform 0.2s linear,\n    border-width 0.2s linear;\n  border: ", "px solid\n    ", ";\n"])), function (props) {
  return props.$frame > 1 ? 1 : props.$frame === 1 ? 1.25 : 0.75;
}, function (props) {
  return props.$frame >= 5 ? 10 : 0;
}, function (props) {
  return props.$borderColor;
});
var LoadingGraphicCardGroup = styled.g(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  transform: translate(", ", 0);\n  transform-style: preserve-3d;\n  transition: transform 0.3s linear;\n"], ["\n  transform: translate(", ", 0);\n  transform-style: preserve-3d;\n  transition: transform 0.3s linear;\n"])), function (props) {
  return props.$offScreen ? '-500px' : '0';
});
var LoadingGraphicPhoneGroup = styled.g(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  transform: translate(", ", 0);\n  transform-style: preserve-3d;\n  transition: transform 0.3s linear;\n"], ["\n  transform: translate(", ", 0);\n  transform-style: preserve-3d;\n  transition: transform 0.3s linear;\n"])), function (props) {
  return props.$offScreen ? '40px' : '0';
});
var templateObject_1$z, templateObject_2$u, templateObject_3$m, templateObject_4$g;

function LoadingListItemIndicator(_a) {
  var _b = _a.state,
    state = _b === void 0 ? 'running' : _b,
    svgProps = __rest(_a, ["state"]);
  return /*#__PURE__*/React__default.createElement("svg", _assign({
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: _assign({
      margin: 'auto 0.5rem auto 0',
      flexShrink: 0
    }, svgProps.style)
  }, svgProps), state === 'done' ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0_49_385)"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM19.5643 8.27852C19.9549 7.88799 19.9549 7.25483 19.5643 6.8643C19.1738 6.47378 18.5406 6.47378 18.1501 6.8643L9.42866 15.5858L5.85005 12.0072C5.45953 11.6166 4.82636 11.6166 4.43584 12.0072C4.04531 12.3977 4.04531 13.0309 4.43584 13.4214L8.72155 17.7071C9.11208 18.0976 9.74524 18.0976 10.1358 17.7071L19.5643 8.27852Z",
    fill: "currentColor"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_49_385"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))))) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0_49_370)"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "path-1-inside-1_49_370",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51472 20.4855C8.20101 25.1718 15.799 25.1718 20.4853 20.4855C25.1716 15.7992 25.1716 8.20119 20.4853 3.5149C15.799 -1.17139 8.20101 -1.17139 3.51472 3.5149C-1.17157 8.20119 -1.17157 15.7992 3.51472 20.4855Z"
  })), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.39814 11.459C5.84586 11.459 5.39814 11.9067 5.39814 12.459C5.39814 13.0112 5.84586 13.459 6.39814 13.459V11.459ZM17.6019 13.459C18.1541 13.459 18.6019 13.0112 18.6019 12.459C18.6019 11.9067 18.1541 11.459 17.6019 11.459V13.459ZM6.39814 13.459H17.6019V11.459H6.39814V13.459ZM3.51472 20.4855L4.92893 19.0713L4.92893 19.0713L3.51472 20.4855ZM20.4853 3.5149L19.0711 4.92912L19.0711 4.92912L20.4853 3.5149ZM3.51472 3.5149L4.92893 4.92912L4.92893 4.92912L3.51472 3.5149ZM19.0711 19.0713C15.1658 22.9765 8.83417 22.9765 4.92893 19.0713L2.10051 21.8997C7.56784 27.367 16.4322 27.367 21.8995 21.8997L19.0711 19.0713ZM19.0711 4.92912C22.9763 8.83436 22.9763 15.166 19.0711 19.0713L21.8995 21.8997C27.3668 16.4323 27.3668 7.56803 21.8995 2.10069L19.0711 4.92912ZM4.92893 4.92912C8.83417 1.02387 15.1658 1.02387 19.0711 4.92912L21.8995 2.10069C16.4322 -3.36665 7.56784 -3.36665 2.10051 2.10069L4.92893 4.92912ZM4.92893 19.0713C1.02369 15.166 1.02369 8.83436 4.92893 4.92912L2.10051 2.10069C-3.36683 7.56803 -3.36683 16.4323 2.10051 21.8997L4.92893 19.0713Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_49_370)"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_49_370"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))))));
}

var legacyInstructionImageUrl$1 = "".concat(DEFAULT_CDN_URL, "/WebSDK-Instruction-DL-Capture-3-Portrait.png");
var IdCaptureLoadingOverlayDefault = function IdCaptureLoadingOverlayDefault(_a) {
  var _b, _c, _d, _e, _f, _g;
  var onDismissed = _a.onDismissed,
    onUserCancel = _a.onUserCancel,
    instructions = _a.instructions,
    _h = _a.rotateImage,
    rotateImage = _h === void 0 ? false : _h,
    _j = _a.assets,
    assets = _j === void 0 ? {} : _j,
    _k = _a.classNames,
    classNames = _k === void 0 ? {} : _k,
    _l = _a.colors,
    colors = _l === void 0 ? {} : _l,
    _m = _a.verbiage,
    rawVerbiage = _m === void 0 ? {} : _m,
    customOverlayContent = _a.customOverlayContent;
  var _o = useContext(IdCaptureModelsContext),
    modelsReady = _o.ready,
    modelDownloadProgress = _o.modelDownloadProgress;
  var _p = useCameraStore(),
    cameraReady = _p.cameraReady,
    cameraAccessDenied = _p.cameraAccessDenied,
    iphoneContinuityCameraAvailable = _p.iphoneContinuityCameraAvailable,
    setIphoneContinuityCameraAllowed = _p.setIphoneContinuityCameraAllowed;
  var _q = useState(false),
    dismissed = _q[0],
    setDismissed = _q[1];
  assets.instructionImageUrl || (assets.instructionImageUrl = legacyInstructionImageUrl$1);
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Use your device camera to capture your ID',
    useContinuityCameraText: 'Use your iPhone as a webcam',
    downloadingText: 'Downloading...',
    modelsWarmingUpText: 'Loading guided capture experience...',
    modelsReadyText: 'Guided capture experience ready',
    cameraInitializingText: 'Camera initializing...',
    cameraInitializedText: 'Camera ready',
    continueText: "Let's Go!"
  });
  useEffect(function () {
    if (modelsReady && cameraReady) return function () {
      return null;
    };
    var t = setTimeout(function () {
      setDismissed(false);
    }, 500);
    return function () {
      clearTimeout(t);
    };
  }, [cameraReady, modelsReady]);
  var imageRef = useRef(null);
  if (dismissed) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  if (cameraAccessDenied) {
    return /*#__PURE__*/React__default.createElement(CameraAccessDeniedOverlay, {
      assets: assets.cameraAccessDenied,
      classNames: classNames.cameraAccessDenied,
      colors: colors.cameraAccessDenied,
      verbiage: rawVerbiage.cameraAccessDenied
    });
  }
  var imageStyle = {};
  if (rotateImage) {
    var naturalWidth = (_c = (_b = imageRef.current) === null || _b === void 0 ? void 0 : _b.naturalWidth) !== null && _c !== void 0 ? _c : 0;
    var naturalHeight = (_e = (_d = imageRef.current) === null || _d === void 0 ? void 0 : _d.naturalHeight) !== null && _e !== void 0 ? _e : 0;
    var scale = naturalWidth > naturalHeight ? naturalHeight / naturalWidth : 1;
    imageStyle = {
      transform: "rotate(-90deg) scale(".concat(scale, ")")
    };
  }
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$1, {
    className: classNames.inner
  }, onUserCancel && ( /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onUserCancel,
    className: classNames.cancelBtn
  })), customOverlayContent || ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OverlayHeader$1, null, /*#__PURE__*/React__default.createElement(StyledGuidanceMessage$2, {
    className: classNames.heading
  }, verbiage.headingText)), /*#__PURE__*/React__default.createElement(StyledOverlayImageContainer$2, {
    className: classNames.imageContainer,
    style: {
      pointerEvents: 'none'
    }
  }, (assets === null || assets === void 0 ? void 0 : assets.instructionImageUrl) && assets.instructionImageUrl !== legacyInstructionImageUrl$1 ? ( /*#__PURE__*/React__default.createElement(CustomLoadingGraphic$1, {
    ref: imageRef,
    alt: verbiage.headingText,
    src: assets.instructionImageUrl,
    className: classNames.image,
    style: imageStyle
  })) : ( /*#__PURE__*/React__default.createElement(IdCaptureLoadingGraphic, {
    className: classNames.image
  }))))), instructions, /*#__PURE__*/React__default.createElement(ContinuityCameraCheckboxContainer$1, {
    className: classNames.continuityCameraCheckboxContainer
  }, iphoneContinuityCameraAvailable && ( /*#__PURE__*/React__default.createElement(ContinuityCameraCheckboxInner, {
    className: classNames.continuityCameraCheckboxInner
  }, /*#__PURE__*/React__default.createElement(ContinuityCameraCheckbox$1, {
    className: classNames.continuityCameraCheckbox,
    id: "use-continuity-camera",
    type: "checkbox",
    defaultChecked: true,
    onChange: function onChange(e) {
      setIphoneContinuityCameraAllowed(e.target.checked);
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "use-continuity-camera",
    className: classNames.continuityCameraCheckboxLabel
  }, verbiage.useContinuityCameraText)))), /*#__PURE__*/React__default.createElement(StyledButtonsRow$a, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(ProgressContainer$1, {
    className: classNames.progressContainer
  }, /*#__PURE__*/React__default.createElement(ProgressBarBackground$1, {
    className: classNames.progressBackground
  }), /*#__PURE__*/React__default.createElement(ProgressBar$1, {
    "$progress": modelDownloadProgress,
    className: classNames.progressBar
  }, /*#__PURE__*/React__default.createElement(ProgressIndicator$1, {
    className: classNames.progressIndicator
  }))), /*#__PURE__*/React__default.createElement(LoadingListContainer$1, {
    className: classNames.loadingListContainer
  }, /*#__PURE__*/React__default.createElement(LoadingList$1, {
    className: classNames.loadingList
  }, /*#__PURE__*/React__default.createElement(LoadingListItem$1, {
    className: "".concat((_f = classNames.loadingListItem) !== null && _f !== void 0 ? _f : '', " ").concat(cameraReady ? 'done' : 'running')
  }, /*#__PURE__*/React__default.createElement(LoadingListItemIndicator, {
    className: classNames.loadingListItemIndicator,
    state: cameraReady ? 'done' : 'running'
  }), cameraReady ? verbiage.cameraInitializedText : verbiage.cameraInitializingText), /*#__PURE__*/React__default.createElement(LoadingListItem$1, {
    className: "".concat((_g = classNames.loadingListItem) !== null && _g !== void 0 ? _g : '', " ").concat(modelsReady ? 'done' : 'running')
  }, /*#__PURE__*/React__default.createElement(LoadingListItemIndicator, {
    className: classNames.loadingListItemIndicator,
    state: modelsReady ? 'done' : 'running'
  }), modelsReady ? verbiage.modelsReadyText : modelDownloadProgress >= 100 ? verbiage.modelsWarmingUpText : "".concat(verbiage.downloadingText, " (").concat(modelDownloadProgress, "%)")))), /*#__PURE__*/React__default.createElement(ContinueButtonContainer$1, {
    className: classNames.continueBtnContainer
  }, modelsReady && cameraReady && ( /*#__PURE__*/React__default.createElement(ContinueButton$1, {
    finished: true,
    className: classNames.continueBtn,
    variant: "positive",
    colors: colors.continueBtn,
    onClick: function onClick() {
      setDismissed(true);
      onDismissed === null || onDismissed === void 0 ? void 0 : onDismissed();
    }
  }, verbiage.continueText))))));
};
var OverlayInner$1 = styled.div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n"], ["\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.backgroundColor) !== null && _d !== void 0 ? _d : '#ecedf3';
}, function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.textColor) !== null && _d !== void 0 ? _d : 'black';
});
var OverlayHeader$1 = styled.div(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  text-align: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  ", "\n  padding-bottom: 0;\n"], ["\n  text-align: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  ", "\n  padding-bottom: 0;\n"])), function (props) {
  var _a;
  return (_a = props.theme.textAlign) !== null && _a !== void 0 ? _a : 'center';
}, function (props) {
  return props.theme.padding ? "box-sizing: border-box; padding: ".concat(props.theme.padding, ";") : "";
});
var StyledGuidanceMessage$2 = styled(GuidanceMessage)(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  padding: 16px 24px;\n  margin-top: 16px;\n  font-size: 18px;\n  font-weight: bold;\n  background: white;\n  box-shadow:\n    0 1px 3px 0 rgb(0 0 0 / 0.1),\n    0 1px 2px -1px rgb(0 0 0 / 0.1);\n"], ["\n  padding: 16px 24px;\n  margin-top: 16px;\n  font-size: 18px;\n  font-weight: bold;\n  background: white;\n  box-shadow:\n    0 1px 3px 0 rgb(0 0 0 / 0.1),\n    0 1px 2px -1px rgb(0 0 0 / 0.1);\n"])));
var StyledOverlayImageContainer$2 = styled(OverlayImageContainer)(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  padding: 0 0 100px;\n\n  & > svg {\n    height: 100%;\n  }\n"], ["\n  padding: 0 0 100px;\n\n  & > svg {\n    height: 100%;\n  }\n"])));
var ContinuityCameraCheckboxContainer$1 = styled.div(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  position: fixed;\n  bottom: 120px;\n  width: 100dvw;\n  display: flex;\n"], ["\n  position: fixed;\n  bottom: 120px;\n  width: 100dvw;\n  display: flex;\n"])));
var ContinuityCameraCheckboxInner = styled(GuidanceMessage)(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  padding: 12px 18px;\n  margin: 0 auto;\n  font-size: 14px;\n  font-weight: bold;\n  background: white;\n  box-shadow:\n    0 1px 3px 0 rgb(0 0 0 / 0.1),\n    0 1px 2px -1px rgb(0 0 0 / 0.1);\n"], ["\n  padding: 12px 18px;\n  margin: 0 auto;\n  font-size: 14px;\n  font-weight: bold;\n  background: white;\n  box-shadow:\n    0 1px 3px 0 rgb(0 0 0 / 0.1),\n    0 1px 2px -1px rgb(0 0 0 / 0.1);\n"])));
var ContinuityCameraCheckbox$1 = styled.input(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
var StyledButtonsRow$a = styled(ButtonsRow)(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  padding: 15px 25px;\n  height: 100px;\n  color: ", ";\n  ", "\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100dvw;\n  box-sizing: border-box;\n"], ["\n  display: flex;\n  flex-direction: row;\n  padding: 15px 25px;\n  height: 100px;\n  color: ", ";\n  ", "\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100dvw;\n  box-sizing: border-box;\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarTextColor) !== null && _d !== void 0 ? _d : 'white';
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarFontSize) ? "font-size: ".concat((_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.idCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.progressBarFontSize, ";") : '';
});
var LoadingListContainer$1 = styled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  z-index: 2;\n"], ["\n  display: flex;\n  position: relative;\n  z-index: 2;\n"])));
var LoadingList$1 = styled.ul(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  display: block;\n  margin: auto;\n  list-style: none;\n  padding: 0;\n"], ["\n  display: block;\n  margin: auto;\n  list-style: none;\n  padding: 0;\n"])));
var LoadingListItem$1 = styled.li(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px 1.25rem 2px 0;\n  line-height: 1rem;\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px 1.25rem 2px 0;\n  line-height: 1rem;\n"])));
var ProgressContainer$1 = styled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var ProgressBarBackground$1 = styled.div(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  opacity: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  opacity: ", ";\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarBackgroundColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
}, function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarBackgroundOpacity) !== null && _d !== void 0 ? _d : 0.75;
});
var ProgressBar$1 = styled.span(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  display: block;\n  width: ", "%;\n  height: 100%;\n  left: 0;\n  position: absolute;\n"], ["\n  display: block;\n  width: ", "%;\n  height: 100%;\n  left: 0;\n  position: absolute;\n"])), function (props) {
  return props.$progress;
});
var ProgressIndicator$1 = styled.span(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n  display: block;\n  height: 100%;\n  background: ", ";\n  animation: ", " 3s ease-in-out;\n  animation-fill-mode: both;\n"], ["\n  display: block;\n  height: 100%;\n  background: ", ";\n  animation: ", " 3s ease-in-out;\n  animation-fill-mode: both;\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarIndicatorColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
}, progressBarAnimation);
var CustomLoadingGraphic$1 = styled.img(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  transform-style: preserve-3d;\n"], ["\n  transform-style: preserve-3d;\n"])));
var ContinueButtonContainer$1 = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ContinueButton$1 = styled(LoaderButton)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  margin: auto;\n  white-space: nowrap;\n  ", "\n  ", "\n"], ["\n  margin: auto;\n  white-space: nowrap;\n  ", "\n  ", "\n"])), function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarFontSize) ? "font-size: ".concat((_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.idCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.progressBarFontSize, ";") : '';
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.continueBtnBorder) ? "border: ".concat((_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.idCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.continueBtnBorder, ";") : '';
});
var templateObject_1$y, templateObject_2$t, templateObject_3$l, templateObject_4$f, templateObject_5$a, templateObject_6$8, templateObject_7$5, templateObject_8$2, templateObject_9$2, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16, templateObject_17, templateObject_18;

var ContinuityCameraCheckboxContainer = styled.div(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  margin-top: 15px;\n  margin-bottom: 15px;\n"], ["\n  margin-top: 15px;\n  margin-bottom: 15px;\n"])));
var ContinuityCameraCheckbox = styled.input(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
var IdCaptureLoadingOverlayLegacy = function IdCaptureLoadingOverlayLegacy(_a) {
  var _b, _c, _d, _e;
  var onDismissed = _a.onDismissed,
    onUserCancel = _a.onUserCancel,
    instructions = _a.instructions,
    _f = _a.rotateImage,
    rotateImage = _f === void 0 ? false : _f,
    _g = _a.assets,
    assets = _g === void 0 ? {} : _g,
    _h = _a.classNames,
    classNames = _h === void 0 ? {} : _h,
    _j = _a.colors,
    colors = _j === void 0 ? {} : _j,
    _k = _a.verbiage,
    rawVerbiage = _k === void 0 ? {} : _k;
  var _l = useContext(IdCaptureModelsContext),
    modelsReady = _l.ready,
    modelDownloadProgress = _l.modelDownloadProgress;
  var _m = useCameraStore(useShallow(function (state) {
      return {
        cameraReady: state.cameraReady,
        cameraAccessDenied: state.cameraAccessDenied,
        iphoneContinuityCameraAvailable: state.iphoneContinuityCameraAvailable,
        setIphoneContinuityCameraAllowed: state.setIphoneContinuityCameraAllowed
      };
    })),
    cameraReady = _m.cameraReady,
    cameraAccessDenied = _m.cameraAccessDenied,
    iphoneContinuityCameraAvailable = _m.iphoneContinuityCameraAvailable,
    setIphoneContinuityCameraAllowed = _m.setIphoneContinuityCameraAllowed;
  var _o = useState(false),
    dismissed = _o[0],
    setDismissed = _o[1];
  assets.instructionImageUrl || (assets.instructionImageUrl = "".concat(DEFAULT_CDN_URL, "/WebSDK-Instruction-DL-Capture-3-Portrait.png"));
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Use your device camera to capture your ID',
    useContinuityCameraText: 'Use your iPhone as a webcam',
    downloadingText: 'Downloading...',
    modelsWarmingUpText: 'Models warming up...',
    cameraInitializingText: 'Camera initializing...',
    continueText: 'Continue'
  });
  useEffect(function () {
    if (modelsReady && cameraReady) return function () {
      return null;
    };
    var t = setTimeout(function () {
      setDismissed(false);
    }, 500);
    return function () {
      clearTimeout(t);
    };
  }, [cameraReady, modelsReady]);
  var imageRef = useRef(null);
  if (dismissed) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  if (cameraAccessDenied) {
    return /*#__PURE__*/React__default.createElement(CameraAccessDeniedOverlay, {
      assets: assets.cameraAccessDenied,
      classNames: classNames.cameraAccessDenied,
      colors: colors.cameraAccessDenied,
      verbiage: rawVerbiage.cameraAccessDenied
    });
  }
  var imageStyle = {};
  if (rotateImage) {
    var naturalWidth = (_c = (_b = imageRef.current) === null || _b === void 0 ? void 0 : _b.naturalWidth) !== null && _c !== void 0 ? _c : 0;
    var naturalHeight = (_e = (_d = imageRef.current) === null || _d === void 0 ? void 0 : _d.naturalHeight) !== null && _e !== void 0 ? _e : 0;
    var scale = naturalWidth > naturalHeight ? naturalHeight / naturalWidth : 1;
    imageStyle = {
      transform: "rotate(-90deg) scale(".concat(scale, ")")
    };
  }
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: classNames.heading
  }, verbiage.headingText), onUserCancel && ( /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onUserCancel,
    className: classNames.cancelBtn
  })), /*#__PURE__*/React__default.createElement(OverlayImageContainer, {
    className: classNames.imageContainer,
    style: {
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    ref: imageRef,
    alt: verbiage.headingText,
    src: assets.instructionImageUrl,
    className: classNames.image,
    style: imageStyle
  })), instructions, /*#__PURE__*/React__default.createElement(ContinuityCameraCheckboxContainer, {
    className: classNames.continuityCameraCheckboxContainer
  }, iphoneContinuityCameraAvailable && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ContinuityCameraCheckbox, {
    className: classNames.continuityCameraCheckbox,
    id: "use-continuity-camera",
    type: "checkbox",
    defaultChecked: true,
    onChange: function onChange(e) {
      setIphoneContinuityCameraAllowed(e.target.checked);
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "use-continuity-camera",
    className: classNames.continuityCameraCheckboxLabel
  }, verbiage.useContinuityCameraText)))), /*#__PURE__*/React__default.createElement(LoaderButton, {
    className: classNames.continueBtn,
    variant: "positive",
    disabled: !cameraReady || !modelsReady,
    finished: modelsReady && cameraReady,
    colors: colors.continueBtn,
    onClick: function onClick() {
      setDismissed(true);
      onDismissed === null || onDismissed === void 0 ? void 0 : onDismissed();
    }
  }, cameraReady && modelsReady ? verbiage.continueText : modelsReady ? verbiage.cameraInitializingText : modelDownloadProgress >= 100 ? verbiage.modelsWarmingUpText : "".concat(verbiage.downloadingText, " (").concat(modelDownloadProgress, "%)"))));
};
var templateObject_1$x, templateObject_2$s;

var components$1 = {
  "default": IdCaptureLoadingOverlayDefault,
  legacy: IdCaptureLoadingOverlayLegacy
};
var IdCaptureLoadingOverlay = function IdCaptureLoadingOverlay(_a) {
  var _b;
  var _c = _a.mode,
    mode = _c === void 0 ? 'default' : _c,
    props = __rest(_a, ["mode"]);
  var Component = (_b = components$1[mode]) !== null && _b !== void 0 ? _b : components$1["default"];
  return /*#__PURE__*/React__default.createElement(Component, _assign({}, props));
};

var CapturedDocumentImg = function CapturedDocumentImg(_a) {
  var alt = _a.alt,
    className = _a.className,
    image = _a.image;
  var _b = useState(image.imageData),
    url = _b[0],
    setUrl = _b[1];
  var _c = useState(false),
    cropped = _c[0],
    setCropped = _c[1];
  var bbox = image.boundingBox;
  var imgRef = useRef(null);
  var onLoaded = useCallback(function () {
    if (!bbox || cropped) return;
    setCropped(true);
    setTimeout(function () {
      setUrl(cropToDetectedObjectBox(imgRef.current, bbox).toDataURL('image/jpeg', 0.95));
    }, 100);
  }, [bbox, cropped]);
  var onDoubleClick = useCallback(function () {
    fetch(image.imageData).then(function (resp) {
      return resp.blob();
    }).then(function (blob) {
      var _a;
      var url = URL.createObjectURL(new Blob([blob]));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "".concat(image.documentType, ".jpg"));
      document.body.appendChild(link);
      link.click();
      (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
    });
  }, [image.documentType, image.imageData]);
  return /*#__PURE__*/React__default.createElement("img", {
    ref: imgRef,
    alt: alt,
    className: className,
    src: url,
    onLoad: onLoaded,
    onDoubleClick: onDoubleClick
  });
};

var Card = styled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  margin: auto;\n  max-width: min(500px, 100dvw - 48px);\n  max-height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n"], ["\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  margin: auto;\n  max-width: min(500px, 100dvw - 48px);\n  max-height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n"])));
var FlexCard = styled(Card)(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var templateObject_1$w, templateObject_2$r;

var IdCaptureSuccess = function IdCaptureSuccess(_a) {
  var capturedDocuments = _a.capturedDocuments,
    onSubmitClick = _a.onSubmitClick,
    onRetryClick = _a.onRetryClick,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.colors,
    colors = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    rawVerbiage = _d === void 0 ? {} : _d,
    _e = _a.debugMode,
    debugMode = _e === void 0 ? false : _e;
  var submissionStatus = useContext(SubmissionContext).submissionStatus;
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'ID Capture Successful',
    retryText: 'Retry',
    submittingText: 'Submitting...',
    submitText: 'Done'
  });
  return /*#__PURE__*/React__default.createElement(GrayOverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(FlexCard, {
    className: classNames.card
  }, /*#__PURE__*/React__default.createElement(Heading$a, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ImagesContainer, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement(ImageRow, {
    className: classNames.imageRow
  }, Object.values(capturedDocuments).map(function (doc) {
    return /*#__PURE__*/React__default.createElement(ImageCol$1, {
      className: classNames.imageCol,
      key: doc.imageData
    }, /*#__PURE__*/React__default.createElement(StyledImage, {
      image: doc,
      className: classNames.image,
      alt: doc.documentType
    }), debugMode && ( /*#__PURE__*/React__default.createElement(DebugPre, null, "Document Type: ".concat(doc.documentType, "\nDetection Score: ").concat(doc.detectionScore, "\nFocus Score: ").concat(doc.focusScore, "\nBounding Box: ").concat(JSON.stringify(doc.boundingBox)))));
  }))), /*#__PURE__*/React__default.createElement(ButtonsColumn, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(WideButton, {
    className: classNames.submitBtn,
    variant: "positive",
    onClick: onSubmitClick,
    disabled: submissionStatus === SubmissionStatus.SUBMITTING,
    colors: colors.doneBtn,
    finished: true
  }, submissionStatus === SubmissionStatus.SUBMITTING ? verbiage.submittingText : verbiage.submitText), /*#__PURE__*/React__default.createElement(WideBorderButton, {
    className: classNames.retryBtn,
    variant: "warning",
    onClick: onRetryClick,
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryText)))));
};
var Heading$a = styled.h1(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  font-size: 1.5rem;\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n"], ["\n  font-size: 1.5rem;\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n"])));
var ImagesContainer = styled(OverlayImageContainer)(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  flex-grow: 1;\n  overflow-y: auto;\n  padding-bottom: 0;\n  max-width: 100%;\n"], ["\n  flex-grow: 1;\n  overflow-y: auto;\n  padding-bottom: 0;\n  max-width: 100%;\n"])));
var ImageRow = styled(OverlayImageRow)(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  max-width: 100%;\n  flex-direction: column;\n  display: grid;\n  grid-gap: 12px;\n"], ["\n  max-width: 100%;\n  flex-direction: column;\n  display: grid;\n  grid-gap: 12px;\n"])));
var ImageCol$1 = styled.div(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  width: 100%;\n  max-height: none !important;\n"], ["\n  width: 100%;\n  max-height: none !important;\n"])));
var StyledImage = styled(CapturedDocumentImg)(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  width: 100%;\n  border-radius: 12px;\n"], ["\n  width: 100%;\n  border-radius: 12px;\n"])));
var DebugPre = styled.pre(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  text-align: left;\n  max-width: min(450px, 100dvw - 100px);\n  overflow-x: auto;\n"], ["\n  text-align: left;\n  max-width: min(450px, 100dvw - 100px);\n  overflow-x: auto;\n"])));
var templateObject_1$v, templateObject_2$q, templateObject_3$k, templateObject_4$e, templateObject_5$9, templateObject_6$7;

function useShowSuccessScreen(skipSuccessScreen, successScreenReady, onDoneCallback) {
  var _this = this;
  var _a = useState(false),
    skipSuccessScreenResolvedFalse = _a[0],
    setSkipSuccessScreenResolvedFalse = _a[1];
  useEffect(function () {
    if (successScreenReady && skipSuccessScreen) {
      if (typeof skipSuccessScreen === 'function') {
        (function () {
          return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4 /*yield*/, skipSuccessScreen()];
                case 1:
                  if (_a.sent()) {
                    onDoneCallback === null || onDoneCallback === void 0 ? void 0 : onDoneCallback();
                  } else {
                    setSkipSuccessScreenResolvedFalse(true);
                  }
                  return [2 /*return*/];
              }
            });
          });
        })();
      } else {
        onDoneCallback === null || onDoneCallback === void 0 ? void 0 : onDoneCallback();
      }
    }
  }, [successScreenReady, onDoneCallback, skipSuccessScreen]);
  return !skipSuccessScreen || skipSuccessScreenResolvedFalse;
}

function setCanvasDimensions(canvas, width, height) {
  var _a;
  var devicePixelRatio = 1;
  if (typeof window !== 'undefined') devicePixelRatio = window.devicePixelRatio;
  canvas.width = width * devicePixelRatio;
  canvas.height = height * devicePixelRatio;
  canvas.style.width = width + 'px';
  canvas.style.height = height + 'px';
  (_a = canvas.getContext('2d')) === null || _a === void 0 ? void 0 : _a.scale(devicePixelRatio, devicePixelRatio);
}
function resetCanvasDimensions(canvas) {
  canvas.width = 0;
  canvas.height = 0;
  canvas.style.width = '0';
  canvas.style.height = '0';
}

var IdCardGuideImageContainer = styled(IdCardBorder)(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  position: relative;\n  ", "\n  box-sizing: border-box;\n"], ["\n  position: relative;\n  ", "\n  box-sizing: border-box;\n"])), function (props) {
  return props.$isVisible ? '' : 'opacity: 0;';
});
var IdCardGuideImage = styled.img(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  transform-style: preserve-3d;\n  ", "\n  ", "\n"], ["\n  transform-style: preserve-3d;\n  ", "\n  ", "\n"])), function (props) {
  return props.$isMirrored ? 'transform: scaleX(-1);' : '';
}, function (props) {
  return props.$isInvisible ? 'opacity: 0;' : '';
});
function IdCardBorder(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var children = _a.children,
    _l = _a.status,
    status = _l === void 0 ? 'ready' : _l,
    _m = _a.borderWidth,
    borderWidth = _m === void 0 ? 20 : _m,
    _o = _a.borderRadius,
    borderRadius = _o === void 0 ? 25 : _o,
    _p = _a.borderColor,
    borderColor = _p === void 0 ? 'white' : _p,
    aspectRatio = _a.aspectRatio,
    _q = _a.progress,
    progress = _q === void 0 ? 0 : _q,
    props = __rest(_a, ["children", "status", "borderWidth", "borderRadius", "borderColor", "aspectRatio", "progress"]);
  var _r = useResizeObserver(),
    ref = _r.ref,
    _s = _r.width,
    width = _s === void 0 ? 0 : _s,
    _t = _r.height,
    height = _t === void 0 ? 0 : _t;
  var _u = useState(0),
    progressResets = _u[0],
    setProgressResets = _u[1];
  useEffect(function () {
    if (progress === 0 && status === 'capturing') {
      setProgressResets(function (n) {
        return n + 1;
      });
    }
  }, [progress, status]);
  var theme = useTheme();
  var wavesDisabled = (_d = (_c = (_b = theme.idCapture) === null || _b === void 0 ? void 0 : _b.guideBox) === null || _c === void 0 ? void 0 : _c.wavesDisabled) !== null && _d !== void 0 ? _d : false;
  var wavesColor = (_g = (_f = (_e = theme.idCapture) === null || _e === void 0 ? void 0 : _e.guideBox) === null || _f === void 0 ? void 0 : _f.wavesColor) !== null && _g !== void 0 ? _g : '#287ec6';
  var progressBarColor = (_k = (_j = (_h = theme.idCapture) === null || _h === void 0 ? void 0 : _h.guideBox) === null || _j === void 0 ? void 0 : _j.progressBarColor) !== null && _k !== void 0 ? _k : '#287ec6';
  return /*#__PURE__*/React__default.createElement(IdCardBorderContainer, _assign({}, props), /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    style: {
      aspectRatio: aspectRatio
    }
  }, children), status === 'ready' && !wavesDisabled && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IdCardBorderSvg, {
    width: width,
    height: height,
    borderRadius: borderRadius,
    borderOpacity: 0.25,
    borderColor: wavesColor,
    borderWidth: borderWidth,
    className: "idmSdkWaves"
  }), /*#__PURE__*/React__default.createElement(IdCardBorderSvg, {
    width: width,
    height: height,
    borderRadius: borderRadius,
    borderOpacity: 0.25,
    borderColor: wavesColor,
    borderWidth: borderWidth,
    className: "idmSdkWaves"
  }), /*#__PURE__*/React__default.createElement(IdCardBorderSvg, {
    width: width,
    height: height,
    borderRadius: borderRadius,
    borderOpacity: 0.25,
    borderColor: wavesColor,
    borderWidth: borderWidth,
    className: "idmSdkWaves"
  }))), /*#__PURE__*/React__default.createElement(IdCardBorderSvg, {
    width: width,
    height: height,
    borderRadius: borderRadius,
    borderColor: borderColor,
    borderWidth: borderWidth,
    className: "idmSdkWavesOrigin"
  }), (status === 'capturing' || progress > 0) && ( /*#__PURE__*/React__default.createElement(IdCardBorderSvg, {
    key: "progress".concat(progressResets),
    width: width,
    height: height,
    borderRadius: borderRadius,
    borderColor: progressBarColor,
    borderWidth: borderWidth,
    isProgressBar: true,
    progress: progress,
    progressPaused: progress > 0 && status !== 'capturing'
  })));
}
function IdCardBorderSvg(_a) {
  var borderRadius = _a.borderRadius,
    borderColor = _a.borderColor,
    borderWidth = _a.borderWidth,
    _b = _a.borderOpacity,
    borderOpacity = _b === void 0 ? 1 : _b,
    _c = _a.progress,
    progress = _c === void 0 ? 0 : _c,
    _d = _a.progressPaused,
    progressPaused = _d === void 0 ? false : _d,
    _e = _a.isProgressBar,
    isProgressBar = _e === void 0 ? false : _e,
    props = __rest(_a, ["borderRadius", "borderColor", "borderWidth", "borderOpacity", "progress", "progressPaused", "isProgressBar"]);
  var _f = useState(0),
    totalLength = _f[0],
    setTotalLength = _f[1];
  var resolvedProgress = progress * totalLength;
  var rectRef = function rectRef(r) {
    try {
      if (isProgressBar && r) setTotalLength(r.getTotalLength());
    } catch (e) {
      debug('failed to measure SVG length', e);
    }
  };
  return /*#__PURE__*/React__default.createElement(SvgOverlay, _assign({
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "round-corner"
  }, /*#__PURE__*/React__default.createElement("rect", {
    x: "0",
    y: "0",
    width: props.width || '100%',
    height: props.height || '100%',
    rx: borderRadius,
    ry: borderRadius
  }))), /*#__PURE__*/React__default.createElement(IdCardBorderRect, {
    ref: rectRef,
    x: "0",
    y: "0",
    width: props.width || '100%',
    height: props.height || '100%',
    rx: borderRadius,
    ry: borderRadius,
    clipPath: "url(#round-corner)",
    stroke: borderColor,
    strokeWidth: borderWidth,
    strokeOpacity: borderOpacity,
    strokeDashoffset: isProgressBar ? resolvedProgress : undefined,
    strokeDasharray: isProgressBar ? totalLength : undefined,
    className: isProgressBar ? "idmSdkProgressBorder ".concat(progressPaused ? 'idmSdkProgressPaused' : '') : ''
  }));
}
var IdCardBorderContainer = styled.div(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  & > .idmSdkWaves {\n    position: absolute;\n    animation: ", " 2s ease-out infinite;\n    transform-style: preserve-3d;\n\n    &:nth-child(2) {\n      animation-delay: 0.66s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 1.33s;\n    }\n  }\n"], ["\n  & > .idmSdkWaves {\n    position: absolute;\n    animation: ", " 2s ease-out infinite;\n    transform-style: preserve-3d;\n\n    &:nth-child(2) {\n      animation-delay: 0.66s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 1.33s;\n    }\n  }\n"])), wavesAnimation);
var SvgOverlay = styled.svg(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n"])));
var IdCardBorderRect = styled.rect(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  &.idmSdkProgressBorder {\n    animation: ", " ", "\n      ", ";\n  }\n\n  &.idmSdkProgressPaused {\n    animation-play-state: paused;\n  }\n"], ["\n  &.idmSdkProgressBorder {\n    animation: ", " ", "\n      ", ";\n  }\n\n  &.idmSdkProgressPaused {\n    animation-play-state: paused;\n  }\n"])), progressBorderAnimation, function (props) {
  var _a;
  return (_a = props.$speed) !== null && _a !== void 0 ? _a : '3s';
}, function (props) {
  var _a;
  return (_a = props.$fillMode) !== null && _a !== void 0 ? _a : 'forwards';
});
var templateObject_1$u, templateObject_2$p, templateObject_3$j, templateObject_4$d, templateObject_5$8;

var defaultIdCaptureGuideImages = {
  portrait: {
    SHOW_ID_FRONT: {
      url: "".concat(DEFAULT_CDN_URL, "/Shieldout-IDCard-Front-SVG-Portrait-Borderless.svg"),
      width: 386,
      height: 573
    },
    SHOW_ID_BACK: {
      url: "".concat(DEFAULT_CDN_URL, "/Shieldout-IDCard-Back-SVG-Portrait-Borderless.svg"),
      width: 386,
      height: 573
    },
    SHOW_PASSPORT: {
      url: "".concat(DEFAULT_CDN_URL, "/Shieldout-Passport-Front-SVG-Portrait-2.svg"),
      width: 386,
      height: 573
    }
  },
  landscape: {
    SHOW_ID_FRONT: {
      url: "".concat(DEFAULT_CDN_URL, "/Shieldout-IDCard-Front-SVG-Landscape-Borderless.svg"),
      width: 573,
      height: 386
    },
    SHOW_ID_BACK: {
      url: "".concat(DEFAULT_CDN_URL, "/Shieldout-IDCard-Back-SVG-Landscape-Borderless.svg"),
      width: 573,
      height: 386
    },
    SHOW_PASSPORT: {
      url: "".concat(DEFAULT_CDN_URL, "/Shieldout-Passport-Front-SVG-Landscape-2.svg"),
      width: 573,
      height: 386
    }
  }
};

function useGuideImagesByUrl(images) {
  return useMemo(function () {
    return Object.fromEntries(Object.values(images).flatMap(function (v) {
      return Object.values(v);
    }).map(function (v) {
      return [v.url, v];
    }));
  }, [images]);
}

function isObject(item) {
  return !!item && typeof item === 'object' && !Array.isArray(item);
}
function mergeDeep(target, source) {
  var output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      var _a, _b;
      var keyT = key;
      if (isObject(source[keyT])) {
        if (!(keyT in target)) Object.assign(output, (_a = {}, _a[keyT] = source[keyT], _a));else {
          // @ts-expect-error TS2345
          output[keyT] = mergeDeep(target[keyT], source[keyT]);
        }
      } else {
        Object.assign(output, (_b = {}, _b[keyT] = source[keyT], _b));
      }
    });
  }
  return output;
}

function useGuideImages(userSuppliedImages) {
  return useMemo(function () {
    warnAboutImagesMissingDimensions(userSuppliedImages);
    return mergeDeep(defaultIdCaptureGuideImages, userSuppliedImages);
  }, [userSuppliedImages]);
}
function warnAboutImagesMissingDimensions(userSuppliedImages) {
  Object.values(userSuppliedImages).forEach(function (images) {
    Object.values(images).forEach(function (image) {
      if (image.url && (!image.width || !image.height)) {
        warn("The image ".concat(image.url, " is missing width and/or height. This will cause the image scaling issues in Safari. Please provide the width and height of the image."));
      }
    });
  });
}

function useImagesWithBackToFront(userSuppliedImages, isBackToFront) {
  var images = useGuideImages(userSuppliedImages);
  return useMemo(function () {
    if (!isBackToFront) return images;
    var _images = structuredClone(images);
    var temp = _images.portrait.SHOW_ID_FRONT;
    _images.portrait.SHOW_ID_FRONT = _images.portrait.SHOW_ID_BACK;
    _images.portrait.SHOW_ID_BACK = temp;
    var temp2 = _images.landscape.SHOW_ID_FRONT;
    _images.landscape.SHOW_ID_FRONT = _images.landscape.SHOW_ID_BACK;
    _images.landscape.SHOW_ID_BACK = temp2;
    return _images;
  }, [images, isBackToFront]);
}

function getOrientation(allowPortraitOnMobile) {
  return allowPortraitOnMobile && window.innerWidth < window.innerHeight ? 'portrait' : 'landscape';
}

var IdVideoCaptureFlipIdPrompt = function IdVideoCaptureFlipIdPrompt(_a) {
  var _b = _a.idCaptureGuideImages,
    idCaptureGuideImages = _b === void 0 ? defaultIdCaptureGuideImages : _b,
    _c = _a.classNames,
    classNames = _c === void 0 ? {} : _c,
    borderWidth = _a.borderWidth,
    borderColor = _a.borderColor,
    borderRadius = _a.borderRadius,
    imageStyle = _a.imageStyle;
  var isRearFacing = useCameraStore(function (state) {
    return state.isRearFacing;
  });
  var isMirrored = !isRearFacing;
  var _d = useState(1),
    transitionTime = _d[0],
    setTransitionTime = _d[1];
  var _e = useState(0),
    rotationAngle = _e[0],
    setRotationAngle = _e[1];
  var frontTransforms = ["rotateY(".concat(rotationAngle, "deg)")];
  if (isMirrored) frontTransforms.push('scaleX(-1)');
  var backTransforms = ["rotateY(".concat(180 - rotationAngle, "deg)")];
  if (isMirrored) backTransforms.push('scaleX(-1)');
  useEffect(function () {
    var timeout;
    function doFlip() {
      setTransitionTime(1);
      setRotationAngle(180);
      timeout = setTimeout(function () {
        setTransitionTime(0);
        setRotationAngle(0);
      }, 1500);
    }
    var interval = setInterval(doFlip, 2500);
    timeout = setTimeout(doFlip, 250);
    return function () {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FlipImageContainer, {
    className: classNames.frontImageContainer,
    status: "disabled",
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    "$transforms": frontTransforms.join(' '),
    "$transitionTime": transitionTime,
    "$isVisible": true
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImage, {
    src: idCaptureGuideImages.landscape.SHOW_ID_FRONT.url,
    className: classNames.frontImage,
    alt: "",
    style: imageStyle
  })), /*#__PURE__*/React__default.createElement(FlipImageContainer, {
    className: classNames.backImageContainer,
    status: "disabled",
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    "$transforms": backTransforms.join(' '),
    "$transitionTime": transitionTime,
    "$isVisible": true
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImage, {
    src: idCaptureGuideImages.landscape.SHOW_ID_BACK.url,
    className: classNames.backImage,
    alt: "",
    style: imageStyle
  })));
};
var FlipImageContainer = styled(IdCardGuideImageContainer)(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  backface-visibility: hidden;\n  transition: transform ", "s;\n  transform: ", ";\n  transform-style: preserve-3d;\n  position: absolute;\n  display: block;\n  top: 0;\n  width: 100%;\n  max-height: 100%;\n"], ["\n  backface-visibility: hidden;\n  transition: transform ", "s;\n  transform: ", ";\n  transform-style: preserve-3d;\n  position: absolute;\n  display: block;\n  top: 0;\n  width: 100%;\n  max-height: 100%;\n"])), function (props) {
  return props.$transitionTime;
}, function (props) {
  return props.$transforms;
});
var templateObject_1$t;

var GuideOrientationContext = /*#__PURE__*/createContext({
  orientation: 'landscape',
  wrapperWidth: 1,
  wrapperHeight: 1,
  wrapperAspectRatio: 0,
  imageAspectRatio: 0,
  wrapperRef: null,
  setDimensions: function setDimensions() {
    return null;
  },
  onImageLoaded: function onImageLoaded() {
    return null;
  }
});
function GuideOrientationContextProvider(_a) {
  var children = _a.children;
  var setDimensions = useState({
    width: 1,
    height: 1
  })[1];
  var _b = useState(1),
    imageAspectRatio = _b[0],
    setImageAspectRatio = _b[1];
  var _c = useResizeObserver(),
    wrapperRef = _c.ref,
    _d = _c.width,
    wrapperWidth = _d === void 0 ? 1 : _d,
    _e = _c.height,
    wrapperHeight = _e === void 0 ? 1 : _e;
  var wrapperAspectRatio = useMemo(function () {
    return wrapperWidth / wrapperHeight;
  }, [wrapperHeight, wrapperWidth]);
  var onImageLoaded = useCallback(function (e) {
    var img = e.target;
    setImageAspectRatio(img.naturalWidth / img.naturalHeight);
  }, []);
  var orientation = 'landscape'; //width > height ? 'landscape' : 'portrait'
  var value = useMemo(function () {
    return {
      orientation: orientation,
      wrapperWidth: wrapperWidth,
      wrapperHeight: wrapperHeight,
      wrapperAspectRatio: wrapperAspectRatio,
      imageAspectRatio: imageAspectRatio,
      setDimensions: setDimensions,
      wrapperRef: wrapperRef,
      onImageLoaded: onImageLoaded
    };
  }, [imageAspectRatio, onImageLoaded, setDimensions, wrapperAspectRatio, wrapperHeight, wrapperRef, wrapperWidth]);
  return /*#__PURE__*/React__default.createElement(GuideOrientationContext.Provider, {
    value: value
  }, children);
}
function useGuideOrientationContext() {
  var ctx = useContext(GuideOrientationContext);
  if (!ctx) throw new Error('useGuideOrientationContext cannot be used without GuideOrientationContextProvider');
  return ctx;
}

var FlipIdPrompt = function FlipIdPrompt(_a) {
  var _b = _a.images,
    images = _b === void 0 ? defaultIdCaptureGuideImages : _b,
    width = _a.width,
    height = _a.height,
    _c = _a.borderWidth,
    borderWidth = _c === void 0 ? 20 : _c,
    _d = _a.borderColor,
    borderColor = _d === void 0 ? 'white' : _d,
    _e = _a.borderRadius,
    borderRadius = _e === void 0 ? 25 : _e,
    _f = _a.isMirrored,
    isMirrored = _f === void 0 ? false : _f,
    _g = _a.portraitGuidesOnMobile,
    portraitGuidesOnMobile = _g === void 0 ? true : _g,
    _h = _a.classNames,
    classNames = _h === void 0 ? {} : _h;
  var onImageLoaded = useGuideOrientationContext().onImageLoaded;
  var orientation = getOrientation(portraitGuidesOnMobile);
  var _j = useState(1),
    transitionTime = _j[0],
    setTransitionTime = _j[1];
  var _k = useState(0),
    rotationAngle = _k[0],
    setRotationAngle = _k[1];
  var frontTransforms = ["rotateY(".concat(rotationAngle, "deg)")];
  if (isMirrored) frontTransforms.push('scaleX(-1)');
  var backTransforms = ["rotateY(".concat(180 - rotationAngle, "deg)")];
  if (isMirrored) backTransforms.push('scaleX(-1)');
  useEffect(function () {
    var timeout;
    var doFlip = function doFlip() {
      setTransitionTime(1);
      setRotationAngle(180);
      timeout = setTimeout(function () {
        setTransitionTime(0);
        setRotationAngle(0);
      }, 1500);
    };
    var interval = setInterval(doFlip, 2500);
    timeout = setTimeout(doFlip, 250);
    return function () {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FlipImageContainer, {
    status: "disabled",
    className: classNames.frontImageContainer,
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    "$transforms": frontTransforms.join(' '),
    "$transitionTime": transitionTime,
    "$isVisible": true
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImage, {
    alt: "",
    src: images[orientation].SHOW_ID_FRONT.url,
    className: classNames.frontImage,
    onLoad: onImageLoaded,
    width: width,
    height: height
  })), /*#__PURE__*/React__default.createElement(FlipImageContainer, {
    status: "disabled",
    className: classNames.backImageContainer,
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    "$transforms": backTransforms.join(' '),
    "$transitionTime": transitionTime,
    "$isVisible": true
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImage, {
    alt: "",
    src: images[orientation].SHOW_ID_BACK.url,
    className: classNames.backImage,
    width: width,
    height: height
  })));
};

var IdCaptureGuideOverlay = function IdCaptureGuideOverlay(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var _p = _a.classNames,
    classNames = _p === void 0 ? {} : _p,
    _q = _a.images,
    userSuppliedImages = _q === void 0 ? defaultIdCaptureGuideImages : _q,
    userSuppliedPadding = _a.padding,
    userSuppliedImagePadding = _a.imagePadding,
    _r = _a.imageVisible,
    imageVisible = _r === void 0 ? true : _r,
    borderWidth = _a.borderWidth,
    borderColor = _a.borderColor,
    _s = _a.idCardBorderWidth,
    idCardBorderWidth = _s === void 0 ? '2.5%' : _s,
    _t = _a.idCardBorderColor,
    idCardBorderColor = _t === void 0 ? 'white' : _t,
    maskColor = _a.maskColor,
    _u = _a.isMirrored,
    isMirrored = _u === void 0 ? false : _u,
    _v = _a.isBackToFront,
    isBackToFront = _v === void 0 ? false : _v,
    _w = _a.portraitGuidesOnMobile,
    portraitGuidesOnMobile = _w === void 0 ? true : _w,
    _x = _a.instruction,
    instruction = _x === void 0 ? '' : _x,
    _y = _a.requestedAction,
    requestedAction = _y === void 0 ? 'SHOW_ID_FRONT' : _y,
    _z = _a.progress,
    progress = _z === void 0 ? 0 : _z,
    _0 = _a.status,
    status = _0 === void 0 ? 'ready' : _0,
    onClick = _a.onClick;
  var _1 = useGuideOrientationContext(),
    wrapperRef = _1.wrapperRef,
    wrapperWidth = _1.wrapperWidth,
    wrapperHeight = _1.wrapperHeight,
    imageAspectRatio = _1.imageAspectRatio,
    wrapperAspectRatio = _1.wrapperAspectRatio,
    guideOrientationOnImageLoaded = _1.onImageLoaded,
    setDimensions = _1.setDimensions;
  var _2 = useIdCaptureState(),
    state = _2[0],
    dispatch = _2[1];
  var theme = useTheme();
  if (borderWidth === undefined) borderWidth = (_d = (_c = (_b = theme.idCapture) === null || _b === void 0 ? void 0 : _b.guideBox) === null || _c === void 0 ? void 0 : _c.borderWidth) !== null && _d !== void 0 ? _d : 4;
  useEffect(function () {
    setDimensions({
      width: wrapperWidth,
      height: wrapperHeight
    });
  }, [setDimensions, wrapperHeight, wrapperWidth]);
  var padding = userSuppliedPadding !== null && userSuppliedPadding !== void 0 ? userSuppliedPadding : isMobile() ? (_g = (_f = (_e = theme.idCapture) === null || _e === void 0 ? void 0 : _e.guideBox) === null || _f === void 0 ? void 0 : _f.mobilePadding) !== null && _g !== void 0 ? _g : 0 : (_k = (_j = (_h = theme.idCapture) === null || _h === void 0 ? void 0 : _h.guideBox) === null || _j === void 0 ? void 0 : _j.desktopPadding) !== null && _k !== void 0 ? _k : 50;
  var paddingAndBorderPx = padding * 2 + (borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0) * 2;
  var images = useImagesWithBackToFront(userSuppliedImages, isBackToFront);
  var imagesByUrl = useGuideImagesByUrl(images);
  var orientation = getOrientation(portraitGuidesOnMobile);
  var currentImage = images[orientation][requestedAction === 'FLIP_ID' ? 'SHOW_ID_FRONT' : requestedAction];
  var imagePadding = (_o = userSuppliedImagePadding !== null && userSuppliedImagePadding !== void 0 ? userSuppliedImagePadding : (_m = (_l = theme.idCapture) === null || _l === void 0 ? void 0 : _l.guideBox) === null || _m === void 0 ? void 0 : _m.imagePadding) !== null && _o !== void 0 ? _o : 50;
  var imageWidth = state.guideRectWidth - imagePadding * 2;
  var imageHeight = state.guideRectHeight - imagePadding * 2;
  var centerRegionMinWidth = imageAspectRatio >= wrapperAspectRatio ? wrapperWidth - paddingAndBorderPx : undefined;
  var onImageLoaded = useCallback(function (e) {
    var _a, _b;
    guideOrientationOnImageLoaded(e);
    var img = e.currentTarget;
    var imageByUrl = imagesByUrl[img.src];
    var width = (_a = imageByUrl === null || imageByUrl === void 0 ? void 0 : imageByUrl.width) !== null && _a !== void 0 ? _a : img.naturalWidth;
    var height = (_b = imageByUrl === null || imageByUrl === void 0 ? void 0 : imageByUrl.height) !== null && _b !== void 0 ? _b : img.naturalHeight;
    dispatch({
      type: 'guideImageLoaded',
      payload: {
        width: width,
        height: height
      }
    });
  }, [dispatch, guideOrientationOnImageLoaded, imagesByUrl]);
  return /*#__PURE__*/React__default.createElement(StyledPageContainer, {
    ref: wrapperRef,
    onClick: onClick,
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(GuidesContainer, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(GuideRegion, {
    "$maskColor": maskColor,
    "$minHeight": padding,
    className: regionClsx(classNames, 'Top')
  }, instruction !== '' && ( /*#__PURE__*/React__default.createElement(GuideText, {
    className: classNames.guideText
  }, instruction))), /*#__PURE__*/React__default.createElement(GuideCenterRow, {
    className: classNames.centerRow
  }, /*#__PURE__*/React__default.createElement(Spacer, {
    "$maskColor": maskColor,
    "$minWidth": padding,
    className: regionClsx(classNames, 'Left')
  }), /*#__PURE__*/React__default.createElement(GuideCenterRegion, {
    "$minWidth": centerRegionMinWidth,
    "$isMirrored": isMirrored,
    className: classNames.centerRegion
  }, /*#__PURE__*/React__default.createElement(GuideCenterBorder, {
    "$borderWidth": borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
    "$borderColor": borderColor,
    "$padding": imagePadding,
    className: classNames.centerRegionBorder
  }, /*#__PURE__*/React__default.createElement(GuideCenterInner, {
    className: classNames.centerRegionInner
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImageContainer, {
    status: status,
    progress: progress,
    borderWidth: idCardBorderWidth,
    borderColor: idCardBorderColor,
    "$isVisible": requestedAction !== 'FLIP_ID'
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImage, {
    alt: "",
    src: currentImage.url,
    onLoad: onImageLoaded,
    className: classNames.image,
    "$isInvisible": !imageVisible,
    "$isMirrored": isMirrored,
    width: imageWidth,
    height: imageHeight
  })), requestedAction === 'FLIP_ID' && ( /*#__PURE__*/React__default.createElement(FlipIdPrompt, {
    images: images,
    borderWidth: idCardBorderWidth,
    borderColor: idCardBorderColor,
    portraitGuidesOnMobile: portraitGuidesOnMobile,
    isMirrored: isMirrored,
    classNames: classNames.flipIdPrompt,
    width: imageWidth,
    height: imageHeight
  }))))), /*#__PURE__*/React__default.createElement(Spacer, {
    "$maskColor": maskColor,
    "$minWidth": padding,
    className: regionClsx(classNames, 'Right')
  })), /*#__PURE__*/React__default.createElement(GuideRegion, {
    "$maskColor": maskColor,
    "$minHeight": padding,
    className: regionClsx(classNames, 'Bottom')
  }, instruction !== '' && ( /*#__PURE__*/React__default.createElement(GuideText, {
    style: {
      opacity: 0
    }
  }, instruction)))));
};
var regionClsx = function regionClsx(classNames, which) {
  return [classNames.dimmingRegion, classNames["dimmingRegion".concat(which)]].filter(function (v) {
    return v;
  }).join(' ');
};
var StyledPageContainer = styled(PageContainerDiv)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  z-index: 1000;\n  overflow-y: hidden;\n"], ["\n  z-index: 1000;\n  overflow-y: hidden;\n"])));
var GuidesContainer = styled.div(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column nowrap;\n  width: 100dvw;\n  height: 100dvh;\n"], ["\n  display: flex;\n  flex-flow: column nowrap;\n  width: 100dvw;\n  height: 100dvh;\n"])));
var GuideCenterRow = styled.div(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-items: center;\n  box-sizing: border-box;\n  max-width: 100%;\n  max-height: 100%;\n  min-height: 0;\n  flex: 1;\n"], ["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-items: center;\n  box-sizing: border-box;\n  max-width: 100%;\n  max-height: 100%;\n  min-height: 0;\n  flex: 1;\n"])));
var GuideRegion = styled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  width: 100%;\n  position: relative;\n  z-index: 1000;\n  background: ", ";\n  color: ", ";\n  text-align: center;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  width: 100%;\n  position: relative;\n  z-index: 1000;\n  background: ", ";\n  color: ", ";\n  text-align: center;\n  ", "\n  ", "\n"])), function (props) {
  var _a, _b, _c, _d, _e;
  return (_e = (_a = props.$maskColor) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.idCapture) === null || _c === void 0 ? void 0 : _c.guideOverlay) === null || _d === void 0 ? void 0 : _d.backgroundColor) !== null && _e !== void 0 ? _e : 'rgba(0, 0, 0, 0.5)';
}, function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.idCapture) === null || _b === void 0 ? void 0 : _b.guideOverlay) === null || _c === void 0 ? void 0 : _c.textColor) !== null && _d !== void 0 ? _d : 'white';
}, function (props) {
  return props.$minWidth ? "min-width: ".concat(props.$minWidth, "px;") : "";
}, function (props) {
  return props.$minHeight ? "min-height: ".concat(props.$minHeight, "px;") : "";
});
var Spacer = styled(GuideRegion)(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  display: block;\n  width: auto;\n"], ["\n  display: block;\n  width: auto;\n"])));
var GuideCenterRegion = styled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  ", "\n  ", "\n  transform-style: preserve-3d;\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  max-height: 100%;\n  height: 100%;\n"], ["\n  ", "\n  ", "\n  transform-style: preserve-3d;\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  max-height: 100%;\n  height: 100%;\n"])), function (props) {
  return props.$minWidth ? "min-width: ".concat(props.$minWidth, "px;") : "";
}, function (props) {
  return props.$isMirrored ? 'transform: scaleX(-1);' : '';
});
var GuideCenterBorder = styled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  box-sizing: border-box;\n  border: ", ";\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  max-height: 100%;\n  min-height: 0;\n  position: relative;\n  ", "\n"], ["\n  box-sizing: border-box;\n  border: ", ";\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  max-height: 100%;\n  min-height: 0;\n  position: relative;\n  ", "\n"])), function (props) {
  var _a, _b;
  return "".concat((_a = props.$borderWidth) !== null && _a !== void 0 ? _a : 4, "px solid ").concat((_b = props.$borderColor) !== null && _b !== void 0 ? _b : 'white');
}, function (props) {
  return props.$padding ? "padding: ".concat(props.$padding, "px;") : '';
});
var GuideText = styled.span(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  align-content: center;\n  margin-top: 12px;\n  margin-bottom: 12px;\n"], ["\n  align-content: center;\n  margin-top: 12px;\n  margin-bottom: 12px;\n"])));
var GuideCenterInner = styled.div(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  position: relative;\n  margin: auto;\n"], ["\n  position: relative;\n  margin: auto;\n"])));
var templateObject_1$s, templateObject_2$o, templateObject_3$i, templateObject_4$c, templateObject_5$7, templateObject_6$6, templateObject_7$4, templateObject_8$1, templateObject_9$1;

var IdCaptureFitGuide = function IdCaptureFitGuide(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var aspectRatio = _a.aspectRatio,
    maskColor = _a.maskColor,
    _p = _a.borderRadius,
    borderRadius = _p === void 0 ? 33 : _p,
    borderColor = _a.borderColor,
    borderWidth = _a.borderWidth,
    padding = _a.padding,
    imageVisible = _a.imageVisible,
    _q = _a.isMirrored,
    isMirrored = _q === void 0 ? false : _q,
    _r = _a.isBackToFront,
    isBackToFront = _r === void 0 ? false : _r,
    _s = _a.portraitGuidesOnMobile,
    portraitGuidesOnMobile = _s === void 0 ? true : _s,
    instruction = _a.instruction,
    _t = _a.requestedAction,
    requestedAction = _t === void 0 ? 'SHOW_ID_FRONT' : _t,
    _u = _a.status,
    status = _u === void 0 ? 'ready' : _u,
    _v = _a.progress,
    progress = _v === void 0 ? 0 : _v,
    _w = _a.images,
    images = _w === void 0 ? defaultIdCaptureGuideImages : _w,
    _x = _a.classNames,
    classNames = _x === void 0 ? {} : _x;
  var _y = useIdCaptureState(),
    _z = _y[0],
    redrawing = _z.redrawing,
    guideImageWidth = _z.guideImageWidth,
    guideImageHeight = _z.guideImageHeight,
    dispatch = _y[1];
  var canvasRef = useRef(null);
  var _0 = useResizeObserver(),
    wrapperRef = _0.ref,
    _1 = _0.width,
    wrapperWidth = _1 === void 0 ? 1 : _1,
    _2 = _0.height,
    wrapperHeight = _2 === void 0 ? 1 : _2;
  var theme = useTheme();
  if (borderWidth === undefined) borderWidth = (_d = (_c = (_b = theme.idCapture) === null || _b === void 0 ? void 0 : _b.guideBox) === null || _c === void 0 ? void 0 : _c.borderWidth) !== null && _d !== void 0 ? _d : 4;
  if (padding === undefined) {
    padding = isMobile() ? (_g = (_f = (_e = theme.idCapture) === null || _e === void 0 ? void 0 : _e.guideBox) === null || _f === void 0 ? void 0 : _f.mobilePadding) !== null && _g !== void 0 ? _g : 0 : (_k = (_j = (_h = theme.idCapture) === null || _h === void 0 ? void 0 : _h.guideBox) === null || _j === void 0 ? void 0 : _j.desktopPadding) !== null && _k !== void 0 ? _k : 0;
  }
  if (aspectRatio === undefined && guideImageWidth !== 0) {
    aspectRatio = guideImageWidth / guideImageHeight;
  }
  if (maskColor === undefined) {
    maskColor = (_o = (_m = (_l = theme.idCapture) === null || _l === void 0 ? void 0 : _l.guideOverlay) === null || _m === void 0 ? void 0 : _m.backgroundColor) !== null && _o !== void 0 ? _o : '#708090';
  }
  useEffect(function () {
    var canvas = canvasRef.current;
    if (!canvas) return;
    if (redrawing) {
      resetCanvasDimensions(canvas);
      var timer_1 = setTimeout(function () {
        dispatch({
          type: 'redrawInProgress'
        });
      }, 10);
      return function () {
        clearTimeout(timer_1);
      };
    }
    var boundingWidth = wrapperWidth - padding * 2 - borderWidth * 2;
    var boundingHeight = wrapperHeight - padding * 2 - borderWidth * 2;
    var _a = [padding + borderWidth, padding + borderWidth, boundingWidth, boundingHeight],
      rectX = _a[0],
      rectY = _a[1],
      rectWidth = _a[2],
      rectHeight = _a[3];
    if (aspectRatio !== undefined) {
      var scaledWidth = boundingHeight * aspectRatio;
      var scaledHeight = boundingWidth / aspectRatio;
      if (scaledWidth < boundingWidth) {
        rectWidth = scaledWidth;
        rectX += (boundingWidth - rectWidth) / 2;
      } else {
        rectHeight = scaledHeight;
        rectY += (boundingHeight - rectHeight) / 2;
      }
    }
    setCanvasDimensions(canvas, wrapperWidth, wrapperHeight);
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.fillStyle = maskColor;
    ctx.clearRect(0, 0, wrapperWidth, wrapperHeight);
    ctx.fillRect(0, 0, wrapperWidth, wrapperHeight);
    // const radius = Math.min(wrapperWidth, wrapperHeight) / 2 - padding!
    ctx.beginPath();
    // ctx.arc(wrapperWidth / 2, wrapperHeight / 2, radius, 0, Math.PI * 2, true) // Hole anticlockwise
    ctx.roundRect(rectX, rectY, rectWidth, rectHeight, borderRadius);
    ctx.lineWidth = borderWidth;
    ctx.strokeStyle = borderColor !== null && borderColor !== void 0 ? borderColor : 'white';
    if (borderColor === null || borderColor === void 0 ? void 0 : borderColor.startsWith('var(')) {
      ctx.strokeStyle = getComputedStyle(document.documentElement).getPropertyValue(borderColor.slice(4, -1));
    }
    ctx.stroke();
    // make alpha solid (the color doesn't matter)
    ctx.fillStyle = 'rgba(0,0,0,1)';
    // change composite mode and fill
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fill();
    // reset composite mode to default
    ctx.globalCompositeOperation = 'source-over';
    var rectOffsetTop = canvas.offsetTop;
    dispatch({
      type: 'redrawCompleted',
      payload: {
        guideRectX: rectX,
        guideRectY: rectY,
        guideRectWidth: rectWidth,
        guideRectHeight: rectHeight,
        guideRectOffsetTop: rectOffsetTop
      }
    });
    return function () {};
  }, [aspectRatio, borderColor, borderRadius, borderWidth, dispatch, maskColor, padding, redrawing, wrapperHeight, wrapperWidth]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CanvasWrapper$1, {
    ref: wrapperRef,
    "$maskColor": maskColor !== null && maskColor !== void 0 ? maskColor : '',
    className: classNames.canvasWrapper
  }, /*#__PURE__*/React__default.createElement(Canvas$1, {
    ref: canvasRef,
    className: classNames.canvas
  })), /*#__PURE__*/React__default.createElement(IdCaptureGuideOverlay, {
    maskColor: "transparent",
    borderWidth: 0,
    isMirrored: isMirrored,
    isBackToFront: isBackToFront,
    portraitGuidesOnMobile: portraitGuidesOnMobile,
    instruction: instruction,
    images: images,
    classNames: classNames,
    imageVisible: imageVisible,
    requestedAction: requestedAction,
    status: status,
    progress: progress
  }));
};
var CanvasWrapper$1 = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  background-clip: padding-box;\n  box-shadow: inset 0 0 0 2px ", ";\n  z-index: -1;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  background-clip: padding-box;\n  box-shadow: inset 0 0 0 2px ", ";\n  z-index: -1;\n"])), function (props) {
  return props.$maskColor;
});
var Canvas$1 = styled.canvas(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var templateObject_1$r, templateObject_2$n;

function IdCaptureGuides(_a) {
  var _b = _a.guideType,
    guideType = _b === void 0 ? 'fit' : _b,
    _c = _a.status,
    status = _c === void 0 ? 'ready' : _c,
    _d = _a.progress,
    progress = _d === void 0 ? 0 : _d,
    _e = _a.portraitGuidesOnMobile,
    portraitGuidesOnMobile = _e === void 0 ? true : _e,
    _f = _a.requestedAction,
    requestedAction = _f === void 0 ? 'SHOW_ID_FRONT' : _f,
    _g = _a.isBackToFront,
    isBackToFront = _g === void 0 ? false : _g,
    _h = _a.images,
    images = _h === void 0 ? defaultIdCaptureGuideImages : _h,
    _j = _a.classNames,
    classNames = _j === void 0 ? {} : _j,
    _k = _a.colors,
    colors = _k === void 0 ? {} : _k,
    _l = _a.verbiage,
    rawVerbiage = _l === void 0 ? {} : _l;
  var state = useIdCaptureState()[0];
  var isRearFacing = useCameraStore(function (state) {
    return state.isRearFacing;
  });
  var verbiage = useTranslations(rawVerbiage, {
    instructionText: 'Scan the front of ID',
    capturingText: 'Capturing...',
    captureFailedText: 'Capture failed!'
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, guideType === 'overlay' && ( /*#__PURE__*/React__default.createElement(IdCaptureGuideOverlay, {
    images: images,
    classNames: classNames,
    status: status,
    progress: progress,
    instruction: state.captureFailed ? verbiage.captureFailedText : state.capturing ? verbiage === null || verbiage === void 0 ? void 0 : verbiage.capturingText : verbiage.instructionText,
    isMirrored: !isRearFacing,
    borderColor: state.isGoodFrame ? colors.guideBoxSatisfiedColor : colors.guideBoxUnsatisfiedColor,
    imageVisible: requestedAction === 'FLIP_ID' || !state.idCardFrontDetectionThresholdMet || !state.documentInBounds || state.documentTooClose
  })), guideType === 'fit' && ( /*#__PURE__*/React__default.createElement(IdCaptureFitGuide, {
    images: images,
    classNames: classNames,
    requestedAction: requestedAction,
    status: status,
    progress: progress,
    instruction: state.captureFailed ? verbiage.captureFailedText : state.capturing ? verbiage === null || verbiage === void 0 ? void 0 : verbiage.capturingText : verbiage.instructionText,
    isMirrored: !isRearFacing,
    isBackToFront: isBackToFront,
    portraitGuidesOnMobile: portraitGuidesOnMobile,
    borderColor: state.isGoodFrame ? colors.guideBoxSatisfiedColor : colors.guideBoxUnsatisfiedColor,
    imageVisible: requestedAction === 'FLIP_ID' || !state.detectionThresholdMet || !state.documentInBounds || state.documentTooClose || state.backDetectedFirst || state.flipRequired
  })));
}

var IdCaptureImagePreview = function IdCaptureImagePreview(_a) {
  var _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    text = _a.text,
    imageUrl = _a.imageUrl;
  var imageRef = useRef(null);
  var _c = useState(false),
    loaded = _c[0],
    setLoaded = _c[1];
  var _d = useState(0),
    aspectRatio = _d[0],
    setAspectRatio = _d[1];
  function onLoad() {
    var aspectRatio = imageRef.current.naturalWidth / imageRef.current.naturalHeight;
    setAspectRatio(aspectRatio);
    setLoaded(true);
  }
  function onError() {
    error('failed to load image from url', imageUrl);
  }
  return /*#__PURE__*/React__default.createElement(ImagePreviewWrapper, {
    className: classNames.container,
    style: {
      opacity: loaded ? 1 : 0
    }
  }, text && ( /*#__PURE__*/React__default.createElement(ImagePreviewText, {
    className: classNames.text
  }, text)), /*#__PURE__*/React__default.createElement(ImagePreviewImageWrapper, {
    className: classNames.imageContainer,
    style: {
      aspectRatio: aspectRatio
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    ref: imageRef,
    src: imageUrl,
    alt: "",
    className: classNames.image,
    onLoad: onLoad,
    onError: onError
  })));
};
var SelfieProgressPreview = function SelfieProgressPreview(_a) {
  var _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    text = _a.text,
    imageUrl = _a.imageUrl;
  var imageRef = useRef(null);
  var _c = useState(false),
    loaded = _c[0],
    setLoaded = _c[1];
  var _d = useState(0),
    aspectRatio = _d[0],
    setAspectRatio = _d[1];
  function onLoad() {
    var aspectRatio = imageRef.current.naturalWidth / imageRef.current.naturalHeight;
    setAspectRatio(aspectRatio);
    setLoaded(true);
  }
  function onError() {
    error('failed to load image from url', imageUrl);
  }
  return /*#__PURE__*/React__default.createElement(ImagePreviewWrapper, {
    className: classNames.container,
    style: {
      aspectRatio: aspectRatio,
      opacity: loaded ? 1 : 0
    }
  }, /*#__PURE__*/React__default.createElement(ImagePreviewText, {
    className: classNames.text
  }, /*#__PURE__*/React__default.createElement(StyledSpinner, {
    className: classNames.spinner,
    "$size": 24,
    "$color": "white",
    "$thickness": 3
  }), text), /*#__PURE__*/React__default.createElement(ImagePreviewImageWrapper, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    ref: imageRef,
    src: imageUrl,
    alt: "",
    className: classNames.image,
    onLoad: onLoad,
    onError: onError
  })));
};
var StyledSpinner = styled(Spinner)(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  position: relative;\n  top: 4px;\n  left: -3px;\n  margin: 0 3px 0 -12px;\n"], ["\n  position: relative;\n  top: 4px;\n  left: -3px;\n  margin: 0 3px 0 -12px;\n"])));
var ImagePreviewWrapper = styled.div(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  height: 33%;\n  bottom: 12px;\n  right: 12px;\n"], ["\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  height: 33%;\n  bottom: 12px;\n  right: 12px;\n"])));
var ImagePreviewText = styled.div(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  display: block;\n  position: absolute;\n  top: -32px;\n  font:\n    14px -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Helvetica,\n    Arial,\n    sans-serif,\n    'Apple Color Emoji',\n    'Segoe UI Emoji',\n    'Segoe UI Symbol';\n  color: white;\n  text-align: center;\n  margin: 0 auto;\n  width: 100%;\n"], ["\n  display: block;\n  position: absolute;\n  top: -32px;\n  font:\n    14px -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Helvetica,\n    Arial,\n    sans-serif,\n    'Apple Color Emoji',\n    'Segoe UI Emoji',\n    'Segoe UI Symbol';\n  color: white;\n  text-align: center;\n  margin: 0 auto;\n  width: 100%;\n"])));
var ImagePreviewImageWrapper = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  position: relative;\n  height: calc(100% - 8px);\n  padding: 4px;\n  border-radius: 4px;\n  background: white;\n\n  & > img {\n    border-radius: 4px;\n    width: auto;\n    max-height: 100%;\n  }\n"], ["\n  position: relative;\n  height: calc(100% - 8px);\n  padding: 4px;\n  border-radius: 4px;\n  background: white;\n\n  & > img {\n    border-radius: 4px;\n    width: auto;\n    max-height: 100%;\n  }\n"])));
var templateObject_1$q, templateObject_2$m, templateObject_3$h, templateObject_4$b;

var documentCaptureInitialState = {
  documents: [],
  currentDocumentIndex: 0,
  initialDrawComplete: false,
  redrawing: false,
  capturing: false,
  rectX: 0,
  rectY: 0,
  rectWidth: 0,
  rectHeight: 0,
  rectOffsetTop: 0,
  uploadCapturedDocument: function uploadCapturedDocument() {
    return Promise.resolve();
  }
};
var DocumentCaptureStateContext = /*#__PURE__*/createContext(documentCaptureInitialState);
var DocumentCaptureDispatchContext = /*#__PURE__*/createContext(function () {});
var documentCaptureStateReducer = function documentCaptureStateReducer(state, action) {
  var _a, _b, _c, _d, _e;
  switch (action.type) {
    case 'setDocuments':
      return _assign(_assign({}, state), {
        documents: action.payload,
        currentDocumentIndex: 0
      });
    case 'setHooks':
      return _assign(_assign({}, state), action.payload);
    case 'redrawRequested':
      return _assign(_assign({}, state), {
        redrawing: true,
        rectX: 0,
        rectY: 0,
        rectWidth: 0,
        rectHeight: 0,
        rectOffsetTop: 0
      });
    case 'redrawInProgress':
      return _assign(_assign({}, state), {
        redrawing: false,
        rectX: 0,
        rectY: 0,
        rectWidth: 0,
        rectHeight: 0,
        rectOffsetTop: 0
      });
    case 'redrawCompleted':
      return _assign(_assign(_assign({}, state), action.payload), {
        initialDrawComplete: true
      });
    case 'captureRequested':
      return _assign(_assign({}, state), {
        capturing: true
      });
    case 'captureCompleted':
      {
        var newState = _assign(_assign({}, state), {
          capturing: false
        });
        var index = state.currentDocumentIndex;
        newState.documents[index].content = action.payload.content;
        newState.documents[index].contentUrl = action.payload.contentUrl;
        (_a = state.onDocumentCaptured) === null || _a === void 0 ? void 0 : _a.call(state, newState.documents[index]);
        return newState;
      }
    case 'retryCapture':
      {
        var newState = _assign({}, state);
        var index = state.currentDocumentIndex;
        newState.documents[index].content = undefined;
        newState.documents[index].contentUrl = undefined;
        return newState;
      }
    case 'uploadStarted':
      {
        var newState = _assign({}, state);
        var index = state.currentDocumentIndex;
        newState.documents[index].uploadState = 'in_progress';
        return newState;
      }
    case 'uploadCompleted':
      {
        var newState = _assign({}, state);
        var index = state.currentDocumentIndex;
        newState.documents[index].documentId = action.payload.documentId;
        newState.documents[index].uploadState = 'succeeded';
        (_c = (_b = newState.documents[index]).onUploaded) === null || _c === void 0 ? void 0 : _c.call(_b, newState.documents[index]);
        (_d = state.onDocumentUploaded) === null || _d === void 0 ? void 0 : _d.call(state, newState.documents[index]);
        if (state.documents.length - 1 > index) {
          newState.currentDocumentIndex += 1;
        } else {
          (_e = state.onAllDocumentsUploaded) === null || _e === void 0 ? void 0 : _e.call(state, newState.documents);
        }
        return newState;
      }
    case 'uploadFailed':
      {
        var newState = _assign({}, state);
        var index = state.currentDocumentIndex;
        newState.documents[index].uploadState = 'failed';
        return newState;
      }
    default:
      return state;
  }
};
var DocumentCaptureStateProvider = function DocumentCaptureStateProvider(_a) {
  var _b = _a.documents,
    documents = _b === void 0 ? [] : _b,
    aspectRatio = _a.aspectRatio,
    cameraFeedMode = _a.cameraFeedMode,
    instructions = _a.instructions,
    onDocumentCaptured = _a.onDocumentCaptured,
    onDocumentUploaded = _a.onDocumentUploaded,
    onAllDocumentsUploaded = _a.onAllDocumentsUploaded,
    children = _a.children;
  var _c = useReducer(documentCaptureStateReducer, documentCaptureInitialState),
    state = _c[0],
    dispatch = _c[1];
  var _d = useCameraStore(),
    videoStream = _d.videoStream,
    videoRef = _d.videoRef;
  var uploadDocument = useContext(SubmissionContext).uploadDocument;
  var uploadCapturedDocument = useCallback(function (content, filetype) {
    return __awaiter(void 0, void 0, void 0, function () {
      var documentId_1, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            dispatch({
              type: 'uploadStarted'
            });
            return [4 /*yield*/, uploadDocument(content, {
              filetype: filetype
            })];
          case 1:
            documentId_1 = _a.sent();
            setTimeout(function () {
              dispatch({
                type: 'uploadCompleted',
                payload: {
                  documentId: documentId_1
                }
              });
            }, 0);
            return [3 /*break*/, 3];
          case 2:
            e_1 = _a.sent();
            debug('upload failed', e_1);
            dispatch({
              type: 'uploadFailed'
            });
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }, [uploadDocument]);
  useEffect(function () {
    var resolvedDocuments = (documents === null || documents === void 0 ? void 0 : documents.length) ? documents.map(function (d) {
      return _assign(_assign({
        title: 'Document Capture',
        aspectRatio: aspectRatio,
        cameraFeedMode: 'snapToGuides',
        instructions: instructions
      }, d), {
        uploadState: 'not_started'
      });
    }) : [{
      title: 'Document Capture',
      aspectRatio: aspectRatio,
      cameraFeedMode: cameraFeedMode !== null && cameraFeedMode !== void 0 ? cameraFeedMode : 'snapToGuides',
      instructions: instructions,
      uploadState: 'not_started'
    }];
    dispatch({
      type: 'setDocuments',
      payload: resolvedDocuments
    });
    resolvedDocuments.forEach(function (d) {
      if (d.content) {
        d.contentUrl || (d.contentUrl = URL.createObjectURL(d.content));
        void uploadCapturedDocument(d.content, d.content.type);
      }
    });
  }, [aspectRatio, cameraFeedMode, documents, instructions, uploadCapturedDocument]);
  useEffect(function () {
    dispatch({
      type: 'setHooks',
      payload: {
        onDocumentCaptured: onDocumentCaptured,
        onDocumentUploaded: onDocumentUploaded,
        onAllDocumentsUploaded: onAllDocumentsUploaded
      }
    });
  }, [onDocumentCaptured, onAllDocumentsUploaded, onDocumentUploaded]);
  var onResize = useDebouncedCallback(function () {
    dispatch({
      type: 'redrawRequested'
    });
  }, 500);
  useLayoutEffect(function () {
    if (typeof window === 'undefined') return;
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  var videoTag = videoRef.current;
  useEffect(function () {
    if (!state.capturing || !(videoStream === null || videoStream === void 0 ? void 0 : videoStream.active)) return;
    function onComplete(content) {
      if (!content) return;
      var contentUrl = URL.createObjectURL(content);
      dispatch({
        type: 'captureCompleted',
        payload: {
          content: content,
          contentUrl: contentUrl
        }
      });
    }
    if (typeof ImageCapture !== 'undefined') {
      var tracks = videoStream.getTracks();
      var videoCameraTrack = tracks.find(function (track) {
        return track.kind === 'video';
      });
      if (videoCameraTrack) {
        var imageCapture = new ImageCapture(videoCameraTrack);
        imageCapture.takePhoto().then(onComplete)["catch"](function () {});
      } else {
        throw new Error('Failed to find a video feed for taking a photo');
      }
    } else if (videoTag) {
      var canvas = document.createElement('canvas');
      drawToCanvas(canvas, videoTag);
      canvas.toBlob(onComplete);
    }
  }, [state.capturing, videoStream, videoTag]);
  var stateWithActions = useMemo(function () {
    return _assign(_assign({}, state), {
      uploadCapturedDocument: uploadCapturedDocument
    });
  }, [state, uploadCapturedDocument]);
  return /*#__PURE__*/React__default.createElement(DocumentCaptureStateContext.Provider, {
    value: stateWithActions
  }, /*#__PURE__*/React__default.createElement(DocumentCaptureDispatchContext.Provider, {
    value: dispatch
  }, children));
};
var useDocumentCaptureState = function useDocumentCaptureState() {
  var state = useContext(DocumentCaptureStateContext);
  var dispatch = useContext(DocumentCaptureDispatchContext);
  if (!state || !dispatch) throw new Error('useDocumentCaptureState cannot be used without DocumentCaptureStateProvider');
  return [state, dispatch];
};

var DocumentCaptureGuideOverlay = function DocumentCaptureGuideOverlay(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var aspectRatio = _a.aspectRatio,
    _l = _a.borderRadius,
    borderRadius = _l === void 0 ? 25 : _l,
    borderColor = _a.borderColor,
    borderWidth = _a.borderWidth,
    maskColor = _a.maskColor,
    padding = _a.padding,
    _m = _a.classNames,
    classNames = _m === void 0 ? {} : _m;
  var _o = useResizeObserver(),
    wrapperRef = _o.ref,
    _p = _o.width,
    wrapperWidth = _p === void 0 ? 1 : _p,
    _q = _o.height,
    wrapperHeight = _q === void 0 ? 1 : _q;
  var _r = useDocumentCaptureState(),
    redrawing = _r[0].redrawing,
    dispatch = _r[1];
  var canvasRef = useRef(null);
  var theme = useTheme();
  if (borderWidth === undefined) borderWidth = (_d = (_c = (_b = theme.documentCapture) === null || _b === void 0 ? void 0 : _b.guideBox) === null || _c === void 0 ? void 0 : _c.borderWidth) !== null && _d !== void 0 ? _d : 4;
  if (padding === undefined) {
    padding = isMobile() ? (_g = (_f = (_e = theme.documentCapture) === null || _e === void 0 ? void 0 : _e.guideBox) === null || _f === void 0 ? void 0 : _f.mobilePadding) !== null && _g !== void 0 ? _g : 0 : (_k = (_j = (_h = theme.documentCapture) === null || _h === void 0 ? void 0 : _h.guideBox) === null || _j === void 0 ? void 0 : _j.desktopPadding) !== null && _k !== void 0 ? _k : 0;
  }
  useEffect(function () {
    var canvas = canvasRef.current;
    if (!canvas) return;
    if (redrawing) {
      resetCanvasDimensions(canvas);
      setTimeout(function () {
        dispatch({
          type: 'redrawInProgress'
        });
      }, 10);
      return;
    }
    var boundingWidth = wrapperWidth - padding * 2 - borderWidth * 2;
    var boundingHeight = wrapperHeight - padding * 2 - borderWidth * 2;
    var _a = [padding + borderWidth, padding + borderWidth, boundingWidth, boundingHeight],
      rectX = _a[0],
      rectY = _a[1],
      rectWidth = _a[2],
      rectHeight = _a[3];
    if (aspectRatio !== undefined) {
      var scaledWidth = boundingHeight * aspectRatio;
      var scaledHeight = boundingWidth / aspectRatio;
      if (scaledWidth < boundingWidth) {
        rectWidth = scaledWidth;
        rectX += (boundingWidth - rectWidth) / 2;
      } else {
        rectHeight = scaledHeight;
        rectY += (boundingHeight - rectHeight) / 2;
      }
    }
    setCanvasDimensions(canvas, wrapperWidth, wrapperHeight);
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.fillStyle = maskColor;
    ctx.clearRect(0, 0, wrapperWidth, wrapperHeight);
    ctx.fillRect(0, 0, wrapperWidth, wrapperHeight);
    // const radius = Math.min(wrapperWidth, wrapperHeight) / 2 - padding!
    ctx.beginPath();
    // ctx.arc(wrapperWidth / 2, wrapperHeight / 2, radius, 0, Math.PI * 2, true) // Hole anticlockwise
    ctx.roundRect(rectX, rectY, rectWidth, rectHeight, borderRadius);
    ctx.lineWidth = borderWidth;
    ctx.strokeStyle = borderColor !== null && borderColor !== void 0 ? borderColor : 'white';
    ctx.stroke();
    // make alpha solid (the color doesn't matter)
    ctx.fillStyle = 'rgba(0,0,0,1)';
    // change composite mode and fill
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fill();
    // reset composite mode to default
    ctx.globalCompositeOperation = 'source-over';
    var rectOffsetTop = canvas.offsetTop;
    dispatch({
      type: 'redrawCompleted',
      payload: {
        rectX: rectX,
        rectY: rectY,
        rectWidth: rectWidth,
        rectHeight: rectHeight,
        rectOffsetTop: rectOffsetTop
      }
    });
  }, [aspectRatio, borderColor, borderRadius, borderWidth, dispatch, maskColor, padding, redrawing, wrapperHeight, wrapperWidth]);
  return /*#__PURE__*/React__default.createElement(CanvasWrapper, {
    ref: wrapperRef,
    className: classNames.container,
    "$maskColor": maskColor
  }, /*#__PURE__*/React__default.createElement(Canvas, {
    ref: canvasRef
  }));
};
var CanvasWrapper = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  flex-grow: 1;\n  background-clip: padding-box;\n  box-shadow: inset 0 0 0 2px ", ";\n"], ["\n  flex-grow: 1;\n  background-clip: padding-box;\n  box-shadow: inset 0 0 0 2px ", ";\n"])), function (props) {
  return props.$maskColor;
});
var Canvas = styled.canvas(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var templateObject_1$p, templateObject_2$l;

var CameraFeedWrapper = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
  return props.$mode === 'snapToGuides' ? "display: flex;\n         position: absolute;\n         left: ".concat(props.$x, "px;\n         top: ").concat(props.$y, "px;\n         width: ").concat(props.$w, "px;\n         height: ").concat(props.$h, "px;") : "";
});
var templateObject_1$o;

var CameraVideoTag = function CameraVideoTag(props) {
  var _a = useCameraStore(useShallow(function (store) {
      return {
        videoRef: store.videoRef,
        videoStream: store.videoStream,
        onVideoMounted: store.onVideoMounted,
        isRearFacing: store.isRearFacing
      };
    })),
    videoRef = _a.videoRef,
    videoStream = _a.videoStream,
    onVideoMounted = _a.onVideoMounted,
    isRearFacing = _a.isRearFacing;
  useEffect(function attachCameraStreamToVideoTagWhenReady() {
    if (videoRef.current && videoStream) {
      debug('attaching camera stream to video tag');
      // eslint-disable-next-line react-compiler/react-compiler
      videoRef.current.srcObject = videoStream;
    }
  }, [videoStream, videoRef]);
  return /*#__PURE__*/React__default.createElement(FullscreenVideoTag, _assign({
    autoPlay: true,
    playsInline: true,
    muted: true,
    ref: videoRef,
    onLoadedData: onVideoMounted,
    "$isRearFacing": isRearFacing
  }, props));
};
var FullscreenVideoTag = styled.video(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  transform: ", ";\n  transform-style: preserve-3d;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n  background: black;\n  z-index: -2;\n"], ["\n  transform: ", ";\n  transform-style: preserve-3d;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n  background: black;\n  z-index: -2;\n"])), function (props) {
  return props.$isRearFacing ? '' : 'scaleX(-1)';
});
var templateObject_1$n;

var DocumentCaptureScreen = function DocumentCaptureScreen(_a) {
  var _b, _c, _d, _e, _f;
  var onCaptureClicked = _a.onCaptureClicked,
    _g = _a.classNames,
    classNames = _g === void 0 ? {} : _g,
    _h = _a.verbiage,
    rawVerbiage = _h === void 0 ? {} : _h;
  var _j = useDocumentCaptureState(),
    _k = _j[0],
    documents = _k.documents,
    currentDocumentIndex = _k.currentDocumentIndex,
    rectX = _k.rectX,
    rectY = _k.rectY,
    rectWidth = _k.rectWidth,
    rectHeight = _k.rectHeight,
    rectOffsetTop = _k.rectOffsetTop,
    capturing = _k.capturing,
    uploadCapturedDocument = _k.uploadCapturedDocument,
    dispatch = _j[1];
  var _l = (_b = documents[currentDocumentIndex]) !== null && _b !== void 0 ? _b : {},
    title = _l.title,
    aspectRatio = _l.aspectRatio,
    cameraFeedMode = _l.cameraFeedMode,
    instructions = _l.instructions,
    contentUrl = _l.contentUrl,
    content = _l.content,
    uploadState = _l.uploadState;
  var _m = useCameraStore(),
    videoStream = _m.videoStream,
    cameraReady = _m.cameraReady,
    cameraAccessDenied = _m.cameraAccessDenied,
    requestCameraAccess = _m.requestCameraAccess;
  var _o = useState(false),
    cameraAccessRequested = _o[0],
    setCameraAccessRequested = _o[1];
  var cameraAccessNeeded =
  // we should force the browser to ask for camera access if...
  uploadState === 'not_started' &&
  // we aren't in the middle of uploading a document...
  !content &&
  // and the user hasn't passed a media blob for the current document...
  !cameraAccessRequested &&
  // and we haven't already tried to force a camera request...
  !(videoStream === null || videoStream === void 0 ? void 0 : videoStream.active); // and we don't already have camera access.
  useEffect(function requestCameraAccessIfNeeded() {
    if (!cameraAccessNeeded) return;
    setCameraAccessRequested(true);
    requestCameraAccess();
  }, [cameraAccessNeeded, requestCameraAccess]);
  var theme = useTheme();
  var maskColor = (_e = (_d = (_c = theme.documentCapture) === null || _c === void 0 ? void 0 : _c.guideBox) === null || _d === void 0 ? void 0 : _d.maskColor) !== null && _e !== void 0 ? _e : cameraFeedMode === 'snapToGuides' ? '#708090' : "rgba(0, 0, 0, 0.5)";
  var verbiage = useTranslations(rawVerbiage, {
    headingText: title,
    loadingBtnText: 'Camera initializing...',
    retryCameraAccessBtnText: 'Retry',
    captureBtnText: 'Capture',
    capturingBtnText: 'Capturing...',
    retryCaptureBtnText: 'Retry capture',
    uploadBtnText: 'Upload',
    uploadingBtnText: 'Uploading...',
    retryUploadBtnText: 'Retry',
    successBtnText: 'Upload succeeded!'
  });
  function onCaptureClick() {
    dispatch({
      type: 'captureRequested'
    });
    onCaptureClicked === null || onCaptureClicked === void 0 ? void 0 : onCaptureClicked();
  }
  function onSubmitClick() {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, uploadCapturedDocument(content, 'image/jpeg')];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  }
  return /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_f = classNames.container) !== null && _f !== void 0 ? _f : '')
  }, /*#__PURE__*/React__default.createElement(CameraFeedWrapper, {
    className: classNames.cameraFeedWrapper,
    "$mode": cameraFeedMode !== null && cameraFeedMode !== void 0 ? cameraFeedMode : 'snapToGuides',
    "$x": rectX,
    "$y": rectY + rectOffsetTop,
    "$w": rectWidth,
    "$h": rectHeight
  }, contentUrl ? ( /*#__PURE__*/React__default.createElement(PreviewImage, {
    alt: "",
    src: contentUrl,
    className: classNames.previewImage
  })) : ( /*#__PURE__*/React__default.createElement(CameraVideoTag, {
    className: classNames.cameraFeed
  }))), /*#__PURE__*/React__default.createElement(CaptureContainer, {
    className: classNames.captureContainer
  }, /*#__PURE__*/React__default.createElement(HeadingRow, {
    "$maskColor": maskColor,
    className: classNames.headingRow
  }, /*#__PURE__*/React__default.createElement(Heading$9, {
    className: classNames.heading
  }, verbiage.headingText)), /*#__PURE__*/React__default.createElement(DocumentCaptureGuideOverlay, {
    aspectRatio: aspectRatio,
    classNames: classNames,
    maskColor: maskColor
  }), /*#__PURE__*/React__default.createElement(FooterRow, {
    "$maskColor": maskColor,
    className: classNames.footerRow
  }, instructions && ( /*#__PURE__*/React__default.createElement(Instructions, {
    className: classNames.instructions
  }, instructions)), /*#__PURE__*/React__default.createElement(StyledButtonsRow$9, {
    className: classNames.buttonsRow
  }, cameraAccessDenied ? ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    className: classNames.retryCameraAccessBtn,
    variant: "negative",
    finished: true,
    onClick: requestCameraAccess
  }, verbiage.retryCameraAccessBtnText)) : contentUrl ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, uploadState === 'not_started' ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LoaderButton, {
    className: classNames.retryCaptureBtn,
    finished: true,
    variant: "warning",
    onClick: function onClick() {
      dispatch({
        type: 'retryCapture'
      });
    }
  }, verbiage.retryCaptureBtnText), /*#__PURE__*/React__default.createElement(LoaderButton, {
    className: classNames.uploadBtn,
    finished: true,
    variant: "positive",
    onClick: onSubmitClick
  }, verbiage.uploadBtnText))) : ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    className: classNames.uploadProgressBtn,
    finished: uploadState !== 'in_progress',
    variant: uploadState === 'failed' ? 'negative' : 'positive',
    onClick: onSubmitClick,
    disabled: ['in_progress', 'succeeded'].includes(uploadState !== null && uploadState !== void 0 ? uploadState : '')
  }, uploadState === 'succeeded' ? verbiage.successBtnText : uploadState === 'failed' ? verbiage.retryUploadBtnText : verbiage.uploadingBtnText)))) : ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    className: classNames.captureBtn,
    finished: cameraReady,
    variant: "primary",
    onClick: onCaptureClick,
    disabled: !cameraReady || capturing
  }, !cameraReady ? verbiage.loadingBtnText : capturing ? verbiage.capturingBtnText : verbiage.captureBtnText))))));
};
var CaptureContainer = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: var(--app-height);\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: var(--app-height);\n"])));
var HeadingRow = styled.div(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  background: ", ";\n  text-align: center;\n  color: white;\n"], ["\n  background: ", ";\n  text-align: center;\n  color: white;\n"])), function (props) {
  return props.$maskColor;
});
var Heading$9 = styled.h1(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  font-size: 22px;\n"], ["\n  font-size: 22px;\n"])));
var FooterRow = styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 20px 20px;\n  height: auto;\n  color: white;\n"], ["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 20px 20px;\n  height: auto;\n  color: white;\n"])), function (props) {
  return props.$maskColor;
});
var Instructions = styled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  max-height: ", ";\n  overflow-y: auto;\n"], ["\n  max-height: ", ";\n  overflow-y: auto;\n"])), function (props) {
  var _a, _b, _c;
  return (_c = (_b = (_a = props.theme.documentCapture) === null || _a === void 0 ? void 0 : _a.instructions) === null || _b === void 0 ? void 0 : _b.maxHeight) !== null && _c !== void 0 ? _c : '8rem';
});
var StyledButtonsRow$9 = styled(ButtonsRow)(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  padding-top: 20px;\n"], ["\n  padding-top: 20px;\n"])));
var PreviewImage = styled.img(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
var templateObject_1$m, templateObject_2$k, templateObject_3$g, templateObject_4$a, templateObject_5$6, templateObject_6$5, templateObject_7$3;

var DocumentCaptureWizard = function DocumentCaptureWizard(_a) {
  var onSuccess = _a.onSuccess,
    onDocumentCaptured = _a.onDocumentCaptured,
    onDocumentUploaded = _a.onDocumentUploaded,
    // TODO: onExitCapture, onUserCancel
    _b = _a.documents,
    // TODO: onExitCapture, onUserCancel
    documents = _b === void 0 ? [] : _b,
    aspectRatio = _a.aspectRatio,
    cameraFeedMode = _a.cameraFeedMode,
    instructions = _a.instructions,
    _c = _a.classNames,
    classNames = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    verbiage = _d === void 0 ? {} : _d;
  return /*#__PURE__*/React__default.createElement(DocumentCaptureStateProvider, {
    documents: documents,
    aspectRatio: aspectRatio,
    cameraFeedMode: cameraFeedMode,
    instructions: instructions,
    onDocumentCaptured: onDocumentCaptured,
    onDocumentUploaded: onDocumentUploaded,
    onAllDocumentsUploaded: onSuccess
  }, /*#__PURE__*/React__default.createElement(DocumentCaptureScreen, {
    classNames: classNames,
    verbiage: verbiage
  }));
};

function useFileState() {
  var _a = useState(),
    file = _a[0],
    setFile = _a[1];
  var fileInputOnChange = useCallback(function (e) {
    var _a, _b;
    setFile((_b = (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0]);
  }, [setFile]);
  return {
    rawFile: file,
    fileInputOnChange: fileInputOnChange
  };
}
function useFileDataUrl(file) {
  var _a = useState(),
    url = _a[0],
    setUrl = _a[1];
  useEffect(function () {
    if (!file) return;
    var aborted = false;
    var reader = new FileReader();
    reader.onload = function () {
      return !aborted && setUrl(reader.result);
    };
    reader.readAsDataURL(file);
    return function () {
      aborted = true;
    };
  }, [file]);
  return {
    url: url
  };
}
function useResizeMaxEdge(_a) {
  var _this = this;
  var rawFile = _a.rawFile,
    _b = _a.maxEdgePx,
    maxEdgePx = _b === void 0 ? 2048 : _b;
  var url = useFileDataUrl(rawFile).url;
  var _c = useState(),
    resizedImageFile = _c[0],
    setResizedImageFile = _c[1];
  useEffect(function () {
    if (!url) return;
    // A flag to prevent out-or-order errors
    var aborted = false;
    var image = new Image();
    image.onload = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, width, height, canvas, context, dataUrl;
        return __generator(this, function (_b) {
          if (aborted) return [2 /*return*/];
          _a = image.width > image.height ? {
            width: maxEdgePx,
            height: maxEdgePx / image.width * image.height
          } : {
            width: maxEdgePx / image.height * image.width,
            height: maxEdgePx
          }, width = _a.width, height = _a.height;
          canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          context = canvas.getContext('2d');
          if (context == null) throw new Error("Can't obtain canvas context");
          context.imageSmoothingQuality = 'high';
          context.drawImage(image,
          // source image
          0,
          // source x, y, width, height
          0, image.width, image.height, 0,
          // destination x, y, width height
          0, width, height);
          dataUrl = canvas.toDataURL('image/jpeg', 0.95);
          if (aborted) return [2 /*return*/];
          setResizedImageFile(dataUrl);
          return [2 /*return*/];
        });
      });
    };
    image.src = url;
    // If one of the props changes before the resize completes then
    // abort in case this run completes after a subsequent one and
    // overwrites the result.
    return function () {
      aborted = true;
    };
  }, [maxEdgePx, url]);
  return {
    resizedImageFile: resizedImageFile
  };
}

var IdCaptureFallback = function IdCaptureFallback(_a) {
  var _b = _a.idCaptureRequirement,
    idCaptureRequirement = _b === void 0 ? 'idCardOrPassport' : _b,
    onCapture = _a.onCapture,
    onFinished = _a.onFinished,
    _c = _a.classNames,
    classNames = _c === void 0 ? {} : _c,
    _d = _a.colors,
    colors = _d === void 0 ? {} : _d,
    _e = _a.verbiage,
    rawVerbiage = _e === void 0 ? {} : _e,
    _f = _a.silentFallback,
    silentFallback = _f === void 0 ? false : _f;
  var lastResizedFileRef = useRef(null);
  var fileInput = useRef(null);
  var _g = useState([]),
    images = _g[0],
    setImages = _g[1];
  var _h = useState(),
    documentToCapture = _h[0],
    setDocumentToCapture = _h[1];
  var _j = useState(silentFallback),
    useFallback = _j[0],
    setUseFallback = _j[1];
  var minImageCount = minImageCountForIdCaptureRequirementOption(idCaptureRequirement);
  var maxImageCount = maxImageCountForIdCaptureRequirementOption(idCaptureRequirement);
  var _k = useFileState(),
    rawFile = _k.rawFile,
    fileInputOnChange = _k.fileInputOnChange;
  var resizedImageFile = useResizeMaxEdge({
    rawFile: rawFile
  }).resizedImageFile;
  var _l = useState(false),
    isProcessing = _l[0],
    setIsProcessing = _l[1]; // helps eliminate some of the flicker as the image processes
  var whatToCapture = idCaptureRequirement === 'idCard' ? 'ID card' : idCaptureRequirement === 'passport' ? 'passport' : idCaptureRequirement === 'idCardOrPassport' ? 'ID card or passport' : 'ID card and passport';
  var firstInstructionText = idCaptureRequirement === 'idCard' || idCaptureRequirement === 'idCardAndPassport' ? 'Please capture the front of your ID card.' : idCaptureRequirement === 'passport' ? 'Please capture the ID page of your passport.' : 'Please capture the front of your ID card, or the ID page of your passport.';
  var secondInstructionText = idCaptureRequirement === 'idCardOrPassport' ? 'Please capture the back of your ID card, or click Done if submitting a passport.' : 'Please capture the back of your ID card.';
  var descriptionText = "On-device capture guidance failed, please capture ".concat(minImageCount > 1 ? 'photos' : ' a photo', " of your ").concat(whatToCapture, " manually.");
  var verbiage = useTranslations(rawVerbiage, {
    headingText: "We're having some trouble.",
    descriptionText: descriptionText,
    firstInstructionText: firstInstructionText,
    secondInstructionText: secondInstructionText,
    thirdInstructionText: 'Please capture the ID page of your passport.',
    captureBtnText: 'Capture',
    captureMoreBtnText: "Capture ".concat(images.length === 2 ? 'ID page of passport' : 'back of ID card'),
    doneBtnText: 'Done'
  });
  useEffect(function resetAfterCapturingImage() {
    // we only want to run this IF the file has changed
    // there IS risk in this if we ever capture multiple documents that are the same (from files)
    if (resizedImageFile && resizedImageFile !== lastResizedFileRef.current) {
      lastResizedFileRef.current = resizedImageFile;
      setImages(function (images) {
        return __spreadArray(__spreadArray([], images, true), [resizedImageFile], false);
      });
      onCapture === null || onCapture === void 0 ? void 0 : onCapture(resizedImageFile);
      setDocumentToCapture(undefined);
      setUseFallback(false);
      setIsProcessing(false);
    }
  }, [onCapture, resizedImageFile]);
  function onFileSelected(e) {
    var _a;
    if (!((_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0])) return;
    setDocumentToCapture(undefined);
    setIsProcessing(true);
    fileInputOnChange(e);
  }
  var instructionText = images.length === 0 ? verbiage.firstInstructionText : images.length === 1 ? verbiage.secondInstructionText : verbiage.thirdInstructionText;
  if (useFallback) {
    setUseFallback(false);
    setDocumentToCapture(instructionText);
  }
  if (!isMobile() && documentToCapture || useFallback) {
    return /*#__PURE__*/React__default.createElement(DocumentCaptureWizard, {
      documents: [{
        title: documentToCapture
      }],
      onDocumentCaptured: function onDocumentCaptured(document) {
        var imageData = document.contentUrl;
        onCapture === null || onCapture === void 0 ? void 0 : onCapture(imageData);
        // todo: this a hack to address what is probably some sub-optimal coupling - fix
        setTimeout(function () {
          setImages(function (images) {
            return __spreadArray(__spreadArray([], images, true), [imageData], false);
          });
          setDocumentToCapture(undefined);
        }, 0);
      }
    });
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(StyledOverlayInner$2, {
    className: classNames.inner
  }, !silentFallback && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Heading$8, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(Description$3, {
    className: classNames.description
  }, verbiage.descriptionText))), (images.length > 0 || isProcessing) && ( /*#__PURE__*/React__default.createElement(OverlayImageRow, {
    className: classNames.imageContainer
  }, images.map(function (image, i) {
    return /*#__PURE__*/React__default.createElement(ImageCol, {
      key: i,
      className: classNames.imageCol
    }, /*#__PURE__*/React__default.createElement("img", {
      src: image,
      alt: "",
      className: classNames.image
    }));
  }))), images.length < minImageCount && ( /*#__PURE__*/React__default.createElement(Instruction, {
    className: classNames.instruction
  }, instructionText)), /*#__PURE__*/React__default.createElement("input", {
    ref: fileInput,
    type: "file",
    accept: "image/*",
    capture: "environment",
    onChange: onFileSelected,
    hidden: true
  }), /*#__PURE__*/React__default.createElement(StyledButtonsRow$8, {
    className: classNames.buttonsRow
  }, images.length < maxImageCount && ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: images.length > 0 ? 'secondary' : 'positive',
    className: images.length > 0 ? classNames.captureMoreBtn : classNames.captureBtn,
    colors: images.length > 0 ? colors.captureMoreBtn : colors.captureBtn,
    finished: true,
    onClick: function onClick() {
      var _a;
      if (isMobile()) {
        (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click();
      } else {
        setDocumentToCapture(instructionText);
      }
    }
  }, images.length > 0 ? verbiage.captureMoreBtnText : verbiage.captureBtnText)), images.length >= minImageCount && ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    className: classNames.doneBtn,
    colors: colors.doneBtn,
    finished: true,
    onClick: function onClick() {
      onFinished === null || onFinished === void 0 ? void 0 : onFinished(images);
    }
  }, verbiage.doneBtnText))))));
};
var StyledOverlayInner$2 = styled(OverlayInner$2)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  justify-content: center;\n"], ["\n  justify-content: center;\n"])));
var Heading$8 = styled.h3(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  margin-bottom: 8px;\n"], ["\n  margin-bottom: 8px;\n"])));
var Description$3 = styled.p(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  margin-bottom: 8px;\n"], ["\n  margin-bottom: 8px;\n"])));
var Instruction = styled.p(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var ImageCol = styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-grow: 1;\n  flex-basis: 0;\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-grow: 1;\n  flex-basis: 0;\n"])));
var StyledButtonsRow$8 = styled(ButtonsRow)(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  margin-top: 32px;\n"], ["\n  margin-top: 32px;\n"])));
var templateObject_1$l, templateObject_2$j, templateObject_3$f, templateObject_4$9, templateObject_5$5, templateObject_6$4;

function ScalingCameraFeed() {
  var _a = useContext(IdCaptureStateContext),
    captureState = _a.captureState,
    guideRectX = _a.guideRectX,
    guideRectY = _a.guideRectY,
    guideRectWidth = _a.guideRectWidth,
    guideRectHeight = _a.guideRectHeight;
  if (captureState === 'complete') return null;
  return /*#__PURE__*/React__default.createElement(CameraFeedWrapper, {
    "$x": guideRectX,
    "$y": guideRectY,
    "$w": guideRectWidth,
    "$h": guideRectHeight,
    "$mode": 'snapToGuides'
  }, /*#__PURE__*/React__default.createElement(CameraVideoTag, null));
}

var IdCaptureWizard = function IdCaptureWizard(_a) {
  var _b, _c, _d, _e, _f, _g;
  var onSuccess = _a.onSuccess,
    onExitCapture = _a.onExitCapture,
    onUserCancel = _a.onUserCancel,
    _h = _a.loadingOverlayMode,
    loadingOverlayMode = _h === void 0 ? 'default' : _h,
    customOverlayContent = _a.customOverlayContent,
    onLoadingOverlayDismissed = _a.onLoadingOverlayDismissed,
    precapturedDocuments = _a.precapturedDocuments,
    _j = _a.captureRequirement,
    captureRequirement = _j === void 0 ? 'idCardOrPassport' : _j,
    _k = _a.allowSinglePageIdCapture,
    allowSinglePageIdCapture = _k === void 0 ? false : _k,
    _l = _a.separateIdCardCaptureSequence,
    separateIdCardCaptureSequence = _l === void 0 ? false : _l,
    _m = _a.thresholds,
    thresholds = _m === void 0 ? defaultIdCaptureThresholds : _m,
    _o = _a.skipSuccessScreen,
    skipSuccessScreen = _o === void 0 ? false : _o,
    instructions = _a.instructions,
    _p = _a.releaseCameraAccessOnExit,
    releaseCameraAccessOnExit = _p === void 0 ? true : _p,
    _q = _a.guideType,
    guideType = _q === void 0 ? 'fit' : _q,
    _r = _a.portraitGuidesOnMobile,
    portraitGuidesOnMobile = _r === void 0 ? true : _r,
    _s = _a.rotateLoadingOverlayImageWhenPortrait,
    rotateLoadingOverlayImageWhenPortrait = _s === void 0 ? true : _s,
    _t = _a.silentFallback,
    silentFallback = _t === void 0 ? false : _t,
    _u = _a.forceFallbackMode,
    forceFallbackMode = _u === void 0 ? false : _u,
    _v = _a.allowIdCardBackToFrontCapture,
    allowIdCardBackToFrontCapture = _v === void 0 ? false : _v,
    _w = _a.enableOverrideWrongDocumentTypeDialog,
    enableOverrideWrongDocumentTypeDialog = _w === void 0 ? false : _w,
    _x = _a.allowOverrideWrongDocumentTypeAfterMs,
    allowOverrideWrongDocumentTypeAfterMs = _x === void 0 ? 8000 : _x,
    _y = _a.guideImages,
    guideImages = _y === void 0 ? defaultIdCaptureGuideImages : _y,
    _z = _a.assets,
    assets = _z === void 0 ? {} : _z,
    _0 = _a.classNames,
    classNames = _0 === void 0 ? {} : _0,
    _1 = _a.colors,
    colors = _1 === void 0 ? {} : _1,
    _2 = _a.verbiage,
    verbiage = _2 === void 0 ? {} : _2,
    _3 = _a.debugMode,
    debugMode = _3 === void 0 ? false : _3;
  var _4 = useIdCaptureState(),
    state = _4[0],
    dispatch = _4[1];
  var _5 = useCameraStore(),
    cameraAccessDenied = _5.cameraAccessDenied,
    requestCameraAccess = _5.requestCameraAccess,
    releaseCameraAccess = _5.releaseCameraAccess;
  var _6 = useState(false),
    overlayDismissed = _6[0],
    setOverlayDismissed = _6[1];
  var _7 = useContext(SubmissionContext),
    submissionStatus = _7.submissionStatus,
    setIdFrontImage = _7.setIdFrontImage,
    setIdBackImage = _7.setIdBackImage,
    setPassportImage = _7.setPassportImage,
    logIdFrontCaptureAttempt = _7.logIdFrontCaptureAttempt,
    logIdBackCaptureAttempt = _7.logIdBackCaptureAttempt;
  var _8 = useContext(IdCaptureModelsContext),
    start = _8.start,
    stop = _8.stop,
    onPredictionMade = _8.onPredictionMade,
    setRequiredDocumentType = _8.setRequiredDocumentType,
    modelError = _8.modelError,
    resetBestFrame = _8.resetBestFrame;
  useEffect(function () {
    dispatch({
      type: 'configureWizard',
      payload: {
        captureRequirement: captureRequirement,
        precapturedDocuments: precapturedDocuments,
        allowSinglePageIdCapture: allowSinglePageIdCapture,
        allowIdCardBackToFrontCapture: allowIdCardBackToFrontCapture,
        enableOverrideWrongDocumentTypeDialog: enableOverrideWrongDocumentTypeDialog,
        allowOverrideWrongDocumentTypeAfterMs: allowOverrideWrongDocumentTypeAfterMs
      }
    });
  }, [allowIdCardBackToFrontCapture, allowOverrideWrongDocumentTypeAfterMs, allowSinglePageIdCapture, captureRequirement, dispatch, enableOverrideWrongDocumentTypeDialog, precapturedDocuments]);
  var documentCount = Object.keys(state.capturedDocuments).length;
  useEffect(function () {
    if (documentCount) resetBestFrame();
  }, [documentCount, resetBestFrame]);
  var logCaptureMetadata = useCallback(function (metadata) {
    var _a;
    metadata.operationTime = new Date().getTime() - ((_a = state.operationStartedAt) !== null && _a !== void 0 ? _a : new Date()).getTime();
    if (state.requestedDocumentType === 'idCardBack') {
      logIdBackCaptureAttempt(metadata);
    } else {
      logIdFrontCaptureAttempt(metadata);
    }
  }, [logIdBackCaptureAttempt, logIdFrontCaptureAttempt, state.operationStartedAt, state.requestedDocumentType]);
  useEffect(function startModelsWhenCapturing() {
    if (!overlayDismissed || state.captureState !== 'capturing') return;
    dispatch({
      type: 'captureStarted'
    });
    start();
  }, [dispatch, overlayDismissed, start, state.captureState]);
  useEffect(function () {
    onPredictionMade(function (prediction) {
      if (state.captureState === 'capturing') {
        dispatch({
          type: 'objectsDetected',
          payload: {
            prediction: prediction
          }
        });
      } else if (state.captureState === 'requestingFlip') {
        if (state.requestedDocumentType !== 'selfie' && prediction["".concat(state.requestedDocumentType, "DetectionThresholdMet")]) {
          resetBestFrame();
          dispatch({
            type: 'flipRequestCompleted'
          });
        }
      }
    });
  }, [dispatch, onPredictionMade, resetBestFrame, state.captureState, state.requestedDocumentType]);
  useEffect(function () {
    if (state.captureState === 'complete') stop();
  }, [state.captureState, stop]);
  var onCapture = useCallback(function (imageData, width, height, documentType, metadata) {
    logCaptureMetadata(metadata);
    dispatch({
      type: 'documentCaptured',
      payload: {
        imageData: imageData,
        width: width,
        height: height,
        documentType: documentType,
        boundingBox: metadata.boundingBox,
        detectionScore: metadata.bestDetectionScore,
        focusScore: metadata.bestFocusScore
      }
    });
  }, [dispatch, logCaptureMetadata]);
  var onSubmitClick = useCallback(function () {
    var _a = state.capturedDocuments,
      idCardFront = _a.idCardFront,
      idCardBack = _a.idCardBack,
      passport = _a.passport,
      singlePage = _a.singlePage;
    var idFrontImage = idCardFront && dataUrlToBase64Sync(idCardFront.imageData);
    var idBackImage = idCardBack && dataUrlToBase64Sync(idCardBack.imageData);
    var passportImage = passport && dataUrlToBase64Sync(passport.imageData);
    var singlePageImage = singlePage && dataUrlToBase64Sync(singlePage.imageData);
    if (idFrontImage) setIdFrontImage(idFrontImage);
    if (idBackImage) setIdBackImage(idBackImage);
    if (passportImage) setPassportImage(passportImage);
    if (singlePageImage) setIdFrontImage(singlePageImage);
    if (releaseCameraAccessOnExit) releaseCameraAccess();
    setTimeout(function () {
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
        idFrontImage: idFrontImage,
        idBackImage: idBackImage,
        passportImage: passportImage
      });
    }, 0);
  }, [onSuccess, releaseCameraAccess, releaseCameraAccessOnExit, setIdBackImage, setIdFrontImage, setPassportImage, state.capturedDocuments]);
  var showSuccessScreen = useShowSuccessScreen(skipSuccessScreen, state.captureState === 'complete', onSubmitClick);
  var onRetryClick = useCallback(function () {
    dispatch({
      type: 'resetWizard'
    });
  }, [dispatch]);
  var _9 = useState(0),
    attempt = _9[0],
    setAttempt = _9[1];
  var onExit = useCallback(function () {
    releaseCameraAccess();
    setOverlayDismissed(false);
    setAttempt(function (n) {
      return n + 1;
    });
    dispatch({
      type: 'resetWizard'
    });
    onExitCapture === null || onExitCapture === void 0 ? void 0 : onExitCapture();
    void requestCameraAccess();
  }, [dispatch, onExitCapture, releaseCameraAccess, requestCameraAccess]);
  useEffect(function () {
    if (submissionStatus !== SubmissionStatus.READY) {
      if (releaseCameraAccessOnExit) releaseCameraAccess();
    }
  }, [releaseCameraAccess, releaseCameraAccessOnExit, submissionStatus]);
  useEffect(function () {
    if (cameraAccessDenied) {
      setOverlayDismissed(false);
      setAttempt(function (n) {
        return n + 1;
      });
    }
  }, [cameraAccessDenied]);
  var idCaptureVerbiages = {
    idCardFront: useTranslations(verbiage.idCardFront, {
      instructionText: 'Scan the front of ID',
      processingIdCardText: "ID card ".concat('idCardFront' in state.capturedDocuments ? 'front' : 'back', " captured.")
    }),
    idCardBack: useTranslations(verbiage.idCardBack, {
      instructionText: 'Scan the back of ID'
    }),
    passport: useTranslations(verbiage.passport, {
      instructionText: 'Scan the ID page of passport'
    })
  };
  var theme = useTheme();
  var idCaptureVerbiage = idCaptureVerbiages[state.requestedDocumentType];
  useEffect(function () {
    if (separateIdCardCaptureSequence) return;
    if (state.captureState !== 'requestingFlip') return;
    var t = setTimeout(function () {
      resetBestFrame();
      dispatch({
        type: 'flipRequestCompleted'
      });
    }, 6000);
    return function () {
      clearTimeout(t);
    };
  }, [dispatch, resetBestFrame, separateIdCardCaptureSequence, state.captureState]);
  useEffect(function () {
    if (state.requestedDocumentType === 'idCardFront') {
      if (captureRequirement === 'idCardOrPassport') {
        setRequiredDocumentType(['idCardFront', 'passport']);
      } else {
        setRequiredDocumentType('idCardFront');
      }
    }
    if (state.requestedDocumentType === 'idCardBack') {
      setRequiredDocumentType('idCardBack');
    }
    if (state.requestedDocumentType === 'passport') {
      setRequiredDocumentType('passport');
    }
    return function () {
      setRequiredDocumentType('none');
    };
  }, [captureRequirement, setRequiredDocumentType, state.requestedDocumentType]);
  var handleCapture = useCallback(function (imageData) {
    return __awaiter(void 0, void 0, void 0, function () {
      var base64ImageData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, dataUrlToBase64(imageData)];
          case 1:
            base64ImageData = _a.sent();
            dispatch({
              type: 'documentCapturedManually',
              payload: {
                imageData: base64ImageData
              }
            });
            return [2 /*return*/];
        }
      });
    });
  }, [dispatch]);
  var _10 = useState(false),
    progressStarted = _10[0],
    setProgressStarted = _10[1];
  useEffect(function () {
    if (state.captureState === 'capturing') {
      setProgressStarted(false);
    }
  }, [state.captureState]);
  useEffect(function () {
    if (state.goodFramesCount > 0) {
      setProgressStarted(true);
    }
  }, [state.goodFramesCount]);
  if (forceFallbackMode || modelError) {
    return /*#__PURE__*/React__default.createElement(IdCaptureFallback, {
      idCaptureRequirement: captureRequirement,
      onFinished: onSubmitClick,
      onCapture: handleCapture,
      classNames: classNames.fallback,
      colors: colors.fallback,
      verbiage: verbiage.fallback,
      silentFallback: silentFallback
    });
  }
  var requestedAction = state.captureState === 'requestingFlip' ? 'FLIP_ID' : state.requestedDocumentType === 'idCardBack' ? 'SHOW_ID_BACK' : state.requestedDocumentType === 'passport' ? 'SHOW_PASSPORT' : 'SHOW_ID_FRONT';
  var guidesStatus = !overlayDismissed ? 'disabled' : state.isGoodFrame ? 'capturing' : 'ready';
  return /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_b = classNames === null || classNames === void 0 ? void 0 : classNames.container) !== null && _b !== void 0 ? _b : '')
  }, /*#__PURE__*/React__default.createElement(ScalingCameraFeed, null), overlayDismissed && state.captureState === 'capturing' && ( /*#__PURE__*/React__default.createElement(IdCapture, {
    requiredDocumentType: state.requestedDocumentType,
    thresholds: thresholds,
    onCapture: onCapture,
    classNames: classNames === null || classNames === void 0 ? void 0 : classNames.capture,
    colors: colors,
    verbiage: idCaptureVerbiage,
    debugMode: debugMode
  })), /*#__PURE__*/React__default.createElement(IdCaptureGuides, {
    key: "guides".concat(attempt),
    guideType: guideType,
    status: guidesStatus,
    progress: progressStarted && state.captureState === 'capturing' ? 1 : 0,
    portraitGuidesOnMobile: portraitGuidesOnMobile,
    requestedAction: requestedAction,
    images: guideImages,
    classNames: classNames.guides,
    colors: colors,
    verbiage: idCaptureVerbiage,
    isBackToFront: state.allowIdCardBackToFrontCapture && 'idCardBack' in state.capturedDocuments
  }), debugMode && !((_d = (_c = theme.idCapture) === null || _c === void 0 ? void 0 : _c.capturePreview) === null || _d === void 0 ? void 0 : _d.disabled) && state.captureState === 'requestingFlip' && !separateIdCardCaptureSequence && state.imageUrl && ( /*#__PURE__*/React__default.createElement(IdCaptureImagePreview, {
    classNames: (_e = classNames.capture) === null || _e === void 0 ? void 0 : _e.imagePreview,
    text: (_f = idCaptureVerbiages === null || idCaptureVerbiages === void 0 ? void 0 : idCaptureVerbiages.idCardFront) === null || _f === void 0 ? void 0 : _f.processingIdCardText,
    imageUrl: state.imageUrl
  })), state.captureState !== 'complete' && ( /*#__PURE__*/React__default.createElement("div", {
    id: "idmission-above-guides-content"
  })), /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onExit,
    className: (_g = classNames.capture) === null || _g === void 0 ? void 0 : _g.exitCaptureBtn
  }), !overlayDismissed && ( /*#__PURE__*/React__default.createElement(IdCaptureLoadingOverlay, {
    key: "loading".concat(attempt),
    mode: loadingOverlayMode,
    customOverlayContent: customOverlayContent,
    instructions: instructions,
    assets: assets.loadingOverlay,
    classNames: classNames.loadingOverlay,
    colors: colors.loadingOverlay,
    verbiage: verbiage.loadingOverlay,
    onUserCancel: onUserCancel,
    onDismissed: function onDismissed() {
      setOverlayDismissed(true);
      onLoadingOverlayDismissed === null || onLoadingOverlayDismissed === void 0 ? void 0 : onLoadingOverlayDismissed();
    },
    rotateImage: rotateLoadingOverlayImageWhenPortrait && portraitGuidesOnMobile && window.innerWidth < window.innerHeight
  })), state.captureState === 'requestingFlip' && separateIdCardCaptureSequence && ( /*#__PURE__*/React__default.createElement(IdCaptureSuccess, {
    capturedDocuments: state.capturedDocuments,
    classNames: classNames.success,
    onSubmitClick: function onSubmitClick() {
      dispatch({
        type: 'flipRequestCompleted'
      });
    },
    onRetryClick: onRetryClick,
    colors: colors.success,
    verbiage: verbiage.success
  })), state.captureState === 'complete' && showSuccessScreen && ( /*#__PURE__*/React__default.createElement(IdCaptureSuccess, {
    capturedDocuments: state.capturedDocuments,
    classNames: classNames.success,
    onSubmitClick: onSubmitClick,
    onRetryClick: onRetryClick,
    colors: colors.success,
    verbiage: verbiage.success,
    debugMode: debugMode
  })));
};

function SelfieCaptureLoadingGraphic(_a) {
  var _b, _c, _d;
  var _e = _a.width,
    width = _e === void 0 ? 840 : _e,
    _f = _a.height,
    height = _f === void 0 ? 740 : _f,
    className = _a.className;
  var _g = useState(1),
    frame = _g[0],
    setFrame = _g[1];
  useEffect(function () {
    var i = setInterval(function () {
      setFrame(function (n) {
        return (n + 1) % 10;
      });
    }, 750);
    return function () {
      clearInterval(i);
    };
  }, []);
  var theme = useTheme();
  var satisfiedColor = (_d = (_c = (_b = theme.selfieCapture) === null || _b === void 0 ? void 0 : _b.guides) === null || _c === void 0 ? void 0 : _c.satisfiedColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
  return /*#__PURE__*/React__default.createElement("svg", {
    width: width,
    height: height,
    className: className,
    viewBox: "0 0 840 740",
    fill: "none",
    preserveAspectRatio: "xMidYMax slice",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0_428_1188)"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask0_428_1188",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "840",
    height: "740"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "840",
    height: "740",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask0_428_1188)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M503.781 449.497C491.561 503.154 458.442 541.609 419.561 541.609C380.68 541.609 347.492 503.015 335.272 449.358L344.645 412.916L347.492 402.019H491.561L502.253 443.667L503.225 447.415L503.781 449.497Z",
    fill: "#D2D4DA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M574.88 244.97C647.073 163.885 598.921 362.155 558.945 338.928C488.709 298.211 574.88 244.97 574.88 244.97Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M816.983 742.838C779.698 781.432 736.86 814.612 689.786 841.127C617.161 882.012 534.399 906.862 446.153 911.027C437.335 911.513 428.448 911.721 419.491 911.721C374.986 911.721 331.731 906.446 290.281 896.519C232.514 882.706 178.358 859.8 129.271 829.397C89.9033 805.033 53.9382 775.948 22 742.838L31.512 705.355C45.8842 649.061 90.2505 605.33 146.837 591.795L153.085 590.337L222.447 573.747L241.401 569.235C249.386 567.292 257.023 564.585 264.244 561.114C270.285 558.199 276.047 554.797 281.463 550.91C287.295 546.745 292.78 542.025 297.71 536.819C310.971 522.867 320.761 505.653 325.76 486.286L333.119 457.688L335.064 449.983L335.202 449.358L344.645 412.916L347.422 402.019H491.491L502.253 443.667L503.225 447.415L503.78 449.497V449.983L505.863 457.757L513.223 486.286C520.097 512.802 535.996 535.5 557.589 550.91C569.393 559.448 582.932 565.765 597.581 569.235L615.078 573.4L692.146 591.795C748.732 605.33 793.099 649.061 807.471 705.355L816.983 742.838Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M503.781 449.497C491.561 503.154 458.442 541.609 419.561 541.609C380.68 541.609 347.492 503.015 335.272 449.358L344.645 412.916L347.492 402.019H491.561L502.253 443.667L503.225 447.415L503.781 449.497Z",
    fill: "#DC968D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M264.123 244.97C191.93 163.885 240.082 362.155 280.058 338.928C350.294 298.211 264.123 244.97 264.123 244.97Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M586.473 187.324C586.473 193.432 586.126 199.402 585.432 205.371C584.876 210.785 582.446 233.9 578.141 263.331C575.781 279.713 572.726 297.969 569.115 316.294C569.115 316.502 569.115 316.78 568.976 316.988C560.159 361.621 547.731 406.045 531.484 422.219C513.154 440.544 498.435 457.203 481.632 469.211C464.83 481.289 446.014 488.786 419.631 488.786C393.247 488.786 374.431 481.289 357.629 469.211C340.896 457.203 326.107 440.544 307.778 422.219C291.531 405.976 279.103 361.482 270.216 316.918C270.216 316.918 270.216 316.71 270.216 316.641C269.105 310.879 268.063 305.118 267.022 299.426C266.605 297.066 266.189 294.706 265.772 292.346C264.036 282.351 262.509 272.563 261.12 263.401C256.121 229.596 253.691 204.122 253.691 204.122C253.136 198.638 252.858 193.016 252.858 187.324C252.858 185.866 252.858 184.408 252.858 182.951C253.205 169.832 255.01 157.06 258.274 144.843C258.412 144.287 258.551 143.732 258.69 143.177C277.228 75.4294 337.425 24.8271 410.049 20.8011C413.243 20.5928 416.368 20.5234 419.631 20.5234C465.733 20.5234 507.461 39.1956 537.663 69.3904C563.769 95.4205 581.266 130.127 585.501 168.79C586.195 174.899 586.542 181.077 586.542 187.324H586.473Z",
    fill: "#FEAEA5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M445.867 337.327C445.867 348.849 434.133 358.151 419.622 358.151C405.111 358.151 393.447 348.849 393.447 337.327C393.447 335.939 393.586 334.55 394.002 333.301C396.293 342.88 406.916 350.099 419.622 350.099C432.328 350.099 443.02 342.88 445.312 333.301C445.728 334.62 445.867 335.939 445.867 337.327Z",
    fill: "#F7A69C"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M817.053 743.187C716.586 847.238 575.642 912 419.561 912C263.481 912 122.467 847.238 22.0698 743.118L31.5818 705.704C45.954 649.34 90.3203 605.61 146.906 592.074L222.655 574.027L241.471 569.515C249.942 567.502 258.135 564.517 265.772 560.699C304.237 601.653 358.879 627.267 419.561 627.267C480.244 627.267 534.886 601.653 573.351 560.699C580.988 564.448 589.111 567.502 597.651 569.515L614.106 573.471L692.216 592.074C748.802 605.61 793.168 649.34 807.471 705.704L817.053 743.187Z",
    fill: "#6E7174"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M614.106 573.471C597.165 594.018 534.886 659.058 419.561 663.639C286.671 668.984 226.266 579.441 222.655 574.027L241.471 569.515C249.942 567.502 258.134 564.517 265.772 560.699C304.236 601.653 358.879 627.267 419.561 627.267C480.244 627.267 534.886 601.653 573.35 560.699C580.988 564.448 589.111 567.502 597.651 569.515L614.106 573.471Z",
    fill: "#555A5E"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M249.898 196.144C249.898 249.777 270.317 315.623 270.317 315.623C270.317 315.623 266.862 205.572 314.892 164.108C347.514 135.946 374.019 167.565 417.115 167.565C456.137 167.565 492.558 136.481 525.436 164.108C578.852 208.994 568.738 315.623 568.738 315.623C568.738 315.623 589.157 250.557 589.157 196.144C589.157 76.4319 542.638 20 417.115 20C302.8 20 249.898 75.8365 249.898 196.144Z",
    fill: "#525252"
  })), frame >= 8 ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    d: "M565.5 295C565.5 350.583 549.016 400.803 522.488 437.067C495.958 473.332 459.517 495.5 419.5 495.5C379.483 495.5 343.042 473.332 316.512 437.067C289.984 400.803 273.5 350.583 273.5 295C273.5 239.417 289.984 189.197 316.512 152.933C343.042 116.668 379.483 94.5 419.5 94.5C459.517 94.5 495.958 116.668 522.488 152.933C549.016 189.197 565.5 239.417 565.5 295Z",
    stroke: satisfiedColor,
    strokeWidth: "5"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "518.5",
    cy: "438.5",
    r: "25.5",
    fill: satisfiedColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M504 440.5L512 448L531 427",
    stroke: "white",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, frame > 2 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, frame > 3 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, frame > 4 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, frame > 5 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    d: "M298.5 182.5L419 164.5L540 182",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "165",
    r: "7",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: "M565.5 295C565.5 350.583 549.016 400.803 522.488 437.067C495.958 473.332 459.517 495.5 419.5 495.5C379.483 495.5 343.042 473.332 316.512 437.067C289.984 400.803 273.5 350.583 273.5 295C273.5 239.417 289.984 189.197 316.512 152.933C343.042 116.668 379.483 94.5 419.5 94.5C459.517 94.5 495.958 116.668 522.488 152.933C549.016 189.197 565.5 239.417 565.5 295Z",
    stroke: "white",
    strokeOpacity: frame > 7 ? 0.8 : frame > 5 ? 0.3 : 0.1,
    strokeWidth: "5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M299.939 262.805L419 478.5L538.5 261.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M298.5 182.5L418.871 230.054L540 182",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M298.5 182.5L299.939 262.805",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M540.001 182L538.501 261.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "299.914",
    cy: "182",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "540",
    cy: "182",
    r: "7",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: "M418.828 230L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 4 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M300 263.001L419 342.501",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 4 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M538.5 261.5L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 4 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.5 409L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 4 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M536.5 410L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 4 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M300 263L419 230",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 4 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M538.5 261.5L419 230",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 4 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "229.971",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "342.4",
    r: "7",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: "M538.5 261.5L536.5 410",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M419 478.5L536.5 410",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "537",
    cy: "263",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "537",
    cy: "409",
    r: "7",
    fill: "white"
  }))), frame > 1 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    d: "M301.501 409L300.001 263",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 2 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.501 409L419.001 478.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 2 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "477.576",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "301.914",
    cy: "263",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "301.444",
    cy: "409",
    r: "7",
    fill: "white"
  })))))), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_428_1188"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "840",
    height: "740",
    fill: "white"
  }))));
}
var HeadGuideSvg = /*#__PURE__*/forwardRef(function (_a, ref) {
  var _b = _a.borderColor,
    borderColor = _b === void 0 ? 'white' : _b,
    _c = _a.borderOpacity,
    borderOpacity = _c === void 0 ? 0.8 : _c,
    _d = _a.borderWidth,
    borderWidth = _d === void 0 ? 5 : _d,
    _e = _a.status,
    status = _e === void 0 ? 'ready' : _e,
    props = __rest(_a, ["borderColor", "borderOpacity", "borderWidth", "status"]);
  return /*#__PURE__*/React__default.createElement("svg", _assign({}, props, {
    ref: ref,
    viewBox: "271 92 297 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0_428_1188)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M565.5 295C565.5 350.583 549.016 400.803 522.488 437.067C495.958 473.332 459.517 495.5 419.5 495.5C379.483 495.5 343.042 473.332 316.512 437.067C289.984 400.803 273.5 350.583 273.5 295C273.5 239.417 289.984 189.197 316.512 152.933C343.042 116.668 379.483 94.5 419.5 94.5C459.517 94.5 495.958 116.668 522.488 152.933C549.016 189.197 565.5 239.417 565.5 295Z",
    stroke: borderColor,
    strokeOpacity: borderOpacity,
    strokeWidth: borderWidth
  }), status === 'success' && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("circle", {
    cx: "518.5",
    cy: "438.5",
    r: "25.5",
    fill: borderColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M504 440.5L512 448L531 427",
    stroke: "white",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), status === 'failure' && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("circle", {
    cx: "518.5",
    cy: "438.5",
    r: "25.5",
    fill: borderColor
  }), /*#__PURE__*/React__default.createElement("image", {
    href: "https://websdk-cdn-dev.idmission.com/assets/x.svg",
    x: "507",
    y: "427",
    width: "24",
    height: "24"
  })))), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_428_1188"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "840",
    height: "740",
    fill: "white"
  }))));
});
HeadGuideSvg.displayName = 'HeadGuideSvg';
var PulsingHeadGuideContainer = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  height: 100%;\n  max-height: 100%;\n\n  & > .idmSdkWaves {\n    position: absolute;\n    animation: ", " 2s ease-out infinite;\n    transform-style: preserve-3d;\n\n    &:nth-child(2) {\n      animation-delay: 0.66s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 1.33s;\n    }\n  }\n\n  & > .idmSdkWavesOrigin {\n    position: relative;\n  }\n"], ["\n  display: flex;\n  position: relative;\n  height: 100%;\n  max-height: 100%;\n\n  & > .idmSdkWaves {\n    position: absolute;\n    animation: ", " 2s ease-out infinite;\n    transform-style: preserve-3d;\n\n    &:nth-child(2) {\n      animation-delay: 0.66s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 1.33s;\n    }\n  }\n\n  & > .idmSdkWavesOrigin {\n    position: relative;\n  }\n"])), wavesAnimation);
function HeadGuide(_a) {
  var _b;
  var _c = _a.status,
    status = _c === void 0 ? 'ready' : _c,
    props = __rest(_a, ["status"]);
  var ref = useRef(null);
  var _d = useResizeObserver(),
    parentRef = _d.ref,
    parentHeight = _d.height;
  var _e = useState(),
    contentAspectRatio = _e[0],
    setContentAspectRatio = _e[1];
  useEffect(function () {
    if (!ref.current) return;
    var bbox = ref.current.getBBox();
    setContentAspectRatio((bbox.x + bbox.width + bbox.x) / (bbox.y + bbox.height + bbox.y));
  }, []);
  var scaledWidth = useMemo(function () {
    return contentAspectRatio && parentHeight && parentHeight / contentAspectRatio;
  }, [contentAspectRatio, parentHeight]);
  return /*#__PURE__*/React__default.createElement(PulsingHeadGuideContainer, {
    ref: parentRef
  }, status === 'ready' && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(HeadGuideSvg, _assign({}, props, {
    className: "idmSdkWaves",
    borderOpacity: 0.25,
    borderColor: "#287ec6",
    width: scaledWidth,
    height: parentHeight
  })), /*#__PURE__*/React__default.createElement(HeadGuideSvg, _assign({}, props, {
    className: "idmSdkWaves",
    borderOpacity: 0.25,
    borderColor: "#287ec6",
    width: scaledWidth,
    height: parentHeight
  })), /*#__PURE__*/React__default.createElement(HeadGuideSvg, _assign({}, props, {
    className: "idmSdkWaves",
    borderOpacity: 0.25,
    borderColor: "#287ec6",
    width: scaledWidth,
    height: parentHeight
  })))), /*#__PURE__*/React__default.createElement(HeadGuideSvg, _assign({}, props, {
    ref: ref,
    borderOpacity: 1,
    className: "idmSdkWavesOrigin ".concat((_b = props.className) !== null && _b !== void 0 ? _b : ''),
    status: status,
    width: scaledWidth,
    height: parentHeight
  })));
}
var AbsoluteSvg = styled.svg(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n"])));
var RelativeSvgContainer = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: ", ";\n"], ["\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: ", ";\n"])), function (props) {
  return props.$verticalAlign === 'bottom' ? 'flex-end' : 'center';
});
function SelfieCaptureAnimatedMask(_a) {
  var _b, _c, _d, _e, _f, _g;
  var _h = _a.frame,
    frame = _h === void 0 ? 0 : _h,
    _j = _a.borderWidth,
    borderWidth = _j === void 0 ? 5 : _j,
    _k = _a.borderColor,
    borderColor = _k === void 0 ? 'white' : _k,
    _l = _a.borderOpacity,
    borderOpacity = _l === void 0 ? 0.8 : _l,
    _m = _a.verticalAlign,
    verticalAlign = _m === void 0 ? 'center' : _m,
    _o = _a.status,
    status = _o === void 0 ? 'ready' : _o,
    props = __rest(_a, ["frame", "borderWidth", "borderColor", "borderOpacity", "verticalAlign", "status"]);
  var theme = useTheme();
  var satisfiedColor = (_d = (_c = (_b = theme.selfieCapture) === null || _b === void 0 ? void 0 : _b.guides) === null || _c === void 0 ? void 0 : _c.satisfiedColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
  var negativeColor = (_g = (_f = (_e = theme.selfieCapture) === null || _e === void 0 ? void 0 : _e.guides) === null || _f === void 0 ? void 0 : _f.failureColor) !== null && _g !== void 0 ? _g : 'var(--idm-color-negative-600)';
  var statusBorderColor = status === 'failure' ? negativeColor : status === 'success' ? satisfiedColor : borderColor;
  return /*#__PURE__*/React__default.createElement(RelativeSvgContainer, {
    "$verticalAlign": verticalAlign
  }, /*#__PURE__*/React__default.createElement(HeadGuide, _assign({
    borderOpacity: borderOpacity,
    borderWidth: borderWidth,
    borderColor: statusBorderColor,
    status: status
  }, props)), status === 'processing' && ( /*#__PURE__*/React__default.createElement(AbsoluteSvg, _assign({}, props, {
    viewBox: "271 92 297 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0_428_1188)"
  }, frame > 1 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, frame > 2 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, frame > 3 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, frame > 4 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    d: "M298.5 182.5L419 164.5L540 182",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "165",
    r: "7",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: "M299.939 262.805L419 478.5L538.5 261.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M298.5 182.5L418.871 230.054L540 182",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M298.5 182.5L299.939 262.805",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M540.001 182L538.501 261.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "299.914",
    cy: "182",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "540",
    cy: "182",
    r: "7",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: "M418.828 230L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M300 263.001L419 342.501",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M538.5 261.5L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.5 409L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M536.5 410L419 342.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M300 263L419 230",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M538.5 261.5L419 230",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "229.971",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "342.4",
    r: "7",
    fill: "white"
  }))), /*#__PURE__*/React__default.createElement("path", {
    d: "M538.5 261.5L536.5 410",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M419 478.5L536.5 410",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 3 && frame < 7 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "537",
    cy: "263",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "537",
    cy: "409",
    r: "7",
    fill: "white"
  }))), frame > 0 && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("path", {
    d: "M301.501 409L300.001 263",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 1 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.501 409L419.001 478.5",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: frame > 1 && frame < 6 ? 0.3 : 1
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "419",
    cy: "477.576",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "301.914",
    cy: "263",
    r: "7",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "301.444",
    cy: "409",
    r: "7",
    fill: "white"
  })))), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_428_1188"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "840",
    height: "740",
    fill: "white"
  }))))));
}
function SelfieCaptureAnimatedMaskWithStatus(_a) {
  var _b = _a.status,
    status = _b === void 0 ? 'ready' : _b,
    props = __rest(_a, ["status"]);
  var _c = useState(1),
    frame = _c[0],
    setFrame = _c[1];
  useEffect(function () {
    if (status !== 'processing') {
      setFrame(0);
      return;
    }
    setFrame(1);
    var interval = setInterval(function () {
      setFrame(function (n) {
        return (n + 1) % 6;
      });
    }, 250);
    return function () {
      clearInterval(interval);
    };
  }, [status]);
  return /*#__PURE__*/React__default.createElement(SelfieCaptureAnimatedMask, _assign({}, props, {
    frame: frame,
    status: status
  }));
}
var templateObject_1$k, templateObject_2$i, templateObject_3$e;

var FaceCaptureGuideContainer = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  position: fixed;\n  z-index: 1000;\n  width: 100dvw;\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  box-sizing: border-box;\n"], ["\n  position: fixed;\n  z-index: 1000;\n  width: 100dvw;\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  box-sizing: border-box;\n"])));
var FaceCaptureGuideInner = styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  position: relative;\n  height: 60%;\n"], ["\n  position: relative;\n  height: 60%;\n"])));
var FaceCaptureGuideOverlay = function FaceCaptureGuideOverlay(_a) {
  var _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.status,
    status = _c === void 0 ? 'ready' : _c,
    _d = _a.borderWidth,
    borderWidth = _d === void 0 ? 5 : _d,
    _e = _a.borderColor,
    borderColor = _e === void 0 ? 'white' : _e,
    _f = _a.borderOpacity,
    borderOpacity = _f === void 0 ? 0.8 : _f;
  return /*#__PURE__*/React__default.createElement(FaceCaptureGuideContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(FaceCaptureGuideInner, null, /*#__PURE__*/React__default.createElement(SelfieCaptureAnimatedMaskWithStatus, {
    status: status,
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderOpacity: borderOpacity,
    verticalAlign: "center"
  })));
};
var templateObject_1$j, templateObject_2$h;

var SelfieGuidanceModelsContext = /*#__PURE__*/createContext({
  start: function start() {
    return null;
  },
  stop: function stop() {
    return null;
  },
  onPredictionMade: function onPredictionMade() {
    return null;
  },
  canvasRef: {
    current: null
  },
  ready: false,
  error: null,
  modelDownloadProgress: 0
});
function SelfieGuidanceModelsProvider(_a) {
  var _this = this;
  var _b = _a.autoStart,
    autoStart = _b === void 0 ? true : _b,
    children = _a.children,
    throttleMs = _a.throttleMs,
    onModelError = _a.onModelError,
    _c = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _c === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _c,
    _d = _a.requireVerticalFaceCentering,
    requireVerticalFaceCentering = _d === void 0 ? true : _d;
  var _e = useCameraStore(useShallow(function (state) {
      return {
        videoRef: state.videoRef,
        videoLoaded: state.videoLoaded,
        cameraReady: state.cameraReady
      };
    })),
    videoRef = _e.videoRef,
    videoLoaded = _e.videoLoaded,
    cameraReady = _e.cameraReady;
  var canvasRef = useRef(null);
  var onPredictionHandler = useRef();
  var _f = useLoadFaceDetector({
      onModelError: onModelError,
      modelLoadTimeoutMs: modelLoadTimeoutMs,
      videoRef: videoRef
    }),
    ready = _f.ready,
    modelDownloadProgress = _f.modelDownloadProgress,
    modelError = _f.modelError;
  var _g = useFrameLoop(useCallback(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var vw, vh, ctx, prediction, processed, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!videoLoaded || !cameraReady || !ready || modelError || !videoRef.current || !canvasRef.current) return [2 /*return*/];
              vw = videoRef.current.videoWidth;
              vh = videoRef.current.videoHeight;
              ctx = canvasRef.current.getContext('2d');
              canvasRef.current.width = vw;
              canvasRef.current.height = vh;
              if (!(ctx && videoRef.current.readyState === 4)) return [3 /*break*/, 4];
              ctx.translate(vw, 0);
              ctx.scale(-1, 1);
              ctx.drawImage(videoRef.current, 0, 0, vw, vh);
              _c.label = 1;
            case 1:
              _c.trys.push([1, 3,, 4]);
              prediction = makeFaceDetectorPrediction(canvasRef.current);
              processed = processFaceDetectorPrediction({
                faces: (_a = prediction === null || prediction === void 0 ? void 0 : prediction.faces) !== null && _a !== void 0 ? _a : [],
                videoWidth: vw,
                videoHeight: vh,
                requireVerticalFaceCentering: requireVerticalFaceCentering
              });
              setLastFaceDetectionAt(new Date().getTime());
              return [4 /*yield*/, (_b = onPredictionHandler.current) === null || _b === void 0 ? void 0 : _b.call(onPredictionHandler, processed)];
            case 2:
              _c.sent();
              return [3 /*break*/, 4];
            case 3:
              e_1 = _c.sent();
              error('caught face detection error', e_1);
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    }, [cameraReady, modelError, ready, requireVerticalFaceCentering, videoLoaded, videoRef]), {
      throttleMs: throttleMs,
      autoStart: autoStart
    }),
    start = _g.start,
    stop = _g.stop;
  var onPredictionMade = useCallback(function (handler) {
    onPredictionHandler.current = handler;
  }, []);
  var value = useMemo(function () {
    return {
      start: start,
      stop: stop,
      ready: ready,
      canvasRef: canvasRef,
      onPredictionMade: onPredictionMade,
      error: modelError,
      modelDownloadProgress: modelDownloadProgress
    };
  }, [modelError, modelDownloadProgress, onPredictionMade, ready, start, stop]);
  return /*#__PURE__*/React.createElement(SelfieGuidanceModelsContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(InvisibleCanvas, {
    ref: canvasRef
  }), children);
}

var useTimeout = function useTimeout(durationMs, onTimeout, timeoutAverted, shouldWaitLonger, shouldStart) {
  if (shouldStart === void 0) {
    shouldStart = true;
  }
  var _a = useState(false),
    timedOut = _a[0],
    setTimedOut = _a[1];
  var _b = useState(),
    timeoutStartedAt = _b[0],
    setTimeoutStartedAt = _b[1];
  useEffect(function () {
    if (!durationMs || !shouldStart) return;
    setTimeoutStartedAt(new Date());
    var timer = setTimeout(function () {
      setTimedOut(true);
    }, durationMs);
    return function () {
      if (timer) clearTimeout(timer);
    };
  }, [durationMs, shouldStart]);
  useEffect(function () {
    if (!timedOut || timeoutAverted) return;
    if (!shouldWaitLonger) {
      onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
      return;
    }
    var t = setTimeout(function () {
      onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
    }, 120000);
    return function () {
      clearTimeout(t);
    };
  }, [onTimeout, shouldWaitLonger, timedOut, timeoutAverted]);
  return {
    timedOut: timedOut,
    timeoutStartedAt: timeoutStartedAt
  };
};

var SelfieCaptureFallback = function SelfieCaptureFallback(_a) {
  var onFinished = _a.onFinished,
    onCapture = _a.onCapture,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.colors,
    colors = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    rawVerbiage = _d === void 0 ? {} : _d,
    _e = _a.silentFallback,
    silentFallback = _e === void 0 ? false : _e,
    _f = _a.invalidSelfie,
    invalidSelfie = _f === void 0 ? false : _f,
    _g = _a.guidanceMessage,
    guidanceMessage = _g === void 0 ? undefined : _g;
  var _h = useState(null),
    image = _h[0],
    setImage = _h[1];
  var lastResizedFileRef = useRef(null);
  var fileInput = useRef(null);
  var _j = useState(false),
    loading = _j[0],
    setLoading = _j[1];
  var _k = useState(false),
    usingDocumentCapture = _k[0],
    setUsingDocumentCapture = _k[1];
  var _l = useFileState(),
    rawFile = _l.rawFile,
    fileInputOnChange = _l.fileInputOnChange;
  var resizedImageFile = useResizeMaxEdge({
    rawFile: rawFile
  }).resizedImageFile;
  useEffect(function resetAfterCapturingImage() {
    // we only want to run this IF the file has changed
    if (resizedImageFile && resizedImageFile !== lastResizedFileRef.current) {
      lastResizedFileRef.current = resizedImageFile;
      setImage(resizedImageFile);
      setLoading(true);
      onCapture === null || onCapture === void 0 ? void 0 : onCapture(resizedImageFile);
      onFinished === null || onFinished === void 0 ? void 0 : onFinished(resizedImageFile);
    }
  }, [resizedImageFile, onCapture, onFinished, loading]);
  var verbiage = useTranslations(rawVerbiage, {
    headingText: "We're having some trouble.",
    descriptionText: silentFallback ? 'Use your device camera to capture your face' : 'On-device capture guidance failed, please capture a selfie manually.',
    captureBtnText: 'Capture',
    doneBtnText: 'Done',
    doneBtnLoadingText: 'Verifying...',
    livenessFailedText: 'Live face not detected, please try again',
    livenessFailedReasonText: guidanceMessage,
    retryButtonText: 'Retry',
    retryCaptureButtonText: 'Retry capture'
  });
  useEffect(function triggerInputWhenInSilentFallbackMode() {
    var fallbackTimeout;
    if (silentFallback) {
      fallbackTimeout = setTimeout(function () {
        var _a;
        // using the input element, we want to click on it "immediately" which is 250ms to allow for even old browsers to finish connecting the input
        if (isMobile()) {
          (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click();
        } else {
          setUsingDocumentCapture(true);
        }
      }, 250);
    }
    return function () {
      clearTimeout(fallbackTimeout);
    };
  }, [silentFallback]);
  function onFileSelected(e) {
    var _a;
    if (!((_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0])) return;
    setImage('LOADING'); // this is to reduce some of the flicker - it isn't perfect since .readAsDataURL() is slow
    fileInputOnChange(e);
  }
  if (usingDocumentCapture || silentFallback && !!invalidSelfie && !image && !isMobile() // desktop silent fallback - not a very realistic situation
  ) {
    return /*#__PURE__*/React__default.createElement(DocumentCaptureWizard, {
      documents: [{
        title: invalidSelfie ? verbiage.livenessFailedText : verbiage.descriptionText
      }],
      onDocumentCaptured: function onDocumentCaptured(document) {
        var imageData = document.contentUrl;
        onCapture === null || onCapture === void 0 ? void 0 : onCapture(imageData);
        // todo: this a hack to address what is probably some sub-optimal coupling - fix
        setTimeout(function () {
          setImage(imageData);
          setUsingDocumentCapture(false);
        }, 0);
      }
    });
  }
  // todo: JN - we might be able to use the media stream instead if we clone it - as it stands today, we hae to use the camera to support iOS 16 devices
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("input", {
    ref: fileInput,
    type: "file",
    accept: "image/*",
    capture: "user",
    onChange: onFileSelected,
    hidden: true
  }), /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(StyledOverlayInner$1, {
    className: classNames.inner
  }, silentFallback ? invalidSelfie && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Heading$7, {
    className: classNames.heading
  }, verbiage.livenessFailedText), /*#__PURE__*/React__default.createElement(Description$2, {
    className: classNames.description
  }, verbiage.livenessFailedReasonText || verbiage.descriptionText))) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Heading$7, {
    className: classNames.heading
  }, invalidSelfie ? verbiage.livenessFailedText : verbiage.headingText), /*#__PURE__*/React__default.createElement(Description$2, {
    className: classNames.description
  }, verbiage.livenessFailedReasonText || verbiage.descriptionText))), image && image !== 'LOADING' && ( /*#__PURE__*/React__default.createElement(ImageContainer$6, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    src: image,
    alt: "",
    className: classNames.image
  }))), /*#__PURE__*/React__default.createElement(StyledButtonsRow$7, {
    className: classNames.buttonsRow
  }, image && !loading && !isMobile() && ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    className: classNames.retryCaptureBtn,
    finished: true,
    variant: "warning",
    onClick: function onClick() {
      var _a;
      if (isMobile()) {
        (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click();
      } else {
        setUsingDocumentCapture(true);
      }
    }
  }, verbiage.retryCaptureButtonText)), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    key: loading ? 'loading-btn' : 'ready-btn',
    className: !image ? classNames.captureBtn : classNames === null || classNames === void 0 ? void 0 : classNames.doneBtn,
    colors: !image ? colors.captureBtn : colors === null || colors === void 0 ? void 0 : colors.doneBtn,
    finished: !image ? true : !loading,
    onClick: function onClick() {
      var _a;
      if (isMobile()) {
        (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click();
      } else {
        if (!image) {
          setUsingDocumentCapture(true);
        } else {
          setLoading(true);
          onFinished === null || onFinished === void 0 ? void 0 : onFinished(image);
        }
      }
    }
  }, !image ? invalidSelfie ? verbiage.retryButtonText : verbiage.captureBtnText : loading ? verbiage.doneBtnLoadingText : verbiage.doneBtnText)))));
};
var StyledOverlayInner$1 = styled(OverlayInner$2)(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  justify-content: center;\n"], ["\n  justify-content: center;\n"])));
var Heading$7 = styled.h3(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  margin-bottom: 8px;\n"], ["\n  margin-bottom: 8px;\n"])));
var Description$2 = styled.p(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  margin-bottom: 8px;\n"], ["\n  margin-bottom: 8px;\n"])));
var ImageContainer$6 = styled(OverlayImageContainer)(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  margin-top: 32px;\n"], ["\n  margin-top: 32px;\n"])));
var StyledButtonsRow$7 = styled(ButtonsRow)(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  margin-top: 32px;\n"], ["\n  margin-top: 32px;\n"])));
var templateObject_1$i, templateObject_2$g, templateObject_3$d, templateObject_4$8, templateObject_5$4;

var initialState$3 = {
  busy: false,
  frame: null,
  prediction: null
};
var reducer$3 = function reducer(state, action) {
  switch (action.type) {
    case 'facesDetected':
      {
        if (state.busy) return state;
        return _assign(_assign({}, state), {
          prediction: action.payload,
          busy: action.payload.faceReady
        });
      }
    case 'captureStarted':
      return _assign(_assign({}, state), {
        busy: true
      });
    case 'captureCompleted':
      return _assign(_assign({}, state), {
        busy: false
      });
  }
};
var SelfieCapture = function SelfieCapture(_a) {
  var _b, _c, _d, _e, _f, _g;
  var onGuidanceSatisfied = _a.onGuidanceSatisfied,
    onGuidanceNotSatisfied = _a.onGuidanceNotSatisfied,
    onSelfieCaptureStarted = _a.onSelfieCaptureStarted,
    onSelfieCaptured = _a.onSelfieCaptured,
    onTimeout = _a.onTimeout,
    onExit = _a.onExit,
    _h = _a.timeoutDurationMs,
    timeoutDurationMs = _h === void 0 ? 15000 : _h,
    guidanceMessage = _a.guidanceMessage,
    guidanceSatisfied = _a.guidanceSatisfied,
    guidesComponent = _a.guidesComponent,
    _j = _a.shouldCapture,
    shouldCapture = _j === void 0 ? true : _j,
    _k = _a.classNames,
    classNames = _k === void 0 ? {} : _k,
    _l = _a.colors,
    colors = _l === void 0 ? {} : _l,
    _m = _a.verbiage,
    rawVerbiage = _m === void 0 ? {} : _m,
    _o = _a.debugMode,
    debugMode = _o === void 0 ? false : _o;
  var _p = useResizeObserver(),
    ref = _p.ref,
    _q = _p.width,
    width = _q === void 0 ? 1 : _q,
    _r = _p.height,
    height = _r === void 0 ? 1 : _r;
  var _s = useReducer(reducer$3, initialState$3),
    _t = _s[0],
    busy = _t.busy,
    prediction = _t.prediction,
    dispatch = _s[1];
  var lastPredictionCanvas = useRef(null);
  var _u = useCameraStore(useShallow(function (state) {
      return {
        camera: state.camera,
        cameraReady: state.cameraReady,
        videoRef: state.videoRef
      };
    })),
    camera = _u.camera,
    videoRef = _u.videoRef;
  var _v = useContext(SelfieGuidanceModelsContext),
    onPredictionMade = _v.onPredictionMade,
    canvasRef = _v.canvasRef,
    guidanceError = _v.error;
  onPredictionMade(useThrottledCallback(useCallback(function (prediction) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (shouldCapture && !busy) {
          drawToCanvas(lastPredictionCanvas.current, canvasRef.current);
          dispatch({
            type: 'facesDetected',
            payload: prediction
          });
        }
        return [2 /*return*/];
      });
    });
  }, [canvasRef, shouldCapture, busy]), 16));
  useEffect(function () {
    if (prediction === null || prediction === void 0 ? void 0 : prediction.faceReady) {
      onGuidanceSatisfied === null || onGuidanceSatisfied === void 0 ? void 0 : onGuidanceSatisfied();
    } else {
      onGuidanceNotSatisfied === null || onGuidanceNotSatisfied === void 0 ? void 0 : onGuidanceNotSatisfied();
    }
  }, [onGuidanceNotSatisfied, onGuidanceSatisfied, prediction === null || prediction === void 0 ? void 0 : prediction.faceReady]);
  useEffect(function () {
    if (!(prediction === null || prediction === void 0 ? void 0 : prediction.faceReady)) return;
    var timer = setTimeout(function () {
      dispatch({
        type: 'captureStarted'
      });
      onSelfieCaptureStarted === null || onSelfieCaptureStarted === void 0 ? void 0 : onSelfieCaptureStarted();
      var frame = lastPredictionCanvas.current;
      if (!frame) return;
      var ctx = frame.getContext('2d');
      if (!ctx) return;
      var imageData = ctx.getImageData(0, 0, frame.width, frame.height);
      onSelfieCaptured === null || onSelfieCaptured === void 0 ? void 0 : onSelfieCaptured(imageData, prediction.face);
      clearCanvas(frame);
      dispatch({
        type: 'captureCompleted'
      });
    }, 100);
    return function () {
      if (timer) clearTimeout(timer);
    };
  }, [onSelfieCaptureStarted, onSelfieCaptured, prediction]);
  var _w = useTimeout(timeoutDurationMs, onTimeout),
    timedOut = _w.timedOut,
    timeoutStartedAt = _w.timeoutStartedAt;
  var debugScalingDetails = useDebugScalingDetails({
    enabled: debugMode,
    pageWidth: width,
    pageHeight: height,
    videoWidth: (_c = (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) !== null && _c !== void 0 ? _c : 0,
    videoHeight: (_e = (_d = videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) !== null && _e !== void 0 ? _e : 0
  });
  colors.guidesUnsatisfiedColor || (colors.guidesUnsatisfiedColor = 'white');
  colors.guidesSatisfiedColor || (colors.guidesSatisfiedColor = 'green');
  var verbiage = useTranslations(rawVerbiage, {
    guidanceHoldStillText: 'Hold still for a few seconds...',
    guidanceLookStraightText: 'Look straight into the camera...',
    guidanceMoveBackText: 'Move back...',
    guidanceMoveForwardText: 'Move forward...',
    guidanceMoveToCenterText: 'Move to the center...',
    guidanceNoFaceDetectedText: 'Waiting for face to be detected...',
    guidanceNotStableText: 'Please hold still...'
  });
  var satisfied = (_f = prediction === null || prediction === void 0 ? void 0 : prediction.faceReady) !== null && _f !== void 0 ? _f : false;
  if (typeof guidanceSatisfied === 'boolean') satisfied = guidanceSatisfied;
  guidanceMessage || (guidanceMessage = satisfied ? verbiage.guidanceHoldStillText : (prediction === null || prediction === void 0 ? void 0 : prediction.faceLookingAway) ? verbiage.guidanceLookStraightText : (prediction === null || prediction === void 0 ? void 0 : prediction.faceTooClose) ? verbiage.guidanceMoveBackText : (prediction === null || prediction === void 0 ? void 0 : prediction.faceTooFar) ? verbiage.guidanceMoveForwardText : (prediction === null || prediction === void 0 ? void 0 : prediction.faceNotCentered) ? verbiage.guidanceMoveToCenterText : (prediction === null || prediction === void 0 ? void 0 : prediction.faceNotDetected) ? verbiage.guidanceNoFaceDetectedText : !(prediction === null || prediction === void 0 ? void 0 : prediction.faceIsStable) ? verbiage.guidanceNotStableText : '');
  if (guidanceError) {
    return /*#__PURE__*/React__default.createElement(SelfieCaptureFallback, {
      classNames: classNames.fallback
    });
  }
  var GuidesComponent = guidesComponent !== null && guidesComponent !== void 0 ? guidesComponent : FaceCaptureGuideOverlay;
  return /*#__PURE__*/React__default.createElement(PageContainer, {
    ref: ref,
    className: "flex ".concat((_g = classNames.container) !== null && _g !== void 0 ? _g : '')
  }, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: lastPredictionCanvas
  }), /*#__PURE__*/React__default.createElement(GuidesComponent, {
    classNames: classNames.guides,
    status: satisfied ? 'processing' : 'ready'
  }), guidanceMessage !== '' && ( /*#__PURE__*/React__default.createElement(GuidanceMessageContainer, {
    className: classNames.guidanceMessageContainer
  }, /*#__PURE__*/React__default.createElement(GuidanceMessage, {
    "$variant": satisfied ? 'positive' : 'negative',
    className: classNames.guidanceMessage
  }, guidanceMessage))), debugMode && (prediction === null || prediction === void 0 ? void 0 : prediction.face) && ( /*#__PURE__*/React__default.createElement(ObjectDetectionDebugOverlayDiv, null, /*#__PURE__*/React__default.createElement(SelfieCaptureFaceDebugBox, {
    face: prediction.face,
    scaling: debugScalingDetails,
    color: satisfied ? 'green' : 'red'
  }))), debugMode && ( /*#__PURE__*/React__default.createElement(DebugStatsPane, null, camera ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\u2705 Camera: ", camera.label, " (", camera.width, "x", camera.height, ")")) : '❌ Camera not ready', /*#__PURE__*/React__default.createElement("br", null), !(prediction === null || prediction === void 0 ? void 0 : prediction.faceNotCentered) ? '✅' : '❌', " Face Centered", /*#__PURE__*/React__default.createElement("br", null), !(prediction === null || prediction === void 0 ? void 0 : prediction.faceTooClose) && !(prediction === null || prediction === void 0 ? void 0 : prediction.faceTooFar) ? '✅' : '❌', ' ', "Face", ' ', (prediction === null || prediction === void 0 ? void 0 : prediction.faceTooClose) ? 'Too Close' : (prediction === null || prediction === void 0 ? void 0 : prediction.faceTooFar) ? 'Too Far' : 'Distance Correct', /*#__PURE__*/React__default.createElement("br", null), !(prediction === null || prediction === void 0 ? void 0 : prediction.faceLookingAway) ? '✅' : '❌', " Face Looking Forward", /*#__PURE__*/React__default.createElement("br", null), !(prediction === null || prediction === void 0 ? void 0 : prediction.faceIsStable) ? '✅' : '❌', " Face Is Stable", /*#__PURE__*/React__default.createElement("br", null), !timedOut ? '✅' : '❌', " Time Remaining:", ' ', Math.max(0, timeoutDurationMs - (new Date().getTime() - (timeoutStartedAt !== null && timeoutStartedAt !== void 0 ? timeoutStartedAt : new Date()).getTime())), "ms")), /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onExit,
    className: classNames.exitCaptureBtn
  }));
};

var initialState$2 = {
  frame: null,
  face: null,
  requestState: 'CAPTURING',
  requestError: null,
  imageUrl: null,
  faceLive: false,
  eyeCoveringDetected: false,
  maskDetected: false,
  headCoveringDetected: false,
  phoneDetected: false,
  timesLivenessCheckFailed: 0
};
var reducer$2 = function reducer(state, action) {
  var _a, _b;
  switch (action.type) {
    case 'resetLivenessCheck':
      return _assign(_assign({}, initialState$2), {
        timesLivenessCheckFailed: state.timesLivenessCheckFailed
      });
    case 'guidanceUnsatisfied':
      return _assign({}, state);
    case 'guidanceSatisfied':
      return _assign(_assign({}, state), {
        requestState: 'GUIDANCE_SATISFIED'
      });
    case 'selfieCaptureStarted':
      return _assign(_assign({}, state), {
        requestState: 'CAPTURE_STARTED'
      });
    case 'livenessReady':
      {
        var allowedStates = ['CAPTURE_STARTED'];
        if (allowedStates.includes(state.requestState)) {
          return _assign(_assign({}, state), {
            requestState: 'CAPTURED',
            frame: action.payload.frame,
            face: action.payload.face
          });
        } else {
          return state;
        }
      }
    case 'livenessChecking':
      return _assign(_assign({}, state), {
        requestState: 'IN_PROGRESS'
      });
    case 'livenessChecked':
      {
        var _c = action.payload.response,
          _d = _c.status,
          statusCode = _d.statusCode,
          statusMessage = _d.statusMessage,
          errorData = _d.errorData,
          resultData = _c.resultData;
        if (statusCode !== '000') {
          return _assign(_assign({}, state), {
            requestState: 'ERROR',
            requestError: new Error("".concat(statusMessage, ": ").concat(errorData))
          });
        }
        var faceLive = ['Live Face Detected', 'Approved'].includes(resultData.verificationResult);
        var eyeCoveringDetected = resultData.eyeCovering === 'true';
        var maskDetected = resultData.faceMask === 'true';
        var headCoveringDetected = resultData.headCovering === 'true';
        var phoneDetected = resultData.cellPhone === 'true';
        var livenessCheckPassed = faceLive && !eyeCoveringDetected && !maskDetected && !headCoveringDetected;
        var requestState = livenessCheckPassed ? 'PASSED' : 'FAILED';
        var timesLivenessCheckFailed = state.timesLivenessCheckFailed;
        if (livenessCheckPassed) {
          timesLivenessCheckFailed = 0;
        } else {
          timesLivenessCheckFailed += 1;
        }
        return _assign(_assign({}, state), {
          frame: (_a = action.payload.frame) !== null && _a !== void 0 ? _a : null,
          face: (_b = action.payload.face) !== null && _b !== void 0 ? _b : null,
          imageUrl: action.payload.imageUrl,
          requestState: requestState,
          faceLive: faceLive,
          eyeCoveringDetected: eyeCoveringDetected,
          maskDetected: maskDetected,
          headCoveringDetected: headCoveringDetected,
          phoneDetected: phoneDetected,
          timesLivenessCheckFailed: timesLivenessCheckFailed
        });
      }
    case 'livenessCheckFailed':
      return _assign(_assign({}, state), {
        requestState: 'ERROR',
        requestError: action.payload.error
      });
    default:
      return state;
  }
};
var FaceLivenessCapture = function FaceLivenessCapture(_a) {
  var _b, _c, _d, _e;
  var onCapture = _a.onCapture,
    onLivenessChecked = _a.onLivenessChecked,
    onSuccess = _a.onSuccess,
    onFailure = _a.onFailure,
    onTimeout = _a.onTimeout,
    onDenied = _a.onDenied,
    onExit = _a.onExit,
    _f = _a.timeoutDurationMs,
    timeoutDurationMs = _f === void 0 ? 15000 : _f,
    _g = _a.silentFallback,
    silentFallback = _g === void 0 ? false : _g,
    guidesComponent = _a.guidesComponent,
    disableCapturePreview = _a.disableCapturePreview,
    _h = _a.classNames,
    classNames = _h === void 0 ? {} : _h,
    _j = _a.colors,
    colors = _j === void 0 ? {} : _j,
    _k = _a.verbiage,
    rawVerbiage = _k === void 0 ? {} : _k,
    debugMode = _a.debugMode;
  var _l = useContext(SubmissionContext),
    checkLiveness = _l.checkLiveness,
    submissionError = _l.submissionError;
  var modelError = useContext(SelfieGuidanceModelsContext).error;
  var _m = useReducer(reducer$2, initialState$2),
    state = _m[0],
    dispatch = _m[1];
  var _o = useState(null),
    imageUrl = _o[0],
    setImageUrl = _o[1];
  var rawCanvas = useRef(null);
  var cropCanvas = useRef(null);
  var resizeCanvas = useRef(null);
  var theme = useTheme();
  var onSelfieCaptureStarted = useCallback(function () {
    dispatch({
      type: 'selfieCaptureStarted'
    });
  }, []);
  var onSelfieCaptured = useCallback(function (frame, face) {
    onCapture === null || onCapture === void 0 ? void 0 : onCapture();
    dispatch({
      type: 'livenessReady',
      payload: {
        frame: frame,
        face: face
      }
    });
  }, [onCapture]);
  var frame = state.frame,
    face = state.face;
  var isReady = state.requestState === 'CAPTURED';
  var isPassed = state.requestState === 'PASSED';
  useEffect(function checkLivenessIfPossible() {
    var _this = this;
    if (!frame || !face || !isReady || submissionError) return;
    dispatch({
      type: 'livenessChecking'
    });
    (function () {
      return __awaiter(_this, void 0, void 0, function () {
        var imageUrl_1, response, _a, e_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 3,, 4]);
              imageUrl_1 = cropToShoulders(rawCanvas.current, cropCanvas.current, resizeCanvas.current, frame, face, 0.92, 600);
              setImageUrl(imageUrl_1);
              _a = checkLiveness;
              return [4 /*yield*/, dataUrlToBase64(imageUrl_1)];
            case 1:
              return [4 /*yield*/, _a.apply(void 0, [_b.sent()])];
            case 2:
              response = _b.sent();
              onLivenessChecked === null || onLivenessChecked === void 0 ? void 0 : onLivenessChecked(response);
              dispatch({
                type: 'livenessChecked',
                payload: {
                  frame: frame,
                  face: face,
                  imageUrl: imageUrl_1,
                  response: response
                }
              });
              return [3 /*break*/, 4];
            case 3:
              e_1 = _b.sent();
              dispatch({
                type: 'livenessCheckFailed',
                payload: {
                  error: e_1
                }
              });
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    })();
  }, [checkLiveness, face, frame, isReady, onLivenessChecked, submissionError]);
  var onFallbackImageCaptured = useCallback(function (imageUrl) {
    return __awaiter(void 0, void 0, void 0, function () {
      var imageData, response, e_2;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            dispatch({
              type: 'livenessChecking'
            });
            _b.label = 1;
          case 1:
            _b.trys.push([1, 4,, 5]);
            return [4 /*yield*/, dataUrlToBase64(imageUrl)];
          case 2:
            imageData = _b.sent();
            return [4 /*yield*/, checkLiveness(imageData)];
          case 3:
            response = _b.sent();
            if (((_a = response === null || response === void 0 ? void 0 : response.resultData) === null || _a === void 0 ? void 0 : _a.verificationResult) !== 'Live Face Detected') {
              onFailure === null || onFailure === void 0 ? void 0 : onFailure();
              onDenied === null || onDenied === void 0 ? void 0 : onDenied();
            }
            dispatch({
              type: 'livenessChecked',
              payload: {
                imageUrl: imageUrl,
                response: response
              }
            });
            return [3 /*break*/, 5];
          case 4:
            e_2 = _b.sent();
            dispatch({
              type: 'livenessCheckFailed',
              payload: {
                error: e_2
              }
            });
            return [3 /*break*/, 5];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }, [checkLiveness, onFailure, onDenied]);
  useEffect(function () {
    if (state.requestState === 'FAILED' || state.requestState === 'ERROR') {
      setTimeout(function () {
        dispatch({
          type: 'resetLivenessCheck'
        });
      }, 1000);
    }
  }, [state.requestState]);
  useEffect(function callSuccessIfAvailable() {
    if (isPassed && state.imageUrl) onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(state.imageUrl);
  }, [onSuccess, state.imageUrl, isPassed]);
  useEffect(function timeoutOnTooManyLivenessCheckFailures() {
    if (modelError) return;
    var allowedFailures = 2;
    if (state.timesLivenessCheckFailed > allowedFailures) {
      onFailure === null || onFailure === void 0 ? void 0 : onFailure();
      onDenied === null || onDenied === void 0 ? void 0 : onDenied();
    }
  }, [modelError, onFailure, onDenied, state.timesLivenessCheckFailed]);
  var callOnTimeoutHooks = useCallback(function () {
    onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
    onDenied === null || onDenied === void 0 ? void 0 : onDenied();
  }, [onDenied, onTimeout]);
  useTimeout(timeoutDurationMs, callOnTimeoutHooks, state.requestState === 'PASSED' || !!modelError, state.requestState === 'IN_PROGRESS');
  var verbiage = useTranslations(rawVerbiage, {
    guidanceLivenessCheckFailedText: 'Could not verify your face.',
    guidanceLivenessCheckErrorText: 'An error occurred while verifying your face.',
    guidanceRemoveEyeCoveringsText: 'Please remove your eye coverings (sunglasses, eye patch, etc.)...',
    guidanceRemoveHeadCoveringsText: 'Please remove your head coverings (hat, scarf, etc.)...',
    guidanceRemoveMaskText: 'Please remove your mask...',
    progressPreviewText: 'Processing...'
  });
  var guidanceMessage = state.eyeCoveringDetected ? verbiage.guidanceRemoveEyeCoveringsText : state.headCoveringDetected ? verbiage.guidanceRemoveHeadCoveringsText : state.maskDetected ? verbiage.guidanceRemoveMaskText : state.requestState === 'FAILED' ? verbiage.guidanceLivenessCheckFailedText : state.requestState === 'ERROR' ? verbiage.guidanceLivenessCheckErrorText : undefined;
  disableCapturePreview || (disableCapturePreview = (_d = (_c = (_b = theme.selfieCapture) === null || _b === void 0 ? void 0 : _b.capturePreview) === null || _c === void 0 ? void 0 : _c.disabled) !== null && _d !== void 0 ? _d : false);
  var guidesByRequestState = useCallback(function (props) {
    var GuidesComponent = guidesComponent !== null && guidesComponent !== void 0 ? guidesComponent : FaceCaptureGuideOverlay;
    var status = ['IN_PROGRESS', 'CAPTURE_STARTED', 'GUIDANCE_SATISFIED', 'CAPTURED'].includes(state.requestState) ? 'processing' : ['FAILED', 'ERROR'].includes(state.requestState) ? 'failure' : 'ready';
    return /*#__PURE__*/React__default.createElement(GuidesComponent, _assign({}, props, {
      status: status
    }));
  }, [guidesComponent, state.requestState]);
  var onGuidanceSatisfied = useCallback(function () {
    dispatch({
      type: 'guidanceSatisfied'
    });
  }, []);
  var onGuidanceNotSatisfied = useCallback(function () {
    dispatch({
      type: 'guidanceUnsatisfied'
    });
  }, []);
  if (modelError) {
    return /*#__PURE__*/React__default.createElement(SelfieCaptureFallback, {
      key: state.timesLivenessCheckFailed,
      onFinished: onFallbackImageCaptured,
      silentFallback: silentFallback,
      invalidSelfie: !!state.timesLivenessCheckFailed,
      guidanceMessage: guidanceMessage
    });
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: rawCanvas
  }), /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: cropCanvas
  }), /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: resizeCanvas
  }), /*#__PURE__*/React__default.createElement(SelfieCapture, {
    shouldCapture: state.requestState === 'CAPTURING',
    onSelfieCaptureStarted: onSelfieCaptureStarted,
    onSelfieCaptured: onSelfieCaptured,
    onExit: onExit,
    timeoutDurationMs: timeoutDurationMs,
    guidanceMessage: guidanceMessage,
    guidanceSatisfied: guidanceMessage ? false : undefined,
    onGuidanceSatisfied: onGuidanceSatisfied,
    onGuidanceNotSatisfied: onGuidanceNotSatisfied,
    guidesComponent: guidesByRequestState,
    classNames: classNames,
    colors: colors,
    verbiage: verbiage,
    debugMode: debugMode
  }), debugMode && !disableCapturePreview && imageUrl && ( /*#__PURE__*/React__default.createElement(SelfieProgressPreview, {
    classNames: classNames.imagePreview,
    imageUrl: imageUrl,
    text: (_e = verbiage.progressPreviewText) !== null && _e !== void 0 ? _e : ''
  })));
};

var FaceLivenessSuccess = function FaceLivenessSuccess(_a) {
  var imageUrl = _a.imageUrl,
    onDoneClick = _a.onDoneClick,
    onRetryClick = _a.onRetryClick,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.colors,
    colors = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    rawVerbiage = _d === void 0 ? {} : _d;
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Face liveness has been verified!',
    retryBtnText: 'Retry',
    doneBtnText: 'Done'
  });
  var imageContainerRef = useRef(null);
  var onImageLoaded = useCallback(function (e) {
    var _a;
    if (!imageContainerRef.current) return;
    var containerHeight = imageContainerRef.current.getBoundingClientRect().height;
    var imageHeight = e.currentTarget.getBoundingClientRect().height;
    (_a = imageContainerRef.current) === null || _a === void 0 ? void 0 : _a.scroll(0, (imageHeight - containerHeight) / 2);
  }, []);
  return /*#__PURE__*/React__default.createElement(GrayOverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(FlexCard, null, /*#__PURE__*/React__default.createElement(ImageContainer$5, {
    className: classNames.imageContainer,
    ref: imageContainerRef
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: verbiage.headingText,
    src: imageUrl,
    className: classNames.image,
    onLoad: onImageLoaded
  })), /*#__PURE__*/React__default.createElement(Heading$6, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ButtonsColumn, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(WideButton, {
    variant: "positive",
    onClick: onDoneClick,
    colors: colors.doneBtn,
    className: classNames.doneBtn,
    finished: true
  }, verbiage.doneBtnText), /*#__PURE__*/React__default.createElement(WideBorderButton, {
    variant: "secondary",
    onClick: onRetryClick,
    colors: colors.retryBtn,
    className: classNames.retryBtn,
    finished: true
  }, verbiage.retryBtnText)))));
};
var ImageContainer$5 = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  position: relative;\n  flex-grow: 1;\n  margin-bottom: 25px;\n  max-width: 100dvw;\n  max-height: 100dvh;\n  overflow-y: auto;\n  border-radius: 12px;\n\n  & > img,\n  & > svg {\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n    display: block;\n    border-radius: 12px;\n  }\n"], ["\n  position: relative;\n  flex-grow: 1;\n  margin-bottom: 25px;\n  max-width: 100dvw;\n  max-height: 100dvh;\n  overflow-y: auto;\n  border-radius: 12px;\n\n  & > img,\n  & > svg {\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n    display: block;\n    border-radius: 12px;\n  }\n"])));
var Heading$6 = styled.h3(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  font-size: 1.2rem;\n  margin: 0;\n"], ["\n  font-size: 1.2rem;\n  margin: 0;\n"])));
var templateObject_1$h, templateObject_2$f;

var FaceLivenessFailure = function FaceLivenessFailure(_a) {
  var _b = _a.canRetry,
    canRetry = _b === void 0 ? true : _b,
    onRetryClick = _a.onRetryClick,
    onExitClick = _a.onExitClick,
    _c = _a.assets,
    assets = _c === void 0 ? {} : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  assets.imageUrl || (assets.imageUrl = "".concat(DEFAULT_CDN_URL, "/Face_Not_Detected.svg"));
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Live face not detected, please try again',
    retryBtnText: 'Retry',
    exitBtnText: 'Exit'
  });
  return /*#__PURE__*/React__default.createElement(GrayOverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(Card, null, /*#__PURE__*/React__default.createElement(ImageContainer$4, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: verbiage.headingText,
    src: assets.imageUrl,
    className: classNames.image
  })), /*#__PURE__*/React__default.createElement(Heading$5, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ButtonsColumn, {
    className: classNames.buttonsRow
  }, canRetry && ( /*#__PURE__*/React__default.createElement(WideButton, {
    variant: "secondary",
    className: classNames.retryBtn,
    onClick: onRetryClick,
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryBtnText)), /*#__PURE__*/React__default.createElement(WideBorderButton, {
    variant: "secondary",
    className: classNames.exitBtn,
    onClick: onExitClick,
    colors: colors.exitBtn,
    finished: true
  }, verbiage.exitBtnText)))));
};
var ImageContainer$4 = styled(OverlayImageContainer)(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  max-height: calc(100vh - 185px);\n"], ["\n  max-height: calc(100vh - 185px);\n"])));
var Heading$5 = styled.h3(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  margin-bottom: 36px;\n"], ["\n  margin-bottom: 36px;\n"])));
var templateObject_1$g, templateObject_2$e;

var MicrophoneAccessDeniedOverlay = function MicrophoneAccessDeniedOverlay(_a) {
  var _b;
  var _c = _a.assets,
    assets = _c === void 0 ? {} : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  var requestMicrophoneAccess = useCameraStore(function (state) {
    return state.requestMicrophoneAccess;
  });
  assets.imageUrl || (assets.imageUrl = DEFAULT_CDN_URL + '/microphone-disable-icon.svg');
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Your microphone permission is disabled',
    descriptionText: 'This application requires access to your microphone to continue. ' + 'Please accept the permission once prompted by the browser. ' + 'If the browser does not prompt for microphone permissions, you must go to settings ' + 'and provide microphone access to the current browser.',
    retryBtnText: 'Retry'
  });
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: "flex ".concat((_b = classNames.container) !== null && _b !== void 0 ? _b : '')
  }, /*#__PURE__*/React__default.createElement(StyledOverlayInner, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(StyledOverlayImageContainer$1, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    src: assets.imageUrl,
    alt: "",
    className: classNames.image
  })), /*#__PURE__*/React__default.createElement("h3", {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(Description$1, {
    className: classNames.description
  }, verbiage.descriptionText), /*#__PURE__*/React__default.createElement(RetryButton, {
    variant: "warning",
    onClick: requestMicrophoneAccess,
    colors: colors.retryBtn,
    className: classNames.retryBtn,
    finished: true
  }, verbiage.retryBtnText)));
};
var StyledOverlayInner = styled(OverlayInner$2)(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  max-width: 500px;\n  height: auto;\n  margin: auto;\n"], ["\n  max-width: 500px;\n  height: auto;\n  margin: auto;\n"])));
var StyledOverlayImageContainer$1 = styled(OverlayImageContainer)(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  flex-grow: 0;\n"], ["\n  flex-grow: 0;\n"])));
var Description$1 = styled.p(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  line-height: 1.5;\n  margin-bottom: 50px;\n"], ["\n  line-height: 1.5;\n  margin-bottom: 50px;\n"])));
var RetryButton = styled(LoaderButton)(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  width: 200px;\n  margin: 0 auto;\n"], ["\n  width: 200px;\n  margin: 0 auto;\n"])));
var templateObject_1$f, templateObject_2$d, templateObject_3$c, templateObject_4$7;

var SelfieCaptureLoadingOverlayLegacy = function SelfieCaptureLoadingOverlayLegacy(_a) {
  var onDismissed = _a.onDismissed,
    onUserCancel = _a.onUserCancel,
    _b = _a.waitForIdCaptureModels,
    waitForIdCaptureModels = _b === void 0 ? false : _b,
    _c = _a.assets,
    assets = _c === void 0 ? {} : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  var _g = useCameraStore(useShallow(function (state) {
      return {
        cameraReady: state.cameraReady,
        cameraAccessDenied: state.cameraAccessDenied,
        microphoneAccessDenied: state.microphoneAccessDenied
      };
    })),
    cameraReady = _g.cameraReady,
    cameraAccessDenied = _g.cameraAccessDenied,
    microphoneAccessDenied = _g.microphoneAccessDenied;
  var _h = useContext(SelfieGuidanceModelsContext),
    modelsReady = _h.ready,
    modelDownloadProgress = _h.modelDownloadProgress;
  var idCaptureModelsContext = useContext(IdCaptureModelsContext);
  assets.instructionImageUrl || (assets.instructionImageUrl = "".concat(DEFAULT_CDN_URL, "/Selfie-Image-1.png"));
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Use your device camera to capture your face',
    removeEyeCoveringsText: 'Remove Sunglasses & Hat',
    avoidExcessiveBacklightingText: 'Avoid Excessive Backlighting',
    continueText: 'Continue',
    cameraInitializingText: 'Camera initializing...',
    downloadingText: 'Downloading...',
    modelsWarmingUpText: 'Models warming up...'
  });
  var _j = useState(false),
    dismissed = _j[0],
    setDismissed = _j[1];
  if (dismissed) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  if (cameraAccessDenied) {
    return /*#__PURE__*/React__default.createElement(CameraAccessDeniedOverlay, {
      assets: assets.cameraAccessDenied,
      classNames: classNames.cameraAccessDenied,
      colors: colors.cameraAccessDenied,
      verbiage: rawVerbiage.cameraAccessDenied
    });
  }
  if (microphoneAccessDenied) {
    return /*#__PURE__*/React__default.createElement(MicrophoneAccessDeniedOverlay, {
      assets: assets.microphoneAccessDenied,
      classNames: classNames.microphoneAccessDenied,
      colors: colors.microphoneAccessDenied,
      verbiage: rawVerbiage.microphoneAccessDenied
    });
  }
  var allModelsReady = modelsReady && (!waitForIdCaptureModels || (idCaptureModelsContext === null || idCaptureModelsContext === void 0 ? void 0 : idCaptureModelsContext.ready));
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: classNames.heading
  }, verbiage.headingText), onUserCancel && ( /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onUserCancel,
    className: classNames.cancelBtn
  })), /*#__PURE__*/React__default.createElement(StyledGuidanceMessage$1, null, verbiage.removeEyeCoveringsText, /*#__PURE__*/React__default.createElement("br", null), verbiage.avoidExcessiveBacklightingText), /*#__PURE__*/React__default.createElement(OverlayImageContainer, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    className: classNames.image,
    alt: verbiage.headingText,
    src: assets.instructionImageUrl
  })), /*#__PURE__*/React__default.createElement(StyledButtonsRow$6, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    disabled: !cameraReady || !allModelsReady,
    finished: cameraReady && allModelsReady,
    className: classNames.continueBtn,
    colors: colors.continueBtn,
    onClick: function onClick() {
      setDismissed(true);
      onDismissed === null || onDismissed === void 0 ? void 0 : onDismissed();
    }
  }, cameraReady && allModelsReady ? verbiage.continueText : allModelsReady ? verbiage.cameraInitializingText : modelDownloadProgress >= 100 ? "".concat(verbiage.modelsWarmingUpText) : "".concat(verbiage.downloadingText, " (").concat(modelDownloadProgress, "%)")))));
};
var StyledGuidanceMessage$1 = styled(GuidanceMessage)(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  padding: 12px 24px;\n  font-weight: normal;\n  line-height: 1.5;\n  margin-bottom: -30px;\n"], ["\n  padding: 12px 24px;\n  font-weight: normal;\n  line-height: 1.5;\n  margin-bottom: -30px;\n"])));
var StyledButtonsRow$6 = styled(ButtonsRow)(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  flex-direction: column;\n  padding-top: 25px;\n"], ["\n  flex-direction: column;\n  padding-top: 25px;\n"])));
var templateObject_1$e, templateObject_2$c;

var legacyInstructionImageUrl = "".concat(DEFAULT_CDN_URL, "/Selfie-Image-1.png");
var SelfieCaptureLoadingOverlayDefault = function SelfieCaptureLoadingOverlayDefault(_a) {
  var onDismissed = _a.onDismissed,
    onUserCancel = _a.onUserCancel,
    customOverlayContent = _a.customOverlayContent,
    _b = _a.waitForIdCaptureModels,
    waitForIdCaptureModels = _b === void 0 ? false : _b,
    _c = _a.assets,
    assets = _c === void 0 ? {} : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  var _g = useCameraStore(useShallow(function (state) {
      return {
        cameraReady: state.cameraReady,
        cameraAccessDenied: state.cameraAccessDenied,
        microphoneAccessDenied: state.microphoneAccessDenied
      };
    })),
    cameraReady = _g.cameraReady,
    cameraAccessDenied = _g.cameraAccessDenied,
    microphoneAccessDenied = _g.microphoneAccessDenied;
  var _h = useContext(SelfieGuidanceModelsContext),
    modelsReady = _h.ready,
    modelDownloadProgress = _h.modelDownloadProgress;
  var idCaptureModelsContext = useContext(IdCaptureModelsContext);
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Use your device camera to capture your face',
    removeEyeCoveringsText: 'Remove Sunglasses & Hat',
    avoidExcessiveBacklightingText: 'Avoid Excessive Backlighting',
    continueText: "Let's Go!",
    cameraInitializingText: 'Accessing camera...',
    cameraInitializedText: 'Camera ready',
    downloadingText: 'Downloading...',
    modelsWarmingUpText: 'Loading guided capture experience...',
    modelsReadyText: 'Guided capture experience ready'
  });
  var _j = useState(0),
    headingTextIndex = _j[0],
    setHeadingTextIndex = _j[1];
  var headingText = [verbiage.headingText, verbiage.removeEyeCoveringsText, verbiage.avoidExcessiveBacklightingText][headingTextIndex];
  useEffect(function () {
    setInterval(function () {
      setHeadingTextIndex(function (n) {
        return (n + 1) % 3;
      });
    }, 3000);
  }, []);
  var _k = useState(false),
    dismissed = _k[0],
    setDismissed = _k[1];
  if (dismissed) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  if (cameraAccessDenied) {
    return /*#__PURE__*/React__default.createElement(CameraAccessDeniedOverlay, {
      assets: assets.cameraAccessDenied,
      classNames: classNames.cameraAccessDenied,
      colors: colors.cameraAccessDenied,
      verbiage: rawVerbiage.cameraAccessDenied
    });
  }
  if (microphoneAccessDenied) {
    return /*#__PURE__*/React__default.createElement(MicrophoneAccessDeniedOverlay, {
      assets: assets.microphoneAccessDenied,
      classNames: classNames.microphoneAccessDenied,
      colors: colors.microphoneAccessDenied,
      verbiage: rawVerbiage.microphoneAccessDenied
    });
  }
  var allModelsReady = modelsReady && (!waitForIdCaptureModels || (idCaptureModelsContext === null || idCaptureModelsContext === void 0 ? void 0 : idCaptureModelsContext.ready));
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner, {
    className: classNames.inner
  }, onUserCancel && ( /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onUserCancel,
    className: classNames.cancelBtn
  })), customOverlayContent || ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OverlayHeader, {
    className: classNames.headingContainer
  }, /*#__PURE__*/React__default.createElement(StyledGuidanceMessage, {
    className: classNames.heading
  }, headingText)), /*#__PURE__*/React__default.createElement(StyledOverlayImageContainer, {
    className: classNames.imageContainer
  }, (assets === null || assets === void 0 ? void 0 : assets.instructionImageUrl) && assets.instructionImageUrl !== legacyInstructionImageUrl ? ( /*#__PURE__*/React__default.createElement(CustomLoadingGraphic, {
    className: classNames.image,
    alt: verbiage.headingText,
    src: assets.instructionImageUrl
  })) : ( /*#__PURE__*/React__default.createElement(SelfieCaptureLoadingGraphic, {
    className: classNames.image
  }))))), /*#__PURE__*/React__default.createElement(StyledButtonsRow$5, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(ProgressContainer, {
    className: classNames.progressContainer
  }, /*#__PURE__*/React__default.createElement(ProgressBarBackground, {
    className: classNames.progressBackground
  }), /*#__PURE__*/React__default.createElement(ProgressBar, {
    "$progress": modelDownloadProgress,
    className: classNames.progressBar
  }, /*#__PURE__*/React__default.createElement(ProgressIndicator, {
    className: classNames.progressIndicator
  }))), /*#__PURE__*/React__default.createElement(LoadingListContainer, {
    className: classNames.loadingListContainer
  }, /*#__PURE__*/React__default.createElement(LoadingList, {
    className: classNames.loadingList
  }, /*#__PURE__*/React__default.createElement(LoadingListItem, {
    className: "".concat(classNames.loadingListItem, " ").concat(cameraReady ? 'done' : 'running')
  }, /*#__PURE__*/React__default.createElement(LoadingListItemIndicator, {
    className: classNames.loadingListItemIndicator,
    state: cameraReady ? 'done' : 'running'
  }), cameraReady ? verbiage.cameraInitializedText : verbiage.cameraInitializingText), /*#__PURE__*/React__default.createElement(LoadingListItem, {
    className: "".concat(classNames.loadingListItem, " ").concat(allModelsReady ? 'done' : 'running')
  }, /*#__PURE__*/React__default.createElement(LoadingListItemIndicator, {
    className: classNames.loadingListItemIndicator,
    state: allModelsReady ? 'done' : 'running'
  }), allModelsReady ? verbiage.modelsReadyText : modelDownloadProgress >= 100 ? verbiage.modelsWarmingUpText : "".concat(verbiage.downloadingText, " (").concat(modelDownloadProgress, "%)")))), /*#__PURE__*/React__default.createElement(ContinueButtonContainer, {
    className: classNames.continueBtnContainer
  }, allModelsReady && cameraReady && ( /*#__PURE__*/React__default.createElement(ContinueButton, {
    finished: true,
    className: classNames.continueBtn,
    variant: "positive",
    colors: colors.continueBtn,
    onClick: function onClick() {
      setDismissed(true);
      onDismissed === null || onDismissed === void 0 ? void 0 : onDismissed();
    }
  }, verbiage.continueText))))));
};
var OverlayInner = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n"], ["\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  color: ", ";\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.backgroundColor) !== null && _d !== void 0 ? _d : '#ecedf3';
}, function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.textColor) !== null && _d !== void 0 ? _d : 'black';
});
var OverlayHeader = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  text-align: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  ", "\n  padding-bottom: 0;\n"], ["\n  text-align: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  ", "\n  padding-bottom: 0;\n"])), function (props) {
  var _a;
  return (_a = props.theme.textAlign) !== null && _a !== void 0 ? _a : 'center';
}, function (props) {
  return props.theme.padding ? "box-sizing: border-box; padding: ".concat(props.theme.padding, ";") : "";
});
var StyledGuidanceMessage = styled(GuidanceMessage)(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  padding: 16px 24px;\n  margin-top: 16px;\n  font-size: 18px;\n  font-weight: bold;\n  background: white;\n  box-shadow:\n    0 1px 3px 0 rgb(0 0 0 / 0.1),\n    0 1px 2px -1px rgb(0 0 0 / 0.1);\n"], ["\n  padding: 16px 24px;\n  margin-top: 16px;\n  font-size: 18px;\n  font-weight: bold;\n  background: white;\n  box-shadow:\n    0 1px 3px 0 rgb(0 0 0 / 0.1),\n    0 1px 2px -1px rgb(0 0 0 / 0.1);\n"])));
var StyledButtonsRow$5 = styled(ButtonsRow)(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  padding: 15px 25px;\n  height: 100px;\n  color: ", ";\n  ", "\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100dvw;\n  box-sizing: border-box;\n"], ["\n  display: flex;\n  flex-direction: row;\n  padding: 15px 25px;\n  height: 100px;\n  color: ", ";\n  ", "\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100dvw;\n  box-sizing: border-box;\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarTextColor) !== null && _d !== void 0 ? _d : 'white';
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarFontSize) ? "font-size: ".concat((_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.selfieCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.progressBarFontSize, ";") : '';
});
var StyledOverlayImageContainer = styled(OverlayImageContainer)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  padding: 0;\n\n  & > svg {\n    height: 100%;\n  }\n"], ["\n  padding: 0;\n\n  & > svg {\n    height: 100%;\n  }\n"])));
var LoadingListContainer = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  z-index: 2;\n"], ["\n  display: flex;\n  position: relative;\n  z-index: 2;\n"])));
var LoadingList = styled.ul(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  display: block;\n  margin: auto;\n  list-style: none;\n  padding: 0;\n"], ["\n  display: block;\n  margin: auto;\n  list-style: none;\n  padding: 0;\n"])));
var LoadingListItem = styled.li(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px 1.25rem 2px 0;\n  line-height: 1rem;\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px 1.25rem 2px 0;\n  line-height: 1rem;\n"])));
var ProgressContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var ProgressBarBackground = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  opacity: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  opacity: ", ";\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarBackgroundColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
}, function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarBackgroundOpacity) !== null && _d !== void 0 ? _d : 0.75;
});
var ProgressBar = styled.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: block;\n  width: ", "%;\n  height: 100%;\n  left: 0;\n  position: absolute;\n"], ["\n  display: block;\n  width: ", "%;\n  height: 100%;\n  left: 0;\n  position: absolute;\n"])), function (props) {
  return props.$progress;
});
var ProgressIndicator = styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: block;\n  height: 100%;\n  background: ", ";\n  animation: ", " 3s ease-in-out;\n  animation-fill-mode: both;\n"], ["\n  display: block;\n  height: 100%;\n  background: ", ";\n  animation: ", " 3s ease-in-out;\n  animation-fill-mode: both;\n"])), function (props) {
  var _a, _b, _c, _d;
  return (_d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarIndicatorColor) !== null && _d !== void 0 ? _d : 'var(--idm-color-positive-600)';
}, progressBarAnimation);
var CustomLoadingGraphic = styled.img(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])));
var ContinueButtonContainer = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ContinueButton = styled(LoaderButton)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  margin: auto;\n  white-space: nowrap;\n  ", "\n  ", "\n"], ["\n  margin: auto;\n  white-space: nowrap;\n  ", "\n  ", "\n"])), function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.progressBarFontSize) ? "font-size: ".concat((_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.selfieCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.progressBarFontSize, ";") : '';
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.selfieCapture) === null || _b === void 0 ? void 0 : _b.loadingOverlay) === null || _c === void 0 ? void 0 : _c.continueBtnBorder) ? "border: ".concat((_f = (_e = (_d = props.theme) === null || _d === void 0 ? void 0 : _d.selfieCapture) === null || _e === void 0 ? void 0 : _e.loadingOverlay) === null || _f === void 0 ? void 0 : _f.continueBtnBorder, ";") : '';
});
var templateObject_1$d, templateObject_2$b, templateObject_3$b, templateObject_4$6, templateObject_5$3, templateObject_6$3, templateObject_7$2, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;

var components = {
  "default": SelfieCaptureLoadingOverlayDefault,
  legacy: SelfieCaptureLoadingOverlayLegacy
};
var SelfieCaptureLoadingOverlay = function SelfieCaptureLoadingOverlay(_a) {
  var _b;
  var _c = _a.mode,
    mode = _c === void 0 ? 'default' : _c,
    props = __rest(_a, ["mode"]);
  var Component = (_b = components[mode]) !== null && _b !== void 0 ? _b : components["default"];
  return /*#__PURE__*/React__default.createElement(Component, _assign({}, props));
};

var FaceLivenessWizard = function FaceLivenessWizard(_a) {
  var _b, _c, _d;
  var onComplete = _a.onComplete,
    onSuccess = _a.onSuccess,
    onFailure = _a.onFailure,
    onTimeout = _a.onTimeout,
    onDenied = _a.onDenied,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    _e = _a.loadingOverlayMode,
    loadingOverlayMode = _e === void 0 ? 'default' : _e,
    customOverlayContent = _a.customOverlayContent,
    onLoadingOverlayDismissed = _a.onLoadingOverlayDismissed,
    _f = _a.timeoutDurationMs,
    timeoutDurationMs = _f === void 0 ? 15000 : _f,
    _g = _a.maxRetries,
    maxRetries = _g === void 0 ? 2 : _g,
    _h = _a.skipSuccessScreen,
    skipSuccessScreen = _h === void 0 ? false : _h,
    _j = _a.renderCameraFeed,
    renderCameraFeed = _j === void 0 ? true : _j,
    _k = _a.releaseCameraAccessOnExit,
    releaseCameraAccessOnExit = _k === void 0 ? true : _k,
    _l = _a.silentFallback,
    silentFallback = _l === void 0 ? false : _l,
    _m = _a.waitForIdCaptureModels,
    waitForIdCaptureModels = _m === void 0 ? false : _m,
    guidesComponent = _a.guidesComponent,
    disableCapturePreview = _a.disableCapturePreview,
    _o = _a.assets,
    assets = _o === void 0 ? {} : _o,
    _p = _a.classNames,
    classNames = _p === void 0 ? {} : _p,
    _q = _a.colors,
    colors = _q === void 0 ? {} : _q,
    _r = _a.verbiage,
    verbiage = _r === void 0 ? {} : _r,
    _s = _a.debugMode,
    debugMode = _s === void 0 ? false : _s;
  var _t = useContext(SubmissionContext),
    submissionResponse = _t.submissionResponse,
    livenessCheckRequest = _t.livenessCheckRequest,
    setSelfieImage = _t.setSelfieImage,
    logSelfieCaptureAttempt = _t.logSelfieCaptureAttempt;
  var _u = useCameraStore(useShallow(function (state) {
      return {
        cameraAccessDenied: state.cameraAccessDenied,
        requestCameraAccess: state.requestCameraAccess,
        releaseCameraAccess: state.releaseCameraAccess
      };
    })),
    cameraAccessDenied = _u.cameraAccessDenied,
    requestCameraAccess = _u.requestCameraAccess,
    releaseCameraAccess = _u.releaseCameraAccess;
  var _v = useState(''),
    faceCropImageUrl = _v[0],
    setFaceCropImageUrl = _v[1];
  var _w = useState(0),
    retryCount = _w[0],
    setRetryCount = _w[1];
  var _x = useState('LOADING'),
    captureState = _x[0],
    setCaptureState = _x[1];
  var captureStartedAt = useRef();
  var captureEndedAt = useRef();
  var operationStartedAt = useRef();
  var livenessScore = useRef();
  var _y = useContext(SelfieGuidanceModelsContext),
    start = _y.start,
    stop = _y.stop;
  useEffect(function () {
    operationStartedAt.current = new Date();
  }, []);
  useEffect(function () {
    if (captureState !== 'CAPTURING') return;
    captureStartedAt.current = new Date();
    start();
    return stop;
  }, [captureState, start, stop]);
  var onCapture = useCallback(function () {
    captureEndedAt.current = new Date();
  }, []);
  var onLivenessChecked = useCallback(function (resp) {
    livenessScore.current = resp.resultData.realScore;
  }, []);
  var logCaptureMetadata = useCallback(function () {
    var _a, _b, _c;
    logSelfieCaptureAttempt({
      autoCapture: 'Y',
      captureTime: ((_a = captureEndedAt.current) !== null && _a !== void 0 ? _a : new Date()).getTime() - ((_b = captureStartedAt.current) !== null && _b !== void 0 ? _b : new Date()).getTime(),
      operationTime: new Date().getTime() - ((_c = operationStartedAt.current) !== null && _c !== void 0 ? _c : new Date()).getTime(),
      livenessScore: livenessScore.current
    });
    operationStartedAt.current = new Date();
  }, [logSelfieCaptureAttempt]);
  var onSuccessCallback = useCallback(function (faceCropImageUrl) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!livenessCheckRequest || !submissionResponse) return [2 /*return*/];
            setCaptureState('SUCCESS');
            setFaceCropImageUrl(faceCropImageUrl);
            _a = setSelfieImage;
            return [4 /*yield*/, dataUrlToBase64(faceCropImageUrl)];
          case 1:
            _a.apply(void 0, [_b.sent()]);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(submissionResponse, livenessCheckRequest);
            return [2 /*return*/];
        }
      });
    });
  }, [onSuccess, setSelfieImage, livenessCheckRequest, submissionResponse]);
  var onFailureCallback = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        onFailure === null || onFailure === void 0 ? void 0 : onFailure(submissionResponse, livenessCheckRequest);
        return [2 /*return*/];
      });
    });
  }, [livenessCheckRequest, onFailure, submissionResponse]);
  var onDeniedCallback = useCallback(function () {
    setCaptureState('FAILED');
    onDenied === null || onDenied === void 0 ? void 0 : onDenied(submissionResponse, livenessCheckRequest);
  }, [onDenied, submissionResponse, livenessCheckRequest]);
  var _z = useState(0),
    attempt = _z[0],
    setAttempt = _z[1];
  var onExitCallback = useCallback(function () {
    setAttempt(function (n) {
      return n + 1;
    });
    setCaptureState('LOADING');
    releaseCameraAccess();
    onExitCapture === null || onExitCapture === void 0 ? void 0 : onExitCapture();
    void requestCameraAccess();
  }, [onExitCapture, releaseCameraAccess, requestCameraAccess]);
  var onRetryCallback = useCallback(function () {
    logCaptureMetadata();
    setAttempt(function (n) {
      return n + 1;
    });
    setRetryCount(function (n) {
      return n + 1;
    });
    setCaptureState('LOADING');
    releaseCameraAccess();
    void requestCameraAccess();
  }, [logCaptureMetadata, releaseCameraAccess, requestCameraAccess]);
  var onDoneCallback = useCallback(function () {
    logCaptureMetadata();
    if (releaseCameraAccessOnExit) releaseCameraAccess();
    setTimeout(function () {
      onComplete === null || onComplete === void 0 ? void 0 : onComplete(submissionResponse, livenessCheckRequest);
    }, 0);
  }, [logCaptureMetadata, onComplete, releaseCameraAccess, releaseCameraAccessOnExit, livenessCheckRequest, submissionResponse]);
  var showSuccessScreen = useShowSuccessScreen(skipSuccessScreen, captureState === 'SUCCESS', onDoneCallback);
  useEffect(function () {
    if (cameraAccessDenied) {
      setAttempt(function (n) {
        return n + 1;
      });
      setCaptureState('LOADING');
    }
  }, [cameraAccessDenied]);
  var onLoadingOverlayDismissedCallback = useCallback(function () {
    setCaptureState('CAPTURING');
    onLoadingOverlayDismissed === null || onLoadingOverlayDismissed === void 0 ? void 0 : onLoadingOverlayDismissed();
  }, [onLoadingOverlayDismissed]);
  var onFailureExitClick = useCallback(function () {
    if (releaseCameraAccessOnExit) releaseCameraAccess();
    setTimeout(function () {
      onExitAfterFailure === null || onExitAfterFailure === void 0 ? void 0 : onExitAfterFailure(submissionResponse, livenessCheckRequest);
    }, 0);
  }, [livenessCheckRequest, onExitAfterFailure, releaseCameraAccess, releaseCameraAccessOnExit, submissionResponse]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_c = (_b = classNames.capture) === null || _b === void 0 ? void 0 : _b.container) !== null && _c !== void 0 ? _c : '')
  }, renderCameraFeed && ( /*#__PURE__*/React__default.createElement(CameraVideoTag, {
    className: (_d = classNames.capture) === null || _d === void 0 ? void 0 : _d.cameraFeed
  })), captureState !== 'LOADING' && function () {
    switch (captureState) {
      case 'CAPTURING':
        return /*#__PURE__*/React__default.createElement(FaceLivenessCapture, {
          key: "capture".concat(attempt),
          onCapture: onCapture,
          onLivenessChecked: onLivenessChecked,
          onSuccess: onSuccessCallback,
          onFailure: onFailureCallback,
          onTimeout: onTimeout,
          onDenied: onDeniedCallback,
          onExit: onExitCallback,
          timeoutDurationMs: timeoutDurationMs,
          silentFallback: silentFallback,
          guidesComponent: guidesComponent,
          disableCapturePreview: disableCapturePreview,
          classNames: classNames.capture,
          colors: colors,
          verbiage: verbiage,
          debugMode: debugMode
        });
      case 'SUCCESS':
        if (!showSuccessScreen) return null;
        return /*#__PURE__*/React__default.createElement(FaceLivenessSuccess, {
          key: "success",
          imageUrl: faceCropImageUrl,
          classNames: classNames.success,
          colors: colors.success,
          verbiage: verbiage.success,
          onDoneClick: onDoneCallback,
          onRetryClick: onRetryCallback
        });
      case 'FAILED':
        return /*#__PURE__*/React__default.createElement(FaceLivenessFailure, {
          key: "failure",
          assets: assets.failure,
          classNames: classNames.failure,
          colors: colors.failure,
          verbiage: verbiage.failure,
          canRetry: maxRetries > -1 && retryCount < maxRetries,
          onRetryClick: onRetryCallback,
          onExitClick: onFailureExitClick
        });
      default:
        return null;
    }
  }()), /*#__PURE__*/React__default.createElement(SelfieCaptureLoadingOverlay, {
    key: attempt,
    mode: loadingOverlayMode,
    customOverlayContent: customOverlayContent,
    assets: assets.loadingOverlay,
    classNames: classNames.loadingOverlay,
    colors: colors.loadingOverlay,
    verbiage: verbiage.loadingOverlay,
    onUserCancel: onUserCancel,
    onDismissed: onLoadingOverlayDismissedCallback,
    waitForIdCaptureModels: waitForIdCaptureModels
  }));
};

var SubmissionSuccess = function SubmissionSuccess() {
  var _a = useContext(SubmissionContext),
    submissionRequest = _a.submissionRequest,
    submissionResponse = _a.submissionResponse;
  var _b = useState(false),
    showRequestBody = _b[0],
    setShowRequestBody = _b[1];
  var _c = useState(true),
    truncateImages = _c[0],
    setTruncateImages = _c[1];
  var requestBodyDisplay = useMemo(function () {
    var _a, _b, _c, _d, _e, _f;
    var body = JSON.parse(JSON.stringify(submissionRequest));
    if (truncateImages) {
      if ((_b = (_a = body === null || body === void 0 ? void 0 : body.customerData) === null || _a === void 0 ? void 0 : _a.idData) === null || _b === void 0 ? void 0 : _b.idImageFront) body.customerData.idData.idImageFront = truncate(body.customerData.idData.idImageFront, 200);
      if ((_d = (_c = body === null || body === void 0 ? void 0 : body.customerData) === null || _c === void 0 ? void 0 : _c.idData) === null || _d === void 0 ? void 0 : _d.idImageBack) body.customerData.idData.idImageBack = truncate(body.customerData.idData.idImageBack, 200);
      if ((_f = (_e = body === null || body === void 0 ? void 0 : body.customerData) === null || _e === void 0 ? void 0 : _e.biometricData) === null || _f === void 0 ? void 0 : _f.selfie) body.customerData.biometricData.selfie = truncate(body.customerData.biometricData.selfie, 200);
    }
    return JSON.stringify(body, null, 2);
  }, [submissionRequest, truncateImages]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", null, "Submission completed!"), /*#__PURE__*/React__default.createElement("button", {
    onClick: function onClick() {
      setShowRequestBody(!showRequestBody);
    }
  }, showRequestBody ? 'Hide' : 'Show', " request body"), showRequestBody && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
    style: {
      marginLeft: 8
    },
    onClick: function onClick() {
      setTruncateImages(!truncateImages);
    }
  }, truncateImages ? 'Display full images' : 'Truncate images'), /*#__PURE__*/React__default.createElement("h5", null, "Request Body"), /*#__PURE__*/React__default.createElement("pre", null, requestBodyDisplay))), /*#__PURE__*/React__default.createElement("h5", null, "Response Body"), /*#__PURE__*/React__default.createElement("pre", null, JSON.stringify(submissionResponse, null, 2)));
};
function truncate(str, max_chars) {
  var truncated = str.split('').splice(0, max_chars).join('');
  if (truncated.length < str.length) truncated += '...';
  return truncated;
}

var AdditionalDocumentCapture = function AdditionalDocumentCapture(_a) {
  var document = _a.document,
    onComplete = _a.onComplete,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.verbiage,
    rawVerbiage = _c === void 0 ? {} : _c;
  var fileInput = useRef(null);
  var _d = useState(null),
    file = _d[0],
    setFile = _d[1];
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Additional document capture',
    captureBtnText: 'Capture',
    nextBtnText: 'Next'
  });
  function onFileSelected(e) {
    var _a;
    var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
    if (file) setFile(file);
  }
  function onNextClicked() {
    if (!file) return;
    var fileReader = new FileReader();
    fileReader.onloadend = function () {
      if (!fileReader.result) return;
      var fileContent = fileReader.result.toString();
      onComplete === null || onComplete === void 0 ? void 0 : onComplete({
        documentName: document.name,
        processAsPOA: document.processAsPOA ? 'Y' : 'N',
        additionalDocument: {
          name: file.name,
          fileContent: dataUrlToBase64Sync(fileContent),
          type: contentDispositionFromDataUrl(fileContent),
          fileUploadType: 'Y',
          isImageControlData: 'Y',
          fieldId: ''
        }
      });
    };
    fileReader.readAsDataURL(file);
  }
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(Inner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(Heading$4, {
    className: classNames.heading
  }, verbiage.headingText, ": ", document.name), document.description && ( /*#__PURE__*/React__default.createElement(Description, {
    className: classNames.description
  }, document.description)), /*#__PURE__*/React__default.createElement("input", {
    ref: fileInput,
    type: "file",
    accept: "image/*,.pdf",
    onChange: onFileSelected,
    hidden: true
  }), /*#__PURE__*/React__default.createElement(StyledButtonsRow$4, {
    className: classNames.buttonsRow
  }, file ? ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    className: classNames.nextBtn,
    disabled: !file,
    finished: true,
    onClick: onNextClicked
  }, verbiage.nextBtnText)) : ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "primary",
    className: classNames.captureBtn,
    finished: true,
    onClick: function onClick() {
      var _a;
      (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click();
    }
  }, verbiage.captureBtnText)))));
};
var Inner$2 = styled(OverlayInner$2)(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  justify-content: center;\n"], ["\n  justify-content: center;\n"])));
var Heading$4 = styled.h3(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  margin-bottom: 8px;\n"], ["\n  margin-bottom: 8px;\n"])));
var Description = styled.p(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  margin-bottom: 8px;\n"], ["\n  margin-bottom: 8px;\n"])));
var StyledButtonsRow$4 = styled(ButtonsRow)(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  margin-top: 32px;\n"], ["\n  margin-top: 32px;\n"])));
var templateObject_1$c, templateObject_2$a, templateObject_3$a, templateObject_4$5;

var AdditionalDocumentCaptureWizard = function AdditionalDocumentCaptureWizard(_a) {
  var documents = _a.documents,
    onComplete = _a.onComplete,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.verbiage,
    verbiage = _c === void 0 ? {} : _c;
  var _d = useState([]),
    uploadedDocuments = _d[0],
    setUploadedDocuments = _d[1];
  var documentIndex = uploadedDocuments.length;
  var currentDocument = documents[documentIndex];
  var isComplete = documentIndex >= documents.length;
  useEffect(function () {
    if (!(currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.skip)) return;
    (function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4 /*yield*/, (_a = currentDocument.skip) === null || _a === void 0 ? void 0 : _a.call(currentDocument)];
            case 1:
              if (_b.sent()) {
                setUploadedDocuments(function (f) {
                  return __spreadArray(__spreadArray([], f, true), [null], false);
                });
              }
              return [2 /*return*/];
          }
        });
      });
    })();
  }, [currentDocument]);
  useEffect(function () {
    if (isComplete) {
      onComplete === null || onComplete === void 0 ? void 0 : onComplete(uploadedDocuments.filter(function (d) {
        return !!d;
      }));
    }
  }, [isComplete, onComplete, uploadedDocuments]);
  if (isComplete) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Thanks, your documents have been received.");
  return /*#__PURE__*/React__default.createElement(AdditionalDocumentCapture, {
    key: documentIndex,
    document: currentDocument,
    classNames: classNames,
    verbiage: verbiage,
    onComplete: function onComplete(data) {
      setUploadedDocuments(function (f) {
        return __spreadArray(__spreadArray([], f, true), [data], false);
      });
    }
  });
};

function signatureDataToIdmissionFormat(signatureCanvas, imageUrl) {
  imageUrl || (imageUrl = signatureCanvas.toDataURL());
  var signatureData = {
    clickX_simple: [],
    clickY_simple: [],
    time_simple: [],
    pressure: '',
    fileContent: imageUrl ? dataUrlToBase64Sync(imageUrl) : ''
  };
  signatureCanvas.toData().forEach(function (stroke) {
    var xs = [];
    var ys = [];
    var times = [];
    stroke.forEach(function (d) {
      xs.push(d.x);
      ys.push(d.y);
      times.push(new Date(d.time).toString());
    });
    signatureData.clickX_simple.push(xs);
    signatureData.clickY_simple.push(ys);
    signatureData.time_simple.push(times);
  });
  return signatureData;
}
function exportSignatureImage(signaturePad_1) {
  return __awaiter(this, arguments, void 0, function (signaturePad, exportWidth) {
    var signatureCanvas, scaledHeight, svgB64Url, svgContent, scaledSvgContent, scaledSvgUrl;
    if (exportWidth === void 0) {
      exportWidth = 600;
    }
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          signatureCanvas = signaturePad.getCanvas();
          scaledHeight = signatureCanvas.height * exportWidth / signatureCanvas.width;
          svgB64Url = signaturePad.getSignaturePad()._toSVG();
          svgContent = atob(svgB64Url.replace('data:image/svg+xml;base64,', ''));
          scaledSvgContent = svgContent.replace(/width="[0-9.]+"/, "width=\"".concat(exportWidth, "\"")).replace(/height="[0-9.]+"/, "height=\"".concat(scaledHeight, "\"")).replace(/viewBox="0 0 [0-9.]+ [0-9.]+"/, "viewBox=\"0 0 ".concat(signatureCanvas.width, " ").concat(signatureCanvas.height, "\""));
          scaledSvgUrl = 'data:image/svg+xml;base64,' + btoa(scaledSvgContent);
          return [4 /*yield*/, convertSVGtoImg(scaledSvgUrl)];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
function loadImage(url) {
  return __awaiter(this, void 0, void 0, function () {
    var img;
    return __generator(this, function (_a) {
      img = document.createElement('img');
      img.src = url;
      return [2 /*return*/, new Promise(function (resolve, reject) {
        img.onload = function () {
          return resolve(img);
        };
        img.onerror = reject;
      })];
    });
  });
}
function convertSVGtoImg(svgData_1) {
  return __awaiter(this, arguments, void 0, function (svgData, format) {
    var img, canvas, ctx;
    if (format === void 0) {
      format = 'jpeg';
    }
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, loadImage(svgData)];
        case 1:
          img = _a.sent();
          canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          ctx = canvas.getContext('2d');
          if (!ctx) return [2 /*return*/, null];
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);
          return [2 /*return*/, canvas.toDataURL("image/".concat(format), 1.0)];
      }
    });
  });
}

var SignaturePaperBacking = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n  ", "\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  var _a, _b;
  return ((_a = props.theme.signatureCapture) === null || _a === void 0 ? void 0 : _a.background) ? "background: ".concat((_b = props.theme.signatureCapture) === null || _b === void 0 ? void 0 : _b.background, ";") : "";
}, function (props) {
  var _a, _b;
  return ((_a = props.theme.signatureCapture) === null || _a === void 0 ? void 0 : _a.backgroundSize) ? "background-size: ".concat((_b = props.theme.signatureCapture) === null || _b === void 0 ? void 0 : _b.backgroundSize, ";") : "";
}, function (props) {
  var _a, _b;
  return ((_a = props.theme.signatureCapture) === null || _a === void 0 ? void 0 : _a.backgroundPosition) ? "background-position: ".concat((_b = props.theme.signatureCapture) === null || _b === void 0 ? void 0 : _b.backgroundPosition, ";") : "";
});
var SignatureCanvasContainer$1 = styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  position: absolute;\n  top: 25%;\n  left: 15%;\n  width: 70%;\n  height: 50%;\n\n  @media (max-width: 800px) {\n    top: 15%;\n    left: 2%;\n    width: 96%;\n    height: 70%;\n  }\n"], ["\n  position: absolute;\n  top: 25%;\n  left: 15%;\n  width: 70%;\n  height: 50%;\n\n  @media (max-width: 800px) {\n    top: 15%;\n    left: 2%;\n    width: 96%;\n    height: 70%;\n  }\n"])));
var SignaturePad = styled.div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  position: relative;\n  background: ", ";\n  border: ", ";\n  border-radius: ", ";\n  flex-grow: 1;\n  z-index: 100;\n  height: 100%;\n"], ["\n  position: relative;\n  background: ", ";\n  border: ", ";\n  border-radius: ", ";\n  flex-grow: 1;\n  z-index: 100;\n  height: 100%;\n"])), function (props) {
  var _a, _b, _c;
  return (_c = (_b = (_a = props.theme.signatureCapture) === null || _a === void 0 ? void 0 : _a.canvas) === null || _b === void 0 ? void 0 : _b.background) !== null && _c !== void 0 ? _c : 'rgba(255, 255, 255, 0.5)';
}, function (props) {
  var _a, _b, _c;
  return (_c = (_b = (_a = props.theme.signatureCapture) === null || _a === void 0 ? void 0 : _a.canvas) === null || _b === void 0 ? void 0 : _b.border) !== null && _c !== void 0 ? _c : "1px solid #dedede";
}, function (props) {
  var _a, _b, _c;
  return (_c = (_b = (_a = props.theme.signatureCapture) === null || _a === void 0 ? void 0 : _a.canvas) === null || _b === void 0 ? void 0 : _b.borderRadius) !== null && _c !== void 0 ? _c : '16px';
});
var SignatureButtonsContainer = styled(ButtonsRow)(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  flex-grow: 0;\n  padding-top: 12px;\n  display: flex;\n  z-index: 1000;\n  position: relative;\n"], ["\n  flex-grow: 0;\n  padding-top: 12px;\n  display: flex;\n  z-index: 1000;\n  position: relative;\n"])));
var templateObject_1$b, templateObject_2$9, templateObject_3$9, templateObject_4$4;

var SignatureCapture = function SignatureCapture(_a) {
  var onAccept = _a.onAccept,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.verbiage,
    rawVerbiage = _c === void 0 ? {} : _c;
  var _d = useResizeObserver(),
    ref = _d.ref,
    width = _d.width,
    height = _d.height;
  var signaturePad = useRef(null);
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Please sign the box below',
    acceptBtnText: 'Accept',
    clearBtnText: 'Clear'
  });
  function onAcceptClicked() {
    return __awaiter(this, void 0, void 0, function () {
      var imageUrl, signatureData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!signaturePad.current) return [2 /*return*/];
            return [4 /*yield*/, exportSignatureImage(signaturePad.current)];
          case 1:
            imageUrl = _a.sent();
            signatureData = signatureDataToIdmissionFormat(signaturePad.current, imageUrl);
            onAccept === null || onAccept === void 0 ? void 0 : onAccept(signatureData, imageUrl !== null && imageUrl !== void 0 ? imageUrl : '');
            return [2 /*return*/];
        }
      });
    });
  }
  return /*#__PURE__*/React__default.createElement(PageContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(SignaturePaperBacking, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(GuidanceMessageContainer, {
    className: classNames.guidanceMessageContainer,
    "$top": "5vh"
  }, /*#__PURE__*/React__default.createElement(GuidanceMessage, {
    className: classNames.guidanceMessage
  }, verbiage.headingText)), /*#__PURE__*/React__default.createElement(SignatureCanvasContainer$1, {
    className: classNames.canvasContainer
  }, /*#__PURE__*/React__default.createElement(SignaturePad, {
    ref: ref,
    className: classNames.canvasInner
  }, /*#__PURE__*/React__default.createElement(SignatureCanvas, {
    ref: signaturePad,
    canvasProps: {
      width: width,
      height: height,
      className: classNames.canvas
    }
  })), /*#__PURE__*/React__default.createElement(SignatureButtonsContainer, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "secondary",
    className: classNames.clearBtn,
    finished: true,
    onClick: function onClick() {
      var _a;
      (_a = signaturePad.current) === null || _a === void 0 ? void 0 : _a.clear();
    }
  }, verbiage.clearBtnText), /*#__PURE__*/React__default.createElement(AcceptBtn$1, {
    variant: "positive",
    className: classNames.acceptBtn,
    onClick: onAcceptClicked,
    finished: true
  }, verbiage.acceptBtnText)))));
};
var AcceptBtn$1 = styled(LoaderButton)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var templateObject_1$a;

var useVideoRecorder = function useVideoRecorder(camera, audioStream, mergeAVStreams) {
  if (mergeAVStreams === void 0) {
    mergeAVStreams = false;
  }
  var videoRecorder = useRef(null);
  var audioRecorder = useRef(null);
  var videoChunks = useRef([]);
  var audioChunks = useRef([]);
  var _a = useState(null),
    videoUrl = _a[0],
    setVideoUrl = _a[1];
  var _b = useState(null),
    audioUrl = _b[0],
    setAudioUrl = _b[1];
  var _c = useState(false),
    isRecordingVideo = _c[0],
    setIsRecordingVideo = _c[1];
  var _d = useState(false),
    isRecordingAudio = _d[0],
    setIsRecordingAudio = _d[1];
  var _e = useState(false),
    videoRecordingStopped = _e[0],
    setVideoRecordingStopped = _e[1];
  var _f = useState(false),
    audioRecordingStopped = _f[0],
    setAudioRecordingStopped = _f[1];
  var _g = useState(false),
    videoRecordingIntentionallyStopped = _g[0],
    setVideoRecordingIntentionallyStopped = _g[1];
  var _h = useState(false),
    audioRecordingIntentionallyStopped = _h[0],
    setAudioRecordingIntentionallyStopped = _h[1];
  var getVideoStream = useCallback(function () {
    var _a, _b, _c;
    if (!mergeAVStreams) return camera === null || camera === void 0 ? void 0 : camera.stream;
    var videoTracks = (_b = (_a = camera === null || camera === void 0 ? void 0 : camera.stream) === null || _a === void 0 ? void 0 : _a.getTracks()) !== null && _b !== void 0 ? _b : [];
    var audioTracks = (_c = audioStream === null || audioStream === void 0 ? void 0 : audioStream.getTracks()) !== null && _c !== void 0 ? _c : [];
    return new MediaStream(__spreadArray(__spreadArray([], videoTracks, true), audioTracks, true));
  }, [audioStream, camera === null || camera === void 0 ? void 0 : camera.stream, mergeAVStreams]);
  var processVideo = useCallback(function () {
    var videoBlob = new Blob(videoChunks.current, {
      type: 'video/mp4'
    });
    videoChunks.current = [];
    setVideoUrl(URL.createObjectURL(videoBlob));
    setIsRecordingVideo(false);
    camera === null || camera === void 0 ? void 0 : camera.release();
  }, [camera]);
  var processAudio = useCallback(function () {
    var _a;
    var audioBlob = new Blob(audioChunks.current, {
      type: 'audio/mp4'
    });
    audioChunks.current = [];
    setAudioUrl(URL.createObjectURL(audioBlob));
    setIsRecordingAudio(false);
    (_a = audioStream === null || audioStream === void 0 ? void 0 : audioStream.stop) === null || _a === void 0 ? void 0 : _a.call(audioStream);
  }, [audioStream]);
  var startRecordingVideo = useCallback(function () {
    var videoStream = getVideoStream();
    if (!videoStream) return;
    videoChunks.current = [];
    setIsRecordingVideo(true);
    setVideoRecordingStopped(false);
    setVideoRecordingIntentionallyStopped(false);
    videoRecorder.current = new MediaRecorder(videoStream, {
      videoBitsPerSecond: 270000,
      audioBitsPerSecond: 32000
    });
    videoRecorder.current.ondataavailable = function (e) {
      videoChunks.current.push(e.data);
    };
    videoRecorder.current.onstop = function () {
      setVideoRecordingStopped(true);
    };
    videoRecorder.current.start(1000);
    setTimeout(function () {
      var _a;
      if (((_a = videoRecorder.current) === null || _a === void 0 ? void 0 : _a.state) === 'inactive') {
        log('media recorder is inactive!');
        // TODO: figure out what to do here
      }
    }, 100);
  }, [getVideoStream]);
  var startRecordingAudio = useCallback(function () {
    if (mergeAVStreams) return;
    if (!audioStream) return;
    audioChunks.current = [];
    setIsRecordingAudio(true);
    setAudioRecordingStopped(false);
    setAudioRecordingIntentionallyStopped(false);
    audioRecorder.current = new MediaRecorder(audioStream, {
      audioBitsPerSecond: 32000
    });
    audioRecorder.current.ondataavailable = function (e) {
      audioChunks.current.push(e.data);
    };
    audioRecorder.current.onstop = function () {
      setAudioRecordingStopped(true);
    };
    audioRecorder.current.start(1000);
  }, [audioStream, mergeAVStreams]);
  var stopRecordingVideo = useCallback(function () {
    var _a, _b;
    setVideoRecordingIntentionallyStopped(true);
    if (((_a = videoRecorder.current) === null || _a === void 0 ? void 0 : _a.state) !== 'inactive') {
      (_b = videoRecorder.current) === null || _b === void 0 ? void 0 : _b.stop(); // if you call this while state === 'inactive', an exception is thrown.
    }
  }, []);
  var stopRecordingAudio = useCallback(function () {
    var _a, _b;
    setAudioRecordingIntentionallyStopped(true);
    if (((_a = audioRecorder.current) === null || _a === void 0 ? void 0 : _a.state) !== 'inactive') {
      (_b = audioRecorder.current) === null || _b === void 0 ? void 0 : _b.stop(); // if you call this while state === 'inactive', an exception is thrown.
    }
  }, []);
  useEffect(function () {
    if (videoRecordingStopped && videoRecordingIntentionallyStopped) {
      processVideo();
    }
  }, [processVideo, videoRecordingIntentionallyStopped, videoRecordingStopped]);
  useEffect(function () {
    if (audioRecordingStopped && audioRecordingIntentionallyStopped) {
      processAudio();
    }
  }, [audioRecordingIntentionallyStopped, audioRecordingStopped, processAudio]);
  return {
    isRecordingVideo: isRecordingVideo,
    isRecordingAudio: isRecordingAudio,
    startRecordingVideo: startRecordingVideo,
    startRecordingAudio: startRecordingAudio,
    stopRecordingVideo: stopRecordingVideo,
    stopRecordingAudio: stopRecordingAudio,
    videoRecordingUnintentionallyStopped: videoRecordingStopped && !videoRecordingIntentionallyStopped,
    audioRecordingUnintentionallyStopped: audioRecordingStopped && !audioRecordingIntentionallyStopped,
    videoUrl: videoUrl,
    audioUrl: audioUrl
  };
};

var videoSignatureInitialState = {
  startRecording: function startRecording() {
    return null;
  },
  stopRecording: function stopRecording() {
    return null;
  },
  signatureData: null,
  signatureDataUrl: null,
  signatureVideoData: null,
  signatureVideoUrl: null,
  onAcceptClicked: function onAcceptClicked() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, void 0];
      });
    });
  }
};
var VideoSignatureContext = /*#__PURE__*/createContext(videoSignatureInitialState);
function VideoSignatureContextProvider(_a) {
  var _this = this;
  var children = _a.children;
  var signaturePad = useRef(null);
  var _b = useState(null),
    signatureData = _b[0],
    setSignatureData = _b[1];
  var _c = useState(null),
    signatureDataUrl = _c[0],
    setSignatureDataUrl = _c[1];
  var _d = useState(null),
    signatureVideoData = _d[0],
    setSignatureVideoData = _d[1];
  var _e = useState(null),
    signatureVideoUrl = _e[0],
    setSignatureVideoUrl = _e[1];
  var signatureRecorder = useRef(null);
  var recordedChunks = useRef([]);
  var _f = useCameraStore(),
    camera = _f.camera,
    videoRef = _f.videoRef;
  var _g = useVideoRecorder(camera),
    isRecordingVideo = _g.isRecordingVideo,
    startRecordingVideo = _g.startRecordingVideo,
    stopRecordingVideo = _g.stopRecordingVideo,
    videoUrl = _g.videoUrl;
  var outputCanvas = useRef(null);
  var recordingLock = useRef(false);
  var _h = useState(false),
    isRecording = _h[0],
    setIsRecording = _h[1];
  var startRecording = useCallback(function () {
    setIsRecording(true);
  }, []);
  var stopRecording = useCallback(function () {
    setIsRecording(false);
  }, []);
  useEffect(function () {
    if (!isRecording) return;
    if (recordingLock.current) return;
    recordingLock.current = true;
    (function () {
      return __awaiter(_this, void 0, void 0, function () {
        var stream;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!!outputCanvas.current) return [3 /*break*/, 2];
              return [4 /*yield*/, new Promise(function (resolve) {
                var interval = setInterval(function () {
                  if (outputCanvas.current) {
                    clearInterval(interval);
                    resolve(null);
                  }
                }, 10);
              })];
            case 1:
              _a.sent();
              _a.label = 2;
            case 2:
              startRecordingVideo();
              stream = outputCanvas.current.captureStream(24 /* fps */);
              signatureRecorder.current = new MediaRecorder(stream, {
                videoBitsPerSecond: 270000
              });
              signatureRecorder.current.start();
              signatureRecorder.current.ondataavailable = function (event) {
                var _a;
                recordedChunks.current.push(event.data);
                if (((_a = signatureRecorder.current) === null || _a === void 0 ? void 0 : _a.state) === 'recording') {
                  signatureRecorder.current.stop();
                }
              };
              signatureRecorder.current.onstop = function () {
                var blob = new Blob(recordedChunks.current, {
                  type: 'video/mp4'
                });
                setSignatureVideoData(blob);
                setSignatureVideoUrl(URL.createObjectURL(blob));
              };
              return [2 /*return*/];
          }
        });
      });
    })();
  }, [isRecording, isRecordingVideo, startRecordingVideo, videoUrl]);
  var animationFrame = useRef(0);
  useEffect(function () {
    if (!signaturePad.current || !videoRef.current || !outputCanvas.current || !camera || !isRecording || !isRecordingVideo) return;
    var ctx = outputCanvas.current.getContext('2d');
    if (!ctx) return;
    animationFrame.current = requestAnimationFrame(function runFrame() {
      return __awaiter(this, void 0, void 0, function () {
        var _a, w, h, isPortrait, rect;
        return __generator(this, function (_b) {
          if (!signaturePad.current || !videoRef.current || !outputCanvas.current) {
            cancelAnimationFrame(animationFrame.current);
            return [2 /*return*/];
          }
          _a = [videoRef.current.videoWidth, videoRef.current.videoHeight], w = _a[0], h = _a[1];
          isPortrait = w < h;
          outputCanvas.current.width = w;
          outputCanvas.current.height = h;
          rect = [w * (isPortrait ? 0.02 : 0.15), h * (isPortrait ? 0.15 : 0.25), w * (isPortrait ? 0.96 : 0.7), h * (isPortrait ? 0.7 : 0.5)];
          ctx.drawImage(videoRef.current, 0, 0, w, h);
          ctx.beginPath();
          ctx.fillStyle = 'rgba(255,255,255,0.5)';
          ctx.roundRect.apply(ctx, __spreadArray(__spreadArray([], rect, false), [16], false));
          ctx.fill();
          ctx.drawImage.apply(ctx, __spreadArray([signaturePad.current.getCanvas()], rect, false));
          animationFrame.current = requestAnimationFrame(runFrame);
          return [2 /*return*/];
        });
      });
    });
    return function () {
      cancelAnimationFrame(animationFrame.current);
    };
  }, [camera, isRecording, isRecordingVideo, videoRef]);
  var onAcceptClicked = useCallback(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var imageUrl;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!signaturePad.current) return [2 /*return*/];
            return [4 /*yield*/, exportSignatureImage(signaturePad.current)];
          case 1:
            imageUrl = _b.sent();
            setSignatureDataUrl(imageUrl);
            setSignatureData(signatureDataToIdmissionFormat(signaturePad.current, imageUrl));
            stopRecordingVideo();
            (_a = signatureRecorder.current) === null || _a === void 0 ? void 0 : _a.stop();
            return [2 /*return*/];
        }
      });
    });
  }, [stopRecordingVideo]);
  var value = useMemo(function () {
    return {
      startRecording: startRecording,
      stopRecording: stopRecording,
      signaturePad: signaturePad,
      signatureData: signatureData,
      signatureDataUrl: signatureDataUrl,
      signatureVideoData: signatureVideoData,
      signatureVideoUrl: signatureVideoUrl,
      onAcceptClicked: onAcceptClicked
    };
  }, [onAcceptClicked, signatureData, signatureDataUrl, signatureVideoData, signatureVideoUrl, startRecording, stopRecording]);
  return /*#__PURE__*/React__default.createElement(VideoSignatureContext.Provider, {
    value: value
  }, children, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: outputCanvas
  }));
}
function useVideoSignatureContext() {
  var ctx = useContext(VideoSignatureContext);
  if (!ctx) throw new Error('useVideoSignatureContext cannot be used without ContextProvider');
  return ctx;
}

function VideoSignatureGuides(_a) {
  var _b;
  var _c = _a.requestedAction,
    requestedAction = _c === void 0 ? 'VERIFY_LIVENESS' : _c,
    _d = _a.faceGuideStatus,
    faceGuideStatus = _d === void 0 ? 'success' : _d,
    faceGuideBorderWidth = _a.faceGuideBorderWidth,
    faceGuideBorderColor = _a.faceGuideBorderColor,
    _e = _a.classNames,
    classNames = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  var _g = useResizeObserver(),
    ref = _g.ref,
    width = _g.width,
    height = _g.height;
  var _h = useVideoSignatureContext(),
    signaturePad = _h.signaturePad,
    onAcceptClicked = _h.onAcceptClicked;
  var verbiage = useTranslations(rawVerbiage, {
    clearSignatureBtnText: 'Clear',
    acceptSignatureBtnText: 'Accept'
  });
  var canvasProps = useMemo(function () {
    return {
      width: width,
      height: height,
      className: classNames.signatureCanvas
    };
  }, [classNames.signatureCanvas, height, width]);
  return /*#__PURE__*/React__default.createElement(Container$1, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(Inner$1, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(FaceGuideContainer$1, {
    className: classNames.faceGuideContainer
  }, /*#__PURE__*/React__default.createElement(StyledSelfieCaptureAnimatedMask, {
    className: classNames.faceGuide,
    status: requestedAction === 'VERIFY_LIVENESS' ? faceGuideStatus : 'success',
    borderWidth: faceGuideBorderWidth,
    borderColor: faceGuideBorderColor,
    verticalAlign: "bottom"
  })), /*#__PURE__*/React__default.createElement(SignaturePadContainer, {
    className: classNames.signaturePadContainer
  }, /*#__PURE__*/React__default.createElement(SignatureCanvasContainer, {
    className: classNames.signatureCanvasContainer,
    "$disabled": requestedAction === 'VERIFY_LIVENESS'
  }, /*#__PURE__*/React__default.createElement(SignaturePad, {
    ref: ref,
    className: classNames.signatureCanvasInner
  }, /*#__PURE__*/React__default.createElement(SignatureCanvas, {
    ref: signaturePad,
    canvasProps: canvasProps
  })), /*#__PURE__*/React__default.createElement(SignatureButtonsContainer, {
    className: classNames.signatureButtonsRow
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "secondary",
    className: classNames.clearSignatureBtn,
    onClick: (_b = signaturePad === null || signaturePad === void 0 ? void 0 : signaturePad.current) === null || _b === void 0 ? void 0 : _b.clear,
    disabled: requestedAction === 'VERIFY_LIVENESS',
    finished: true
  }, verbiage.clearSignatureBtnText), /*#__PURE__*/React__default.createElement(AcceptBtn, {
    variant: "positive",
    className: classNames.acceptSignatureBtn,
    disabled: requestedAction === 'VERIFY_LIVENESS',
    onClick: onAcceptClicked,
    finished: true
  }, verbiage.acceptSignatureBtnText))))));
}
var Container$1 = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  display: flex;\n  max-height: 100%;\n  position: absolute;\n  z-index: 1000;\n  width: 100dvw;\n  height: 100dvh;\n  font-family: ", ";\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 40px;\n"], ["\n  display: flex;\n  max-height: 100%;\n  position: absolute;\n  z-index: 1000;\n  width: 100dvw;\n  height: 100dvh;\n  font-family: ", ";\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 40px;\n"])), function (props) {
  var _a;
  return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.fontFamily;
});
var Inner$1 = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  max-height: 1280px;\n  display: flex;\n  margin: auto;\n  align-items: center;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  height: 100%;\n  max-height: 1280px;\n  display: flex;\n  margin: auto;\n  align-items: center;\n  flex-direction: column;\n"])));
var FaceGuideContainer$1 = styled.div(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  position: relative;\n  height: 50%;\n"], ["\n  position: relative;\n  height: 50%;\n"])));
var StyledSelfieCaptureAnimatedMask = styled(SelfieCaptureAnimatedMaskWithStatus)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  max-width: 100%;\n  height: 100%;\n"], ["\n  max-width: 100%;\n  height: 100%;\n"])));
var SignaturePadContainer = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  position: relative;\n  max-width: 100%;\n  height: 50%;\n  aspect-ratio: 2;\n"], ["\n  position: relative;\n  max-width: 100%;\n  height: 50%;\n  aspect-ratio: 2;\n"])));
var SignatureCanvasContainer = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 67px);\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 67px);\n  ", "\n"])), function (props) {
  return props.$disabled ? 'opacity: 0.5; pointer-events: none;' : '';
});
var AcceptBtn = styled(LoaderButton)(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var templateObject_1$9, templateObject_2$8, templateObject_3$8, templateObject_4$3, templateObject_5$2, templateObject_6$2, templateObject_7$1;

var VideoSignatureCapture = function VideoSignatureCapture(_a) {
  var _b;
  var onVideoCaptured = _a.onVideoCaptured,
    onFaceNotDetected = _a.onFaceNotDetected,
    onExit = _a.onExit,
    guidesComponent = _a.guidesComponent,
    _c = _a.classNames,
    classNames = _c === void 0 ? {} : _c,
    _d = _a.colors,
    colors = _d === void 0 ? {} : _d,
    _e = _a.verbiage,
    rawVerbiage = _e === void 0 ? {} : _e,
    _f = _a.debugMode,
    debugMode = _f === void 0 ? false : _f;
  var camera = useCameraStore(function (state) {
    return state.camera;
  });
  var onPredictionMade = useContext(SelfieGuidanceModelsContext).onPredictionMade;
  var _g = useVideoSignatureContext(),
    signatureData = _g.signatureData,
    signatureDataUrl = _g.signatureDataUrl,
    signatureVideoData = _g.signatureVideoData,
    startRecording = _g.startRecording,
    stopRecording = _g.stopRecording;
  useEffect(function () {
    startRecording();
    return function () {
      stopRecording();
    };
  }, [startRecording, stopRecording]);
  colors.guidanceMessageBackgroundColor || (colors.guidanceMessageBackgroundColor = '#ccc');
  colors.guidanceMessageTextColor || (colors.guidanceMessageTextColor = 'black');
  var verbiage = useTranslations(rawVerbiage, {
    guidanceMessageText: 'Please sign the box below'
  });
  useEffect(function () {
    if (signatureVideoData && signatureData && signatureDataUrl) {
      onVideoCaptured === null || onVideoCaptured === void 0 ? void 0 : onVideoCaptured(signatureVideoData, signatureData, signatureDataUrl);
    }
  }, [onVideoCaptured, signatureData, signatureDataUrl, signatureVideoData]);
  var _h = useState(0),
    numFramesWithoutFaces = _h[0],
    setNumFramesWithoutFaces = _h[1];
  useEffect(function () {
    onPredictionMade(function (_a) {
      var face = _a.face;
      setNumFramesWithoutFaces(face ? 0 : function (n) {
        return n + 1;
      });
    });
  }, [onPredictionMade]);
  useEffect(function () {
    if (numFramesWithoutFaces >= 2) {
      onFaceNotDetected === null || onFaceNotDetected === void 0 ? void 0 : onFaceNotDetected();
    }
  }, [numFramesWithoutFaces, onFaceNotDetected]);
  var GuidesComponent = guidesComponent !== null && guidesComponent !== void 0 ? guidesComponent : VideoSignatureGuides;
  return /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_b = classNames.container) !== null && _b !== void 0 ? _b : '')
  }, verbiage.guidanceMessageText && ( /*#__PURE__*/React__default.createElement(GuidanceMessageContainer, {
    "$top": "10vh",
    className: classNames.guidanceMessageContainer
  }, /*#__PURE__*/React__default.createElement(GuidanceMessage, {
    className: classNames.guidanceMessage,
    "$background": colors.guidanceMessageBackgroundColor,
    "$textColor": colors.guidanceMessageTextColor
  }, verbiage.guidanceMessageText))), /*#__PURE__*/React__default.createElement(GuidesComponent, {
    classNames: classNames.videoSignatureGuidesClassNames,
    status: "success"
  }), debugMode && ( /*#__PURE__*/React__default.createElement(DebugStatsPane, null, "Video: ", camera === null || camera === void 0 ? void 0 : camera.width, "x", camera === null || camera === void 0 ? void 0 : camera.height)), /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onExit,
    className: classNames.exitCaptureBtn
  }));
};

var VideoSignatureSuccess = function VideoSignatureSuccess(_a) {
  var imageUrl = _a.imageUrl,
    onDoneClick = _a.onDoneClick,
    onRetryClick = _a.onRetryClick,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.colors,
    colors = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    rawVerbiage = _d === void 0 ? {} : _d;
  var signatureVideoUrl = useVideoSignatureContext().signatureVideoUrl;
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Video signature has been successfully captured!',
    retryBtnText: 'Retry',
    doneBtnText: 'Done'
  });
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement("h1", {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(OverlayImageContainer, {
    className: classNames.videoContainer
  }, signatureVideoUrl && ( /*#__PURE__*/React__default.createElement(StyledVideo$1, {
    className: classNames.video,
    src: signatureVideoUrl,
    poster: signatureVideoUrl + '#t=0.1',
    controls: true,
    preload: "metadata",
    autoPlay: true
  })), /*#__PURE__*/React__default.createElement("img", {
    src: imageUrl,
    alt: "",
    style: {
      display: 'none'
    }
  })), /*#__PURE__*/React__default.createElement(ButtonsRow, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    className: classNames.retryBtn,
    onClick: onRetryClick,
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryBtnText), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    className: classNames.doneBtn,
    onClick: onDoneClick,
    colors: colors.doneBtn,
    finished: true
  }, verbiage.doneBtnText))));
};
var StyledVideo$1 = styled.video(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n"], ["\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n"])));
var templateObject_1$8;

var VideoSignatureWizard = function VideoSignatureWizard(_a) {
  var _b;
  var onComplete = _a.onComplete,
    onVideoCaptured = _a.onVideoCaptured,
    onRetryClicked = _a.onRetryClicked,
    onExitCapture = _a.onExitCapture,
    onUserCancel = _a.onUserCancel,
    onLoadingOverlayDismissed = _a.onLoadingOverlayDismissed,
    _c = _a.loadingOverlayMode,
    loadingOverlayMode = _c === void 0 ? 'default' : _c,
    customOverlayContent = _a.customOverlayContent,
    _d = _a.skipSuccessScreen,
    skipSuccessScreen = _d === void 0 ? false : _d,
    _e = _a.allowSignatureAfterLivenessCheckFailure,
    allowSignatureAfterLivenessCheckFailure = _e === void 0 ? false : _e,
    faceLivenessProps = _a.faceLivenessProps,
    _f = _a.assets,
    assets = _f === void 0 ? {} : _f,
    _g = _a.classNames,
    classNames = _g === void 0 ? {} : _g,
    _h = _a.colors,
    colors = _h === void 0 ? {} : _h,
    _j = _a.verbiage,
    verbiage = _j === void 0 ? {} : _j,
    _k = _a.debugMode,
    debugMode = _k === void 0 ? false : _k;
  var _l = useContext(SubmissionContext),
    selfieImage = _l.selfieImage,
    setSelfieImage = _l.setSelfieImage,
    setSignatureData = _l.setSignatureData,
    setSignatureVideoUrl = _l.setSignatureVideoUrl,
    logSelfieCaptureAttempt = _l.logSelfieCaptureAttempt;
  var _m = useCameraStore(useShallow(function (state) {
      return {
        cameraAccessDenied: state.cameraAccessDenied,
        requestCameraAccess: state.requestCameraAccess,
        releaseCameraAccess: state.releaseCameraAccess
      };
    })),
    cameraAccessDenied = _m.cameraAccessDenied,
    requestCameraAccess = _m.requestCameraAccess,
    releaseCameraAccess = _m.releaseCameraAccess;
  var _o = useState('CHECKING_LIVENESS'),
    captureState = _o[0],
    setCaptureState = _o[1];
  var operationStartedAt = useRef();
  var captureStartedAt = useRef();
  var captureEndedAt = useRef();
  var _p = useContext(SelfieGuidanceModelsContext),
    start = _p.start,
    stop = _p.stop;
  useEffect(function () {
    operationStartedAt.current = new Date();
  }, []);
  useEffect(function () {
    if (captureState !== 'CHECKING_LIVENESS') return;
    captureStartedAt.current = new Date();
  }, [captureState]);
  var shouldRun = ['CHECKING_LIVENESS', 'CAPTURING_SIGNATURE'].includes(captureState);
  useEffect(function () {
    if (!shouldRun) return;
    start();
    return function () {
      stop();
    };
  }, [shouldRun, start, stop]);
  var logCaptureMetadata = useCallback(function () {
    var _a, _b, _c;
    logSelfieCaptureAttempt({
      autoCapture: 'Y',
      captureTime: ((_a = captureEndedAt.current) !== null && _a !== void 0 ? _a : new Date()).getTime() - ((_b = captureStartedAt.current) !== null && _b !== void 0 ? _b : new Date()).getTime(),
      operationTime: new Date().getTime() - ((_c = operationStartedAt.current) !== null && _c !== void 0 ? _c : new Date()).getTime()
    });
    operationStartedAt.current = new Date();
  }, [logSelfieCaptureAttempt]);
  var onFaceLivenessSuccessProp = faceLivenessProps === null || faceLivenessProps === void 0 ? void 0 : faceLivenessProps.onSuccess;
  var onFaceCaptureSuccess = useCallback(function (response, request) {
    var _a, _b;
    onFaceLivenessSuccessProp === null || onFaceLivenessSuccessProp === void 0 ? void 0 : onFaceLivenessSuccessProp(response, request);
    setCaptureState('CAPTURING_SIGNATURE');
    logCaptureMetadata();
    var selfieFromRequest = (_b = (_a = request.customerData) === null || _a === void 0 ? void 0 : _a.biometricData) === null || _b === void 0 ? void 0 : _b.selfie;
    if (!selfieImage && selfieFromRequest) {
      setSelfieImage(selfieFromRequest);
    }
  }, [logCaptureMetadata, onFaceLivenessSuccessProp, selfieImage, setSelfieImage]);
  var _q = useState(null),
    signatureImageUrl = _q[0],
    setSignatureImageUrl = _q[1];
  var onSignatureCaptureCompleted = useCallback(function (videoData, signatureData, signatureImageData) {
    setSignatureData(signatureData);
    setSignatureVideoUrl(URL.createObjectURL(videoData));
    setSignatureImageUrl(signatureImageData);
    setCaptureState('SUCCESS');
    onVideoCaptured === null || onVideoCaptured === void 0 ? void 0 : onVideoCaptured(videoData, signatureData, signatureImageData);
  }, [onVideoCaptured, setSignatureData, setSignatureVideoUrl]);
  var onSignatureCaptureFacesNotDetected = useCallback(function () {
    setCaptureState('CHECKING_LIVENESS');
  }, []);
  var _r = useState(0),
    attempt = _r[0],
    setAttempt = _r[1];
  var onExit = useCallback(function () {
    releaseCameraAccess();
    setAttempt(function (n) {
      return n + 1;
    });
    setCaptureState('CHECKING_LIVENESS');
    onExitCapture === null || onExitCapture === void 0 ? void 0 : onExitCapture();
    requestCameraAccess();
  }, [onExitCapture, releaseCameraAccess, requestCameraAccess]);
  var onRetry = useCallback(function () {
    onRetryClicked === null || onRetryClicked === void 0 ? void 0 : onRetryClicked();
    onExit();
  }, [onExit, onRetryClicked]);
  var showSuccessScreen = useShowSuccessScreen(skipSuccessScreen, captureState === 'SUCCESS', onComplete);
  useEffect(function () {
    if (cameraAccessDenied) {
      setAttempt(function (n) {
        return n + 1;
      });
      setCaptureState('CHECKING_LIVENESS');
    }
  }, [cameraAccessDenied]);
  var guidesComponent = useCallback(function (_a) {
    var status = _a.status;
    return /*#__PURE__*/React__default.createElement(VideoSignatureGuides, {
      classNames: classNames === null || classNames === void 0 ? void 0 : classNames.videoSignatureGuidesClassNames,
      faceGuideStatus: status,
      requestedAction: status === 'success' ? 'CAPTURE_SIGNATURE' : 'VERIFY_LIVENESS'
    });
  }, [classNames === null || classNames === void 0 ? void 0 : classNames.videoSignatureGuidesClassNames]);
  var onExitAfterFailureProp = faceLivenessProps === null || faceLivenessProps === void 0 ? void 0 : faceLivenessProps.onExitAfterFailure;
  var onExitAfterFailure = useCallback(function (resp, req) {
    onExitAfterFailureProp === null || onExitAfterFailureProp === void 0 ? void 0 : onExitAfterFailureProp(resp, req);
    if (allowSignatureAfterLivenessCheckFailure) {
      setCaptureState('CAPTURING_SIGNATURE');
    }
  }, [allowSignatureAfterLivenessCheckFailure, onExitAfterFailureProp]);
  var faceLivenessOnLoadingOverlayDismissed = faceLivenessProps === null || faceLivenessProps === void 0 ? void 0 : faceLivenessProps.onLoadingOverlayDismissed;
  var onLoadingOverlayDismissedCallback = useCallback(function () {
    onLoadingOverlayDismissed === null || onLoadingOverlayDismissed === void 0 ? void 0 : onLoadingOverlayDismissed();
    faceLivenessOnLoadingOverlayDismissed === null || faceLivenessOnLoadingOverlayDismissed === void 0 ? void 0 : faceLivenessOnLoadingOverlayDismissed();
  }, [faceLivenessOnLoadingOverlayDismissed, onLoadingOverlayDismissed]);
  return /*#__PURE__*/React__default.createElement(VideoSignatureContextProvider, null, /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_b = classNames === null || classNames === void 0 ? void 0 : classNames.container) !== null && _b !== void 0 ? _b : '')
  }, /*#__PURE__*/React__default.createElement(CameraVideoTag, {
    className: classNames.cameraFeed
  }), function () {
    switch (captureState) {
      case 'CHECKING_LIVENESS':
        return /*#__PURE__*/React__default.createElement(FaceLivenessWizard, _assign({
          key: "face-liveness-".concat(attempt)
        }, faceLivenessProps, {
          onSuccess: onFaceCaptureSuccess,
          onExitCapture: onExit,
          onUserCancel: onUserCancel,
          onExitAfterFailure: onExitAfterFailure,
          onLoadingOverlayDismissed: onLoadingOverlayDismissedCallback,
          customOverlayContent: customOverlayContent,
          loadingOverlayMode: loadingOverlayMode,
          guidesComponent: guidesComponent,
          assets: assets.faceLiveness,
          classNames: classNames.faceLiveness,
          colors: colors.faceLiveness,
          verbiage: verbiage.faceLiveness,
          debugMode: debugMode,
          releaseCameraAccessOnExit: false,
          renderCameraFeed: false
        }));
      case 'CAPTURING_SIGNATURE':
        return /*#__PURE__*/React__default.createElement(VideoSignatureCapture, {
          onVideoCaptured: onSignatureCaptureCompleted,
          onFaceNotDetected: onSignatureCaptureFacesNotDetected,
          onExit: onExit,
          guidesComponent: guidesComponent,
          classNames: classNames,
          colors: colors,
          verbiage: verbiage,
          debugMode: debugMode
        });
      case 'SUCCESS':
        if (!showSuccessScreen) return;
        return /*#__PURE__*/React__default.createElement(VideoSignatureSuccess, {
          imageUrl: signatureImageUrl !== null && signatureImageUrl !== void 0 ? signatureImageUrl : '',
          onDoneClick: onComplete,
          onRetryClick: onRetry,
          classNames: classNames.success,
          colors: colors.success,
          verbiage: verbiage.success
        });
      default:
        return null;
    }
  }()));
};

var IdVideoCaptureGuides = function IdVideoCaptureGuides(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
  var _z = _a.requestedAction,
    requestedAction = _z === void 0 ? 'SHOW_ID_FRONT' : _z,
    _0 = _a.idDocumentType,
    idDocumentType = _0 === void 0 ? 'idCard' : _0,
    _1 = _a.satisfied,
    satisfied = _1 === void 0 ? false : _1,
    _2 = _a.faceGuideStatus,
    faceGuideStatus = _2 === void 0 ? 'success' : _2,
    faceGuideBorderWidth = _a.faceGuideBorderWidth,
    faceGuideBorderColor = _a.faceGuideBorderColor,
    _3 = _a.idCardGuideStatus,
    idCardGuideStatus = _3 === void 0 ? 'ready' : _3,
    idCardGuideBorderWidth = _a.idCardGuideBorderWidth,
    idCardGuideBorderColor = _a.idCardGuideBorderColor,
    idCardCaptureProgress = _a.idCardCaptureProgress,
    _4 = _a.idCaptureGuideImages,
    userSuppliedImages = _4 === void 0 ? defaultIdCaptureGuideImages : _4,
    _5 = _a.classNames,
    classNames = _5 === void 0 ? {} : _5,
    _6 = _a.verbiage,
    rawVerbiage = _6 === void 0 ? {} : _6;
  var isRearFacing = useCameraStore(function (state) {
    return state.isRearFacing;
  });
  var verbiage = useTranslations(rawVerbiage, {
    idFrontInstructionText: 'Display the front of your ID card...',
    idBackInstructionText: 'Display the back of your ID card...',
    passportInstructionText: 'Display the ID page of your passport...',
    flipIdInstructionText: 'Please flip your ID card...',
    verifyLivenessInstructionText: 'Performing facial recognition, please hold still...'
  });
  var instructionText = requestedAction === 'VERIFY_LIVENESS' ? verbiage.verifyLivenessInstructionText : requestedAction === 'SHOW_PASSPORT' ? verbiage.passportInstructionText : requestedAction === 'SHOW_ID_FRONT' ? verbiage.idFrontInstructionText : requestedAction === 'FLIP_ID' ? verbiage.flipIdInstructionText : verbiage.idBackInstructionText;
  var theme = useTheme();
  if (faceGuideBorderWidth === undefined) faceGuideBorderWidth = (_d = (_c = (_b = theme.idVideoCapture) === null || _b === void 0 ? void 0 : _b.faceGuides) === null || _c === void 0 ? void 0 : _c.borderWidth) !== null && _d !== void 0 ? _d : 5;
  if (faceGuideBorderColor === undefined) faceGuideBorderColor = (_j = satisfied ? (_f = (_e = theme.idVideoCapture) === null || _e === void 0 ? void 0 : _e.faceGuides) === null || _f === void 0 ? void 0 : _f.satisfiedColor : (_h = (_g = theme.idVideoCapture) === null || _g === void 0 ? void 0 : _g.faceGuides) === null || _h === void 0 ? void 0 : _h.unsatisfiedColor) !== null && _j !== void 0 ? _j : '#D6DCE7';
  if (idCardGuideBorderWidth === undefined) idCardGuideBorderWidth = (_m = (_l = (_k = theme.idVideoCapture) === null || _k === void 0 ? void 0 : _k.idCardGuides) === null || _l === void 0 ? void 0 : _l.borderWidth) !== null && _m !== void 0 ? _m : 20;
  if (idCardGuideBorderColor === undefined) idCardGuideBorderColor = (_s = satisfied ? (_p = (_o = theme.idVideoCapture) === null || _o === void 0 ? void 0 : _o.idCardGuides) === null || _p === void 0 ? void 0 : _p.satisfiedColor : (_r = (_q = theme.idVideoCapture) === null || _q === void 0 ? void 0 : _q.idCardGuides) === null || _r === void 0 ? void 0 : _r.unsatisfiedColor) !== null && _s !== void 0 ? _s : '#D6DCE7';
  var _7 = useResizeObserver(),
    idCardGuideRef = _7.ref,
    _8 = _7.width,
    idCardGuideWidth = _8 === void 0 ? 0 : _8,
    _9 = _7.height,
    idCardGuideHeight = _9 === void 0 ? 0 : _9;
  var idCaptureGuideImages = useGuideImages(userSuppliedImages);
  var idCaptureGuideImagesByUrl = useGuideImagesByUrl(idCaptureGuideImages);
  var _10 = useState(undefined),
    aspectRatio = _10[0],
    setAspectRatio = _10[1];
  var onImageLoaded = useCallback(function (e) {
    var _a, _b, _c, _d;
    var img = e.currentTarget;
    var imageByUrl = idCaptureGuideImagesByUrl[img.src];
    var naturalWidth = (_b = (_a = imageByUrl === null || imageByUrl === void 0 ? void 0 : imageByUrl.width) !== null && _a !== void 0 ? _a : img.naturalWidth) !== null && _b !== void 0 ? _b : 0;
    var naturalHeight = (_d = (_c = imageByUrl === null || imageByUrl === void 0 ? void 0 : imageByUrl.height) !== null && _c !== void 0 ? _c : img.naturalHeight) !== null && _d !== void 0 ? _d : 0;
    setAspectRatio(naturalHeight > 0 ? naturalWidth / naturalHeight : undefined);
  }, [idCaptureGuideImagesByUrl]);
  var idCardImageStyle = useMemo(function () {
    return {
      maxWidth: idCardGuideWidth > idCardGuideHeight ? idCardGuideWidth : undefined,
      maxHeight: idCardGuideHeight > idCardGuideWidth ? idCardGuideHeight : undefined,
      height: '100%',
      aspectRatio: aspectRatio
    };
  }, [idCardGuideWidth, idCardGuideHeight, aspectRatio]);
  var disableIdGuides = ((_u = (_t = theme.idVideoCapture) === null || _t === void 0 ? void 0 : _t.idCardGuides) === null || _u === void 0 ? void 0 : _u.disableDuringLivenessCheck) && requestedAction === 'VERIFY_LIVENESS';
  return /*#__PURE__*/React__default.createElement(Container, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(Inner, null, /*#__PURE__*/React__default.createElement(FaceGuideContainer, {
    className: classNames.faceGuideContainer
  }, /*#__PURE__*/React__default.createElement(SelfieCaptureAnimatedMaskWithStatus, {
    className: classNames.faceGuide,
    status: requestedAction === 'VERIFY_LIVENESS' ? faceGuideStatus : 'success',
    borderWidth: faceGuideBorderWidth,
    borderColor: faceGuideBorderColor,
    verticalAlign: "bottom"
  })), !disableIdGuides && ( /*#__PURE__*/React__default.createElement(IdCardGuideContainer, {
    className: classNames.idCardGuideContainer,
    ref: idCardGuideRef
  }, /*#__PURE__*/React__default.createElement(IdCardGuideInner, {
    className: classNames.idCardGuideInner,
    style: {
      aspectRatio: aspectRatio
    }
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImageContainer, {
    className: classNames.idCardGuideImageContainer,
    status: requestedAction === 'VERIFY_LIVENESS' ? 'disabled' : idCardGuideStatus,
    borderWidth: idCardGuideBorderWidth,
    borderColor: idCardGuideBorderColor,
    aspectRatio: aspectRatio,
    "$isVisible": requestedAction !== 'FLIP_ID',
    progress: requestedAction === 'VERIFY_LIVENESS' ? undefined : idCardCaptureProgress
  }, /*#__PURE__*/React__default.createElement(IdCardGuideImage, {
    alt: "",
    className: classNames.idCardGuideImage,
    "$isMirrored": !isRearFacing,
    style: idCardImageStyle,
    src: idDocumentType === 'passport' ? idCaptureGuideImages.landscape.SHOW_PASSPORT.url : requestedAction === 'SHOW_ID_BACK' ? idCaptureGuideImages.landscape.SHOW_ID_BACK.url : idCaptureGuideImages.landscape.SHOW_ID_FRONT.url,
    onLoad: onImageLoaded
  })), requestedAction === 'FLIP_ID' && ( /*#__PURE__*/React__default.createElement(IdVideoCaptureFlipIdPrompt, {
    idCaptureGuideImages: idCaptureGuideImages,
    classNames: classNames.flipIdPrompt,
    borderWidth: idCardGuideBorderWidth,
    borderColor: idCardGuideBorderColor,
    imageStyle: idCardImageStyle
  }))), /*#__PURE__*/React__default.createElement(IdCardGuideInstructionsContainer, {
    className: classNames.idCardGuideInstructionsContainer
  }, /*#__PURE__*/React__default.createElement(IdCardGuideInstructions, {
    className: classNames.idCardGuideInstructions,
    "$textColor": (_w = (_v = theme.idVideoCapture) === null || _v === void 0 ? void 0 : _v.idCardGuides) === null || _w === void 0 ? void 0 : _w.instructionsTextColor,
    "$background": (_y = (_x = theme.idVideoCapture) === null || _x === void 0 ? void 0 : _x.idCardGuides) === null || _y === void 0 ? void 0 : _y.instructionsBackgroundColor
  }, instructionText))))));
};
var Container = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  display: flex;\n  max-height: 100%;\n  position: absolute;\n  z-index: 1000;\n  width: 100dvw;\n  height: 100dvh;\n  font-family: ", ";\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 40px;\n"], ["\n  display: flex;\n  max-height: 100%;\n  position: absolute;\n  z-index: 1000;\n  width: 100dvw;\n  height: 100dvh;\n  font-family: ", ";\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 40px;\n"])), function (props) {
  var _a;
  return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.fontFamily;
});
var Inner = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  max-height: 1280px;\n  display: flex;\n  margin: auto;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  max-height: 1280px;\n  display: flex;\n  margin: auto;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n"])));
var FaceGuideContainer = styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  position: relative;\n  height: 65%;\n"], ["\n  position: relative;\n  height: 65%;\n"])));
var IdCardGuideContainer = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column nowrap;\n  margin: 0 auto;\n  position: relative;\n  max-width: 100%;\n  height: 35%;\n"], ["\n  display: flex;\n  flex-flow: column nowrap;\n  margin: 0 auto;\n  position: relative;\n  max-width: 100%;\n  height: 35%;\n"])));
var IdCardGuideInner = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n  width: 100%;\n"], ["\n  position: relative;\n  height: 100%;\n  width: 100%;\n"])));
var IdCardGuideInstructionsContainer = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  padding: 0 40px;\n  position: fixed;\n  bottom: 14px;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n"], ["\n  width: 100%;\n  text-align: center;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  padding: 0 40px;\n  position: fixed;\n  bottom: 14px;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n"])));
var IdCardGuideInstructions = styled(GuidanceMessage)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  align-content: center;\n  margin: 12px auto;\n  padding: 8px 12px;\n  font-weight: bold;\n  font-size: 18px;\n"], ["\n  align-content: center;\n  margin: 12px auto;\n  padding: 8px 12px;\n  font-weight: bold;\n  font-size: 18px;\n"])));
var templateObject_1$7, templateObject_2$7, templateObject_3$7, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7;

var ReadTextPrompt = function ReadTextPrompt(_a) {
  var text = _a.text,
    onComplete = _a.onComplete,
    _b = _a.durationMs,
    durationMs = _b === void 0 ? 15000 : _b,
    _c = _a.minReadingMs,
    minReadingMs = _c === void 0 ? 10000 : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.verbiage,
    rawVerbiage = _e === void 0 ? {} : _e;
  text = useVerbiage(text, '');
  var countdownTimeoutRef = useRef(undefined);
  var _f = useState(durationMs / 1000),
    countdownRemaining = _f[0],
    setCountdownRemaining = _f[1];
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Please read the following text aloud',
    doneBtnText: 'Done'
  });
  var manualCountdown = useCallback(function (remainingTime) {
    if (remainingTime > 0) {
      var nextCycle_1 = remainingTime - 1;
      setCountdownRemaining(nextCycle_1);
      countdownTimeoutRef.current = setTimeout(function () {
        return manualCountdown(nextCycle_1);
      }, 1000);
    }
  }, []);
  useEffect(function () {
    setCountdownRemaining(countdownRemaining);
    countdownTimeoutRef.current = setTimeout(function () {
      return manualCountdown(countdownRemaining);
    }, 1000);
    return function () {
      clearTimeout(countdownTimeoutRef.current);
    };
  }, [countdownRemaining, manualCountdown]);
  var _g = useState(false),
    minReadingTimeElapsed = _g[0],
    setMinReadingTimeElapsed = _g[1];
  useEffect(function trackReadingTime() {
    var timeout = setTimeout(function () {
      setMinReadingTimeElapsed(true);
    }, minReadingMs);
    return function () {
      clearTimeout(timeout);
    };
  }, [minReadingMs]);
  return /*#__PURE__*/React__default.createElement(ReadTextPromptContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(ReadTextPromptHeading, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ReadTextPromptText, {
    className: classNames.prompt
  }, text), /*#__PURE__*/React__default.createElement(ReadTextPromptButtonsRow, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(ReadTextPromptTimeRemaining, {
    className: classNames.timeRemaining
  }, countdownRemaining), /*#__PURE__*/React__default.createElement(DoneButton, {
    variant: "positive",
    className: classNames.doneBtn,
    onClick: minReadingTimeElapsed ? onComplete : undefined,
    disabled: !minReadingTimeElapsed,
    finished: true
  }, verbiage.doneBtnText)));
};
var ReadTextPromptContainer = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n"])));
var ReadTextPromptHeading = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  padding: 20px;\n  font-weight: bold;\n  margin: auto auto 32px;\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  padding: 20px;\n  font-weight: bold;\n  margin: auto auto 32px;\n\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.heading) === null || _c === void 0 ? void 0 : _c.backgroundColor) ? "background: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.heading) === null || _f === void 0 ? void 0 : _f.backgroundColor, ";") : "";
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.heading) === null || _c === void 0 ? void 0 : _c.textColor) ? "color: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.heading) === null || _f === void 0 ? void 0 : _f.textColor, ";") : "";
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.heading) === null || _c === void 0 ? void 0 : _c.borderRadius) ? "border-radius: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.heading) === null || _f === void 0 ? void 0 : _f.borderRadius, ";") : "";
});
var ReadTextPromptText = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  margin: 0 auto;\n  text-align: center;\n  padding: 50px;\n  font-size: 24px;\n  max-width: ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  margin: 0 auto;\n  text-align: center;\n  padding: 50px;\n  font-size: 24px;\n  max-width: ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"])), typeof window !== 'undefined' && window.innerWidth > window.innerHeight ? '40%' : '90%', function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.prompt) === null || _c === void 0 ? void 0 : _c.backgroundColor) ? "background: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.prompt) === null || _f === void 0 ? void 0 : _f.backgroundColor, ";") : "";
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.prompt) === null || _c === void 0 ? void 0 : _c.textColor) ? "color: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.prompt) === null || _f === void 0 ? void 0 : _f.textColor, ";") : "";
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.prompt) === null || _c === void 0 ? void 0 : _c.borderRadius) ? "border-radius: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.prompt) === null || _f === void 0 ? void 0 : _f.borderRadius, ";") : "";
});
var ReadTextPromptButtonsRow = styled(ButtonsRow)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  margin: 32px auto auto;\n  gap: 20px;\n"], ["\n  margin: 32px auto auto;\n  gap: 20px;\n"])));
var ReadTextPromptTimeRemaining = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 20px;\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  padding: 20px;\n\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.timeRemaining) === null || _c === void 0 ? void 0 : _c.backgroundColor) ? "background: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.timeRemaining) === null || _f === void 0 ? void 0 : _f.backgroundColor, ";") : "";
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.timeRemaining) === null || _c === void 0 ? void 0 : _c.textColor) ? "color: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.timeRemaining) === null || _f === void 0 ? void 0 : _f.textColor, ";") : "";
}, function (props) {
  var _a, _b, _c, _d, _e, _f;
  return ((_c = (_b = (_a = props.theme.idVideoCapture) === null || _a === void 0 ? void 0 : _a.readTextPrompt) === null || _b === void 0 ? void 0 : _b.timeRemaining) === null || _c === void 0 ? void 0 : _c.borderRadius) ? "border-radius: ".concat((_f = (_e = (_d = props.theme.idVideoCapture) === null || _d === void 0 ? void 0 : _d.readTextPrompt) === null || _e === void 0 ? void 0 : _e.timeRemaining) === null || _f === void 0 ? void 0 : _f.borderRadius, ";") : "";
});
var DoneButton = styled(LoaderButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: auto 0;\n"], ["\n  margin: auto 0;\n"])));
var templateObject_1$6, templateObject_2$6, templateObject_3$6, templateObject_4$1, templateObject_5, templateObject_6;

var edgeBoundary = 0.05;
var defaultVideoIdCaptureThresholds = {
  detection: {
    idCardFront: 0.4,
    idCardBack: 0.5,
    passport: 0.3,
    singlePage: 0.3
  },
  focus: {
    idCardFront: {
      desktop: 0,
      mobile: 0
    },
    idCardBack: {
      desktop: 0,
      mobile: 0
    },
    passport: {
      desktop: 0,
      mobile: 0
    },
    singlePage: {
      desktop: 0,
      mobile: 0
    }
  },
  goodFrames: {
    idCardFront: 1,
    idCardBack: 1,
    passport: 1,
    singlePage: 1
  },
  flipShortcutThreshold: 0.7
};
var IdVideoCapture = function IdVideoCapture(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
  var onComplete = _a.onComplete,
    onIdFrontImageCaptured = _a.onIdFrontImageCaptured,
    onIdBackImageCaptured = _a.onIdBackImageCaptured,
    onFaceNotDetected = _a.onFaceNotDetected,
    onRecordingFailed = _a.onRecordingFailed,
    onExitCapture = _a.onExitCapture,
    _w = _a.idCaptureModelsEnabled,
    idCaptureModelsEnabled = _w === void 0 ? true : _w,
    _x = _a.idDocumentType,
    idDocumentType = _x === void 0 ? 'idCard' : _x,
    _y = _a.idCaptureGuideImages,
    idCaptureGuideImages = _y === void 0 ? defaultIdCaptureGuideImages : _y,
    _z = _a.idCardFrontDelay,
    idCardFrontDelay = _z === void 0 ? 1000 : _z,
    _0 = _a.videoIdCaptureThresholds,
    videoIdCaptureThresholds = _0 === void 0 ? defaultVideoIdCaptureThresholds : _0,
    _1 = _a.skipShowIdCardBack,
    skipShowIdCardBack = _1 === void 0 ? false : _1,
    _2 = _a.captureCountdownSeconds,
    captureCountdownSeconds = _2 === void 0 ? 3 : _2,
    readTextPrompt = _a.readTextPrompt,
    _3 = _a.readTextTimeoutDurationMs,
    readTextTimeoutDurationMs = _3 === void 0 ? 15000 : _3,
    _4 = _a.readTextMinReadingMs,
    readTextMinReadingMs = _4 === void 0 ? 10000 : _4,
    _5 = _a.disableFaceDetectionWhileAudioCapture,
    disableFaceDetectionWhileAudioCapture = _5 === void 0 ? false : _5,
    _6 = _a.disableFaceDetectionWhileAudioCaptureMsDelay,
    disableFaceDetectionWhileAudioCaptureMsDelay = _6 === void 0 ? 2000 : _6,
    _7 = _a.mergeAVStreams,
    mergeAVStreams = _7 === void 0 ? false : _7,
    _8 = _a.classNames,
    classNames = _8 === void 0 ? {} : _8,
    _9 = _a.colors,
    colors = _9 === void 0 ? {} : _9,
    _10 = _a.verbiage,
    rawVerbiage = _10 === void 0 ? {} : _10,
    _11 = _a.debugMode,
    debugMode = _11 === void 0 ? false : _11;
  var _12 = useResizeObserver(),
    ref = _12.ref,
    _13 = _12.width,
    width = _13 === void 0 ? 1 : _13,
    _14 = _12.height,
    height = _14 === void 0 ? 1 : _14;
  var _15 = useCameraStore(),
    camera = _15.camera,
    videoRef = _15.videoRef,
    videoLoaded = _15.videoLoaded,
    cameraReady = _15.cameraReady,
    microphoneReady = _15.microphoneReady,
    audioStream = _15.audioStream,
    isRearFacing = _15.isRearFacing,
    releaseCameraAccess = _15.releaseCameraAccess;
  var _16 = useState([]),
    detectedObjects = _16[0],
    setDetectedObjects = _16[1];
  var _17 = useState(null),
    face = _17[0],
    setFace = _17[1];
  var _18 = useContext(IdCaptureModelsContext),
    idModelsReady = _18.ready,
    startIdModels = _18.start,
    stopIdModels = _18.stop,
    onIdPredictionMade = _18.onPredictionMade,
    setThresholds = _18.setThresholds,
    setRequiredDocumentType = _18.setRequiredDocumentType,
    setDocumentDetectionBoundaries = _18.setDocumentDetectionBoundaries,
    bestFrameDetails = _18.bestFrameDetails,
    resetBestFrame = _18.resetBestFrame,
    idModelError = _18.modelError;
  var _19 = useState(null),
    videoStartsAt = _19[0],
    setVideoStartsAt = _19[1];
  var _20 = useContext(SubmissionContext),
    setIdCaptureVideoAudioStartsAt = _20.setIdCaptureVideoAudioStartsAt,
    setExpectedAudioText = _20.setExpectedAudioText;
  var _21 = useContext(SelfieGuidanceModelsContext),
    startSelfieGuidance = _21.start,
    stopSelfieGuidance = _21.stop,
    onSelfiePredictionMade = _21.onPredictionMade,
    selfieModelError = _21.error;
  var _22 = useVideoRecorder(camera, audioStream, mergeAVStreams),
    isRecordingVideo = _22.isRecordingVideo,
    startRecordingVideo = _22.startRecordingVideo,
    startRecordingAudio = _22.startRecordingAudio,
    stopRecordingVideo = _22.stopRecordingVideo,
    stopRecordingAudio = _22.stopRecordingAudio,
    videoRecordingUnintentionallyStopped = _22.videoRecordingUnintentionallyStopped,
    audioRecordingUnintentionallyStopped = _22.audioRecordingUnintentionallyStopped,
    videoUrl = _22.videoUrl,
    audioUrl = _22.audioUrl;
  var countdownTimeoutRef = useRef(undefined);
  var _23 = useState(-1),
    countdownRemaining = _23[0],
    setCountdownRemaining = _23[1];
  useEffect(function () {
    if (!isRecordingVideo && !videoUrl) {
      startRecordingVideo();
      setVideoStartsAt(new Date());
    }
    // if the mergeAVStreams flag is present, the audio stream is on the video
    // stream, so we won't wait for a separate data url containing audio only.
    var needsAudio = !!readTextPrompt && !mergeAVStreams;
    var audioReady = !needsAudio || audioUrl;
    if (videoUrl && audioReady) {
      releaseCameraAccess();
      onComplete === null || onComplete === void 0 ? void 0 : onComplete(videoUrl, audioUrl);
    }
  }, [audioUrl, isRecordingVideo, mergeAVStreams, onComplete, readTextPrompt, releaseCameraAccess, startRecordingVideo, videoUrl]);
  useEffect(function () {
    if (videoRecordingUnintentionallyStopped || audioRecordingUnintentionallyStopped || !!readTextPrompt && !microphoneReady) {
      onRecordingFailed === null || onRecordingFailed === void 0 ? void 0 : onRecordingFailed();
    }
  }, [audioRecordingUnintentionallyStopped, microphoneReady, onRecordingFailed, readTextPrompt, videoRecordingUnintentionallyStopped]);
  var _24 = useState(idDocumentType === 'idCard' ? 'SHOW_ID_FRONT' : 'SHOW_PASSPORT'),
    requestedAction = _24[0],
    setRequestedAction = _24[1];
  var shouldRunIdModels = idCaptureModelsEnabled && videoLoaded && cameraReady && idModelsReady && !idModelError && requestedAction !== 'READ_TEXT' && (!readTextPrompt || microphoneReady);
  useEffect(function startModelsWhenCapturing() {
    if (!shouldRunIdModels) return;
    startIdModels();
    return function () {
      return stopIdModels();
    };
  }, [shouldRunIdModels, startIdModels, stopIdModels]);
  var adjustedThresholds = useMemo(function () {
    if (idDocumentType === 'idCard') {
      return _assign(_assign({}, videoIdCaptureThresholds), {
        detection: _assign(_assign({}, videoIdCaptureThresholds.detection), {
          passport: 1
        })
      });
    } else {
      return _assign(_assign({}, videoIdCaptureThresholds), {
        detection: _assign(_assign({}, videoIdCaptureThresholds.detection), {
          idCardFront: 1,
          idCardBack: 1
        })
      });
    }
  }, [idDocumentType, videoIdCaptureThresholds]);
  useEffect(function () {
    setThresholds(adjustedThresholds);
  }, [requestedAction, setThresholds, adjustedThresholds]);
  useEffect(function () {
    setRequiredDocumentType(requestedAction === 'SHOW_PASSPORT' ? 'passport' : requestedAction === 'SHOW_ID_BACK' ? 'idCardBack' : 'idCardFront');
  }, [requestedAction, setRequiredDocumentType]);
  useEffect(function () {
    setDocumentDetectionBoundaries({
      top: 20,
      left: 20,
      right: 20,
      bottom: 0
    });
  }, [setDocumentDetectionBoundaries]);
  var _25 = useState(0),
    currentDetectionScore = _25[0],
    setCurrentDetectionScore = _25[1];
  var _26 = useState('none'),
    currentDetectedDocumentType = _26[0],
    setCurrentDetectedDocumentType = _26[1];
  var _27 = useState(0),
    currentFocusScore = _27[0],
    setCurrentFocusScore = _27[1];
  var _28 = useState(0),
    goodFramesCount = _28[0],
    setGoodFramesCount = _28[1];
  var goodFramesThreshold = requestedAction === 'SHOW_PASSPORT' ? adjustedThresholds.goodFrames.passport : requestedAction === 'SHOW_ID_FRONT' ? adjustedThresholds.goodFrames.idCardFront : adjustedThresholds.goodFrames.idCardBack;
  var goodFramesThresholdMet = goodFramesCount >= goodFramesThreshold;
  var _29 = useState(false),
    isSinglePage = _29[0],
    setIsSinglePage = _29[1];
  useEffect(function () {
    if (!idCaptureModelsEnabled || idModelError) return;
    onIdPredictionMade(function (prediction) {
      setDetectedObjects(prediction.detectedObjects);
      setCurrentDetectionScore(prediction.detectionScore);
      setCurrentDetectedDocumentType(prediction.detectedDocumentType);
      setCurrentFocusScore(prediction.focusScore);
      setIsSinglePage(prediction.singlePageDetectionThresholdMet);
      var detectionThresholdMet = requestedAction === 'SHOW_PASSPORT' ? prediction.passportDetectionThresholdMet : requestedAction === 'SHOW_ID_BACK' ? prediction.idCardBackDetectionThresholdMet : prediction.idCardFrontDetectionThresholdMet || prediction.singlePageDetectionThresholdMet;
      var isGoodFrame = detectionThresholdMet && prediction.focusThresholdMet;
      var shouldShortcutFlipAnimation = requestedAction === 'FLIP_ID' && isGoodFrame && prediction.idCardBackDetectionScore >= adjustedThresholds.flipShortcutThreshold;
      if (shouldShortcutFlipAnimation) {
        return setRequestedAction('SHOW_ID_BACK');
      }
      setGoodFramesCount(isGoodFrame ? function (n) {
        return n + 1;
      } : 0);
    });
  }, [idCaptureModelsEnabled, onIdPredictionMade, idModelError, requestedAction, adjustedThresholds.flipShortcutThreshold]);
  var _30 = useState(null),
    idFrontCaptureStartedAt = _30[0],
    setFirstGoodFrameTime = _30[1];
  useEffect(function () {
    if (goodFramesCount === 1) setFirstGoodFrameTime(new Date().getTime());
  }, [goodFramesCount]);
  var delaySatisfied = !['SHOW_ID_FRONT', 'SHOW_PASSPORT'].includes(requestedAction) || idFrontCaptureStartedAt !== null && new Date().getTime() > idFrontCaptureStartedAt + idCardFrontDelay;
  var translatedText = useVerbiage(readTextPrompt, '');
  var onIdCaptureComplete = useCallback(function () {
    var _a;
    if (translatedText) {
      setRequestedAction('READ_TEXT');
      startRecordingAudio();
      setIdCaptureVideoAudioStartsAt(new Date().getTime() - ((_a = videoStartsAt === null || videoStartsAt === void 0 ? void 0 : videoStartsAt.getTime()) !== null && _a !== void 0 ? _a : 0));
      setExpectedAudioText(translatedText);
    } else {
      stopRecordingVideo();
    }
  }, [setExpectedAudioText, setIdCaptureVideoAudioStartsAt, startRecordingAudio, stopRecordingVideo, translatedText, videoStartsAt]);
  var frameWidth = (_c = (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) !== null && _c !== void 0 ? _c : 0;
  var frameHeight = (_e = (_d = videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) !== null && _e !== void 0 ? _e : 0;
  var faceBox = face === null || face === void 0 ? void 0 : face.box;
  var faceCentered = !faceBox || !frameWidth || faceBox.xMin > frameWidth * edgeBoundary && faceBox.yMin > frameHeight * edgeBoundary && faceBox.xMax < frameWidth * (1 - edgeBoundary) && faceBox.yMax < frameHeight * (1 - edgeBoundary);
  var _31 = useState(),
    countdownStartedAt = _31[0],
    setCountdownStartedAt = _31[1];
  var photoCanvas = useRef(null);
  var frameLock = useRef(false);
  var captureFrame = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var frameBase64;
      return __generator(this, function (_a) {
        if (frameLock.current) return [2 /*return*/];
        frameLock.current = true;
        drawToCanvas(photoCanvas.current, videoRef.current);
        frameBase64 = photoCanvas.current.toDataURL('image/jpeg');
        if (!frameBase64) {
          frameLock.current = false;
          return [2 /*return*/];
        }
        try {
          if (requestedAction == 'SHOW_ID_FRONT') {
            if (onIdFrontImageCaptured) {
              onIdFrontImageCaptured(frameBase64);
            }
            if (isSinglePage || evaluateShouldSkip(skipShowIdCardBack)) {
              return [2 /*return*/, onIdCaptureComplete()];
            }
            setRequestedAction('FLIP_ID');
          } else if (requestedAction == 'SHOW_ID_BACK') {
            if (onIdBackImageCaptured) {
              onIdBackImageCaptured(frameBase64);
            }
            onIdCaptureComplete();
          } else if (requestedAction == 'SHOW_PASSPORT') {
            if (onIdFrontImageCaptured) {
              onIdFrontImageCaptured(frameBase64);
            }
            onIdCaptureComplete();
          }
        } finally {
          setDetectedObjects([]);
          setCurrentDetectionScore(0);
          setCurrentFocusScore(0);
          setGoodFramesCount(0);
          setCountdownStartedAt(undefined);
          setIsSinglePage(false);
          resetBestFrame();
          frameLock.current = false;
          if (countdownTimeoutRef.current) {
            clearTimeout(countdownTimeoutRef.current);
          }
        }
        return [2 /*return*/];
      });
    });
  }, [videoRef, requestedAction, onIdFrontImageCaptured, isSinglePage, skipShowIdCardBack, onIdCaptureComplete, onIdBackImageCaptured, resetBestFrame]);
  var isFlipping = requestedAction === 'FLIP_ID';
  useEffect(function () {
    if (!isFlipping) return;
    var t = setTimeout(function () {
      setRequestedAction('SHOW_ID_BACK');
    }, 6000);
    return function () {
      clearTimeout(t);
    };
  }, [isFlipping]);
  var stopRecording = useCallback(function () {
    stopRecordingVideo();
    stopRecordingAudio();
  }, [stopRecordingAudio, stopRecordingVideo]);
  var satisfied = !isFlipping && goodFramesThresholdMet && faceCentered && delaySatisfied;
  useEffect(function () {
    if (satisfied && !countdownStartedAt) {
      setCountdownStartedAt(new Date());
    }
  }, [countdownStartedAt, satisfied]);
  useEffect(function () {
    return function () {
      clearTimeout(countdownTimeoutRef.current);
    };
  }, []);
  var manualCountdown = useCallback(function (remainingTime) {
    if (remainingTime > 0) {
      var nextCycle_1 = remainingTime - 1;
      setCountdownRemaining(nextCycle_1);
      countdownTimeoutRef.current = setTimeout(function () {
        return manualCountdown(nextCycle_1);
      }, 1000);
      return;
    }
  }, [countdownTimeoutRef]);
  useEffect(function () {
    if (!countdownStartedAt) return;
    setCountdownRemaining(captureCountdownSeconds);
    countdownTimeoutRef.current = setTimeout(function () {
      return manualCountdown(captureCountdownSeconds);
    }, 1000);
    return function () {
      clearTimeout(countdownTimeoutRef.current);
    };
  }, [captureCountdownSeconds, countdownStartedAt, manualCountdown]);
  useEffect(function () {
    if (countdownRemaining === 0) {
      setCountdownRemaining(-1);
      captureFrame().then();
    }
  }, [captureFrame, countdownRemaining]);
  var timeoutStartedAt = useTimeout(readTextTimeoutDurationMs, stopRecording, requestedAction !== 'READ_TEXT', false, requestedAction === 'READ_TEXT').timeoutStartedAt;
  useEffect(function () {
    startSelfieGuidance();
    return function () {
      stopSelfieGuidance();
    };
  }, [startSelfieGuidance, stopSelfieGuidance]);
  var _32 = useState(0),
    numFramesWithoutFaces = _32[0],
    setNumFramesWithoutFaces = _32[1];
  onSelfiePredictionMade(useThrottledCallback(useCallback(function (_a) {
    var face = _a.face;
    if (selfieModelError) return;
    setFace(face);
    setNumFramesWithoutFaces(face ? 0 : function (n) {
      return n + 1;
    });
  }, [selfieModelError]), 16));
  useEffect(function () {
    var ignoreMissingFaces = disableFaceDetectionWhileAudioCapture && (timeoutStartedAt === null || timeoutStartedAt === void 0 ? void 0 : timeoutStartedAt.getTime()) && new Date().getTime() - (timeoutStartedAt === null || timeoutStartedAt === void 0 ? void 0 : timeoutStartedAt.getTime()) > disableFaceDetectionWhileAudioCaptureMsDelay;
    if (!ignoreMissingFaces && numFramesWithoutFaces >= 2) {
      onFaceNotDetected === null || onFaceNotDetected === void 0 ? void 0 : onFaceNotDetected();
    }
  }, [disableFaceDetectionWhileAudioCapture, disableFaceDetectionWhileAudioCaptureMsDelay, numFramesWithoutFaces, onFaceNotDetected, timeoutStartedAt]);
  var theme = useTheme();
  var _33 = useTranslations(rawVerbiage, {
      faceNotCenteredText: 'Please move your face to the center...',
      captureBtnText: 'Capture'
    }),
    captureBtnText = _33.captureBtnText,
    faceNotCenteredText = _33.faceNotCenteredText;
  var debugScalingDetails = useDebugScalingDetails({
    enabled: debugMode,
    pageWidth: width,
    pageHeight: height,
    videoWidth: (_g = (_f = videoRef.current) === null || _f === void 0 ? void 0 : _f.videoWidth) !== null && _g !== void 0 ? _g : 0,
    videoHeight: (_j = (_h = videoRef.current) === null || _h === void 0 ? void 0 : _h.videoHeight) !== null && _j !== void 0 ? _j : 0
  });
  var capturingId = ['SHOW_ID_FRONT', 'SHOW_ID_BACK', 'SHOW_PASSPORT'].includes(requestedAction);
  var guidanceText = !faceCentered ? faceNotCenteredText : undefined;
  return /*#__PURE__*/React__default.createElement(PageContainer, {
    ref: ref,
    className: "flex ".concat((_k = classNames.container) !== null && _k !== void 0 ? _k : '')
  }, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: photoCanvas
  }), requestedAction === 'READ_TEXT' ? ( /*#__PURE__*/React__default.createElement(ReadTextPrompt, {
    text: readTextPrompt,
    startedAt: timeoutStartedAt || undefined,
    durationMs: readTextTimeoutDurationMs,
    minReadingMs: readTextMinReadingMs,
    classNames: classNames.readTextPrompt,
    verbiage: rawVerbiage.readTextPrompt,
    onComplete: stopRecording
  })) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IdVideoCaptureGuides, {
    classNames: classNames.guides,
    verbiage: rawVerbiage.guides,
    requestedAction: requestedAction,
    idDocumentType: idDocumentType,
    satisfied: satisfied,
    idCardGuideStatus: countdownStartedAt ? 'capturing' : 'ready',
    idCardCaptureProgress: countdownStartedAt ? 1 : 0,
    idCaptureGuideImages: idCaptureGuideImages,
    faceGuideBorderColor: satisfied ? colors.guidesSatisfiedColor : colors.guidesUnsatisfiedColor,
    idCardGuideBorderColor: satisfied ? colors.guidesSatisfiedColor : colors.guidesUnsatisfiedColor
  }), debugMode && capturingId && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ObjectDetectionDebugOverlayDiv, {
    "$flipX": !isRearFacing
  }, detectedObjects.map(function (obj, i) {
    return /*#__PURE__*/React__default.createElement(IdCaptureDetectedObjectDebugBox, {
      key: i,
      obj: obj,
      scaling: debugScalingDetails,
      color: "blue",
      flipX: !isRearFacing
    });
  })), /*#__PURE__*/React__default.createElement(DebugBoundingBoxOverlay, null, face && ( /*#__PURE__*/React__default.createElement(SelfieCaptureFaceDebugBox, {
    face: face,
    scaling: debugScalingDetails
  }))))))), guidanceText && idCaptureModelsEnabled && !idModelError && ( /*#__PURE__*/React__default.createElement(GuidanceMessageContainer, {
    className: classNames.guidanceMessageContainer
  }, /*#__PURE__*/React__default.createElement(GuidanceMessage, {
    className: classNames.guidanceMessage,
    "$background": (_o = (_m = (_l = theme.guidanceMessages) === null || _l === void 0 ? void 0 : _l.negative) === null || _m === void 0 ? void 0 : _m.backgroundColor) !== null && _o !== void 0 ? _o : 'red',
    "$textColor": (_r = (_q = (_p = theme.guidanceMessages) === null || _p === void 0 ? void 0 : _p.negative) === null || _q === void 0 ? void 0 : _q.textColor) !== null && _r !== void 0 ? _r : 'white'
  }, guidanceText))), debugMode && ( /*#__PURE__*/React__default.createElement(DebugStatsPane, null, camera ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "\u2705 Camera: ", camera.label, " (", camera.width, "x", camera.height, ")")) : '❌ Camera not ready', /*#__PURE__*/React__default.createElement("br", null), isRecordingVideo ? '✅ Recording' : '❌ Not recording', /*#__PURE__*/React__default.createElement("br", null), goodFramesThresholdMet ? '✅' : '❌', " Good Frame Count:", ' ', goodFramesCount, "/", goodFramesThreshold, /*#__PURE__*/React__default.createElement("br", null), "Document Type: ", currentDetectedDocumentType, /*#__PURE__*/React__default.createElement("br", null), "Detection Score: ", currentDetectionScore, /*#__PURE__*/React__default.createElement("br", null), "Focus Score: ", currentFocusScore, /*#__PURE__*/React__default.createElement("br", null), "Best Frame Detection Score:", ' ', (_t = (_s = bestFrameDetails.current) === null || _s === void 0 ? void 0 : _s.detectionScore) !== null && _t !== void 0 ? _t : 0, /*#__PURE__*/React__default.createElement("br", null), "Best Frame Focus Score: ", (_v = (_u = bestFrameDetails.current) === null || _u === void 0 ? void 0 : _u.focusScore) !== null && _v !== void 0 ? _v : 0)), countdownRemaining > 0 && capturingId && ( /*#__PURE__*/React__default.createElement(CountdownContainer, {
    className: classNames.countdownContainer
  }, /*#__PURE__*/React__default.createElement(Countdown, {
    className: classNames.countdown
  }, countdownRemaining))), (!idCaptureModelsEnabled || idModelError) && capturingId && ( /*#__PURE__*/React__default.createElement(CaptureButtonContainer, {
    className: classNames.captureBtnContainer
  }, /*#__PURE__*/React__default.createElement(CaptureButton, {
    finished: true,
    onClick: function onClick() {
      return setCountdownStartedAt(new Date());
    },
    disabled: !!countdownStartedAt || frameLock.current,
    className: classNames.captureBtn
  }, captureBtnText))), /*#__PURE__*/React__default.createElement(ExitCaptureButton, {
    onClick: onExitCapture,
    className: classNames.exitCaptureBtn
  }));
};
var CountdownContainer = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100dvw;\n  height: 100dvh;\n  z-index: 99999;\n  display: flex;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100dvw;\n  height: 100dvh;\n  z-index: 99999;\n  display: flex;\n"])));
var Countdown = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  color: white;\n  font-size: 64px;\n  font-weight: bold;\n  margin: auto;\n"], ["\n  color: white;\n  font-size: 64px;\n  font-weight: bold;\n  margin: auto;\n"])));
var CaptureButtonContainer = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  width: 100dvw;\n  display: flex;\n  z-index: 100000;\n"], ["\n  position: fixed;\n  bottom: 0;\n  width: 100dvw;\n  display: flex;\n  z-index: 100000;\n"])));
var CaptureButton = styled(LoaderButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0 auto 25px;\n"], ["\n  margin: 0 auto 25px;\n"])));
function evaluateShouldSkip(value) {
  if (value === true) return true;
  if (typeof value === 'function') return value();
  return false;
}
var templateObject_1$5, templateObject_2$5, templateObject_3$5, templateObject_4;

var IdVideoCaptureSuccess = function IdVideoCaptureSuccess(_a) {
  var videoUrl = _a.videoUrl,
    audioUrl = _a.audioUrl,
    idFrontImageUrl = _a.idFrontImageUrl,
    idBackImageUrl = _a.idBackImageUrl,
    onDoneClick = _a.onDoneClick,
    onRetryClick = _a.onRetryClick,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.colors,
    colors = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    rawVerbiage = _d === void 0 ? {} : _d;
  var _e = useState('video'),
    displayedAsset = _e[0],
    setDisplayedAsset = _e[1];
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Video ID has been successfully captured!',
    retryBtnText: 'Retry',
    doneBtnText: 'Done',
    idFrontText: 'ID Front Image',
    idBackText: 'ID Back Image'
  });
  var requestCameraAccess = useCameraStore().requestCameraAccess;
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement("h1", {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(AssetSelectorOptions, {
    className: classNames.assetSelectorOptions
  }, /*#__PURE__*/React__default.createElement(AssetSelectorOption, {
    className: classNames.assetSelectorOption
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    id: "displayedAssetVideo",
    value: "video",
    checked: displayedAsset === 'video',
    onChange: function onChange() {
      return setDisplayedAsset('video');
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "displayedAssetVideo"
  }, "Video")), audioUrl && ( /*#__PURE__*/React__default.createElement(AssetSelectorOption, {
    className: classNames.assetSelectorOption
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    id: "displayedAssetAudio",
    value: "audio",
    checked: displayedAsset === 'audio',
    onChange: function onChange() {
      return setDisplayedAsset('audio');
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "displayedAssetAudio"
  }, "Audio"))), /*#__PURE__*/React__default.createElement(AssetSelectorOption, {
    className: classNames.assetSelectorOption
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    id: "displayedAssetIdFrontImage",
    value: "idFrontImage",
    checked: displayedAsset === 'idFrontImage',
    onChange: function onChange() {
      return setDisplayedAsset('idFrontImage');
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "displayedAssetIdFrontImage"
  }, verbiage.idFrontText)), idBackImageUrl && ( /*#__PURE__*/React__default.createElement(AssetSelectorOption, {
    className: classNames.assetSelectorOption
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    id: "displayedAssetIdBackImage",
    value: "idBackImage",
    checked: displayedAsset === 'idBackImage',
    onChange: function onChange() {
      return setDisplayedAsset('idBackImage');
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "displayedAssetIdBackImage"
  }, verbiage.idBackText)))), /*#__PURE__*/React__default.createElement(OverlayImageContainer, {
    className: classNames.videoContainer
  }, displayedAsset === 'video' ? ( /*#__PURE__*/React__default.createElement(StyledVideo, {
    src: videoUrl,
    className: classNames.video,
    poster: videoUrl + '#t=0.1',
    controls: true,
    preload: "metadata",
    autoPlay: true
  })) : displayedAsset === 'audio' ? ( /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", null, "Audio"), /*#__PURE__*/React__default.createElement("audio", {
    controls: true
  }, /*#__PURE__*/React__default.createElement("source", {
    src: audioUrl
  })))) : displayedAsset === 'idFrontImage' ? ( /*#__PURE__*/React__default.createElement("img", {
    src: idFrontImageUrl,
    alt: "ID Front Image"
  })) : ( /*#__PURE__*/React__default.createElement("img", {
    src: idBackImageUrl,
    alt: "ID Back Image"
  }))), /*#__PURE__*/React__default.createElement(ButtonsRow, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    className: classNames.retryBtn,
    onClick: function onClick() {
      void requestCameraAccess();
      return onRetryClick === null || onRetryClick === void 0 ? void 0 : onRetryClick();
    },
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryBtnText), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    className: classNames.doneBtn,
    onClick: onDoneClick,
    colors: colors.doneBtn,
    finished: true
  }, verbiage.doneBtnText))));
};
var StyledVideo = styled.video(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n"], ["\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n"])));
var AssetSelectorOptions = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-bottom: 15px;\n  display: flex;\n  justify-content: center;\n"])));
var AssetSelectorOption = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  padding: 0 8px;\n  display: flex;\n  gap: 5px;\n  align-items: center;\n\n  & > input {\n    margin: 0;\n    padding: 0;\n    display: block;\n  }\n"], ["\n  padding: 0 8px;\n  display: flex;\n  gap: 5px;\n  align-items: center;\n\n  & > input {\n    margin: 0;\n    padding: 0;\n    display: block;\n  }\n"])));
var templateObject_1$4, templateObject_2$4, templateObject_3$4;

var VideoIdWizard = function VideoIdWizard(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var onComplete = _a.onComplete,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onIdCaptureModelError = _a.onIdCaptureModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    onMicrophoneAccessDenied = _a.onMicrophoneAccessDenied,
    _l = _a.idCaptureProps,
    idCaptureProps = _l === void 0 ? {} : _l,
    _m = _a.faceLivenessProps,
    faceLivenessProps = _m === void 0 ? {} : _m,
    _o = _a.idCaptureModelsEnabled,
    idCaptureModelsEnabled = _o === void 0 ? true : _o,
    _p = _a.videoIdCaptureThresholds,
    videoIdCaptureThresholds = _p === void 0 ? defaultVideoIdCaptureThresholds : _p,
    readTextPrompt = _a.readTextPrompt,
    readTextTimeoutDurationMs = _a.readTextTimeoutDurationMs,
    readTextMinReadingMs = _a.readTextMinReadingMs,
    _q = _a.skipIdCapture,
    skipIdCapture = _q === void 0 ? false : _q,
    _r = _a.skipShowIdCardBack,
    skipShowIdCardBack = _r === void 0 ? false : _r,
    _s = _a.skipSuccessScreen,
    skipSuccessScreen = _s === void 0 ? false : _s,
    _t = _a.idCaptureLoadingOverlayMode,
    idCaptureLoadingOverlayMode = _t === void 0 ? 'default' : _t,
    customOverlayContent = _a.customOverlayContent,
    onLoadingOverlayDismissed = _a.onLoadingOverlayDismissed,
    _u = _a.idDocumentType,
    idDocumentType = _u === void 0 ? 'idCardOrPassport' : _u,
    _v = _a.idCaptureGuideType,
    idCaptureGuideType = _v === void 0 ? 'fit' : _v,
    _w = _a.idCaptureGuideImages,
    idCaptureGuideImages = _w === void 0 ? defaultIdCaptureGuideImages : _w,
    _x = _a.idCapturePortraitGuidesOnMobile,
    idCapturePortraitGuidesOnMobile = _x === void 0 ? true : _x,
    _y = _a.idCaptureRotateLoadingOverlayImageWhenPortrait,
    idCaptureRotateLoadingOverlayImageWhenPortrait = _y === void 0 ? true : _y,
    _z = _a.idCaptureModelLoadTimeoutMs,
    idCaptureModelLoadTimeoutMs = _z === void 0 ? defaultDocumentDetectionModelLoadTimeoutMs : _z,
    _0 = _a.faceLivenessLoadingOverlayMode,
    faceLivenessLoadingOverlayMode = _0 === void 0 ? 'default' : _0,
    _1 = _a.disableFaceDetectionWhileAudioCapture,
    disableFaceDetectionWhileAudioCapture = _1 === void 0 ? true : _1,
    _2 = _a.disableFaceDetectionWhileAudioCaptureMsDelay,
    disableFaceDetectionWhileAudioCaptureMsDelay = _2 === void 0 ? 2000 : _2,
    _3 = _a.silentFallback,
    silentFallback = _3 === void 0 ? false : _3,
    _4 = _a.mergeAVStreams,
    mergeAVStreams = _4 === void 0 ? false : _4,
    _5 = _a.assets,
    assets = _5 === void 0 ? {} : _5,
    _6 = _a.classNames,
    classNames = _6 === void 0 ? {} : _6,
    _7 = _a.colors,
    colors = _7 === void 0 ? {} : _7,
    _8 = _a.verbiage,
    verbiage = _8 === void 0 ? {} : _8,
    _9 = _a.debugMode,
    debugMode = _9 === void 0 ? false : _9;
  var _10 = useContext(SubmissionContext),
    passportImage = _10.passportImage,
    submissionStatus = _10.submissionStatus,
    idCaptureVideoUrl = _10.idCaptureVideoUrl,
    idCaptureVideoAudioUrl = _10.idCaptureVideoAudioUrl,
    idCaptureVideoIdFrontImage = _10.idCaptureVideoIdFrontImage,
    idCaptureVideoIdBackImage = _10.idCaptureVideoIdBackImage,
    setIdCaptureVideoUrl = _10.setIdCaptureVideoUrl,
    setIdCaptureVideoIdFrontImage = _10.setIdCaptureVideoIdFrontImage,
    setIdCaptureVideoIdBackImage = _10.setIdCaptureVideoIdBackImage,
    setIdCaptureVideoAudioUrl = _10.setIdCaptureVideoAudioUrl;
  var _11 = useState('CAPTURING_ID'),
    captureState = _11[0],
    setCaptureState = _11[1];
  useEffect(function () {
    if (skipIdCapture && captureState === 'CAPTURING_ID') setCaptureState('CHECKING_LIVENESS');
  }, [captureState, skipIdCapture]);
  var onIdCaptureSuccessProp = idCaptureProps.onSuccess;
  var onIdCaptureSuccess = useCallback(function (submission) {
    onIdCaptureSuccessProp === null || onIdCaptureSuccessProp === void 0 ? void 0 : onIdCaptureSuccessProp(submission);
    setCaptureState('CHECKING_LIVENESS');
  }, [onIdCaptureSuccessProp]);
  var onFaceCaptureSuccess = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setCaptureState('CAPTURING_VIDEO');
        return [2 /*return*/];
      });
    });
  }, []);
  var onVideoCaptureComplete = useCallback(function (videoUrl, audioUrl) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setIdCaptureVideoUrl(videoUrl);
        if (audioUrl) setIdCaptureVideoAudioUrl(audioUrl);
        setCaptureState('SUCCESS');
        if (skipSuccessScreen) onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        return [2 /*return*/];
      });
    });
  }, [onComplete, setIdCaptureVideoAudioUrl, setIdCaptureVideoUrl, skipSuccessScreen]);
  var onVideoCaptureFaceNotDetected = useCallback(function () {
    setCaptureState('CHECKING_LIVENESS');
  }, []);
  var _12 = useState(0),
    attempt = _12[0],
    setAttempt = _12[1];
  var userSuppliedExitAfterFailure = onExitAfterFailure !== null && onExitAfterFailure !== void 0 ? onExitAfterFailure : faceLivenessProps.onExitAfterFailure;
  var onFaceCaptureExitAfterFailure = useCallback(function (resp, req) {
    userSuppliedExitAfterFailure === null || userSuppliedExitAfterFailure === void 0 ? void 0 : userSuppliedExitAfterFailure(resp, req);
    setAttempt(function (n) {
      return n + 1;
    });
    setCaptureState('CAPTURING_ID');
  }, [userSuppliedExitAfterFailure]);
  var onSuccessRetryClick = useCallback(function () {
    setAttempt(function (n) {
      return n + 1;
    });
    setCaptureState('CAPTURING_ID');
  }, []);
  var isCapturingId = !skipIdCapture && ['LOADING', 'CAPTURING_ID'].includes(captureState);
  useEffect(function () {
    if (submissionStatus === SubmissionStatus.SUBMITTING) releaseCameraAccess();
  }, [submissionStatus]);
  var onRecordingFailed = useCallback(function () {
    setAttempt(function (n) {
      return n + 1;
    });
    setCaptureState('CHECKING_LIVENESS');
  }, []);
  var handleExitCapture = useCallback(function () {
    setAttempt(function (n) {
      return n + 1;
    });
    onExitCapture === null || onExitCapture === void 0 ? void 0 : onExitCapture();
  }, [onExitCapture]);
  var capturedIdDocumentType = idDocumentType !== 'idCardOrPassport' ? idDocumentType : passportImage ? 'passport' : 'idCard';
  var faceLivenessGuides = useCallback(function (_a) {
    var _b, _c, _d, _e;
    var status = _a.status;
    return /*#__PURE__*/React__default.createElement(IdVideoCaptureGuides, {
      classNames: (_b = classNames.idVideoCapture) === null || _b === void 0 ? void 0 : _b.guides,
      verbiage: (_c = verbiage.idVideoCapture) === null || _c === void 0 ? void 0 : _c.guides,
      requestedAction: "VERIFY_LIVENESS",
      idCaptureGuideImages: idCaptureGuideImages,
      idDocumentType: capturedIdDocumentType,
      faceGuideStatus: status,
      faceGuideBorderColor: status === 'success' ? (_d = colors.idVideoCapture) === null || _d === void 0 ? void 0 : _d.guidesSatisfiedColor : (_e = colors.idVideoCapture) === null || _e === void 0 ? void 0 : _e.guidesUnsatisfiedColor,
      idCardGuideStatus: "disabled"
    });
  }, [capturedIdDocumentType, (_b = classNames.idVideoCapture) === null || _b === void 0 ? void 0 : _b.guides, (_c = colors.idVideoCapture) === null || _c === void 0 ? void 0 : _c.guidesSatisfiedColor, (_d = colors.idVideoCapture) === null || _d === void 0 ? void 0 : _d.guidesUnsatisfiedColor, idCaptureGuideImages, (_e = verbiage.idVideoCapture) === null || _e === void 0 ? void 0 : _e.guides]);
  if (submissionStatus === SubmissionStatus.SUBMITTING) {
    return /*#__PURE__*/React__default.createElement(PageContainer, {
      className: "flex"
    }, /*#__PURE__*/React__default.createElement(Spinner, null));
  }
  return /*#__PURE__*/React__default.createElement(CameraStoreProvider, {
    preferIphoneContinuityCamera: isCapturingId,
    preferFrontFacingCamera: !isCapturingId,
    requireMicrophoneAccess: !isCapturingId && !!readTextPrompt,
    maxVideoWidth: isCapturingId ? 1920 : 1280,
    maxFps: isCapturingId ? 60 : 30,
    onCameraAccessDenied: onCameraAccessDenied,
    onMicrophoneAccessDenied: onMicrophoneAccessDenied
  }, /*#__PURE__*/React__default.createElement(IdCaptureModelsProvider, {
    autoStart: false,
    documentDetectionModelUrl: (_g = (_f = idCaptureProps.assets) === null || _f === void 0 ? void 0 : _f.documentDetectionModelUrl) !== null && _g !== void 0 ? _g : '',
    focusModelUrl: (_j = (_h = idCaptureProps.assets) === null || _h === void 0 ? void 0 : _h.focusModelUrl) !== null && _j !== void 0 ? _j : '',
    onModelError: onIdCaptureModelError,
    modelLoadTimeoutMs: idCaptureModelLoadTimeoutMs,
    allowSinglePageIdCapture: idCaptureProps.allowSinglePageIdCapture
  }, /*#__PURE__*/React__default.createElement(SelfieGuidanceModelsProvider, {
    autoStart: false,
    onModelError: faceLivenessProps === null || faceLivenessProps === void 0 ? void 0 : faceLivenessProps.onModelError,
    modelLoadTimeoutMs: faceLivenessProps === null || faceLivenessProps === void 0 ? void 0 : faceLivenessProps.modelLoadTimeoutMs,
    requireVerticalFaceCentering: false
  }, /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_k = classNames.container) !== null && _k !== void 0 ? _k : '')
  }, ['CHECKING_LIVENESS', 'CAPTURING_VIDEO'].includes(captureState) && /*#__PURE__*/React__default.createElement(CameraVideoTag, {
    className: classNames.cameraFeed
  }), function () {
    switch (captureState) {
      case 'CAPTURING_ID':
        return /*#__PURE__*/React__default.createElement(IdCaptureStateProvider, null, /*#__PURE__*/React__default.createElement(GuideOrientationContextProvider, null, /*#__PURE__*/React__default.createElement(IdCaptureWizard, _assign({
          key: "id-capture-".concat(attempt),
          loadingOverlayMode: idCaptureLoadingOverlayMode,
          customOverlayContent: customOverlayContent,
          onLoadingOverlayDismissed: onLoadingOverlayDismissed,
          silentFallback: silentFallback,
          guideImages: idCaptureGuideImages
        }, idCaptureProps, {
          assets: assets.idCapture,
          classNames: classNames.idCapture,
          colors: colors.idCapture,
          verbiage: verbiage.idCapture,
          onSuccess: onIdCaptureSuccess,
          onExitCapture: handleExitCapture,
          onUserCancel: onUserCancel,
          skipSuccessScreen: true,
          releaseCameraAccessOnExit: false,
          guideType: idCaptureGuideType,
          portraitGuidesOnMobile: idCapturePortraitGuidesOnMobile,
          rotateLoadingOverlayImageWhenPortrait: idCaptureRotateLoadingOverlayImageWhenPortrait,
          captureRequirement: idDocumentType,
          debugMode: debugMode
        }))));
      case 'CHECKING_LIVENESS':
        return /*#__PURE__*/React__default.createElement(FaceLivenessWizard, _assign({
          key: "face-liveness-".concat(attempt),
          loadingOverlayMode: faceLivenessLoadingOverlayMode,
          customOverlayContent: customOverlayContent,
          onLoadingOverlayDismissed: onLoadingOverlayDismissed,
          silentFallback: silentFallback
        }, faceLivenessProps, {
          onComplete: onFaceCaptureSuccess,
          onExitCapture: handleExitCapture,
          onExitAfterFailure: onFaceCaptureExitAfterFailure,
          onUserCancel: onUserCancel,
          skipSuccessScreen: true,
          renderCameraFeed: false,
          releaseCameraAccessOnExit: false,
          waitForIdCaptureModels: true,
          disableCapturePreview: !debugMode,
          guidesComponent: faceLivenessGuides,
          assets: assets.faceLiveness,
          classNames: classNames.faceLiveness,
          colors: colors.faceLiveness,
          verbiage: verbiage.faceLiveness,
          debugMode: debugMode
        }));
      case 'CAPTURING_VIDEO':
        return /*#__PURE__*/React__default.createElement(IdVideoCapture, {
          key: "id-video-capture-".concat(attempt),
          onComplete: onVideoCaptureComplete,
          onIdFrontImageCaptured: setIdCaptureVideoIdFrontImage,
          onIdBackImageCaptured: setIdCaptureVideoIdBackImage,
          onFaceNotDetected: onVideoCaptureFaceNotDetected,
          onRecordingFailed: onRecordingFailed,
          onExitCapture: handleExitCapture,
          idCaptureModelsEnabled: idCaptureModelsEnabled,
          idCaptureGuideImages: idCaptureGuideImages,
          idDocumentType: capturedIdDocumentType,
          videoIdCaptureThresholds: videoIdCaptureThresholds,
          skipShowIdCardBack: skipShowIdCardBack,
          disableFaceDetectionWhileAudioCapture: disableFaceDetectionWhileAudioCapture,
          disableFaceDetectionWhileAudioCaptureMsDelay: disableFaceDetectionWhileAudioCaptureMsDelay,
          readTextPrompt: readTextPrompt,
          readTextTimeoutDurationMs: readTextTimeoutDurationMs,
          readTextMinReadingMs: readTextMinReadingMs,
          mergeAVStreams: mergeAVStreams,
          classNames: classNames.idVideoCapture,
          colors: colors.idVideoCapture,
          verbiage: verbiage.idVideoCapture,
          debugMode: debugMode
        });
      case 'SUCCESS':
        return /*#__PURE__*/React__default.createElement(IdVideoCaptureSuccess, {
          videoUrl: idCaptureVideoUrl !== null && idCaptureVideoUrl !== void 0 ? idCaptureVideoUrl : '',
          audioUrl: idCaptureVideoAudioUrl !== null && idCaptureVideoAudioUrl !== void 0 ? idCaptureVideoAudioUrl : '',
          idFrontImageUrl: idCaptureVideoIdFrontImage !== null && idCaptureVideoIdFrontImage !== void 0 ? idCaptureVideoIdFrontImage : '',
          idBackImageUrl: idCaptureVideoIdBackImage !== null && idCaptureVideoIdBackImage !== void 0 ? idCaptureVideoIdBackImage : undefined,
          onDoneClick: onComplete,
          onRetryClick: onSuccessRetryClick,
          classNames: classNames.success,
          colors: colors.success,
          verbiage: verbiage.success
        });
      default:
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    }
  }()))));
};

function CompositeWizard(_a) {
  var _b, _c, _d, _e, _f;
  var userChecks = _a.checks,
    _g = _a.idCaptureProps,
    idCaptureProps = _g === void 0 ? {} : _g,
    _h = _a.faceLivenessProps,
    faceLivenessProps = _h === void 0 ? {} : _h,
    additionalDocumentCaptureProps = _a.additionalDocumentCaptureProps,
    _j = _a.signatureCaptureProps,
    signatureCaptureProps = _j === void 0 ? {} : _j,
    _k = _a.videoSignatureCaptureProps,
    videoSignatureCaptureProps = _k === void 0 ? {} : _k,
    _l = _a.videoIdCaptureProps,
    videoIdCaptureProps = _l === void 0 ? {} : _l,
    _m = _a.captureSignature,
    captureSignature = _m === void 0 ? false : _m,
    _o = _a.captureSignatureVideo,
    captureSignatureVideo = _o === void 0 ? false : _o,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    onMicrophoneAccessDenied = _a.onMicrophoneAccessDenied,
    _p = _a.debugMode,
    debugMode = _p === void 0 ? false : _p;
  var _q = useContext(SubmissionContext),
    submit = _q.submit,
    submissionStatus = _q.submissionStatus,
    setSignatureData = _q.setSignatureData,
    setAdditionalDocuments = _q.setAdditionalDocuments;
  var _r = useState(0),
    checkIndex = _r[0],
    setCheckIndex = _r[1];
  var checks = useMemo(function () {
    var _a, _b;
    var checks = __spreadArray([], userChecks, true);
    if (captureSignature && captureSignatureVideo) {
      throw new Error('captureSignature and captureSignatureVideo cannot be used together');
    }
    if (captureSignature) {
      checks.push('SignatureCapture');
    }
    if (captureSignatureVideo) {
      checks.push('VideoSignatureCapture');
      // remove face liveness because video signature already has it.
      if (checks.includes('FaceLiveness')) checks.splice(checks.indexOf('FaceLiveness'), 1);
    }
    if ((_b = (_a = additionalDocumentCaptureProps === null || additionalDocumentCaptureProps === void 0 ? void 0 : additionalDocumentCaptureProps.documents) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 > 0) {
      checks.push('AdditionalDocumentCapture');
    }
    return checks;
  }, [(_b = additionalDocumentCaptureProps === null || additionalDocumentCaptureProps === void 0 ? void 0 : additionalDocumentCaptureProps.documents) === null || _b === void 0 ? void 0 : _b.length, captureSignature, captureSignatureVideo, userChecks]);
  var currentCheck = checks[checkIndex];
  var isComplete = checkIndex >= checks.length;
  useEffect(function () {
    if (currentCheck === 'SignatureCapture' && typeof captureSignature === 'function') {
      captureSignature().then(function (shouldProceed) {
        if (!shouldProceed) {
          setCheckIndex(function (i) {
            return i + 1;
          });
        }
      });
    } else if (currentCheck === 'VideoSignatureCapture' && typeof captureSignatureVideo === 'function') {
      captureSignatureVideo().then(function (shouldProceed) {
        if (!shouldProceed) {
          setCheckIndex(function (i) {
            return i + 1;
          });
        }
      });
    }
  }, [captureSignature, captureSignatureVideo, currentCheck]);
  useEffect(function () {
    if (isComplete) submit();
  }, [isComplete, submit]);
  var onIdCaptureSuccessProp = idCaptureProps.onSuccess;
  var onIdCaptureSuccess = useCallback(function (submission) {
    onIdCaptureSuccessProp === null || onIdCaptureSuccessProp === void 0 ? void 0 : onIdCaptureSuccessProp(submission);
    setCheckIndex(function (i) {
      return i + 1;
    });
  }, [onIdCaptureSuccessProp]);
  var onVideoIdCaptureCompleteProp = videoIdCaptureProps.onComplete;
  var onVideoIdCaptureComplete = useCallback(function () {
    onVideoIdCaptureCompleteProp === null || onVideoIdCaptureCompleteProp === void 0 ? void 0 : onVideoIdCaptureCompleteProp();
    setCheckIndex(function (i) {
      return i + 1;
    });
  }, [onVideoIdCaptureCompleteProp]);
  var onFaceLivenessCompleteProp = faceLivenessProps.onComplete;
  var onFaceLivenessComplete = useCallback(function (resp, req) {
    onFaceLivenessCompleteProp === null || onFaceLivenessCompleteProp === void 0 ? void 0 : onFaceLivenessCompleteProp(resp, req);
    setCheckIndex(function (i) {
      return i + 1;
    });
  }, [onFaceLivenessCompleteProp]);
  var onSignatureCaptureSuccess = useCallback(function (signatureData) {
    setSignatureData(signatureData);
    setCheckIndex(function (i) {
      return i + 1;
    });
  }, [setSignatureData]);
  var onVideoSignatureCompleteProp = videoSignatureCaptureProps.onComplete;
  var onVideoSignatureComplete = useCallback(function () {
    onVideoSignatureCompleteProp === null || onVideoSignatureCompleteProp === void 0 ? void 0 : onVideoSignatureCompleteProp();
    setCheckIndex(function (i) {
      return i + 1;
    });
  }, [onVideoSignatureCompleteProp]);
  var onAdditionalDocumentCaptureCompleteProp = additionalDocumentCaptureProps === null || additionalDocumentCaptureProps === void 0 ? void 0 : additionalDocumentCaptureProps.onComplete;
  var onAdditionalDocumentCaptureComplete = useCallback(function (uploadedDocuments) {
    setAdditionalDocuments(uploadedDocuments);
    onAdditionalDocumentCaptureCompleteProp === null || onAdditionalDocumentCaptureCompleteProp === void 0 ? void 0 : onAdditionalDocumentCaptureCompleteProp(uploadedDocuments);
    setCheckIndex(function (i) {
      return i + 1;
    });
  }, [onAdditionalDocumentCaptureCompleteProp, setAdditionalDocuments]);
  var documents = useMemo(function () {
    var _a;
    return (_a = additionalDocumentCaptureProps === null || additionalDocumentCaptureProps === void 0 ? void 0 : additionalDocumentCaptureProps.documents) !== null && _a !== void 0 ? _a : [];
  }, [additionalDocumentCaptureProps === null || additionalDocumentCaptureProps === void 0 ? void 0 : additionalDocumentCaptureProps.documents]);
  if (isComplete) {
    switch (submissionStatus) {
      case SubmissionStatus.SUBMITTING:
        return /*#__PURE__*/React__default.createElement(PageContainer, {
          className: "flex"
        }, /*#__PURE__*/React__default.createElement(Spinner, null));
      case SubmissionStatus.SUBMITTED:
        if (debugMode) return /*#__PURE__*/React__default.createElement(SubmissionSuccess, null);
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      case SubmissionStatus.FAILED:
        if (debugMode) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Submission failed!");
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      default:
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    }
  }
  switch (checks[checkIndex]) {
    case 'IdCapture':
      return /*#__PURE__*/React__default.createElement(CameraStoreProvider, {
        onCameraAccessDenied: onCameraAccessDenied,
        onMicrophoneAccessDenied: onMicrophoneAccessDenied,
        requestAccessAutomatically: !(idCaptureProps === null || idCaptureProps === void 0 ? void 0 : idCaptureProps.forceFallbackMode)
      }, /*#__PURE__*/React__default.createElement(IdCaptureModelsProvider, {
        autoStart: false,
        shouldLoadModels: !(idCaptureProps === null || idCaptureProps === void 0 ? void 0 : idCaptureProps.forceFallbackMode),
        documentDetectionModelUrl: (_d = (_c = idCaptureProps.assets) === null || _c === void 0 ? void 0 : _c.documentDetectionModelUrl) !== null && _d !== void 0 ? _d : '',
        focusModelUrl: (_f = (_e = idCaptureProps.assets) === null || _e === void 0 ? void 0 : _e.focusModelUrl) !== null && _f !== void 0 ? _f : '',
        onModelError: idCaptureProps.onModelError,
        modelLoadTimeoutMs: idCaptureProps.modelLoadTimeoutMs,
        allowSinglePageIdCapture: idCaptureProps.allowSinglePageIdCapture
      }, /*#__PURE__*/React__default.createElement(IdCaptureStateProvider, null, /*#__PURE__*/React__default.createElement(GuideOrientationContextProvider, null, /*#__PURE__*/React__default.createElement(IdCaptureWizard, _assign({}, idCaptureProps, {
        onSuccess: onIdCaptureSuccess
      }))))));
    case 'VideoIdCapture':
      return /*#__PURE__*/React__default.createElement(VideoIdWizard, _assign({}, videoIdCaptureProps, {
        onComplete: onVideoIdCaptureComplete,
        onCameraAccessDenied: onCameraAccessDenied,
        onMicrophoneAccessDenied: onMicrophoneAccessDenied
      }));
    case 'FaceLiveness':
      return /*#__PURE__*/React__default.createElement(CameraStoreProvider, {
        preferFrontFacingCamera: true,
        preferIphoneContinuityCamera: false,
        onCameraAccessDenied: onCameraAccessDenied,
        onMicrophoneAccessDenied: onMicrophoneAccessDenied
      }, /*#__PURE__*/React__default.createElement(SelfieGuidanceModelsProvider, {
        autoStart: false,
        onModelError: faceLivenessProps.onModelError,
        modelLoadTimeoutMs: faceLivenessProps.modelLoadTimeoutMs
      }, /*#__PURE__*/React__default.createElement(FaceLivenessWizard, _assign({}, faceLivenessProps, {
        onComplete: onFaceLivenessComplete
      }))));
    case 'SignatureCapture':
      return /*#__PURE__*/React__default.createElement(SignatureCapture, _assign({}, signatureCaptureProps, {
        onAccept: onSignatureCaptureSuccess
      }));
    case 'VideoSignatureCapture':
      return /*#__PURE__*/React__default.createElement(CameraStoreProvider, {
        preferIphoneContinuityCamera: false,
        preferFrontFacingCamera: true,
        maxVideoWidth: 1280,
        maxFps: 30,
        onCameraAccessDenied: onCameraAccessDenied,
        onMicrophoneAccessDenied: onMicrophoneAccessDenied
      }, /*#__PURE__*/React__default.createElement(SelfieGuidanceModelsProvider, {
        autoStart: false,
        throttleMs: 250,
        onModelError: videoSignatureCaptureProps.onModelError,
        modelLoadTimeoutMs: videoSignatureCaptureProps.modelLoadTimeoutMs,
        requireVerticalFaceCentering: false
      }, /*#__PURE__*/React__default.createElement(VideoSignatureWizard, _assign({}, videoSignatureCaptureProps, {
        onComplete: onVideoSignatureComplete
      }))));
    case 'AdditionalDocumentCapture':
      return /*#__PURE__*/React__default.createElement(AdditionalDocumentCaptureWizard, _assign({}, additionalDocumentCaptureProps, {
        documents: documents,
        onComplete: onAdditionalDocumentCaptureComplete
      }));
    default:
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }
}

var noneTheme = {};
var defaultTheme = {
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
  isFullscreen: true,
  background: 'white',
  textColor: 'black',
  textAlign: 'center',
  padding: '25px',
  colors: {
    primary: {
      '50': '#eef8ff',
      '100': '#d8eeff',
      '200': '#b9e0ff',
      '300': '#89cfff',
      '400': '#52b4ff',
      '500': '#2a91ff',
      '600': '#0d6efd',
      // default
      '700': '#0c5ae9',
      '800': '#1149bc',
      '900': '#144194',
      '950': '#11295a'
    },
    secondary: {
      '50': '#f6f6f6',
      '100': '#e7e7e7',
      '200': '#d1d1d1',
      '300': '#b0b0b0',
      '400': '#888888',
      '500': '#666666',
      // default
      '600': '#5d5d5d',
      '700': '#4f4f4f',
      '800': '#454545',
      '900': '#3d3d3d',
      '950': '#262626'
    },
    positive: {
      '50': '#f1fcf9',
      '100': '#cef9eb',
      '200': '#9df2d8',
      '300': '#65e3c2',
      '400': '#4fd4ad',
      '500': '#1cb090',
      '600': '#16a085',
      // default
      '700': '#147160',
      '800': '#155a4f',
      '900': '#164b42',
      '950': '#062d28'
    },
    negative: {
      '50': '#fff1f2',
      '100': '#ffe4e6',
      '200': '#fecdd3',
      '300': '#fda4af',
      '400': '#fb7185',
      '500': '#f43f5e',
      // default
      '600': '#e11d48',
      '700': '#be123c',
      '800': '#9f1239',
      '900': '#881337',
      '950': '#4c0519'
    },
    warning: {
      '50': '#fdf5ef',
      '100': '#fbe7d9',
      '200': '#f6cdb2',
      '300': '#f0ab81',
      '400': '#ea8557',
      // default
      '500': '#e35e2c',
      '600': '#d54621',
      '700': '#b1341d',
      '800': '#8d2b1f',
      '900': '#72261c',
      '950': '#3d100d'
    }
  },
  buttons: {
    style: 'bootstrap',
    primary: {
      backgroundColor: 'var(--idm-color-primary-600)',
      textColor: 'white'
    },
    secondary: {
      backgroundColor: 'var(--idm-color-secondary-500)',
      textColor: 'white'
    },
    positive: {
      backgroundColor: 'var(--idm-color-positive-600)',
      textColor: 'white'
    },
    negative: {
      backgroundColor: 'var(--idm-color-negative-400)',
      textColor: 'white'
    },
    warning: {
      backgroundColor: 'var(--idm-color-warning-400)',
      textColor: 'white'
    },
    loading: {
      backgroundColor: 'gray',
      textColor: 'white'
    }
  },
  guidanceMessages: {
    "default": {
      backgroundColor: 'var(--idm-color-secondary-200)',
      textColor: 'black'
    },
    positive: {
      backgroundColor: 'var(--idm-color-positive-700)',
      textColor: 'white'
    },
    negative: {
      backgroundColor: 'var(--idm-color-negative-600)',
      textColor: 'white'
    }
  },
  idCapture: {
    loadingOverlay: {
      backgroundColor: '#ecedf3',
      textColor: 'black',
      loadingGraphicAccentColor: 'var(--idm-color-positive-600)',
      loadingGraphicAccentOpacity: 0.2,
      progressBarBackgroundColor: 'var(--idm-color-positive-600)',
      progressBarBackgroundOpacity: 0.75,
      progressBarIndicatorColor: 'var(--idm-color-positive-600)',
      progressBarTextColor: 'white',
      continueBtnBorder: '2px solid white'
    },
    guideOverlay: {
      backgroundColor: '#708090',
      textColor: 'white'
    },
    guideBox: {
      unsatisfiedColor: 'white',
      satisfiedColor: 'var(--idm-color-positive-500)',
      borderWidth: 4,
      desktopPadding: 50,
      mobilePadding: 0,
      imagePadding: 50,
      wavesDisabled: false,
      wavesColor: '#287ec6',
      progressBarColor: '#287ec6'
    }
  },
  selfieCapture: {
    loadingOverlay: {
      backgroundColor: '#ecedf3',
      textColor: 'black',
      loadingGraphicAccentColor: 'var(--idm-color-positive-600)',
      progressBarBackgroundColor: 'var(--idm-color-positive-600)',
      progressBarBackgroundOpacity: 0.75,
      progressBarIndicatorColor: 'var(--idm-color-positive-600)',
      progressBarTextColor: 'white',
      continueBtnBorder: '2px solid white'
    },
    guides: {
      unsatisfiedColor: 'white',
      satisfiedColor: 'var(--idm-color-positive-500)'
    }
  },
  signatureCapture: {
    background: 'radial-gradient(#444cf7 0.5px, transparent 0.5px), radial-gradient(#444cf7 0.5px, #e5e5f7 0.5px)',
    backgroundSize: '20px 20px',
    backgroundPosition: '0 0, 10px 10px'
  },
  idVideoCapture: {
    idCardGuides: {
      disableDuringLivenessCheck: false
    },
    readTextPrompt: {
      heading: {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        textColor: 'black',
        borderRadius: '8px'
      },
      prompt: {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        textColor: 'black',
        borderRadius: '8px'
      },
      timeRemaining: {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        textColor: 'black',
        borderRadius: '4px'
      }
    }
  }
};
var themes = {
  "default": defaultTheme,
  none: noneTheme
};
var resolveTheme = function resolveTheme(input) {
  if (typeof input === 'string') {
    if (input in themes) return themes[input];
    return themes.none;
  }
  if (input.base) {
    var baseTheme = themes[input.base];
    if (baseTheme) {
      return mergeDeep(baseTheme, input);
    }
  }
  return input;
};
var ThemeProvider = function ThemeProvider(_a) {
  var children = _a.children,
    themeInput = _a.theme;
  var themeRef = useState(themeInput)[0];
  var theme = useMemo(function () {
    return resolveTheme(themeRef);
  }, [themeRef]);
  var colors = theme.colors;
  useEffect(function () {
    for (var name_1 in colors) {
      var variants = colors[name_1];
      for (var num in variants) {
        var color = variants[num];
        document.documentElement.style.setProperty("--idm-color-".concat(name_1, "-").concat(num), color);
      }
    }
  }, [colors]);
  return /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: theme
  }, children);
};

/**
 * Render a fullscreen ID capture component that instructs the user to photograph both sides of their ID card, or full page of their passport.
 */
var IdValidation = function IdValidation(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    clientRequestID = _a.clientRequestID,
    submissionUrl = _a.submissionUrl,
    authUrl = _a.authUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    manualReviewRequired = _a.manualReviewRequired,
    idBackImageRequired = _a.idBackImageRequired,
    verifyIdWithExternalDatabases = _a.verifyIdWithExternalDatabases,
    bypassAgeValidation = _a.bypassAgeValidation,
    bypassNameMatching = _a.bypassNameMatching,
    personalData = _a.personalData,
    cardData = _a.cardData,
    idData = _a.idData,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    webhooksFireOnReview = _a.webhooksFireOnReview,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig = _a.customerDataMatchConfig,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    precapturedDocuments = _a.precapturedDocuments,
    _c = _a.loadingOverlayMode,
    loadingOverlayMode = _c === void 0 ? 'default' : _c,
    customOverlayContent = _a.customOverlayContent,
    onLoadingOverlayDismissed = _a.onLoadingOverlayDismissed,
    _d = _a.idCaptureRequirement,
    idCaptureRequirement = _d === void 0 ? 'idCardOrPassport' : _d,
    _e = _a.allowSinglePageIdCapture,
    allowSinglePageIdCapture = _e === void 0 ? false : _e,
    _f = _a.separateIdCardCaptureSequence,
    separateIdCardCaptureSequence = _f === void 0 ? false : _f,
    _g = _a.idCaptureThresholds,
    idCaptureThresholds = _g === void 0 ? defaultIdCaptureThresholds : _g,
    _h = _a.skipSuccessScreen,
    skipSuccessScreen = _h === void 0 ? false : _h,
    instructions = _a.instructions,
    _j = _a.guideType,
    guideType = _j === void 0 ? 'fit' : _j,
    _k = _a.guideImages,
    guideImages = _k === void 0 ? defaultIdCaptureGuideImages : _k,
    _l = _a.portraitGuidesOnMobile,
    portraitGuidesOnMobile = _l === void 0 ? true : _l,
    _m = _a.rotateLoadingOverlayImageWhenPortrait,
    rotateLoadingOverlayImageWhenPortrait = _m === void 0 ? true : _m,
    _o = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _o === void 0 ? defaultDocumentDetectionModelLoadTimeoutMs : _o,
    _p = _a.forceFallbackMode,
    forceFallbackMode = _p === void 0 ? false : _p,
    _q = _a.allowIdCardBackToFrontCapture,
    allowIdCardBackToFrontCapture = _q === void 0 ? false : _q,
    _r = _a.enableOverrideWrongDocumentTypeDialog,
    enableOverrideWrongDocumentTypeDialog = _r === void 0 ? false : _r,
    _s = _a.allowOverrideWrongDocumentTypeAfterMs,
    allowOverrideWrongDocumentTypeAfterMs = _s === void 0 ? 8000 : _s,
    onBeforeSubmit = _a.onBeforeSubmit,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onSubmit = _a.onSubmit,
    onComplete = _a.onComplete,
    onApproved = _a.onApproved,
    onDenied = _a.onDenied,
    onExitCapture = _a.onExitCapture,
    onUserCancel = _a.onUserCancel,
    onModelError = _a.onModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _t = _a.theme,
    theme = _t === void 0 ? 'default' : _t,
    _u = _a.assets,
    assets = _u === void 0 ? {} : _u,
    _v = _a.classNames,
    classNames = _v === void 0 ? {} : _v,
    _w = _a.colors,
    colors = _w === void 0 ? {} : _w,
    _x = _a.verbiage,
    verbiage = _x === void 0 ? {} : _x,
    _y = _a.captureSignature,
    captureSignature = _y === void 0 ? false : _y,
    _z = _a.captureSignatureVideo,
    captureSignatureVideo = _z === void 0 ? false : _z,
    _0 = _a.captureAdditionalDocuments,
    captureAdditionalDocuments = _0 === void 0 ? [] : _0,
    _1 = _a.geolocationEnabled,
    geolocationEnabled = _1 === void 0 ? true : _1,
    _2 = _a.geolocationRequired,
    geolocationRequired = _2 === void 0 ? false : _2,
    _3 = _a.debugMode,
    debugMode = _3 === void 0 ? false : _3;
  useLanguage(lang);
  useDebugLogging(debugMode);
  var idCaptureProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      onModelError: onModelError,
      precapturedDocuments: precapturedDocuments,
      captureRequirement: idCaptureRequirement,
      allowSinglePageIdCapture: allowSinglePageIdCapture,
      separateIdCardCaptureSequence: separateIdCardCaptureSequence,
      thresholds: idCaptureThresholds,
      skipSuccessScreen: skipSuccessScreen,
      loadingOverlayMode: loadingOverlayMode,
      customOverlayContent: customOverlayContent,
      onLoadingOverlayDismissed: onLoadingOverlayDismissed,
      forceFallbackMode: forceFallbackMode,
      allowIdCardBackToFrontCapture: allowIdCardBackToFrontCapture,
      instructions: instructions,
      guideType: guideType,
      guideImages: guideImages,
      portraitGuidesOnMobile: portraitGuidesOnMobile,
      rotateLoadingOverlayImageWhenPortrait: rotateLoadingOverlayImageWhenPortrait,
      modelLoadTimeoutMs: modelLoadTimeoutMs,
      enableOverrideWrongDocumentTypeDialog: enableOverrideWrongDocumentTypeDialog,
      allowOverrideWrongDocumentTypeAfterMs: allowOverrideWrongDocumentTypeAfterMs,
      assets: assets,
      classNames: classNames,
      colors: colors,
      verbiage: verbiage,
      debugMode: debugMode
    };
  }, [onExitCapture, onUserCancel, onModelError, precapturedDocuments, idCaptureRequirement, allowSinglePageIdCapture, separateIdCardCaptureSequence, idCaptureThresholds, skipSuccessScreen, loadingOverlayMode, customOverlayContent, onLoadingOverlayDismissed, forceFallbackMode, allowIdCardBackToFrontCapture, instructions, guideType, guideImages, portraitGuidesOnMobile, rotateLoadingOverlayImageWhenPortrait, modelLoadTimeoutMs, enableOverrideWrongDocumentTypeDialog, allowOverrideWrongDocumentTypeAfterMs, assets, classNames, colors, verbiage, debugMode]);
  var additionalDocumentCaptureProps = useMemo(function () {
    return {
      documents: captureAdditionalDocuments,
      classNames: classNames.additionalDocumentCapture,
      verbiage: verbiage.additionalDocumentCapture
    };
  }, [captureAdditionalDocuments, classNames.additionalDocumentCapture, verbiage.additionalDocumentCapture]);
  var signatureCaptureProps = useMemo(function () {
    return {
      classNames: classNames.signatureCapture,
      verbiage: verbiage.signatureCapture
    };
  }, [classNames.signatureCapture, verbiage.signatureCapture]);
  var videoSignatureCaptureProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      skipSuccessScreen: skipSuccessScreen,
      classNames: classNames.videoSignatureCapture,
      colors: colors.videoSignatureCapture,
      verbiage: verbiage.videoSignatureCapture,
      debugMode: debugMode
    };
  }, [classNames.videoSignatureCapture, colors.videoSignatureCapture, debugMode, onExitCapture, onUserCancel, skipSuccessScreen, verbiage.videoSignatureCapture]);
  var onResponseReceived = useCallback(function (resp, req) {
    onComplete === null || onComplete === void 0 ? void 0 : onComplete(resp, req);
    if (resp.resultData['verificationResult'] === 'Approved') {
      onApproved === null || onApproved === void 0 ? void 0 : onApproved(resp, req);
    } else {
      onDenied === null || onDenied === void 0 ? void 0 : onDenied(resp, req);
    }
  }, [onApproved, onComplete, onDenied]);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.VALIDATE,
    submissionUrl: submissionUrl,
    clientRequestID: clientRequestID,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    needImmediateResponse: needImmediateResponse,
    manualReviewRequired: manualReviewRequired,
    idBackImageRequired: idBackImageRequired,
    verifyIdWithExternalDatabases: verifyIdWithExternalDatabases,
    bypassAgeValidation: bypassAgeValidation,
    bypassNameMatching: bypassNameMatching,
    personalData: personalData,
    cardData: cardData,
    idData: idData,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    webhooksFireOnReview: webhooksFireOnReview,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig: customerDataMatchConfig,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeSubmit: onBeforeSubmit,
    onSubmit: onSubmit,
    onResponseReceived: onResponseReceived,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CompositeWizard, {
    checks: useMemo(function () {
      return ['IdCapture'];
    }, []),
    idCaptureProps: idCaptureProps,
    additionalDocumentCaptureProps: additionalDocumentCaptureProps,
    signatureCaptureProps: signatureCaptureProps,
    videoSignatureCaptureProps: videoSignatureCaptureProps,
    captureSignature: captureSignature,
    captureSignatureVideo: captureSignatureVideo,
    onCameraAccessDenied: onCameraAccessDenied,
    debugMode: debugMode
  }))));
};

/** Render a fullscreen capture component that analyzes frames from the user's front-facing camera to determine whether a live human face is present. */
var FaceValidation = function FaceValidation(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    _c = _a.webhooksFireOnReview,
    webhooksFireOnReview = _c === void 0 ? false : _c,
    webhooksFireOnReviewURL = _a.webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    _d = _a.loadingOverlayMode,
    loadingOverlayMode = _d === void 0 ? 'default' : _d,
    _e = _a.timeoutDurationMs,
    timeoutDurationMs = _e === void 0 ? 15000 : _e,
    _f = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _f === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _f,
    _g = _a.skipSuccessScreen,
    skipSuccessScreen = _g === void 0 ? false : _g,
    idCardForFaceMatch = _a.idCardForFaceMatch,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onBeforeSubmit = _a.onBeforeSubmit,
    onComplete = _a.onComplete,
    onApproved = _a.onApproved,
    onDenied = _a.onDenied,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onModelError = _a.onModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _h = _a.theme,
    theme = _h === void 0 ? 'default' : _h,
    assets = _a.assets,
    classNames = _a.classNames,
    colors = _a.colors,
    verbiage = _a.verbiage,
    _j = _a.geolocationEnabled,
    geolocationEnabled = _j === void 0 ? true : _j,
    _k = _a.geolocationRequired,
    geolocationRequired = _k === void 0 ? false : _k,
    _l = _a.debugMode,
    debugMode = _l === void 0 ? false : _l;
  useLanguage(lang);
  useDebugLogging(debugMode);
  var faceLivenessProps = useMemo(function () {
    return {
      loadingOverlayMode: loadingOverlayMode,
      timeoutDurationMs: timeoutDurationMs,
      modelLoadTimeoutMs: modelLoadTimeoutMs,
      skipSuccessScreen: skipSuccessScreen,
      onComplete: onComplete,
      onSuccess: onApproved,
      onDenied: onDenied,
      onExitCapture: onExitCapture,
      onExitAfterFailure: onExitAfterFailure,
      onModelError: onModelError,
      onUserCancel: onUserCancel,
      assets: assets,
      classNames: classNames,
      colors: colors,
      verbiage: verbiage,
      debugMode: debugMode
    };
  }, [assets, classNames, colors, debugMode, loadingOverlayMode, modelLoadTimeoutMs, onApproved, onComplete, onDenied, onExitAfterFailure, onExitCapture, onModelError, onUserCancel, skipSuccessScreen, timeoutDurationMs, verbiage]);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.NONE,
    submissionUrl: submissionUrl,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    needImmediateResponse: needImmediateResponse,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    webhooksFireOnReview: webhooksFireOnReview,
    webhooksFireOnReviewURL: webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    idCardForFaceMatch: idCardForFaceMatch,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeLivenessCheck: onBeforeSubmit,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CompositeWizard, {
    checks: useMemo(function () {
      return ['FaceLiveness'];
    }, []),
    faceLivenessProps: faceLivenessProps,
    onCameraAccessDenied: onCameraAccessDenied,
    debugMode: debugMode
  }))));
};

/**
 * Render a fullscreen capture component that performs `IDValidation` and `FaceValidation` sequentially.
 * */
var IdAndFaceValidation = function IdAndFaceValidation(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    manualReviewRequired = _a.manualReviewRequired,
    idBackImageRequired = _a.idBackImageRequired,
    verifyIdWithExternalDatabases = _a.verifyIdWithExternalDatabases,
    bypassAgeValidation = _a.bypassAgeValidation,
    bypassNameMatching = _a.bypassNameMatching,
    personalData = _a.personalData,
    cardData = _a.cardData,
    idData = _a.idData,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    webhooksFireOnReview = _a.webhooksFireOnReview,
    webhooksFireOnReviewURL = _a.webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig = _a.customerDataMatchConfig,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    precapturedDocuments = _a.precapturedDocuments,
    _c = _a.idCaptureLoadingOverlayMode,
    idCaptureLoadingOverlayMode = _c === void 0 ? 'default' : _c,
    _d = _a.idCaptureRequirement,
    idCaptureRequirement = _d === void 0 ? 'idCardOrPassport' : _d,
    _e = _a.allowSinglePageIdCapture,
    allowSinglePageIdCapture = _e === void 0 ? false : _e,
    _f = _a.idCaptureThresholds,
    idCaptureThresholds = _f === void 0 ? defaultIdCaptureThresholds : _f,
    _g = _a.faceLivenessLoadingOverlayMode,
    faceLivenessLoadingOverlayMode = _g === void 0 ? 'default' : _g,
    _h = _a.faceLivenessTimeoutDurationMs,
    faceLivenessTimeoutDurationMs = _h === void 0 ? 15000 : _h,
    _j = _a.skipSuccessScreen,
    skipSuccessScreen = _j === void 0 ? false : _j,
    idCaptureInstructions = _a.idCaptureInstructions,
    _k = _a.idCaptureGuideType,
    idCaptureGuideType = _k === void 0 ? 'fit' : _k,
    _l = _a.idCaptureGuideImages,
    idCaptureGuideImages = _l === void 0 ? defaultIdCaptureGuideImages : _l,
    _m = _a.idCapturePortraitGuidesOnMobile,
    idCapturePortraitGuidesOnMobile = _m === void 0 ? true : _m,
    _o = _a.idCaptureRotateLoadingOverlayImageWhenPortrait,
    idCaptureRotateLoadingOverlayImageWhenPortrait = _o === void 0 ? true : _o,
    _p = _a.idCaptureModelLoadTimeoutMs,
    idCaptureModelLoadTimeoutMs = _p === void 0 ? defaultDocumentDetectionModelLoadTimeoutMs : _p,
    _q = _a.idCaptureForceFallbackMode,
    idCaptureForceFallbackMode = _q === void 0 ? false : _q,
    _r = _a.selfieCaptureModelLoadTimeoutMs,
    selfieCaptureModelLoadTimeoutMs = _r === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _r,
    _s = _a.allowIdCardBackToFrontCapture,
    allowIdCardBackToFrontCapture = _s === void 0 ? false : _s,
    _t = _a.enableOverrideWrongDocumentTypeDialog,
    enableOverrideWrongDocumentTypeDialog = _t === void 0 ? false : _t,
    _u = _a.allowOverrideWrongDocumentTypeAfterMs,
    allowOverrideWrongDocumentTypeAfterMs = _u === void 0 ? 8000 : _u,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onBeforeLivenessCheck = _a.onBeforeLivenessCheck,
    onBeforeSubmit = _a.onBeforeSubmit,
    onSubmit = _a.onSubmit,
    onComplete = _a.onComplete,
    onApproved = _a.onApproved,
    onDenied = _a.onDenied,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onIdCaptureModelError = _a.onIdCaptureModelError,
    onSelfieCaptureModelError = _a.onSelfieCaptureModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _v = _a.captureSignature,
    captureSignature = _v === void 0 ? false : _v,
    _w = _a.captureSignatureVideo,
    captureSignatureVideo = _w === void 0 ? false : _w,
    _x = _a.captureAdditionalDocuments,
    captureAdditionalDocuments = _x === void 0 ? [] : _x,
    _y = _a.theme,
    theme = _y === void 0 ? 'default' : _y,
    _z = _a.assets,
    assets = _z === void 0 ? {} : _z,
    _0 = _a.classNames,
    classNames = _0 === void 0 ? {} : _0,
    _1 = _a.colors,
    colors = _1 === void 0 ? {} : _1,
    _2 = _a.verbiage,
    verbiage = _2 === void 0 ? {} : _2,
    _3 = _a.geolocationEnabled,
    geolocationEnabled = _3 === void 0 ? true : _3,
    _4 = _a.geolocationRequired,
    geolocationRequired = _4 === void 0 ? false : _4,
    _5 = _a.debugMode,
    debugMode = _5 === void 0 ? false : _5;
  useLanguage(lang);
  useDebugLogging(debugMode);
  var idCaptureProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      onModelError: onIdCaptureModelError,
      assets: assets.idCapture,
      classNames: classNames.idCapture,
      colors: colors.idCapture,
      verbiage: verbiage.idCapture,
      precapturedDocuments: precapturedDocuments,
      captureRequirement: idCaptureRequirement,
      allowSinglePageIdCapture: allowSinglePageIdCapture,
      thresholds: idCaptureThresholds,
      loadingOverlayMode: idCaptureLoadingOverlayMode,
      instructions: idCaptureInstructions,
      guideType: idCaptureGuideType,
      guideImages: idCaptureGuideImages,
      portraitGuidesOnMobile: idCapturePortraitGuidesOnMobile,
      rotateLoadingOverlayImageWhenPortrait: idCaptureRotateLoadingOverlayImageWhenPortrait,
      modelLoadTimeoutMs: idCaptureModelLoadTimeoutMs,
      allowIdCardBackToFrontCapture: allowIdCardBackToFrontCapture,
      enableOverrideWrongDocumentTypeDialog: enableOverrideWrongDocumentTypeDialog,
      allowOverrideWrongDocumentTypeAfterMs: allowOverrideWrongDocumentTypeAfterMs,
      forceFallbackMode: idCaptureForceFallbackMode,
      skipSuccessScreen: skipSuccessScreen,
      debugMode: debugMode
    };
  }, [onExitCapture, onUserCancel, onIdCaptureModelError, assets.idCapture, classNames.idCapture, colors.idCapture, verbiage.idCapture, precapturedDocuments, idCaptureRequirement, allowSinglePageIdCapture, idCaptureThresholds, idCaptureLoadingOverlayMode, idCaptureInstructions, idCaptureGuideType, idCaptureGuideImages, idCapturePortraitGuidesOnMobile, idCaptureRotateLoadingOverlayImageWhenPortrait, idCaptureModelLoadTimeoutMs, allowIdCardBackToFrontCapture, enableOverrideWrongDocumentTypeDialog, allowOverrideWrongDocumentTypeAfterMs, idCaptureForceFallbackMode, skipSuccessScreen, debugMode]);
  var faceLivenessProps = useMemo(function () {
    return {
      loadingOverlayMode: faceLivenessLoadingOverlayMode,
      timeoutDurationMs: faceLivenessTimeoutDurationMs,
      modelLoadTimeoutMs: selfieCaptureModelLoadTimeoutMs,
      onDenied: onDenied,
      onExitCapture: onExitCapture,
      onExitAfterFailure: onExitAfterFailure,
      onUserCancel: onUserCancel,
      onModelError: onSelfieCaptureModelError,
      skipSuccessScreen: skipSuccessScreen,
      assets: assets.faceLiveness,
      classNames: classNames.faceLiveness,
      colors: colors.faceLiveness,
      verbiage: verbiage.faceLiveness,
      debugMode: debugMode
    };
  }, [assets.faceLiveness, classNames.faceLiveness, colors.faceLiveness, debugMode, faceLivenessLoadingOverlayMode, faceLivenessTimeoutDurationMs, onDenied, onExitAfterFailure, onExitCapture, onSelfieCaptureModelError, onUserCancel, selfieCaptureModelLoadTimeoutMs, skipSuccessScreen, verbiage.faceLiveness]);
  var additionalDocumentCaptureProps = useMemo(function () {
    return {
      documents: captureAdditionalDocuments,
      classNames: classNames.additionalDocumentCapture,
      verbiage: verbiage.additionalDocumentCapture
    };
  }, [captureAdditionalDocuments, classNames.additionalDocumentCapture, verbiage.additionalDocumentCapture]);
  var signatureCaptureProps = useMemo(function () {
    return {
      classNames: classNames.signatureCapture,
      verbiage: verbiage.signatureCapture
    };
  }, [classNames.signatureCapture, verbiage.signatureCapture]);
  var videoSignatureCaptureProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      skipSuccessScreen: skipSuccessScreen,
      classNames: classNames.videoSignatureCapture,
      colors: colors.videoSignatureCapture,
      verbiage: verbiage.videoSignatureCapture,
      debugMode: debugMode
    };
  }, [classNames.videoSignatureCapture, colors.videoSignatureCapture, debugMode, onExitCapture, onUserCancel, skipSuccessScreen, verbiage.videoSignatureCapture]);
  var onResponseReceived = useCallback(function (resp, req) {
    onComplete === null || onComplete === void 0 ? void 0 : onComplete(resp, req);
    if (resp.resultData['verificationResult'] === 'Approved') {
      onApproved === null || onApproved === void 0 ? void 0 : onApproved(resp, req);
    } else {
      onDenied === null || onDenied === void 0 ? void 0 : onDenied(resp, req);
    }
  }, [onApproved, onComplete, onDenied]);
  var checks = useMemo(function () {
    return (precapturedDocuments === null || precapturedDocuments === void 0 ? void 0 : precapturedDocuments.selfie) ? ['IdCapture'] : ['IdCapture', 'FaceLiveness'];
  }, [precapturedDocuments === null || precapturedDocuments === void 0 ? void 0 : precapturedDocuments.selfie]);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.VALIDATE,
    submissionUrl: submissionUrl,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    needImmediateResponse: needImmediateResponse,
    manualReviewRequired: manualReviewRequired,
    idBackImageRequired: idBackImageRequired,
    verifyIdWithExternalDatabases: verifyIdWithExternalDatabases,
    bypassAgeValidation: bypassAgeValidation,
    bypassNameMatching: bypassNameMatching,
    personalData: personalData,
    cardData: cardData,
    idData: idData,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    webhooksFireOnReview: webhooksFireOnReview,
    webhooksFireOnReviewURL: webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig: customerDataMatchConfig,
    precapturedDocuments: precapturedDocuments,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeSubmit: onBeforeSubmit,
    onBeforeLivenessCheck: onBeforeLivenessCheck,
    onSubmit: onSubmit,
    onResponseReceived: onResponseReceived,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CompositeWizard, {
    checks: checks,
    idCaptureProps: idCaptureProps,
    faceLivenessProps: faceLivenessProps,
    signatureCaptureProps: signatureCaptureProps,
    videoSignatureCaptureProps: videoSignatureCaptureProps,
    additionalDocumentCaptureProps: additionalDocumentCaptureProps,
    captureSignature: captureSignature,
    captureSignatureVideo: captureSignatureVideo,
    onCameraAccessDenied: onCameraAccessDenied,
    debugMode: debugMode
  }))));
};

/**
 * Render a fullscreen capture component that performs IDValidation and FaceValidation sequentially, and then stores the results in IDmission's customer database using the supplied `enrollmentId` for later verification or 1:N matching.
 */
var CustomerIdAndBiometricsEnrollment = function CustomerIdAndBiometricsEnrollment(_a) {
  var enrollmentId = _a.enrollmentId,
    _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    manualReviewRequired = _a.manualReviewRequired,
    idBackImageRequired = _a.idBackImageRequired,
    idImageResolutionCheck = _a.idImageResolutionCheck,
    verifyIdWithExternalDatabases = _a.verifyIdWithExternalDatabases,
    bypassAgeValidation = _a.bypassAgeValidation,
    bypassNameMatching = _a.bypassNameMatching,
    personalData = _a.personalData,
    cardData = _a.cardData,
    idData = _a.idData,
    deduplicationEnabled = _a.deduplicationEnabled,
    deduplicationSynchronous = _a.deduplicationSynchronous,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    webhooksFireOnReview = _a.webhooksFireOnReview,
    webhooksFireOnReviewURL = _a.webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig = _a.customerDataMatchConfig,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    _c = _a.idCaptureLoadingOverlayMode,
    idCaptureLoadingOverlayMode = _c === void 0 ? 'default' : _c,
    _d = _a.idCaptureRequirement,
    idCaptureRequirement = _d === void 0 ? 'idCardOrPassport' : _d,
    _e = _a.allowSinglePageIdCapture,
    allowSinglePageIdCapture = _e === void 0 ? false : _e,
    _f = _a.idCaptureThresholds,
    idCaptureThresholds = _f === void 0 ? defaultIdCaptureThresholds : _f,
    _g = _a.faceLivenessTimeoutDurationMs,
    faceLivenessTimeoutDurationMs = _g === void 0 ? 15000 : _g,
    _h = _a.faceLivenessLoadingOverlayMode,
    faceLivenessLoadingOverlayMode = _h === void 0 ? 'default' : _h,
    _j = _a.skipSuccessScreen,
    skipSuccessScreen = _j === void 0 ? false : _j,
    idCaptureInstructions = _a.idCaptureInstructions,
    _k = _a.idCaptureGuideType,
    idCaptureGuideType = _k === void 0 ? 'fit' : _k,
    _l = _a.idCaptureGuideImages,
    idCaptureGuideImages = _l === void 0 ? defaultIdCaptureGuideImages : _l,
    _m = _a.idCapturePortraitGuidesOnMobile,
    idCapturePortraitGuidesOnMobile = _m === void 0 ? true : _m,
    _o = _a.idCaptureRotateLoadingOverlayImageWhenPortrait,
    idCaptureRotateLoadingOverlayImageWhenPortrait = _o === void 0 ? true : _o,
    _p = _a.idCaptureModelLoadTimeoutMs,
    idCaptureModelLoadTimeoutMs = _p === void 0 ? defaultDocumentDetectionModelLoadTimeoutMs : _p,
    _q = _a.idCaptureForceFallbackMode,
    idCaptureForceFallbackMode = _q === void 0 ? false : _q,
    _r = _a.selfieCaptureModelLoadTimeoutMs,
    selfieCaptureModelLoadTimeoutMs = _r === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _r,
    _s = _a.allowIdCardBackToFrontCapture,
    allowIdCardBackToFrontCapture = _s === void 0 ? false : _s,
    _t = _a.enableOverrideWrongDocumentTypeDialog,
    enableOverrideWrongDocumentTypeDialog = _t === void 0 ? false : _t,
    _u = _a.allowOverrideWrongDocumentTypeAfterMs,
    allowOverrideWrongDocumentTypeAfterMs = _u === void 0 ? 8000 : _u,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onBeforeSubmit = _a.onBeforeSubmit,
    onSubmit = _a.onSubmit,
    onComplete = _a.onComplete,
    onEnrolled = _a.onEnrolled,
    onDenied = _a.onDenied,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onIdCaptureModelError = _a.onIdCaptureModelError,
    onSelfieCaptureModelError = _a.onSelfieCaptureModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _v = _a.captureSignature,
    captureSignature = _v === void 0 ? false : _v,
    _w = _a.captureSignatureVideo,
    captureSignatureVideo = _w === void 0 ? false : _w,
    _x = _a.captureAdditionalDocuments,
    captureAdditionalDocuments = _x === void 0 ? [] : _x,
    _y = _a.captureVideoId,
    captureVideoId = _y === void 0 ? false : _y,
    captureVideoIdProps = _a.captureVideoIdProps,
    _z = _a.theme,
    theme = _z === void 0 ? 'default' : _z,
    _0 = _a.assets,
    assets = _0 === void 0 ? {} : _0,
    _1 = _a.classNames,
    classNames = _1 === void 0 ? {} : _1,
    _2 = _a.colors,
    colors = _2 === void 0 ? {} : _2,
    _3 = _a.verbiage,
    verbiage = _3 === void 0 ? {} : _3,
    _4 = _a.geolocationEnabled,
    geolocationEnabled = _4 === void 0 ? true : _4,
    _5 = _a.geolocationRequired,
    geolocationRequired = _5 === void 0 ? false : _5,
    _6 = _a.debugMode,
    debugMode = _6 === void 0 ? false : _6;
  useLanguage(lang);
  useDebugLogging(debugMode);
  var idCaptureProps = useMemo(function () {
    return {
      assets: assets.idCapture,
      classNames: classNames.idCapture,
      colors: colors.idCapture,
      verbiage: verbiage.idCapture,
      captureRequirement: idCaptureRequirement,
      allowSinglePageIdCapture: allowSinglePageIdCapture,
      thresholds: idCaptureThresholds,
      loadingOverlayMode: idCaptureLoadingOverlayMode,
      instructions: idCaptureInstructions,
      guideType: idCaptureGuideType,
      guideImages: idCaptureGuideImages,
      portraitGuidesOnMobile: idCapturePortraitGuidesOnMobile,
      rotateLoadingOverlayImageWhenPortrait: idCaptureRotateLoadingOverlayImageWhenPortrait,
      modelLoadTimeoutMs: idCaptureModelLoadTimeoutMs,
      allowIdCardBackToFrontCapture: allowIdCardBackToFrontCapture,
      forceFallbackMode: idCaptureForceFallbackMode,
      enableOverrideWrongDocumentTypeDialog: enableOverrideWrongDocumentTypeDialog,
      allowOverrideWrongDocumentTypeAfterMs: allowOverrideWrongDocumentTypeAfterMs,
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      onModelError: onIdCaptureModelError,
      skipSuccessScreen: skipSuccessScreen,
      debugMode: debugMode
    };
  }, [assets.idCapture, classNames.idCapture, colors.idCapture, verbiage.idCapture, idCaptureRequirement, allowSinglePageIdCapture, idCaptureThresholds, idCaptureLoadingOverlayMode, idCaptureInstructions, idCaptureGuideType, idCaptureGuideImages, idCapturePortraitGuidesOnMobile, idCaptureRotateLoadingOverlayImageWhenPortrait, idCaptureModelLoadTimeoutMs, allowIdCardBackToFrontCapture, idCaptureForceFallbackMode, enableOverrideWrongDocumentTypeDialog, allowOverrideWrongDocumentTypeAfterMs, onExitCapture, onUserCancel, onIdCaptureModelError, skipSuccessScreen, debugMode]);
  var faceLivenessProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onExitAfterFailure: onExitAfterFailure,
      onUserCancel: onUserCancel,
      onModelError: onSelfieCaptureModelError,
      loadingOverlayMode: faceLivenessLoadingOverlayMode,
      timeoutDurationMs: faceLivenessTimeoutDurationMs,
      modelLoadTimeoutMs: selfieCaptureModelLoadTimeoutMs,
      skipSuccessScreen: skipSuccessScreen,
      assets: assets.faceLiveness,
      classNames: classNames.faceLiveness,
      colors: colors.faceLiveness,
      verbiage: verbiage.faceLiveness,
      debugMode: debugMode
    };
  }, [assets.faceLiveness, classNames.faceLiveness, colors.faceLiveness, debugMode, faceLivenessLoadingOverlayMode, faceLivenessTimeoutDurationMs, onExitAfterFailure, onExitCapture, onSelfieCaptureModelError, onUserCancel, selfieCaptureModelLoadTimeoutMs, skipSuccessScreen, verbiage.faceLiveness]);
  var videoIdCaptureProps = useMemo(function () {
    return _assign({
      onExitCapture: onExitCapture,
      onExitAfterFailure: onExitAfterFailure,
      onUserCancel: onUserCancel,
      onIdCaptureModelError: onIdCaptureModelError,
      idCaptureProps: idCaptureProps,
      faceLivenessProps: faceLivenessProps,
      skipSuccessScreen: skipSuccessScreen,
      assets: assets.videoIdCapture,
      classNames: classNames.videoIdCapture,
      colors: colors.videoIdCapture,
      verbiage: verbiage.videoIdCapture,
      debugMode: debugMode
    }, captureVideoIdProps !== null && captureVideoIdProps !== void 0 ? captureVideoIdProps : {});
  }, [assets.videoIdCapture, captureVideoIdProps, classNames.videoIdCapture, colors.videoIdCapture, debugMode, faceLivenessProps, idCaptureProps, onExitAfterFailure, onExitCapture, onIdCaptureModelError, onUserCancel, skipSuccessScreen, verbiage.videoIdCapture]);
  var additionalDocumentCaptureProps = useMemo(function () {
    return {
      documents: captureAdditionalDocuments,
      classNames: classNames.additionalDocumentCapture,
      verbiage: verbiage.additionalDocumentCapture
    };
  }, [captureAdditionalDocuments, classNames.additionalDocumentCapture, verbiage.additionalDocumentCapture]);
  var signatureCaptureProps = useMemo(function () {
    return {
      classNames: classNames.signatureCapture,
      verbiage: verbiage.signatureCapture
    };
  }, [classNames.signatureCapture, verbiage.signatureCapture]);
  var videoSignatureCaptureProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      skipSuccessScreen: skipSuccessScreen,
      classNames: classNames.videoSignatureCapture,
      colors: colors.videoSignatureCapture,
      verbiage: verbiage.videoSignatureCapture,
      debugMode: debugMode
    };
  }, [classNames.videoSignatureCapture, colors.videoSignatureCapture, debugMode, onExitCapture, onUserCancel, skipSuccessScreen, verbiage.videoSignatureCapture]);
  var onResponseReceived = useCallback(function (resp, req) {
    onComplete === null || onComplete === void 0 ? void 0 : onComplete(resp, req);
    if (resp.resultData['verificationResult'] === 'Customer Onboarded') {
      onEnrolled === null || onEnrolled === void 0 ? void 0 : onEnrolled(resp, req);
    } else {
      onDenied === null || onDenied === void 0 ? void 0 : onDenied(resp, req);
    }
  }, [onEnrolled, onComplete, onDenied]);
  var checks = useMemo(function () {
    return captureVideoId ? ['VideoIdCapture'] : ['IdCapture', 'FaceLiveness'];
  }, [captureVideoId]);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.ENROLL,
    submissionUrl: submissionUrl,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    enrollmentId: enrollmentId,
    needImmediateResponse: needImmediateResponse,
    manualReviewRequired: manualReviewRequired,
    idBackImageRequired: idBackImageRequired,
    idImageResolutionCheck: idImageResolutionCheck,
    verifyIdWithExternalDatabases: verifyIdWithExternalDatabases,
    bypassAgeValidation: bypassAgeValidation,
    bypassNameMatching: bypassNameMatching,
    personalData: personalData,
    cardData: cardData,
    idData: idData,
    deduplicationEnabled: deduplicationEnabled,
    deduplicationSynchronous: deduplicationSynchronous,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    webhooksFireOnReview: webhooksFireOnReview,
    webhooksFireOnReviewURL: webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig: customerDataMatchConfig,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeSubmit: onBeforeSubmit,
    onSubmit: onSubmit,
    onResponseReceived: onResponseReceived,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CompositeWizard, {
    checks: checks,
    idCaptureProps: idCaptureProps,
    faceLivenessProps: faceLivenessProps,
    videoIdCaptureProps: videoIdCaptureProps,
    additionalDocumentCaptureProps: additionalDocumentCaptureProps,
    signatureCaptureProps: signatureCaptureProps,
    videoSignatureCaptureProps: videoSignatureCaptureProps,
    captureSignature: captureSignature,
    captureSignatureVideo: captureSignatureVideo,
    onCameraAccessDenied: onCameraAccessDenied,
    debugMode: debugMode
  }))));
};

var ALLOWED_RETRIES$3 = 0;
var initialState$1 = {
  frame: null,
  face: null,
  imageUrl: null,
  requestState: 'CAPTURING',
  requestError: null,
  unverifiedTimes: 0
};
var reducer$1 = function reducer(state, action) {
  switch (action.type) {
    case 'verificationReady':
      {
        var allowedStates = ['CAPTURING', 'ERROR'];
        if (allowedStates.includes(state.requestState)) {
          return _assign(_assign({}, state), {
            requestState: 'CAPTURED',
            frame: action.payload.frame,
            face: action.payload.face
          });
        } else {
          return state;
        }
      }
    case 'verifying':
      return _assign(_assign({}, state), {
        requestState: 'VERIFYING',
        imageUrl: action.payload.imageUrl
      });
    case 'verificationCompleted':
      {
        var _a = action.payload.response,
          _b = _a.status,
          statusCode = _b.statusCode,
          statusMessage = _b.statusMessage,
          errorData = _b.errorData,
          resultData = _a.resultData;
        if (statusCode !== '000') {
          return _assign(_assign({}, state), {
            requestState: 'ERROR',
            requestError: new Error("".concat(statusMessage, ": ").concat(errorData))
          });
        }
        var requestState = state.requestState,
          unverifiedTimes = state.unverifiedTimes;
        var customerMatched = resultData.verificationResultCode === '00';
        if (customerMatched) {
          requestState = 'VERIFIED';
        } else {
          if (unverifiedTimes < ALLOWED_RETRIES$3) {
            requestState = 'CAPTURING';
            unverifiedTimes += 1;
          } else {
            requestState = 'REJECTED';
          }
        }
        return _assign(_assign({}, state), {
          requestState: requestState,
          unverifiedTimes: unverifiedTimes
        });
      }
    case 'verificationFailed':
      return _assign(_assign({}, state), {
        requestState: 'ERROR',
        requestError: action.payload.error
      });
    default:
      return state;
  }
};
var CustomerVerificationCapture = function CustomerVerificationCapture(_a) {
  var _b, _c;
  var onCustomerMatched = _a.onCustomerMatched,
    onCustomerNotMatched = _a.onCustomerNotMatched,
    onCaptureGuidanceTimeout = _a.onCaptureGuidanceTimeout,
    onExit = _a.onExit,
    captureGuidanceTimeoutDurationMs = _a.captureGuidanceTimeoutDurationMs,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    verbiage = _f === void 0 ? {} : _f,
    _g = _a.debugMode,
    debugMode = _g === void 0 ? false : _g;
  var _h = useReducer(reducer$1, initialState$1),
    state = _h[0],
    dispatch = _h[1];
  var frame = state.frame,
    face = state.face;
  var _j = useContext(SubmissionContext),
    submit = _j.submit,
    submissionRequest = _j.submissionRequest,
    submissionResponse = _j.submissionResponse,
    submissionError = _j.submissionError,
    selfieImage = _j.selfieImage,
    setSelfieImage = _j.setSelfieImage;
  var _k = useState(null),
    imageUrl = _k[0],
    setImageUrl = _k[1];
  var rawCanvas = useRef(null);
  var cropCanvas = useRef(null);
  var resizeCanvas = useRef(null);
  var onSelfieCaptured = useCallback(function (frame, face) {
    dispatch({
      type: 'verificationReady',
      payload: {
        frame: frame,
        face: face
      }
    });
  }, []);
  var isReady = state.requestState === 'CAPTURED';
  useEffect(function () {
    if (!frame || !face || submissionError) return;
    var imageUrl = cropToShoulders(rawCanvas.current, cropCanvas.current, resizeCanvas.current, frame, face);
    setImageUrl(imageUrl);
    dataUrlToBase64(imageUrl).then(function (img) {
      setSelfieImage(img);
    });
  }, [face, frame, setSelfieImage, submissionError]);
  useEffect(function () {
    if (!isReady || !selfieImage || submissionError) return;
    (function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var submissionResponse_1, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);
              dispatch({
                type: 'verifying',
                payload: {
                  imageUrl: selfieImage
                }
              });
              return [4 /*yield*/, submit()];
            case 1:
              submissionResponse_1 = _a.sent();
              if (!submissionResponse_1) throw new Error('submission failed!');
              dispatch({
                type: 'verificationCompleted',
                payload: {
                  response: submissionResponse_1
                }
              });
              return [3 /*break*/, 3];
            case 2:
              e_1 = _a.sent();
              dispatch({
                type: 'verificationFailed',
                payload: {
                  error: e_1
                }
              });
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/];
          }
        });
      });
    })();
  }, [isReady, onCustomerMatched, onCustomerNotMatched, selfieImage, state.requestState, submissionError, submit]);
  useEffect(function () {
    if (!submissionRequest || !submissionResponse) return;
    if (state.requestState === 'VERIFIED') {
      onCustomerMatched === null || onCustomerMatched === void 0 ? void 0 : onCustomerMatched(submissionResponse, submissionRequest);
    } else if (state.requestState === 'REJECTED') {
      onCustomerNotMatched === null || onCustomerNotMatched === void 0 ? void 0 : onCustomerNotMatched(submissionResponse, submissionRequest);
    }
  }, [onCustomerMatched, onCustomerNotMatched, state.requestState, submissionRequest, submissionResponse]);
  useTimeout(captureGuidanceTimeoutDurationMs, onCaptureGuidanceTimeout, ['VERIFIED', 'REJECTED'].includes(state.requestState), state.requestState === 'VERIFYING');
  var progressPreviewText = useVerbiage(verbiage.progressPreviewText, 'Processing...');
  var theme = useTheme();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: rawCanvas
  }), /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: cropCanvas
  }), /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: resizeCanvas
  }), /*#__PURE__*/React__default.createElement(SelfieCapture, {
    onSelfieCaptured: onSelfieCaptured,
    onExit: onExit,
    timeoutDurationMs: captureGuidanceTimeoutDurationMs,
    classNames: classNames,
    colors: colors,
    verbiage: verbiage,
    debugMode: debugMode
  }), debugMode && !((_c = (_b = theme.selfieCapture) === null || _b === void 0 ? void 0 : _b.capturePreview) === null || _c === void 0 ? void 0 : _c.disabled) && imageUrl && ( /*#__PURE__*/React__default.createElement(SelfieProgressPreview, {
    imageUrl: imageUrl,
    text: progressPreviewText,
    classNames: classNames.imagePreview
  })));
};

var CustomerVerificationSuccess = function CustomerVerificationSuccess(_a) {
  var imageUrl = _a.imageUrl,
    onDoneClick = _a.onDoneClick,
    onRetryClick = _a.onRetryClick,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.colors,
    colors = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    rawVerbiage = _d === void 0 ? {} : _d;
  imageUrl || (imageUrl = "".concat(DEFAULT_CDN_URL, "/Selfie-Image-1.png"));
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Customer has been verified!',
    retryBtnText: 'Retry',
    doneBtnText: 'Done'
  });
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(Heading$3, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ImageContainer$3, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: verbiage.headingText,
    src: imageUrl,
    className: classNames.image
  })), /*#__PURE__*/React__default.createElement(StyledButtonsRow$3, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    className: classNames.retryBtn,
    onClick: onRetryClick,
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryBtnText), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    className: classNames.doneBtn,
    onClick: onDoneClick,
    colors: colors.doneBtn,
    finished: true
  }, verbiage.doneBtnText))));
};
var Heading$3 = styled.h3(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var ImageContainer$3 = styled(ButtonsRow)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  max-height: calc(100vh - 185px);\n"], ["\n  max-height: calc(100vh - 185px);\n"])));
var StyledButtonsRow$3 = styled(ButtonsRow)(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  margin-top: 24px;\n"], ["\n  margin-top: 24px;\n"])));
var templateObject_1$3, templateObject_2$3, templateObject_3$3;

var CustomerVerificationFailure = function CustomerVerificationFailure(_a) {
  var _b = _a.canRetry,
    canRetry = _b === void 0 ? true : _b,
    onRetryClick = _a.onRetryClick,
    onExitClick = _a.onExitClick,
    _c = _a.assets,
    assets = _c === void 0 ? {} : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  assets.imageUrl || (assets.imageUrl = "".concat(DEFAULT_CDN_URL, "/manual_capture.png"));
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Customer not verified',
    retryBtnText: 'Retry',
    exitBtnText: 'Exit'
  });
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(Heading$2, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ImageContainer$2, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: verbiage.headingText,
    src: assets.imageUrl,
    className: classNames.image
  })), /*#__PURE__*/React__default.createElement(StyledButtonsRow$2, {
    className: classNames.buttonsRow
  }, canRetry && ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    className: classNames.retryBtn,
    onClick: onRetryClick,
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryBtnText)), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "secondary",
    className: classNames.exitBtn,
    onClick: onExitClick,
    colors: colors.exitBtn,
    finished: true
  }, verbiage.exitBtnText))));
};
var Heading$2 = styled.h3(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var ImageContainer$2 = styled(ButtonsRow)(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  max-height: calc(100vh - 185px);\n"], ["\n  max-height: calc(100vh - 185px);\n"])));
var StyledButtonsRow$2 = styled(ButtonsRow)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  margin-top: 24px;\n"], ["\n  margin-top: 24px;\n"])));
var templateObject_1$2, templateObject_2$2, templateObject_3$2;

var ALLOWED_RETRIES$2 = 2;
var CustomerVerificationWizard = function CustomerVerificationWizard(_a) {
  var _b;
  var onComplete = _a.onComplete,
    onCustomerMatched = _a.onCustomerMatched,
    onCustomerNotMatched = _a.onCustomerNotMatched,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onCaptureGuidanceTimeout = _a.onCaptureGuidanceTimeout,
    captureGuidanceTimeoutDurationMs = _a.captureGuidanceTimeoutDurationMs,
    _c = _a.skipSuccessScreen,
    skipSuccessScreen = _c === void 0 ? false : _c,
    _d = _a.loadingOverlayMode,
    loadingOverlayMode = _d === void 0 ? 'default' : _d,
    _e = _a.assets,
    assets = _e === void 0 ? {} : _e,
    _f = _a.classNames,
    classNames = _f === void 0 ? {} : _f,
    _g = _a.colors,
    colors = _g === void 0 ? {} : _g,
    _h = _a.verbiage,
    verbiage = _h === void 0 ? {} : _h,
    _j = _a.debugMode,
    debugMode = _j === void 0 ? false : _j;
  var _k = useContext(SubmissionContext),
    submissionRequest = _k.submissionRequest,
    submissionResponse = _k.submissionResponse,
    selfieImage = _k.selfieImage;
  var _l = useState('LOADING'),
    captureState = _l[0],
    setCaptureState = _l[1];
  var _m = useCameraStore(),
    cameraAccessDenied = _m.cameraAccessDenied,
    releaseCameraAccess = _m.releaseCameraAccess;
  var _o = useContext(SelfieGuidanceModelsContext),
    start = _o.start,
    stop = _o.stop;
  useEffect(function () {
    if (captureState !== 'CAPTURING') return;
    start();
    return function () {
      stop();
    };
  }, [captureState, start, stop]);
  var onCustomerMatchedCallback = useCallback(function (resp, req) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setCaptureState('MATCHED');
        onCustomerMatched === null || onCustomerMatched === void 0 ? void 0 : onCustomerMatched(resp, req);
        return [2 /*return*/];
      });
    });
  }, [onCustomerMatched]);
  var onCustomerNotMatchedCallback = useCallback(function (resp, req) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setCaptureState('NOT_MATCHED');
        onCustomerNotMatched === null || onCustomerNotMatched === void 0 ? void 0 : onCustomerNotMatched(resp, req);
        return [2 /*return*/];
      });
    });
  }, [onCustomerNotMatched]);
  var onCaptureGuidanceTimeoutCallback = useCallback(function () {
    setCaptureState('FAILED');
    onCaptureGuidanceTimeout === null || onCaptureGuidanceTimeout === void 0 ? void 0 : onCaptureGuidanceTimeout();
  }, [onCaptureGuidanceTimeout]);
  var _p = useState(0),
    attempt = _p[0],
    setAttempt = _p[1];
  var onExitCallback = useCallback(function () {
    setAttempt(function (n) {
      return n + 1;
    });
    setCaptureState('LOADING');
    onExitCapture === null || onExitCapture === void 0 ? void 0 : onExitCapture();
  }, [onExitCapture]);
  var onDoneCallback = useCallback(function () {
    releaseCameraAccess();
    if (submissionRequest && submissionResponse) onComplete === null || onComplete === void 0 ? void 0 : onComplete(submissionResponse, submissionRequest);
  }, [onComplete, releaseCameraAccess, submissionRequest, submissionResponse]);
  var showSuccessScreen = useShowSuccessScreen(skipSuccessScreen, captureState === 'MATCHED', onDoneCallback);
  useEffect(function () {
    if (cameraAccessDenied) {
      setAttempt(function (n) {
        return n + 1;
      });
      setCaptureState('LOADING');
    }
  }, [cameraAccessDenied]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_b = classNames.container) !== null && _b !== void 0 ? _b : '')
  }, /*#__PURE__*/React__default.createElement(CameraVideoTag, {
    className: classNames.cameraFeed
  }), captureState !== 'LOADING' && function () {
    switch (captureState) {
      case 'CAPTURING':
        return /*#__PURE__*/React__default.createElement(CustomerVerificationCapture, {
          key: "capture".concat(attempt),
          onCustomerMatched: onCustomerMatchedCallback,
          onCustomerNotMatched: onCustomerNotMatchedCallback,
          onCaptureGuidanceTimeout: onCaptureGuidanceTimeoutCallback,
          onExit: onExitCallback,
          captureGuidanceTimeoutDurationMs: captureGuidanceTimeoutDurationMs,
          classNames: classNames,
          colors: colors,
          verbiage: verbiage,
          debugMode: debugMode
        });
      case 'MATCHED':
        if (!showSuccessScreen) return;
        return /*#__PURE__*/React__default.createElement(CustomerVerificationSuccess, {
          imageUrl: "data:image/png;base64, ".concat(selfieImage),
          classNames: classNames.success,
          colors: colors.success,
          verbiage: verbiage.success,
          onDoneClick: onDoneCallback,
          onRetryClick: function onRetryClick() {
            setCaptureState('CAPTURING');
            setAttempt(0);
          }
        });
      case 'NOT_MATCHED':
      case 'FAILED':
        return /*#__PURE__*/React__default.createElement(CustomerVerificationFailure, {
          assets: assets.failure,
          classNames: classNames.failure,
          colors: colors.failure,
          verbiage: verbiage.failure,
          canRetry: attempt < ALLOWED_RETRIES$2,
          onExitClick: function onExitClick() {
            releaseCameraAccess();
            onExitAfterFailure === null || onExitAfterFailure === void 0 ? void 0 : onExitAfterFailure();
          },
          onRetryClick: function onRetryClick() {
            setAttempt(function (n) {
              return n + 1;
            });
          }
        });
      default:
        return null;
    }
  }()), /*#__PURE__*/React__default.createElement(SelfieCaptureLoadingOverlay, {
    key: attempt,
    mode: loadingOverlayMode,
    assets: assets.loadingOverlay,
    classNames: classNames.loadingOverlay,
    colors: colors.loadingOverlay,
    verbiage: verbiage.loadingOverlay,
    onUserCancel: onUserCancel,
    onDismissed: function onDismissed() {
      setCaptureState('CAPTURING');
    }
  }));
};

/**
 * Render a fullscreen capture component that analyzes frames from the user's front-facing camera to determine whether the user matches a specified `enrollmentId` that they have previously registered in IDmission's customer database.
 */
var CustomerVerification = function CustomerVerification(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    enrollmentId = _a.enrollmentId,
    sessionId = _a.sessionId,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    _c = _a.loadingOverlayMode,
    loadingOverlayMode = _c === void 0 ? 'default' : _c,
    _d = _a.timeoutDurationMs,
    timeoutDurationMs = _d === void 0 ? 15000 : _d,
    _e = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _e === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _e,
    _f = _a.skipSuccessScreen,
    skipSuccessScreen = _f === void 0 ? false : _f,
    _g = _a.theme,
    theme = _g === void 0 ? 'default' : _g,
    assets = _a.assets,
    classNames = _a.classNames,
    colors = _a.colors,
    verbiage = _a.verbiage,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onBeforeSubmit = _a.onBeforeSubmit,
    onSubmit = _a.onSubmit,
    onComplete = _a.onComplete,
    onCustomerMatched = _a.onCustomerMatched,
    onCustomerNotMatched = _a.onCustomerNotMatched,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onModelError = _a.onModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _h = _a.geolocationEnabled,
    geolocationEnabled = _h === void 0 ? true : _h,
    _j = _a.geolocationRequired,
    geolocationRequired = _j === void 0 ? false : _j,
    _k = _a.debugMode,
    debugMode = _k === void 0 ? false : _k;
  useLanguage(lang);
  useDebugLogging(debugMode);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.VERIFY,
    submissionUrl: submissionUrl,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    enrollmentId: enrollmentId,
    needImmediateResponse: needImmediateResponse,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeSubmit: onBeforeSubmit,
    onSubmit: onSubmit,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CameraStoreProvider, {
    preferFrontFacingCamera: true,
    onCameraAccessDenied: onCameraAccessDenied
  }, /*#__PURE__*/React__default.createElement(SelfieGuidanceModelsProvider, {
    autoStart: false,
    onModelError: onModelError,
    modelLoadTimeoutMs: modelLoadTimeoutMs
  }, /*#__PURE__*/React__default.createElement(CustomerVerificationWizard, {
    onComplete: onComplete,
    onCustomerMatched: onCustomerMatched,
    onCustomerNotMatched: onCustomerNotMatched,
    onExitCapture: onExitCapture,
    onExitAfterFailure: onExitAfterFailure,
    onUserCancel: onUserCancel,
    captureGuidanceTimeoutDurationMs: timeoutDurationMs,
    loadingOverlayMode: loadingOverlayMode,
    skipSuccessScreen: skipSuccessScreen,
    assets: assets,
    classNames: classNames,
    colors: colors,
    verbiage: verbiage,
    debugMode: debugMode
  }))))));
};

var ALLOWED_RETRIES$1 = 0;
var initialState = {
  frame: null,
  face: null,
  imageUrl: null,
  requestState: 'CAPTURING',
  requestError: null,
  notFoundTimes: 0
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'identificationReady':
      {
        var allowedStates = ['CAPTURING', 'ERROR'];
        if (allowedStates.includes(state.requestState)) {
          return _assign(_assign({}, state), {
            requestState: 'CAPTURED',
            frame: action.payload.frame,
            face: action.payload.face
          });
        } else {
          return state;
        }
      }
    case 'identifying':
      return _assign(_assign({}, state), {
        requestState: 'IDENTIFYING',
        imageUrl: action.payload.imageUrl
      });
    case 'identificationCompleted':
      {
        var _a = action.payload.response,
          _b = _a.status,
          statusCode = _b.statusCode,
          statusMessage = _b.statusMessage,
          errorData = _b.errorData,
          resultData = _a.resultData;
        if (statusCode !== '000') {
          return _assign(_assign({}, state), {
            requestState: 'ERROR',
            requestError: new Error("".concat(statusMessage, ": ").concat(errorData))
          });
        }
        var requestState = state.requestState,
          notFoundTimes = state.notFoundTimes;
        var customerMatched = resultData.verificationResultCode === '46';
        if (customerMatched) {
          requestState = 'FOUND';
        } else if (notFoundTimes < ALLOWED_RETRIES$1) {
          requestState = 'CAPTURING';
          notFoundTimes += 1;
        } else {
          requestState = 'NOT_FOUND';
        }
        return _assign(_assign({}, state), {
          requestState: requestState,
          notFoundTimes: notFoundTimes
        });
      }
    case 'identificationFailed':
      return _assign(_assign({}, state), {
        requestState: 'ERROR',
        requestError: action.payload.error
      });
    default:
      return state;
  }
};
var CustomerIdentificationCapture = function CustomerIdentificationCapture(_a) {
  var _b, _c;
  var onCustomerMatched = _a.onCustomerMatched,
    onCustomerNotMatched = _a.onCustomerNotMatched,
    onCaptureGuidanceTimeout = _a.onCaptureGuidanceTimeout,
    onExit = _a.onExit,
    captureGuidanceTimeoutDurationMs = _a.captureGuidanceTimeoutDurationMs,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    verbiage = _f === void 0 ? {} : _f,
    _g = _a.debugMode,
    debugMode = _g === void 0 ? false : _g;
  var _h = useReducer(reducer, initialState),
    state = _h[0],
    dispatch = _h[1];
  var _j = useContext(SubmissionContext),
    submit = _j.submit,
    submissionRequest = _j.submissionRequest,
    submissionResponse = _j.submissionResponse,
    submissionError = _j.submissionError,
    selfieImage = _j.selfieImage,
    setSelfieImage = _j.setSelfieImage;
  var _k = useState(null),
    imageUrl = _k[0],
    setImageUrl = _k[1];
  var rawCanvas = useRef(null);
  var cropCanvas = useRef(null);
  var resizeCanvas = useRef(null);
  var onSelfieCaptured = useCallback(function (frame, face) {
    dispatch({
      type: 'identificationReady',
      payload: {
        frame: frame,
        face: face
      }
    });
  }, []);
  var frame = state.frame,
    face = state.face;
  var isReady = state.requestState === 'CAPTURED';
  useEffect(function () {
    if (!frame || !face || submissionError) return;
    var imageUrl = cropToShoulders(rawCanvas.current, cropCanvas.current, resizeCanvas.current, frame, face);
    setImageUrl(imageUrl);
    dataUrlToBase64(imageUrl).then(function (img) {
      setSelfieImage(img);
    });
  }, [face, frame, setSelfieImage, submissionError]);
  useEffect(function () {
    if (!isReady || !selfieImage || submissionError) return;
    (function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var submissionResponse_1, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);
              dispatch({
                type: 'identifying',
                payload: {
                  imageUrl: selfieImage
                }
              });
              return [4 /*yield*/, submit()];
            case 1:
              submissionResponse_1 = _a.sent();
              if (!submissionResponse_1) throw new Error('submission failed!');
              dispatch({
                type: 'identificationCompleted',
                payload: {
                  response: submissionResponse_1
                }
              });
              return [3 /*break*/, 3];
            case 2:
              e_1 = _a.sent();
              dispatch({
                type: 'identificationFailed',
                payload: {
                  error: e_1
                }
              });
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/];
          }
        });
      });
    })();
  }, [isReady, onCustomerMatched, onCustomerNotMatched, selfieImage, state.requestState, submissionError, submit]);
  useEffect(function () {
    if (!submissionRequest || !submissionResponse) return;
    if (state.requestState === 'FOUND') {
      onCustomerMatched === null || onCustomerMatched === void 0 ? void 0 : onCustomerMatched(submissionResponse, submissionRequest);
    } else if (state.requestState === 'NOT_FOUND') {
      onCustomerNotMatched === null || onCustomerNotMatched === void 0 ? void 0 : onCustomerNotMatched(submissionResponse, submissionRequest);
    }
  }, [onCustomerMatched, onCustomerNotMatched, state.requestState, submissionRequest, submissionResponse]);
  useTimeout(captureGuidanceTimeoutDurationMs, onCaptureGuidanceTimeout, ['FOUND', 'NOT_FOUND'].includes(state.requestState), state.requestState === 'IDENTIFYING');
  var progressPreviewText = useVerbiage(verbiage.progressPreviewText, 'Processing...');
  var theme = useTheme();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: rawCanvas
  }), /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: cropCanvas
  }), /*#__PURE__*/React__default.createElement(InvisibleCanvas, {
    ref: resizeCanvas
  }), /*#__PURE__*/React__default.createElement(SelfieCapture, {
    onSelfieCaptured: onSelfieCaptured,
    onExit: onExit,
    timeoutDurationMs: captureGuidanceTimeoutDurationMs,
    classNames: classNames,
    colors: colors,
    verbiage: verbiage,
    debugMode: debugMode
  }), debugMode && !((_c = (_b = theme.selfieCapture) === null || _b === void 0 ? void 0 : _b.capturePreview) === null || _c === void 0 ? void 0 : _c.disabled) && imageUrl && ( /*#__PURE__*/React__default.createElement(SelfieProgressPreview, {
    text: progressPreviewText,
    imageUrl: imageUrl,
    classNames: classNames.imagePreview
  })));
};

var CustomerIdentificationSuccess = function CustomerIdentificationSuccess(_a) {
  var imageUrl = _a.imageUrl,
    onDoneClick = _a.onDoneClick,
    onRetryClick = _a.onRetryClick,
    _b = _a.classNames,
    classNames = _b === void 0 ? {} : _b,
    _c = _a.colors,
    colors = _c === void 0 ? {} : _c,
    _d = _a.verbiage,
    rawVerbiage = _d === void 0 ? {} : _d;
  imageUrl || (imageUrl = "".concat(DEFAULT_CDN_URL, "/Selfie-Image-1.png"));
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Customer has been identified!',
    retryBtnText: 'Retry',
    doneBtnText: 'Done'
  });
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(Heading$1, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ImageContainer$1, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: verbiage.headingText,
    src: imageUrl,
    className: classNames.image
  })), /*#__PURE__*/React__default.createElement(StyledButtonsRow$1, {
    className: classNames.buttonsRow
  }, /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    className: classNames.retryBtn,
    onClick: onRetryClick,
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryBtnText), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "positive",
    className: classNames.doneBtn,
    onClick: onDoneClick,
    colors: colors.doneBtn,
    finished: true
  }, verbiage.doneBtnText))));
};
var Heading$1 = styled.h3(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var ImageContainer$1 = styled(ButtonsRow)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  max-height: calc(100vh - 185px);\n"], ["\n  max-height: calc(100vh - 185px);\n"])));
var StyledButtonsRow$1 = styled(ButtonsRow)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  margin-top: 24px;\n"], ["\n  margin-top: 24px;\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3$1;

var CustomerIdentificationFailure = function CustomerIdentificationFailure(_a) {
  var _b = _a.canRetry,
    canRetry = _b === void 0 ? true : _b,
    onRetryClick = _a.onRetryClick,
    onExitClick = _a.onExitClick,
    _c = _a.assets,
    assets = _c === void 0 ? {} : _c,
    _d = _a.classNames,
    classNames = _d === void 0 ? {} : _d,
    _e = _a.colors,
    colors = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    rawVerbiage = _f === void 0 ? {} : _f;
  assets.imageUrl || (assets.imageUrl = "".concat(DEFAULT_CDN_URL, "/manual_capture.png"));
  var verbiage = useTranslations(rawVerbiage, {
    headingText: 'Customer not found',
    retryBtnText: 'Retry',
    exitBtnText: 'Exit'
  });
  return /*#__PURE__*/React__default.createElement(OverlayContainer, {
    className: classNames.container
  }, /*#__PURE__*/React__default.createElement(OverlayInner$2, {
    className: classNames.inner
  }, /*#__PURE__*/React__default.createElement(Heading, {
    className: classNames.heading
  }, verbiage.headingText), /*#__PURE__*/React__default.createElement(ImageContainer, {
    className: classNames.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: verbiage.headingText,
    src: assets.imageUrl,
    className: classNames.image
  })), /*#__PURE__*/React__default.createElement(StyledButtonsRow, {
    className: classNames.buttonsRow
  }, canRetry && ( /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "warning",
    className: classNames.retryBtn,
    onClick: onRetryClick,
    colors: colors.retryBtn,
    finished: true
  }, verbiage.retryBtnText)), /*#__PURE__*/React__default.createElement(LoaderButton, {
    variant: "secondary",
    className: classNames.exitBtn,
    onClick: onExitClick,
    colors: colors.exitBtn,
    finished: true
  }, verbiage.exitBtnText))));
};
var Heading = styled.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var ImageContainer = styled(ButtonsRow)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-height: calc(100vh - 185px);\n"], ["\n  max-height: calc(100vh - 185px);\n"])));
var StyledButtonsRow = styled(ButtonsRow)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 24px;\n"], ["\n  margin-top: 24px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;

var ALLOWED_RETRIES = 2;
var CustomerIdentificationWizard = function CustomerIdentificationWizard(_a) {
  var _b;
  var onComplete = _a.onComplete,
    onCustomerMatched = _a.onCustomerMatched,
    onCustomerNotMatched = _a.onCustomerNotMatched,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onCaptureGuidanceTimeout = _a.onCaptureGuidanceTimeout,
    captureGuidanceTimeoutDurationMs = _a.captureGuidanceTimeoutDurationMs,
    _c = _a.skipSuccessScreen,
    skipSuccessScreen = _c === void 0 ? false : _c,
    _d = _a.loadingOverlayMode,
    loadingOverlayMode = _d === void 0 ? 'default' : _d,
    _e = _a.assets,
    assets = _e === void 0 ? {} : _e,
    _f = _a.classNames,
    classNames = _f === void 0 ? {} : _f,
    _g = _a.colors,
    colors = _g === void 0 ? {} : _g,
    _h = _a.verbiage,
    verbiage = _h === void 0 ? {} : _h,
    _j = _a.debugMode,
    debugMode = _j === void 0 ? false : _j;
  var _k = useContext(SubmissionContext),
    submissionResponse = _k.submissionResponse,
    submissionRequest = _k.submissionRequest,
    selfieImage = _k.selfieImage;
  var _l = useState('LOADING'),
    captureState = _l[0],
    setCaptureState = _l[1];
  var _m = useCameraStore(),
    cameraAccessDenied = _m.cameraAccessDenied,
    releaseCameraAccess = _m.releaseCameraAccess;
  var _o = useContext(SelfieGuidanceModelsContext),
    start = _o.start,
    stop = _o.stop;
  useEffect(function () {
    if (captureState !== 'CAPTURING') return;
    start();
    return function () {
      stop();
    };
  }, [captureState, start, stop]);
  var onCustomerMatchedCallback = useCallback(function (resp, req) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setCaptureState('FOUND');
        onCustomerMatched === null || onCustomerMatched === void 0 ? void 0 : onCustomerMatched(resp, req);
        return [2 /*return*/];
      });
    });
  }, [onCustomerMatched]);
  var onCustomerNotMatchedCallback = useCallback(function (resp, req) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setCaptureState('NOT_FOUND');
        onCustomerNotMatched === null || onCustomerNotMatched === void 0 ? void 0 : onCustomerNotMatched(resp, req);
        return [2 /*return*/];
      });
    });
  }, [onCustomerNotMatched]);
  var onCaptureGuidanceTimeoutCallback = useCallback(function () {
    setCaptureState('FAILED');
    onCaptureGuidanceTimeout === null || onCaptureGuidanceTimeout === void 0 ? void 0 : onCaptureGuidanceTimeout();
  }, [onCaptureGuidanceTimeout]);
  var _p = useState(0),
    attempt = _p[0],
    setAttempt = _p[1];
  var onExitCallback = useCallback(function () {
    setAttempt(function (n) {
      return n + 1;
    });
    setCaptureState('LOADING');
    onExitCapture === null || onExitCapture === void 0 ? void 0 : onExitCapture();
  }, [onExitCapture]);
  var onDoneCallback = useCallback(function () {
    releaseCameraAccess();
    if (submissionRequest && submissionResponse) onComplete === null || onComplete === void 0 ? void 0 : onComplete(submissionResponse, submissionRequest);
  }, [onComplete, releaseCameraAccess, submissionRequest, submissionResponse]);
  var showSuccessScreen = useShowSuccessScreen(skipSuccessScreen, captureState === 'FOUND', onDoneCallback);
  useEffect(function () {
    if (cameraAccessDenied) {
      setAttempt(function (n) {
        return n + 1;
      });
      setCaptureState('LOADING');
    }
  }, [cameraAccessDenied]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PageContainer, {
    className: "flex ".concat((_b = classNames.container) !== null && _b !== void 0 ? _b : '')
  }, /*#__PURE__*/React__default.createElement(CameraVideoTag, {
    className: classNames.cameraFeed
  }), captureState !== 'LOADING' && function () {
    switch (captureState) {
      case 'CAPTURING':
        return /*#__PURE__*/React__default.createElement(CustomerIdentificationCapture, {
          key: "capture".concat(attempt),
          onCustomerMatched: onCustomerMatchedCallback,
          onCustomerNotMatched: onCustomerNotMatchedCallback,
          onCaptureGuidanceTimeout: onCaptureGuidanceTimeoutCallback,
          onExit: onExitCallback,
          captureGuidanceTimeoutDurationMs: captureGuidanceTimeoutDurationMs,
          classNames: classNames,
          colors: colors,
          verbiage: verbiage,
          debugMode: debugMode
        });
      case 'FOUND':
        if (!showSuccessScreen) return;
        return /*#__PURE__*/React__default.createElement(CustomerIdentificationSuccess, {
          imageUrl: "data:image/png;base64, ".concat(selfieImage),
          classNames: classNames.success,
          colors: colors.success,
          verbiage: verbiage.success,
          onDoneClick: onDoneCallback,
          onRetryClick: function onRetryClick() {
            setCaptureState('CAPTURING');
            setAttempt(0);
          }
        });
      case 'NOT_FOUND':
      case 'FAILED':
        return /*#__PURE__*/React__default.createElement(CustomerIdentificationFailure, {
          assets: assets.failure,
          classNames: classNames.failure,
          colors: colors.failure,
          verbiage: verbiage.failure,
          canRetry: attempt < ALLOWED_RETRIES,
          onExitClick: function onExitClick() {
            releaseCameraAccess();
            onExitAfterFailure === null || onExitAfterFailure === void 0 ? void 0 : onExitAfterFailure();
          },
          onRetryClick: function onRetryClick() {
            setAttempt(function (n) {
              return n + 1;
            });
          }
        });
      default:
        return null;
    }
  }()), /*#__PURE__*/React__default.createElement(SelfieCaptureLoadingOverlay, {
    key: attempt,
    mode: loadingOverlayMode,
    assets: assets.loadingOverlay,
    classNames: classNames.loadingOverlay,
    colors: colors.loadingOverlay,
    verbiage: verbiage.loadingOverlay,
    onUserCancel: onUserCancel,
    onDismissed: function onDismissed() {
      setCaptureState('CAPTURING');
    }
  }));
};

/**
 * Render a fullscreen capture component that analyzes frames from the user's front-facing camera to determine whether the user matches any previously registered customer in IDmission's customer database.
 * */
var CustomerIdentification = function CustomerIdentification(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    _c = _a.loadingOverlayMode,
    loadingOverlayMode = _c === void 0 ? 'default' : _c,
    _d = _a.timeoutDurationMs,
    timeoutDurationMs = _d === void 0 ? 15000 : _d,
    _e = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _e === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _e,
    _f = _a.skipSuccessScreen,
    skipSuccessScreen = _f === void 0 ? false : _f,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onBeforeSubmit = _a.onBeforeSubmit,
    onSubmit = _a.onSubmit,
    onComplete = _a.onComplete,
    onCustomerMatched = _a.onCustomerMatched,
    onCustomerNotMatched = _a.onCustomerNotMatched,
    onCaptureGuidanceTimeout = _a.onCaptureGuidanceTimeout,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onModelError = _a.onModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _g = _a.theme,
    theme = _g === void 0 ? 'default' : _g,
    assets = _a.assets,
    classNames = _a.classNames,
    colors = _a.colors,
    verbiage = _a.verbiage,
    geolocationEnabled = _a.geolocationEnabled,
    _h = _a.geolocationRequired,
    geolocationRequired = _h === void 0 ? false : _h,
    _j = _a.debugMode,
    debugMode = _j === void 0 ? false : _j;
  useLanguage(lang);
  useDebugLogging(debugMode);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.IDENTIFY,
    submissionUrl: submissionUrl,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    needImmediateResponse: needImmediateResponse,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeSubmit: onBeforeSubmit,
    onSubmit: onSubmit,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CameraStoreProvider, {
    preferFrontFacingCamera: true,
    onCameraAccessDenied: onCameraAccessDenied
  }, /*#__PURE__*/React__default.createElement(SelfieGuidanceModelsProvider, {
    autoStart: false,
    modelLoadTimeoutMs: modelLoadTimeoutMs,
    onModelError: onModelError
  }, /*#__PURE__*/React__default.createElement(CustomerIdentificationWizard, {
    onComplete: onComplete,
    onCustomerMatched: onCustomerMatched,
    onCustomerNotMatched: onCustomerNotMatched,
    onExitCapture: onExitCapture,
    onExitAfterFailure: onExitAfterFailure,
    onUserCancel: onUserCancel,
    onCaptureGuidanceTimeout: onCaptureGuidanceTimeout,
    captureGuidanceTimeoutDurationMs: timeoutDurationMs,
    loadingOverlayMode: loadingOverlayMode,
    skipSuccessScreen: skipSuccessScreen,
    assets: assets,
    classNames: classNames,
    colors: colors,
    verbiage: verbiage,
    debugMode: debugMode
  }))))));
};

/** Render a fullscreen capture component that captures a video of the user signing the screen. */
var SignatureKYC = function SignatureKYC(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    clientRequestID = _a.clientRequestID,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onBeforeSubmit = _a.onBeforeSubmit,
    onSubmit = _a.onSubmit,
    onComplete = _a.onComplete,
    onUserCancel = _a.onUserCancel,
    onModelError = _a.onModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    onLoadingOverlayDismissed = _a.onLoadingOverlayDismissed,
    _c = _a.loadingOverlayMode,
    loadingOverlayMode = _c === void 0 ? 'default' : _c,
    customOverlayContent = _a.customOverlayContent,
    _d = _a.skipSuccessScreen,
    skipSuccessScreen = _d === void 0 ? false : _d,
    idCardForFaceMatch = _a.idCardForFaceMatch,
    _e = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _e === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _e,
    _f = _a.allowSignatureAfterLivenessCheckFailure,
    allowSignatureAfterLivenessCheckFailure = _f === void 0 ? false : _f,
    faceLivenessProps = _a.faceLivenessProps,
    _g = _a.theme,
    theme = _g === void 0 ? 'default' : _g,
    classNames = _a.classNames,
    colors = _a.colors,
    verbiage = _a.verbiage,
    geolocationEnabled = _a.geolocationEnabled,
    geolocationRequired = _a.geolocationRequired,
    _h = _a.debugMode,
    debugMode = _h === void 0 ? false : _h;
  useLanguage(lang);
  useDebugLogging(debugMode);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.NONE,
    submissionUrl: submissionUrl,
    clientRequestID: clientRequestID,
    documentServiceUrl: documentServiceUrl,
    idCardForFaceMatch: idCardForFaceMatch,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeSubmit: onBeforeSubmit,
    onSubmit: onSubmit,
    onResponseReceived: onComplete,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CompositeWizard, {
    debugMode: debugMode,
    checks: useMemo(function () {
      return ['VideoSignatureCapture'];
    }, []),
    onCameraAccessDenied: onCameraAccessDenied,
    videoSignatureCaptureProps: useMemo(function () {
      return {
        customOverlayContent: customOverlayContent,
        onLoadingOverlayDismissed: onLoadingOverlayDismissed,
        loadingOverlayMode: loadingOverlayMode,
        skipSuccessScreen: skipSuccessScreen,
        modelLoadTimeoutMs: modelLoadTimeoutMs,
        faceLivenessProps: faceLivenessProps,
        allowSignatureAfterLivenessCheckFailure: allowSignatureAfterLivenessCheckFailure,
        classNames: classNames,
        colors: colors,
        debugMode: debugMode,
        verbiage: verbiage,
        onModelError: onModelError,
        onUserCancel: onUserCancel
      };
    }, [customOverlayContent, onLoadingOverlayDismissed, loadingOverlayMode, skipSuccessScreen, modelLoadTimeoutMs, faceLivenessProps, allowSignatureAfterLivenessCheckFailure, classNames, colors, debugMode, verbiage, onModelError, onUserCancel])
  }))));
};

/**
 * Render a fullscreen capture component that performs IDValidation and FaceValidation sequentially, then captures a video of the user holding their ID, and optionally speaking a prompt aloud.
 * */
var VideoIdValidation = function VideoIdValidation(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    clientRequestID = _a.clientRequestID,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    manualReviewRequired = _a.manualReviewRequired,
    idBackImageRequired = _a.idBackImageRequired,
    verifyIdWithExternalDatabases = _a.verifyIdWithExternalDatabases,
    bypassAgeValidation = _a.bypassAgeValidation,
    bypassNameMatching = _a.bypassNameMatching,
    personalData = _a.personalData,
    cardData = _a.cardData,
    idData = _a.idData,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    webhooksFireOnReview = _a.webhooksFireOnReview,
    webhooksFireOnReviewURL = _a.webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig = _a.customerDataMatchConfig,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onSubmit = _a.onSubmit,
    onBeforeSubmit = _a.onBeforeSubmit,
    onComplete = _a.onComplete,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    onMicrophoneAccessDenied = _a.onMicrophoneAccessDenied,
    idCaptureProps = _a.idCaptureProps,
    faceLivenessProps = _a.faceLivenessProps,
    _c = _a.idCaptureModelsEnabled,
    idCaptureModelsEnabled = _c === void 0 ? true : _c,
    _d = _a.videoIdCaptureThresholds,
    videoIdCaptureThresholds = _d === void 0 ? defaultVideoIdCaptureThresholds : _d,
    readTextPrompt = _a.readTextPrompt,
    _e = _a.readTextTimeoutDurationMs,
    readTextTimeoutDurationMs = _e === void 0 ? 15000 : _e,
    _f = _a.readTextMinReadingMs,
    readTextMinReadingMs = _f === void 0 ? 10000 : _f,
    _g = _a.skipSuccessScreen,
    skipSuccessScreen = _g === void 0 ? false : _g,
    _h = _a.skipIdCapture,
    skipIdCapture = _h === void 0 ? false : _h,
    _j = _a.skipShowIdCardBack,
    skipShowIdCardBack = _j === void 0 ? false : _j,
    _k = _a.idCaptureLoadingOverlayMode,
    idCaptureLoadingOverlayMode = _k === void 0 ? 'default' : _k,
    customOverlayContent = _a.customOverlayContent,
    onLoadingOverlayDismissed = _a.onLoadingOverlayDismissed,
    _l = _a.idCaptureGuideType,
    idCaptureGuideType = _l === void 0 ? 'fit' : _l,
    _m = _a.idCaptureGuideImages,
    idCaptureGuideImages = _m === void 0 ? defaultIdCaptureGuideImages : _m,
    _o = _a.idCapturePortraitGuidesOnMobile,
    idCapturePortraitGuidesOnMobile = _o === void 0 ? true : _o,
    _p = _a.idCaptureRotateLoadingOverlayImageWhenPortrait,
    idCaptureRotateLoadingOverlayImageWhenPortrait = _p === void 0 ? true : _p,
    idCardForFaceMatch = _a.idCardForFaceMatch,
    _q = _a.idDocumentType,
    idDocumentType = _q === void 0 ? 'idCardOrPassport' : _q,
    _r = _a.faceLivenessLoadingOverlayMode,
    faceLivenessLoadingOverlayMode = _r === void 0 ? 'default' : _r,
    _s = _a.disableFaceDetectionWhileAudioCapture,
    disableFaceDetectionWhileAudioCapture = _s === void 0 ? false : _s,
    _t = _a.disableFaceDetectionWhileAudioCaptureMsDelay,
    disableFaceDetectionWhileAudioCaptureMsDelay = _t === void 0 ? 2000 : _t,
    _u = _a.silentFallback,
    silentFallback = _u === void 0 ? false : _u,
    _v = _a.mergeAVStreams,
    mergeAVStreams = _v === void 0 ? false : _v,
    _w = _a.matchOnly,
    matchOnly = _w === void 0 ? false : _w,
    _x = _a.theme,
    theme = _x === void 0 ? 'default' : _x,
    _y = _a.assets,
    assets = _y === void 0 ? {} : _y,
    _z = _a.classNames,
    classNames = _z === void 0 ? {} : _z,
    _0 = _a.colors,
    colors = _0 === void 0 ? {} : _0,
    _1 = _a.verbiage,
    verbiage = _1 === void 0 ? {} : _1,
    _2 = _a.captureSignature,
    captureSignature = _2 === void 0 ? false : _2,
    _3 = _a.captureSignatureVideo,
    captureSignatureVideo = _3 === void 0 ? false : _3,
    _4 = _a.captureAdditionalDocuments,
    captureAdditionalDocuments = _4 === void 0 ? [] : _4,
    _5 = _a.geolocationEnabled,
    geolocationEnabled = _5 === void 0 ? true : _5,
    _6 = _a.geolocationRequired,
    geolocationRequired = _6 === void 0 ? false : _6,
    _7 = _a.debugMode,
    debugMode = _7 === void 0 ? false : _7;
  useLanguage(lang);
  useDebugLogging(debugMode);
  var videoIdCaptureProps = useMemo(function () {
    return {
      idCaptureProps: idCaptureProps,
      faceLivenessProps: faceLivenessProps,
      idCaptureModelsEnabled: idCaptureModelsEnabled,
      videoIdCaptureThresholds: videoIdCaptureThresholds,
      readTextPrompt: readTextPrompt,
      readTextTimeoutDurationMs: readTextTimeoutDurationMs,
      readTextMinReadingMs: readTextMinReadingMs,
      onExitCapture: onExitCapture,
      onExitAfterFailure: onExitAfterFailure,
      onUserCancel: onUserCancel,
      skipSuccessScreen: skipSuccessScreen,
      skipIdCapture: skipIdCapture,
      skipShowIdCardBack: skipShowIdCardBack,
      idCaptureLoadingOverlayMode: idCaptureLoadingOverlayMode,
      customOverlayContent: customOverlayContent,
      onLoadingOverlayDismissed: onLoadingOverlayDismissed,
      idDocumentType: idDocumentType,
      idCaptureGuideType: idCaptureGuideType,
      idCaptureGuideImages: idCaptureGuideImages,
      idCapturePortraitGuidesOnMobile: idCapturePortraitGuidesOnMobile,
      idCaptureRotateLoadingOverlayImageWhenPortrait: idCaptureRotateLoadingOverlayImageWhenPortrait,
      faceLivenessLoadingOverlayMode: faceLivenessLoadingOverlayMode,
      disableFaceDetectionWhileAudioCapture: disableFaceDetectionWhileAudioCapture,
      disableFaceDetectionWhileAudioCaptureMsDelay: disableFaceDetectionWhileAudioCaptureMsDelay,
      silentFallback: silentFallback,
      mergeAVStreams: mergeAVStreams,
      assets: assets,
      classNames: classNames,
      colors: colors,
      verbiage: verbiage,
      debugMode: debugMode
    };
  }, [idCaptureProps, faceLivenessProps, idCaptureModelsEnabled, videoIdCaptureThresholds, readTextPrompt, readTextTimeoutDurationMs, readTextMinReadingMs, onExitCapture, onExitAfterFailure, onUserCancel, skipSuccessScreen, skipIdCapture, skipShowIdCardBack, idCaptureLoadingOverlayMode, customOverlayContent, onLoadingOverlayDismissed, idDocumentType, idCaptureGuideType, idCaptureGuideImages, idCapturePortraitGuidesOnMobile, idCaptureRotateLoadingOverlayImageWhenPortrait, faceLivenessLoadingOverlayMode, disableFaceDetectionWhileAudioCapture, disableFaceDetectionWhileAudioCaptureMsDelay, silentFallback, mergeAVStreams, assets, classNames, colors, verbiage, debugMode]);
  var additionalDocumentCaptureProps = useMemo(function () {
    return {
      documents: captureAdditionalDocuments,
      classNames: classNames.additionalDocumentCapture,
      verbiage: verbiage.additionalDocumentCapture
    };
  }, [captureAdditionalDocuments, classNames.additionalDocumentCapture, verbiage.additionalDocumentCapture]);
  var signatureCaptureProps = useMemo(function () {
    return {
      classNames: classNames.signatureCapture,
      verbiage: verbiage.signatureCapture
    };
  }, [classNames.signatureCapture, verbiage.signatureCapture]);
  var videoSignatureCaptureProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      skipSuccessScreen: skipSuccessScreen,
      classNames: classNames.videoSignatureCapture,
      colors: colors.videoSignatureCapture,
      verbiage: verbiage.videoSignatureCapture,
      debugMode: debugMode
    };
  }, [classNames.videoSignatureCapture, colors.videoSignatureCapture, debugMode, onExitCapture, onUserCancel, skipSuccessScreen, verbiage.videoSignatureCapture]);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: idCardForFaceMatch || !skipIdCapture ? matchOnly ? SubmissionAction.MATCH_ID_AND_FACE : SubmissionAction.VALIDATE : SubmissionAction.NONE,
    submissionUrl: submissionUrl,
    clientRequestID: clientRequestID,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    needImmediateResponse: needImmediateResponse,
    manualReviewRequired: manualReviewRequired,
    idBackImageRequired: idBackImageRequired,
    verifyIdWithExternalDatabases: verifyIdWithExternalDatabases,
    bypassAgeValidation: bypassAgeValidation,
    bypassNameMatching: bypassNameMatching,
    personalData: personalData,
    cardData: cardData,
    idData: idData,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    webhooksFireOnReview: webhooksFireOnReview,
    webhooksFireOnReviewURL: webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    customerDataMatchConfig: customerDataMatchConfig,
    idCardForFaceMatch: idCardForFaceMatch,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onSubmit: onSubmit,
    onBeforeSubmit: onBeforeSubmit,
    onResponseReceived: onComplete,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CompositeWizard, {
    checks: useMemo(function () {
      return ['VideoIdCapture'];
    }, []),
    videoIdCaptureProps: videoIdCaptureProps,
    additionalDocumentCaptureProps: additionalDocumentCaptureProps,
    signatureCaptureProps: signatureCaptureProps,
    videoSignatureCaptureProps: videoSignatureCaptureProps,
    captureSignature: captureSignature,
    captureSignatureVideo: captureSignatureVideo,
    onCameraAccessDenied: onCameraAccessDenied,
    onMicrophoneAccessDenied: onMicrophoneAccessDenied,
    debugMode: debugMode
  }))));
};

/** Render a fullscreen capture component that performs FaceValidation, and then stores the results in IDmission's customer database using the supplied `enrollmentId` for later verification or 1:N matching. */
var CustomerBiometricsEnrollment = function CustomerBiometricsEnrollment(_a) {
  var enrollmentId = _a.enrollmentId,
    _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    companyId = _a.companyId,
    needImmediateResponse = _a.needImmediateResponse,
    deduplicationEnabled = _a.deduplicationEnabled,
    deduplicationSynchronous = _a.deduplicationSynchronous,
    webhooksEnabled = _a.webhooksEnabled,
    webhooksURL = _a.webhooksURL,
    webhooksClientTraceId = _a.webhooksClientTraceId,
    webhooksStripSpecialCharacters = _a.webhooksStripSpecialCharacters,
    webhooksSendInputImages = _a.webhooksSendInputImages,
    webhooksSendProcessedImages = _a.webhooksSendProcessedImages,
    webhooksFireOnReview = _a.webhooksFireOnReview,
    webhooksFireOnReviewURL = _a.webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    _c = _a.loadingOverlayMode,
    loadingOverlayMode = _c === void 0 ? 'default' : _c,
    _d = _a.timeoutDurationMs,
    timeoutDurationMs = _d === void 0 ? 15000 : _d,
    _e = _a.modelLoadTimeoutMs,
    modelLoadTimeoutMs = _e === void 0 ? defaultSelfieCaptureModelLoadTimeoutMs : _e,
    _f = _a.skipSuccessScreen,
    skipSuccessScreen = _f === void 0 ? false : _f,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onBeforeSubmit = _a.onBeforeSubmit,
    onSubmit = _a.onSubmit,
    onComplete = _a.onComplete,
    onEnrolled = _a.onEnrolled,
    onDenied = _a.onDenied,
    onExitCapture = _a.onExitCapture,
    onExitAfterFailure = _a.onExitAfterFailure,
    onUserCancel = _a.onUserCancel,
    onModelError = _a.onModelError,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _g = _a.captureAdditionalDocuments,
    captureAdditionalDocuments = _g === void 0 ? [] : _g,
    _h = _a.captureSignature,
    captureSignature = _h === void 0 ? false : _h,
    _j = _a.captureSignatureVideo,
    captureSignatureVideo = _j === void 0 ? false : _j,
    _k = _a.theme,
    theme = _k === void 0 ? 'default' : _k,
    _l = _a.assets,
    assets = _l === void 0 ? {} : _l,
    _m = _a.classNames,
    classNames = _m === void 0 ? {} : _m,
    _o = _a.colors,
    colors = _o === void 0 ? {} : _o,
    _p = _a.verbiage,
    verbiage = _p === void 0 ? {} : _p,
    _q = _a.geolocationEnabled,
    geolocationEnabled = _q === void 0 ? true : _q,
    _r = _a.geolocationRequired,
    geolocationRequired = _r === void 0 ? false : _r,
    _s = _a.debugMode,
    debugMode = _s === void 0 ? false : _s;
  useLanguage(lang);
  useDebugLogging(debugMode);
  var faceLivenessProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      onExitAfterFailure: onExitAfterFailure,
      onModelError: onModelError,
      timeoutDurationMs: timeoutDurationMs,
      modelLoadTimeoutMs: modelLoadTimeoutMs,
      loadingOverlayMode: loadingOverlayMode,
      skipSuccessScreen: skipSuccessScreen,
      assets: assets.faceLiveness,
      classNames: classNames.faceLiveness,
      colors: colors.faceLiveness,
      verbiage: verbiage.faceLiveness,
      debugMode: debugMode
    };
  }, [assets.faceLiveness, classNames.faceLiveness, colors.faceLiveness, debugMode, loadingOverlayMode, modelLoadTimeoutMs, onExitAfterFailure, onExitCapture, onModelError, onUserCancel, skipSuccessScreen, timeoutDurationMs, verbiage.faceLiveness]);
  var additionalDocumentCaptureProps = useMemo(function () {
    return {
      documents: captureAdditionalDocuments,
      classNames: classNames.additionalDocumentCapture,
      verbiage: verbiage.additionalDocumentCapture
    };
  }, [captureAdditionalDocuments, classNames.additionalDocumentCapture, verbiage.additionalDocumentCapture]);
  var signatureCaptureProps = useMemo(function () {
    return {
      classNames: classNames.signatureCapture,
      verbiage: verbiage.signatureCapture
    };
  }, [classNames.signatureCapture, verbiage.signatureCapture]);
  var videoSignatureCaptureProps = useMemo(function () {
    return {
      onExitCapture: onExitCapture,
      onUserCancel: onUserCancel,
      skipSuccessScreen: skipSuccessScreen,
      classNames: classNames.videoSignatureCapture,
      colors: colors.videoSignatureCapture,
      verbiage: verbiage.videoSignatureCapture,
      debugMode: debugMode
    };
  }, [classNames.videoSignatureCapture, colors.videoSignatureCapture, debugMode, onExitCapture, onUserCancel, skipSuccessScreen, verbiage.videoSignatureCapture]);
  var onResponseReceived = useCallback(function (resp, req) {
    onComplete === null || onComplete === void 0 ? void 0 : onComplete(resp, req);
    if (resp.resultData['verificationResult'] === 'Customer Onboarded') {
      onEnrolled === null || onEnrolled === void 0 ? void 0 : onEnrolled(resp, req);
    } else {
      onDenied === null || onDenied === void 0 ? void 0 : onDenied(resp, req);
    }
  }, [onEnrolled, onComplete, onDenied]);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.ENROLL,
    submissionUrl: submissionUrl,
    documentServiceUrl: documentServiceUrl,
    companyId: companyId,
    enrollmentId: enrollmentId,
    needImmediateResponse: needImmediateResponse,
    deduplicationEnabled: deduplicationEnabled,
    deduplicationSynchronous: deduplicationSynchronous,
    webhooksEnabled: webhooksEnabled,
    webhooksURL: webhooksURL,
    webhooksClientTraceId: webhooksClientTraceId,
    webhooksStripSpecialCharacters: webhooksStripSpecialCharacters,
    webhooksSendInputImages: webhooksSendInputImages,
    webhooksSendProcessedImages: webhooksSendProcessedImages,
    webhooksFireOnReview: webhooksFireOnReview,
    webhooksFireOnReviewURL: webhooksFireOnReviewURL,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    onBeforeSubmit: onBeforeSubmit,
    onSubmit: onSubmit,
    onResponseReceived: onResponseReceived,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CompositeWizard, {
    checks: useMemo(function () {
      return ['FaceLiveness'];
    }, []),
    faceLivenessProps: faceLivenessProps,
    additionalDocumentCaptureProps: additionalDocumentCaptureProps,
    signatureCaptureProps: signatureCaptureProps,
    videoSignatureCaptureProps: videoSignatureCaptureProps,
    captureSignature: captureSignature,
    captureSignatureVideo: captureSignatureVideo,
    onCameraAccessDenied: onCameraAccessDenied,
    debugMode: debugMode
  }))));
};

/**
 * Render a fullscreen capture component that instructs the user to photograph their document.
 */
var DocumentCapture = function DocumentCapture(_a) {
  var _b = _a.lang,
    lang = _b === void 0 ? 'auto' : _b,
    sessionId = _a.sessionId,
    authUrl = _a.authUrl,
    submissionUrl = _a.submissionUrl,
    documentServiceUrl = _a.documentServiceUrl,
    sendBase64DocumentsInSwaggerProxy = _a.sendBase64DocumentsInSwaggerProxy,
    useDocumentServiceForLivenessChecks = _a.useDocumentServiceForLivenessChecks,
    onBeforeDocumentUpload = _a.onBeforeDocumentUpload,
    onDocumentUploadProgress = _a.onDocumentUploadProgress,
    onDocumentUploaded = _a.onDocumentUploaded,
    onDocumentUploadFailed = _a.onDocumentUploadFailed,
    onComplete = _a.onComplete,
    onExitCapture = _a.onExitCapture,
    onUserCancel = _a.onUserCancel,
    onCameraAccessDenied = _a.onCameraAccessDenied,
    _c = _a.documents,
    documents = _c === void 0 ? [] : _c,
    aspectRatio = _a.aspectRatio,
    cameraFeedMode = _a.cameraFeedMode,
    instructions = _a.instructions,
    _d = _a.theme,
    theme = _d === void 0 ? 'default' : _d,
    _e = _a.classNames,
    classNames = _e === void 0 ? {} : _e,
    _f = _a.verbiage,
    verbiage = _f === void 0 ? {} : _f,
    _g = _a.geolocationEnabled,
    geolocationEnabled = _g === void 0 ? true : _g,
    _h = _a.geolocationRequired,
    geolocationRequired = _h === void 0 ? false : _h,
    _j = _a.debugMode,
    debugMode = _j === void 0 ? false : _j;
  useLanguage(lang);
  useDebugLogging(debugMode);
  return /*#__PURE__*/React__default.createElement(AuthProvider, {
    sessionId: sessionId,
    authUrl: authUrl
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(SubmissionProvider, {
    action: SubmissionAction.NONE,
    submissionUrl: submissionUrl,
    documentServiceUrl: documentServiceUrl,
    sendBase64DocumentsInSwaggerProxy: sendBase64DocumentsInSwaggerProxy,
    onBeforeDocumentUpload: onBeforeDocumentUpload,
    onDocumentUploadProgress: onDocumentUploadProgress,
    onDocumentUploaded: onDocumentUploaded,
    onDocumentUploadFailed: onDocumentUploadFailed,
    geolocationEnabled: geolocationEnabled,
    geolocationRequired: geolocationRequired,
    useDocumentServiceForLivenessChecks: useDocumentServiceForLivenessChecks
  }, /*#__PURE__*/React__default.createElement(CameraStoreProvider, {
    requestAccessAutomatically: false,
    preferIphoneContinuityCamera: true,
    onCameraAccessDenied: onCameraAccessDenied
  }, /*#__PURE__*/React__default.createElement(DocumentCaptureWizard, {
    onSuccess: onComplete,
    onExitCapture: onExitCapture,
    onUserCancel: onUserCancel,
    documents: documents,
    aspectRatio: aspectRatio,
    cameraFeedMode: cameraFeedMode,
    instructions: instructions,
    classNames: classNames,
    verbiage: verbiage
  })))));
};

initializeI18n();
function renderElement(component, targetElement) {
  if (typeof targetElement === 'string') {
    var result = document.querySelector(targetElement);
    if (!result) throw new Error("targetElement ".concat(targetElement, " not found"));
    targetElement = result;
  } else if (!targetElement) {
    targetElement = document.createElement('div');
    document.body.append(targetElement);
  }
  var root = ReactDOM.createRoot(targetElement);
  root.render( /*#__PURE__*/React__default.createElement(OverlayContainer, null, component));
  if ('remove' in targetElement) {
    var originalRemove_1 = targetElement.remove;
    targetElement.remove = function () {
      try {
        root.unmount();
        originalRemove_1();
      } catch (e) {
        debug('failed to unmount', e);
      }
    };
  }
  return targetElement;
}
function renderComponent(Component, targetElement, options) {
  if (!options) {
    options = targetElement;
    targetElement = undefined;
  }
  return renderElement( /*#__PURE__*/React__default.createElement(Component, _assign({}, options)), targetElement);
}
var renderIdValidation = function renderIdValidation(optionsOrTargetElement, options) {
  return renderComponent(IdValidation, optionsOrTargetElement, options);
};
var renderFaceValidation = function renderFaceValidation(optionsOrTargetElement, options) {
  return renderComponent(FaceValidation, optionsOrTargetElement, options);
};
var renderIdAndFaceValidation = function renderIdAndFaceValidation(optionsOrTargetElement, options) {
  return renderComponent(IdAndFaceValidation, optionsOrTargetElement, options);
};
var renderCustomerIdAndBiometricsEnrollment = function renderCustomerIdAndBiometricsEnrollment(optionsOrTargetElement, options) {
  return renderComponent(CustomerIdAndBiometricsEnrollment, optionsOrTargetElement, options);
};
var renderCustomerBiometricsEnrollment = function renderCustomerBiometricsEnrollment(optionsOrTargetElement, options) {
  return renderComponent(CustomerBiometricsEnrollment, optionsOrTargetElement, options);
};
var renderCustomerVerification = function renderCustomerVerification(optionsOrTargetElement, options) {
  return renderComponent(CustomerVerification, optionsOrTargetElement, options);
};
var renderCustomerIdentification = function renderCustomerIdentification(optionsOrTargetElement, options) {
  return renderComponent(CustomerIdentification, optionsOrTargetElement, options);
};
var renderSignatureKYC = function renderSignatureKYC(optionsOrTargetElement, options) {
  return renderComponent(SignatureKYC, optionsOrTargetElement, options);
};
var renderVideoIdValidation = function renderVideoIdValidation(optionsOrTargetElement, options) {
  return renderComponent(VideoIdValidation, optionsOrTargetElement, options);
};
var renderDocumentCapture = function renderDocumentCapture(optionsOrTargetElement, options) {
  return renderComponent(DocumentCapture, optionsOrTargetElement, options);
};
globalThis.IDmissionSDK = {
  renderIdValidation: renderIdValidation,
  renderFaceValidation: renderFaceValidation,
  renderIdAndFaceValidation: renderIdAndFaceValidation,
  renderCustomerIdAndBiometricsEnrollment: renderCustomerIdAndBiometricsEnrollment,
  renderCustomerBiometricsEnrollment: renderCustomerBiometricsEnrollment,
  renderCustomerVerification: renderCustomerVerification,
  renderCustomerIdentification: renderCustomerIdentification,
  renderSignatureKYC: renderSignatureKYC,
  renderVideoIdValidation: renderVideoIdValidation,
  renderDocumentCapture: renderDocumentCapture,
  preloadModels: preloadModels,
  themes: themes,
  version: webSdkVersion,
  ready: true,
  authMode: 'session',
  allowedAuthUrls: allowedAuthUrls,
  defaultAuthUrl: defaultAuthUrl,
  defaultSubmissionUrl: defaultSubmissionUrl,
  setServerUrl: setServerUrl
};

export { CapturedDocumentImg, CustomerBiometricsEnrollment, CustomerIdAndBiometricsEnrollment, CustomerIdentification, CustomerVerification, DocumentCapture, FaceValidation, IdAndFaceValidation, IdValidation, SignatureKYC, VideoIdValidation, allowedAuthUrls, defaultAuthUrl, defaultSubmissionUrl, isObject, preloadModels, renderCustomerBiometricsEnrollment, renderCustomerIdAndBiometricsEnrollment, renderCustomerIdentification, renderCustomerVerification, renderDocumentCapture, renderFaceValidation, renderIdAndFaceValidation, renderIdValidation, renderSignatureKYC, renderVideoIdValidation, setServerUrl, themes };
//# sourceMappingURL=sdk2.esm.js.map
